/*! For license information please see theme.min.js.LICENSE.txt */
(() => {
  "use strict";
  var t = {
    35: (t, e, r) => {
      r.d(e, { Z: () => s });
      var n = r(81),
        i = r.n(n),
        o = r(645),
        a = r.n(o)()(i());
      a.push([
        t.id,
        ":root{--swiper-navigation-size:44px}.swiper-button-next,.swiper-button-prev{position:absolute;top:var(--swiper-navigation-top-offset,50%);width:calc(var(--swiper-navigation-size)/ 44 * 27);height:var(--swiper-navigation-size);margin-top:calc(0px - (var(--swiper-navigation-size)/ 2));z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--swiper-navigation-color,var(--swiper-theme-color))}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-next.swiper-button-hidden,.swiper-button-prev.swiper-button-hidden{opacity:0;cursor:auto;pointer-events:none}.swiper-navigation-disabled .swiper-button-next,.swiper-navigation-disabled .swiper-button-prev{display:none!important}.swiper-button-next:after,.swiper-button-prev:after{font-family:swiper-icons;font-size:var(--swiper-navigation-size);text-transform:none!important;letter-spacing:0;font-variant:initial;line-height:1}.swiper-button-prev,.swiper-rtl .swiper-button-next{left:var(--swiper-navigation-sides-offset,10px);right:auto}.swiper-button-prev:after,.swiper-rtl .swiper-button-next:after{content:'prev'}.swiper-button-next,.swiper-rtl .swiper-button-prev{right:var(--swiper-navigation-sides-offset,10px);left:auto}.swiper-button-next:after,.swiper-rtl .swiper-button-prev:after{content:'next'}.swiper-button-lock{display:none}",
        "",
      ]);
      const s = a;
    },
    257: (t, e, r) => {
      r.d(e, { Z: () => s });
      var n = r(81),
        i = r.n(n),
        o = r(645),
        a = r.n(o)()(i());
      a.push([
        t.id,
        ".swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translate3d(0,0,0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-pagination-disabled>.swiper-pagination,.swiper-pagination.swiper-pagination-disabled{display:none!important}.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:var(--swiper-pagination-bottom,8px);top:var(--swiper-pagination-top,auto);left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:var(--swiper-pagination-bullet-width,var(--swiper-pagination-bullet-size,8px));height:var(--swiper-pagination-bullet-height,var(--swiper-pagination-bullet-size,8px));display:inline-block;border-radius:var(--swiper-pagination-bullet-border-radius,50%);background:var(--swiper-pagination-bullet-inactive-color,#000);opacity:var(--swiper-pagination-bullet-inactive-opacity, .2)}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:var(--swiper-pagination-bullet-opacity, 1);background:var(--swiper-pagination-color,var(--swiper-theme-color))}.swiper-pagination-vertical.swiper-pagination-bullets,.swiper-vertical>.swiper-pagination-bullets{right:var(--swiper-pagination-right,8px);left:var(--swiper-pagination-left,auto);top:50%;transform:translate3d(0px,-50%,0)}.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:var(--swiper-pagination-bullet-vertical-gap,6px) 0;display:block}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 var(--swiper-pagination-bullet-horizontal-gap,4px)}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,:host(.swiper-horizontal.swiper-rtl) .swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-fraction{color:var(--swiper-pagination-fraction-color,inherit)}.swiper-pagination-progressbar{background:var(--swiper-pagination-progressbar-bg-color,rgba(0,0,0,.25));position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-horizontal>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-horizontal,.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite,.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:var(--swiper-pagination-progressbar-size,4px);left:0;top:0}.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-vertical,.swiper-vertical>.swiper-pagination-progressbar{width:var(--swiper-pagination-progressbar-size,4px);height:100%;left:0;top:0}.swiper-pagination-lock{display:none}",
        "",
      ]);
      const s = a;
    },
    814: (t, e, r) => {
      r.d(e, { Z: () => s });
      var n = r(81),
        i = r.n(n),
        o = r(645),
        a = r.n(o)()(i());
      a.push([
        t.id,
        ".swiper-scrollbar{border-radius:var(--swiper-scrollbar-border-radius,10px);position:relative;-ms-touch-action:none;background:var(--swiper-scrollbar-bg-color,rgba(0,0,0,.1))}.swiper-scrollbar-disabled>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-disabled{display:none!important}.swiper-horizontal>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-horizontal{position:absolute;left:var(--swiper-scrollbar-sides-offset,1%);bottom:var(--swiper-scrollbar-bottom,4px);top:var(--swiper-scrollbar-top,auto);z-index:50;height:var(--swiper-scrollbar-size,4px);width:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar.swiper-scrollbar-vertical,.swiper-vertical>.swiper-scrollbar{position:absolute;left:var(--swiper-scrollbar-left,auto);right:var(--swiper-scrollbar-right,4px);top:var(--swiper-scrollbar-sides-offset,1%);z-index:50;width:var(--swiper-scrollbar-size,4px);height:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:var(--swiper-scrollbar-drag-bg-color,rgba(0,0,0,.5));border-radius:var(--swiper-scrollbar-border-radius,10px);left:0;top:0}.swiper-scrollbar-cursor-drag{cursor:move}.swiper-scrollbar-lock{display:none}",
        "",
      ]);
      const s = a;
    },
    147: (t, e, r) => {
      r.d(e, { Z: () => f });
      var n = r(81),
        i = r.n(n),
        o = r(645),
        a = r.n(o),
        s = r(667),
        l = r.n(s),
        c = new URL(r(954), r.b),
        u = a()(i()),
        p = l()(c);
      u.push([
        t.id,
        "/**\n * Swiper 9.4.1\n * Most modern mobile touch slider and framework with hardware accelerated transitions\n * https://swiperjs.com\n *\n * Copyright 2014-2023 Vladimir Kharlampidi\n *\n * Released under the MIT License\n *\n * Released on: June 13, 2023\n */\n\n@font-face{font-family:swiper-icons;src:url(" +
        p +
        ");font-weight:400;font-style:normal}:root{--swiper-theme-color:#007aff}.swiper,swiper-container{margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1;display:block}.swiper-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;transition-timing-function:var(--swiper-wrapper-transition-timing-function,initial);box-sizing:content-box}.swiper-android .swiper-slide,.swiper-wrapper{transform:translate3d(0px,0,0)}.swiper-horizontal{touch-action:pan-y}.swiper-vertical{touch-action:pan-x}.swiper-slide,swiper-slide{flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform;display:block}.swiper-slide-invisible-blank{visibility:hidden}.swiper-autoheight,.swiper-autoheight .swiper-slide{height:auto}.swiper-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-backface-hidden .swiper-slide{transform:translateZ(0);-webkit-backface-visibility:hidden;backface-visibility:hidden;}.swiper-3d.swiper-css-mode .swiper-wrapper{perspective:1200px}.swiper-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-3d{perspective:1200px}.swiper-3d .swiper-cube-shadow,.swiper-3d .swiper-slide,.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top{transform-style:preserve-3d}.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}.swiper-3d .swiper-slide-shadow{background:rgba(0,0,0,.15)}.swiper-3d .swiper-slide-shadow-left{background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-right{background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-top{background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-bottom{background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-css-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:start start}.swiper-horizontal.swiper-css-mode>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-vertical.swiper-css-mode>.swiper-wrapper{scroll-snap-type:y mandatory}.swiper-css-mode.swiper-free-mode>.swiper-wrapper{scroll-snap-type:none}.swiper-css-mode.swiper-free-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:none}.swiper-centered>.swiper-wrapper::before{content:'';flex-shrink:0;order:9999}.swiper-centered>.swiper-wrapper>.swiper-slide{scroll-snap-align:center center;scroll-snap-stop:always}.swiper-centered.swiper-horizontal>.swiper-wrapper>.swiper-slide:first-child{margin-inline-start:var(--swiper-centered-offset-before)}.swiper-centered.swiper-horizontal>.swiper-wrapper::before{height:100%;min-height:1px;width:var(--swiper-centered-offset-after)}.swiper-centered.swiper-vertical>.swiper-wrapper>.swiper-slide:first-child{margin-block-start:var(--swiper-centered-offset-before)}.swiper-centered.swiper-vertical>.swiper-wrapper::before{width:100%;min-width:1px;height:var(--swiper-centered-offset-after)}.swiper-lazy-preloader{width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;box-sizing:border-box;border:4px solid var(--swiper-preloader-color,var(--swiper-theme-color));border-radius:50%;border-top-color:transparent}.swiper-watch-progress .swiper-slide-visible .swiper-lazy-preloader,.swiper:not(.swiper-watch-progress) .swiper-lazy-preloader,swiper-container:not(.swiper-watch-progress) .swiper-lazy-preloader{animation:swiper-preloader-spin 1s infinite linear}.swiper-lazy-preloader-white{--swiper-preloader-color:#fff}.swiper-lazy-preloader-black{--swiper-preloader-color:#000}@keyframes swiper-preloader-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}",
        "",
      ]);
      const f = u;
    },
    645: (t) => {
      t.exports = function (t) {
        var e = [];
        return (
          (e.toString = function () {
            return this.map(function (e) {
              var r = "",
                n = void 0 !== e[5];
              return (
                e[4] && (r += "@supports (".concat(e[4], ") {")),
                e[2] && (r += "@media ".concat(e[2], " {")),
                n && (r += "@layer".concat(e[5].length > 0 ? " ".concat(e[5]) : "", " {")),
                (r += t(e)),
                n && (r += "}"),
                e[2] && (r += "}"),
                e[4] && (r += "}"),
                r
              );
            }).join("");
          }),
          (e.i = function (t, r, n, i, o) {
            "string" == typeof t && (t = [[null, t, void 0]]);
            var a = {};
            if (n)
              for (var s = 0; s < this.length; s++) {
                var l = this[s][0];
                null != l && (a[l] = !0);
              }
            for (var c = 0; c < t.length; c++) {
              var u = [].concat(t[c]);
              (n && a[u[0]]) ||
                (void 0 !== o && (void 0 === u[5] || (u[1] = "@layer".concat(u[5].length > 0 ? " ".concat(u[5]) : "", " {").concat(u[1], "}")), (u[5] = o)),
                  r && (u[2] ? ((u[1] = "@media ".concat(u[2], " {").concat(u[1], "}")), (u[2] = r)) : (u[2] = r)),
                  i && (u[4] ? ((u[1] = "@supports (".concat(u[4], ") {").concat(u[1], "}")), (u[4] = i)) : (u[4] = "".concat(i))),
                  e.push(u));
            }
          }),
          e
        );
      };
    },
    667: (t) => {
      t.exports = function (t, e) {
        return (
          e || (e = {}),
          t
            ? ((t = String(t.__esModule ? t.default : t)),
              /^['"].*['"]$/.test(t) && (t = t.slice(1, -1)),
              e.hash && (t += e.hash),
              /["'() \t\n]|(%20)/.test(t) || e.needQuotes ? '"'.concat(t.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"') : t)
            : t
        );
      };
    },
    81: (t) => {
      t.exports = function (t) {
        return t[1];
      };
    },
    379: (t) => {
      var e = [];
      function r(t) {
        for (var r = -1, n = 0; n < e.length; n++)
          if (e[n].identifier === t) {
            r = n;
            break;
          }
        return r;
      }
      function n(t, n) {
        for (var o = {}, a = [], s = 0; s < t.length; s++) {
          var l = t[s],
            c = n.base ? l[0] + n.base : l[0],
            u = o[c] || 0,
            p = "".concat(c, " ").concat(u);
          o[c] = u + 1;
          var f = r(p),
            d = { css: l[1], media: l[2], sourceMap: l[3], supports: l[4], layer: l[5] };
          if (-1 !== f) e[f].references++, e[f].updater(d);
          else {
            var h = i(d, n);
            (n.byIndex = s), e.splice(s, 0, { identifier: p, updater: h, references: 1 });
          }
          a.push(p);
        }
        return a;
      }
      function i(t, e) {
        var r = e.domAPI(e);
        return (
          r.update(t),
          function (e) {
            if (e) {
              if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap && e.supports === t.supports && e.layer === t.layer) return;
              r.update((t = e));
            } else r.remove();
          }
        );
      }
      t.exports = function (t, i) {
        var o = n((t = t || []), (i = i || {}));
        return function (t) {
          t = t || [];
          for (var a = 0; a < o.length; a++) {
            var s = r(o[a]);
            e[s].references--;
          }
          for (var l = n(t, i), c = 0; c < o.length; c++) {
            var u = r(o[c]);
            0 === e[u].references && (e[u].updater(), e.splice(u, 1));
          }
          o = l;
        };
      };
    },
    569: (t) => {
      var e = {};
      t.exports = function (t, r) {
        var n = (function (t) {
          if (void 0 === e[t]) {
            var r = document.querySelector(t);
            if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement)
              try {
                r = r.contentDocument.head;
              } catch (t) {
                r = null;
              }
            e[t] = r;
          }
          return e[t];
        })(t);
        if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        n.appendChild(r);
      };
    },
    216: (t) => {
      t.exports = function (t) {
        var e = document.createElement("style");
        return t.setAttributes(e, t.attributes), t.insert(e, t.options), e;
      };
    },
    565: (t, e, r) => {
      t.exports = function (t) {
        var e = r.nc;
        e && t.setAttribute("nonce", e);
      };
    },
    795: (t) => {
      t.exports = function (t) {
        if ("undefined" == typeof document) return { update: function () { }, remove: function () { } };
        var e = t.insertStyleElement(t);
        return {
          update: function (r) {
            !(function (t, e, r) {
              var n = "";
              r.supports && (n += "@supports (".concat(r.supports, ") {")), r.media && (n += "@media ".concat(r.media, " {"));
              var i = void 0 !== r.layer;
              i && (n += "@layer".concat(r.layer.length > 0 ? " ".concat(r.layer) : "", " {")), (n += r.css), i && (n += "}"), r.media && (n += "}"), r.supports && (n += "}");
              var o = r.sourceMap;
              o && "undefined" != typeof btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(o)))), " */")), e.styleTagTransform(n, t, e.options);
            })(e, t, r);
          },
          remove: function () {
            !(function (t) {
              if (null === t.parentNode) return !1;
              t.parentNode.removeChild(t);
            })(e);
          },
        };
      };
    },
    589: (t) => {
      t.exports = function (t, e) {
        if (e.styleSheet) e.styleSheet.cssText = t;
        else {
          for (; e.firstChild;) e.removeChild(e.firstChild);
          e.appendChild(document.createTextNode(t));
        }
      };
    },
    954: (t) => {
      t.exports =
        "data:application/font-woff;charset=utf-8;base64, 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";
    },
  },
    e = {};
  function r(n) {
    var i = e[n];
    if (void 0 !== i) return i.exports;
    var o = (e[n] = { id: n, exports: {} });
    return t[n](o, o.exports, r), o.exports;
  }
  (r.m = t),
    (r.n = (t) => {
      var e = t && t.__esModule ? () => t.default : () => t;
      return r.d(e, { a: e }), e;
    }),
    (r.d = (t, e) => {
      for (var n in e) r.o(e, n) && !r.o(t, n) && Object.defineProperty(t, n, { enumerable: !0, get: e[n] });
    }),
    (r.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e)),
    (r.b = document.baseURI || self.location.href),
    (r.nc = void 0),
    (() => {
      function t(t) {
        return (
          (function (t) {
            if (Array.isArray(t)) return e(t);
          })(t) ||
          (function (t) {
            if (("undefined" != typeof Symbol && null != t[Symbol.iterator]) || null != t["@@iterator"]) return Array.from(t);
          })(t) ||
          (function (t, r) {
            if (t) {
              if ("string" == typeof t) return e(t, r);
              var n = Object.prototype.toString.call(t).slice(8, -1);
              return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? e(t, r) : void 0;
            }
          })(t) ||
          (function () {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          })()
        );
      }
      function e(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
        return n;
      }
      var n = {
        execute: function (t) {
          this instanceof Element || this instanceof HTMLDocument
            ? t(this)
            : this.forEach(function (e, r) {
              t(e, r);
            });
        },
        listen: function (t, e, r) {
          var i = this,
            o = function (t, r) {
              return function (n) {
                return e({ $node: t, index: r, e: n });
              };
            };


          this.execute(function (e, a) {
            var s = Object.assign(e, n);
            let lastTriggerElement = null;
            let activeDropdown = null;

            function addListener(eventType) {
              if (r) {
                document.addEventListener(eventType, function (t) {
                  const el = t.target.closest(i.selectedWith);
                  if (el) {
                    o(s, a)(t);
                  }
                });
              } else {
                s.addEventListener(eventType, function (t) {
                  return o(s, a)(t);
                });
              }
            }

            addListener(t);
          
            const targetClass = 'header__menu-item-acessible-dropdown';

            function trapFocus(modal) {
              const focusableSelectors = `
                a[href]:not([tabindex="-1"]),
                button:not([disabled]):not([tabindex="-1"]),
                textarea:not([disabled]):not([tabindex="-1"]),
                input[type="text"]:not([disabled]):not([tabindex="-1"]),
                input[type="radio"]:not([disabled]):not([tabindex="-1"]),
                input[type="checkbox"]:not([disabled]):not([tabindex="-1"]),
                select:not([disabled]):not([tabindex="-1"]),
                [tabindex]:not([tabindex="-1"])
              `;

              const focusableElements = Array.from(modal.querySelectorAll(focusableSelectors))
                .filter(el => el.offsetParent !== null); // só elementos visíveis

              if (focusableElements.length === 0) return;

              const first = focusableElements[0];
              const last = focusableElements[focusableElements.length - 1];

              function handleTrap(e) {
                if (e.key !== 'Tab') return;

                const active = document.activeElement;

                if (e.shiftKey) {
                  if (active === first || !modal.contains(active)) {
                    e.preventDefault();
                    last.focus();
                  }
                } else {
                  if (active === last || !modal.contains(active)) {
                    e.preventDefault();
                    first.focus();
                  }
                }
              }

              modal.addEventListener('keydown', handleTrap);
              modal._trapFocusHandler = handleTrap; // para remoção posterior, se necessário
            }

            function releaseFocusTrap(modal) {
              if (modal && modal._trapFocusHandler) {
                modal.removeEventListener('keydown', modal._trapFocusHandler);
                delete modal._trapFocusHandler;
              }
            }

            function openDropdown(el) {
              const parentId = el.getAttribute('data-parent-link');
              if (!parentId) return;

              const dropdown = document.querySelector(`[data-dropdown-menu="${parentId}"]`);
              if (!dropdown) return;

              dropdown.classList.add('open');

              const closeBtn = dropdown.querySelector('.c-header__closeNav');
              if (closeBtn) closeBtn.focus();

              trapFocus(dropdown);
              activeDropdown = dropdown;
              lastTriggerElement = el;

              if (closeBtn && !closeBtn.dataset.listenerAttached) {
                closeBtn.addEventListener('click', function () {
                  dropdown.classList.remove('open');
                  releaseFocusTrap(dropdown);
                  if (lastTriggerElement) lastTriggerElement.focus();
                });
                closeBtn.dataset.listenerAttached = 'true';
              }
            }

            const keydownHandler = function (t) {
              const el = r ? t.target.closest(`.${targetClass}`) : s;

              if (
                el &&
                el.classList.contains(targetClass) &&
                (t.key === 'Enter' || t.key === ' ')
              ) {
                t.preventDefault();
                o(Object.assign(el, n), a)(t);
                openDropdown(el);
              }
            };

            if (r) {
              document.addEventListener('keydown', keydownHandler);
            } else {
              if (s.classList.contains(targetClass)) {
                s.addEventListener('keydown', keydownHandler);
              }
            }
          });


        },
        modifyClass: function (t, e) {
          this.execute(function (r) {
            return r.classList[t](e);
          });
        },
        addClass: function (t) {
          this.execute(function (e) {
            return e.classList.add(t);
          });
        },
        removeClass: function (t) {
          this.execute(function (e) {
            return e.classList.remove(t);
          });
        },
        toggleClass: function (t) {
          this.execute(function (e) {
            return e.classList.toggle(t);
          });
        },
        hasClass: function (e) {
          return !!this.classList && t(this.classList).includes(e);
        },
      };
      function i(e) {
        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : document,
          i = "string" == typeof e && 0 !== e.indexOf("["),
          o = "string" == typeof e ? r.querySelectorAll(e) : e,
          a = t(o).map(function (t) {
            return Object.assign(t, n, { selectedWith: e });
          }),
          s = a && 1 === a.length ? a[0] : a,
          l = Object.assign(s, n);
        return i && console.warn("Improper selector value passed. Please use data attribute as selector."), l;
      }
      function o(t) {
        return (
          (o =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                return typeof t;
              }
              : function (t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
              }),
          o(t)
        );
      }
      function a(t, e) {
        if (e && ("object" === o(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return s(t);
      }
      function s(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }
      function l(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
          (l = function (t) {
            if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
            var r;
            if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== e) {
              if (e.has(t)) return e.get(t);
              e.set(t, n);
            }
            function n() {
              return c(t, arguments, f(this).constructor);
            }
            return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), p(n, t);
          }),
          l(t)
        );
      }
      function c(t, e, r) {
        return (
          (c = u()
            ? Reflect.construct.bind()
            : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && p(i, r.prototype), i;
            }),
          c.apply(null, arguments)
        );
      }
      function u() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { })), !0;
        } catch (t) {
          return !1;
        }
      }
      function p(t, e) {
        return (
          (p = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (t, e) {
              return (t.__proto__ = e), t;
            }),
          p(t, e)
        );
      }
      function f(t) {
        return (
          (f = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
          f(t)
        );
      }
      var d = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && p(t, e);
        })(l, t);
        var e,
          r,
          n,
          o =
            ((e = l),
              (r = u()),
              function () {
                var t,
                  n = f(e);
                if (r) {
                  var i = f(this).constructor;
                  t = Reflect.construct(n, arguments, i);
                } else t = n.apply(this, arguments);
                return a(this, t);
              });
        function l() {
          var t;
          return (
            (function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            })(this, l),
            ((t = o.call(this)).buttons = i("[data-button]", s(t))),
            t.buttons.listen("click", function (e) {
              var r = e.$node;
              t.buttons.modifyClass("remove", "active"), r.modifyClass("add", "active");
            }),
            t
          );
        }
        return (n = l), Object.defineProperty(n, "prototype", { writable: !1 }), n;
      })(l(HTMLElement));
      function h(t) {
        return (
          (h =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                return typeof t;
              }
              : function (t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
              }),
          h(t)
        );
      }
      function v(t, e) {
        return (
          (v = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (t, e) {
              return (t.__proto__ = e), t;
            }),
          v(t, e)
        );
      }
      function m(t, e) {
        if (e && ("object" === h(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return y(t);
      }
      function y(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }
      function g(t) {
        return (
          (g = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
          g(t)
        );
      }
      var b = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && v(t, e);
        })(a, t);
        var e,
          r,
          n,
          o =
            ((r = a),
              (n = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { })), !0;
                } catch (t) {
                  return !1;
                }
              })()),
              function () {
                var t,
                  e = g(r);
                if (n) {
                  var i = g(this).constructor;
                  t = Reflect.construct(e, arguments, i);
                } else t = e.apply(this, arguments);
                return m(this, t);
              });
        function a() {
          var t;
          return (
            (function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            })(this, a),
            ((t = o.call(this)).colors = i("[data-color]", y(t))),
            t.buttons.listen("click", function (e) {
              var r = e.index;
              t.colors.modifyClass("remove", "active"), t.colors[r].modifyClass("add", "active");
            }),
            t
          );
        }
        return (e = a), Object.defineProperty(e, "prototype", { writable: !1 }), e;
      })(d);
      function w(t) {
        return (
          (w =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                return typeof t;
              }
              : function (t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
              }),
          w(t)
        );
      }
      function _(t, e) {
        if (e && ("object" === w(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return x(t);
      }
      function x(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }
      function T(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
          (T = function (t) {
            if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
            var r;
            if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== e) {
              if (e.has(t)) return e.get(t);
              e.set(t, n);
            }
            function n() {
              return E(t, arguments, P(this).constructor);
            }
            return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), O(n, t);
          }),
          T(t)
        );
      }
      function E(t, e, r) {
        return (
          (E = S()
            ? Reflect.construct.bind()
            : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && O(i, r.prototype), i;
            }),
          E.apply(null, arguments)
        );
      }
      function S() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { })), !0;
        } catch (t) {
          return !1;
        }
      }
      function O(t, e) {
        return (
          (O = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (t, e) {
              return (t.__proto__ = e), t;
            }),
          O(t, e)
        );
      }
      function P(t) {
        return (
          (P = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
          P(t)
        );
      }
      var A = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && O(t, e);
        })(a, t);
        var e,
          r,
          n,
          o =
            ((e = a),
              (r = S()),
              function () {
                var t,
                  n = P(e);
                if (r) {
                  var i = P(this).constructor;
                  t = Reflect.construct(n, arguments, i);
                } else t = n.apply(this, arguments);
                return _(this, t);
              });
        function a() {
          var t;
          return (
            (function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            })(this, a),
            ((t = o.call(this)).buttons = i("[data-accordion-trigger]", x(t))),
            (t.accordion = i("[data-accordion]", x(t))),
            t.buttons.listen("click", function () {
              t.accordion.modifyClass("toggle", "c-accordion--open");
            }),
            t
          );
        }
        return (n = a), Object.defineProperty(n, "prototype", { writable: !1 }), n;
      })(T(HTMLElement));
      function C(t) {
        return null !== t && "object" == typeof t && "constructor" in t && t.constructor === Object;
      }
      function L(t = {}, e = {}) {
        Object.keys(e).forEach((r) => {
          void 0 === t[r] ? (t[r] = e[r]) : C(e[r]) && C(t[r]) && Object.keys(e[r]).length > 0 && L(t[r], e[r]);
        });
      }
      const k = {
        body: {},
        addEventListener() { },
        removeEventListener() { },
        activeElement: { blur() { }, nodeName: "" },
        querySelector: () => null,
        querySelectorAll: () => [],
        getElementById: () => null,
        createEvent: () => ({ initEvent() { } }),
        createElement: () => ({ children: [], childNodes: [], style: {}, setAttribute() { }, getElementsByTagName: () => [] }),
        createElementNS: () => ({}),
        importNode: () => null,
        location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
      };
      function M() {
        const t = "undefined" != typeof document ? document : {};
        return L(t, k), t;
      }
      const j = {
        document: k,
        navigator: { userAgent: "" },
        location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
        history: { replaceState() { }, pushState() { }, go() { }, back() { } },
        CustomEvent: function () {
          return this;
        },
        addEventListener() { },
        removeEventListener() { },
        getComputedStyle: () => ({ getPropertyValue: () => "" }),
        Image() { },
        Date() { },
        screen: {},
        setTimeout() { },
        clearTimeout() { },
        matchMedia: () => ({}),
        requestAnimationFrame: (t) => ("undefined" == typeof setTimeout ? (t(), null) : setTimeout(t, 0)),
        cancelAnimationFrame(t) {
          "undefined" != typeof setTimeout && clearTimeout(t);
        },
      };
      function R() {
        const t = "undefined" != typeof window ? window : {};
        return L(t, j), t;
      }
      function I(t, e = 0) {
        return setTimeout(t, e);
      }
      function z() {
        return Date.now();
      }
      function D(t) {
        return "object" == typeof t && null !== t && t.constructor && "Object" === Object.prototype.toString.call(t).slice(8, -1);
      }
      function B(...t) {
        const e = Object(t[0]),
          r = ["__proto__", "constructor", "prototype"];
        for (let i = 1; i < t.length; i += 1) {
          const o = t[i];
          if (null != o && ((n = o), !("undefined" != typeof window && void 0 !== window.HTMLElement ? n instanceof HTMLElement : n && (1 === n.nodeType || 11 === n.nodeType)))) {
            const t = Object.keys(Object(o)).filter((t) => r.indexOf(t) < 0);
            for (let r = 0, n = t.length; r < n; r += 1) {
              const n = t[r],
                i = Object.getOwnPropertyDescriptor(o, n);
              void 0 !== i && i.enumerable && (D(e[n]) && D(o[n]) ? (o[n].__swiper__ ? (e[n] = o[n]) : B(e[n], o[n])) : !D(e[n]) && D(o[n]) ? ((e[n] = {}), o[n].__swiper__ ? (e[n] = o[n]) : B(e[n], o[n])) : (e[n] = o[n]));
            }
          }
        }
        var n;
        return e;
      }
      function F(t, e, r) {
        t.style.setProperty(e, r);
      }
      function G({ swiper: t, targetPosition: e, side: r }) {
        const n = R(),
          i = -t.translate;
        let o,
          a = null;
        const s = t.params.speed;
        (t.wrapperEl.style.scrollSnapType = "none"), n.cancelAnimationFrame(t.cssModeFrameID);
        const l = e > i ? "next" : "prev",
          c = (t, e) => ("next" === l && t >= e) || ("prev" === l && t <= e),
          u = () => {
            (o = new Date().getTime()), null === a && (a = o);
            const l = Math.max(Math.min((o - a) / s, 1), 0),
              p = 0.5 - Math.cos(l * Math.PI) / 2;
            let f = i + p * (e - i);
            if ((c(f, e) && (f = e), t.wrapperEl.scrollTo({ [r]: f }), c(f, e)))
              return (
                (t.wrapperEl.style.overflow = "hidden"),
                (t.wrapperEl.style.scrollSnapType = ""),
                setTimeout(() => {
                  (t.wrapperEl.style.overflow = ""), t.wrapperEl.scrollTo({ [r]: f });
                }),
                void n.cancelAnimationFrame(t.cssModeFrameID)
              );
            t.cssModeFrameID = n.requestAnimationFrame(u);
          };
        u();
      }
      function N(t, e = "") {
        return [...t.children].filter((t) => t.matches(e));
      }
      function Y(t, e = []) {
        const r = document.createElement(t);
        return r.classList.add(...(Array.isArray(e) ? e : [e])), r;
      }
      function H(t, e) {
        return R().getComputedStyle(t, null).getPropertyValue(e);
      }
      function V(t) {
        let e,
          r = t;
        if (r) {
          for (e = 0; null !== (r = r.previousSibling);) 1 === r.nodeType && (e += 1);
          return e;
        }
      }
      function q(t, e) {
        const r = [];
        let n = t.parentElement;
        for (; n;) e ? n.matches(e) && r.push(n) : r.push(n), (n = n.parentElement);
        return r;
      }
      function $(t, e, r) {
        const n = R();
        return r
          ? t["width" === e ? "offsetWidth" : "offsetHeight"] +
          parseFloat(n.getComputedStyle(t, null).getPropertyValue("width" === e ? "margin-right" : "margin-top")) +
          parseFloat(n.getComputedStyle(t, null).getPropertyValue("width" === e ? "margin-left" : "margin-bottom"))
          : t.offsetWidth;
      }
      let X, W, U;
      function Z() {
        return (
          X ||
          (X = (function () {
            const t = R(),
              e = M();
            return { smoothScroll: e.documentElement && e.documentElement.style && "scrollBehavior" in e.documentElement.style, touch: !!("ontouchstart" in t || (t.DocumentTouch && e instanceof t.DocumentTouch)) };
          })()),
          X
        );
      }
      const Q = {
        on(t, e, r) {
          const n = this;
          if (!n.eventsListeners || n.destroyed) return n;
          if ("function" != typeof e) return n;
          const i = r ? "unshift" : "push";
          return (
            t.split(" ").forEach((t) => {
              n.eventsListeners[t] || (n.eventsListeners[t] = []), n.eventsListeners[t][i](e);
            }),
            n
          );
        },
        once(t, e, r) {
          const n = this;
          if (!n.eventsListeners || n.destroyed) return n;
          if ("function" != typeof e) return n;
          function i(...r) {
            n.off(t, i), i.__emitterProxy && delete i.__emitterProxy, e.apply(n, r);
          }
          return (i.__emitterProxy = e), n.on(t, i, r);
        },
        onAny(t, e) {
          const r = this;
          if (!r.eventsListeners || r.destroyed) return r;
          if ("function" != typeof t) return r;
          const n = e ? "unshift" : "push";
          return r.eventsAnyListeners.indexOf(t) < 0 && r.eventsAnyListeners[n](t), r;
        },
        offAny(t) {
          const e = this;
          if (!e.eventsListeners || e.destroyed) return e;
          if (!e.eventsAnyListeners) return e;
          const r = e.eventsAnyListeners.indexOf(t);
          return r >= 0 && e.eventsAnyListeners.splice(r, 1), e;
        },
        off(t, e) {
          const r = this;
          return !r.eventsListeners || r.destroyed
            ? r
            : r.eventsListeners
              ? (t.split(" ").forEach((t) => {
                void 0 === e
                  ? (r.eventsListeners[t] = [])
                  : r.eventsListeners[t] &&
                  r.eventsListeners[t].forEach((n, i) => {
                    (n === e || (n.__emitterProxy && n.__emitterProxy === e)) && r.eventsListeners[t].splice(i, 1);
                  });
              }),
                r)
              : r;
        },
        emit(...t) {
          const e = this;
          if (!e.eventsListeners || e.destroyed) return e;
          if (!e.eventsListeners) return e;
          let r, n, i;
          return (
            "string" == typeof t[0] || Array.isArray(t[0]) ? ((r = t[0]), (n = t.slice(1, t.length)), (i = e)) : ((r = t[0].events), (n = t[0].data), (i = t[0].context || e)),
            n.unshift(i),
            (Array.isArray(r) ? r : r.split(" ")).forEach((t) => {
              e.eventsAnyListeners &&
                e.eventsAnyListeners.length &&
                e.eventsAnyListeners.forEach((e) => {
                  e.apply(i, [t, ...n]);
                }),
                e.eventsListeners &&
                e.eventsListeners[t] &&
                e.eventsListeners[t].forEach((t) => {
                  t.apply(i, n);
                });
            }),
            e
          );
        },
      },
        K = (t, e) => {
          if (!t || t.destroyed || !t.params) return;
          const r = e.closest(t.isElement ? "swiper-slide" : `.${t.params.slideClass}`);
          if (r) {
            const e = r.querySelector(`.${t.params.lazyPreloaderClass}`);
            e && e.remove();
          }
        },
        J = (t, e) => {
          if (!t.slides[e]) return;
          const r = t.slides[e].querySelector('[loading="lazy"]');
          r && r.removeAttribute("loading");
        },
        tt = (t) => {
          if (!t || t.destroyed || !t.params) return;
          let e = t.params.lazyPreloadPrevNext;
          const r = t.slides.length;
          if (!r || !e || e < 0) return;
          e = Math.min(e, r);
          const n = "auto" === t.params.slidesPerView ? t.slidesPerViewDynamic() : Math.ceil(t.params.slidesPerView),
            i = t.activeIndex;
          if (t.params.grid && t.params.grid.rows > 1) {
            const r = i,
              o = [r - e];
            return (
              o.push(...Array.from({ length: e }).map((t, e) => r + n + e)),
              void t.slides.forEach((e, r) => {
                o.includes(e.column) && J(t, r);
              })
            );
          }
          const o = i + n - 1;
          if (t.params.rewind || t.params.loop)
            for (let n = i - e; n <= o + e; n += 1) {
              const e = ((n % r) + r) % r;
              (e < i || e > o) && J(t, e);
            }
          else for (let n = Math.max(i - e, 0); n <= Math.min(o + e, r - 1); n += 1) n !== i && (n > o || n < i) && J(t, n);
        },
        et = {
          updateSize: function () {
            const t = this;
            let e, r;
            const n = t.el;
            (e = void 0 !== t.params.width && null !== t.params.width ? t.params.width : n.clientWidth),
              (r = void 0 !== t.params.height && null !== t.params.height ? t.params.height : n.clientHeight),
              (0 === e && t.isHorizontal()) ||
              (0 === r && t.isVertical()) ||
              ((e = e - parseInt(H(n, "padding-left") || 0, 10) - parseInt(H(n, "padding-right") || 0, 10)),
                (r = r - parseInt(H(n, "padding-top") || 0, 10) - parseInt(H(n, "padding-bottom") || 0, 10)),
                Number.isNaN(e) && (e = 0),
                Number.isNaN(r) && (r = 0),
                Object.assign(t, { width: e, height: r, size: t.isHorizontal() ? e : r }));
          },
          updateSlides: function () {
            const t = this;
            function e(e) {
              return t.isHorizontal()
                ? e
                : {
                  width: "height",
                  "margin-top": "margin-left",
                  "margin-bottom ": "margin-right",
                  "margin-left": "margin-top",
                  "margin-right": "margin-bottom",
                  "padding-left": "padding-top",
                  "padding-right": "padding-bottom",
                  marginRight: "marginBottom",
                }[e];
            }
            function r(t, r) {
              return parseFloat(t.getPropertyValue(e(r)) || 0);
            }
            const n = t.params,
              { wrapperEl: i, slidesEl: o, size: a, rtlTranslate: s, wrongRTL: l } = t,
              c = t.virtual && n.virtual.enabled,
              u = c ? t.virtual.slides.length : t.slides.length,
              p = N(o, `.${t.params.slideClass}, swiper-slide`),
              f = c ? t.virtual.slides.length : p.length;
            let d = [];
            const h = [],
              v = [];
            let m = n.slidesOffsetBefore;
            "function" == typeof m && (m = n.slidesOffsetBefore.call(t));
            let y = n.slidesOffsetAfter;
            "function" == typeof y && (y = n.slidesOffsetAfter.call(t));
            const g = t.snapGrid.length,
              b = t.slidesGrid.length;
            let w = n.spaceBetween,
              _ = -m,
              x = 0,
              T = 0;
            if (void 0 === a) return;
            "string" == typeof w && w.indexOf("%") >= 0 ? (w = (parseFloat(w.replace("%", "")) / 100) * a) : "string" == typeof w && (w = parseFloat(w)),
              (t.virtualSize = -w),
              p.forEach((t) => {
                s ? (t.style.marginLeft = "") : (t.style.marginRight = ""), (t.style.marginBottom = ""), (t.style.marginTop = "");
              }),
              n.centeredSlides && n.cssMode && (F(i, "--swiper-centered-offset-before", ""), F(i, "--swiper-centered-offset-after", ""));
            const E = n.grid && n.grid.rows > 1 && t.grid;
            let S;
            E && t.grid.initSlides(f);
            const O = "auto" === n.slidesPerView && n.breakpoints && Object.keys(n.breakpoints).filter((t) => void 0 !== n.breakpoints[t].slidesPerView).length > 0;
            for (let i = 0; i < f; i += 1) {
              let o;
              if (((S = 0), p[i] && (o = p[i]), E && t.grid.updateSlide(i, o, f, e), !p[i] || "none" !== H(o, "display"))) {
                if ("auto" === n.slidesPerView) {
                  O && (p[i].style[e("width")] = "");
                  const a = getComputedStyle(o),
                    s = o.style.transform,
                    l = o.style.webkitTransform;
                  if ((s && (o.style.transform = "none"), l && (o.style.webkitTransform = "none"), n.roundLengths)) S = t.isHorizontal() ? $(o, "width", !0) : $(o, "height", !0);
                  else {
                    const t = r(a, "width"),
                      e = r(a, "padding-left"),
                      n = r(a, "padding-right"),
                      i = r(a, "margin-left"),
                      s = r(a, "margin-right"),
                      l = a.getPropertyValue("box-sizing");
                    if (l && "border-box" === l) S = t + i + s;
                    else {
                      const { clientWidth: r, offsetWidth: a } = o;
                      S = t + e + n + i + s + (a - r);
                    }
                  }
                  s && (o.style.transform = s), l && (o.style.webkitTransform = l), n.roundLengths && (S = Math.floor(S));
                } else (S = (a - (n.slidesPerView - 1) * w) / n.slidesPerView), n.roundLengths && (S = Math.floor(S)), p[i] && (p[i].style[e("width")] = `${S}px`);
                p[i] && (p[i].swiperSlideSize = S),
                  v.push(S),
                  n.centeredSlides
                    ? ((_ = _ + S / 2 + x / 2 + w),
                      0 === x && 0 !== i && (_ = _ - a / 2 - w),
                      0 === i && (_ = _ - a / 2 - w),
                      Math.abs(_) < 0.001 && (_ = 0),
                      n.roundLengths && (_ = Math.floor(_)),
                      T % n.slidesPerGroup == 0 && d.push(_),
                      h.push(_))
                    : (n.roundLengths && (_ = Math.floor(_)), (T - Math.min(t.params.slidesPerGroupSkip, T)) % t.params.slidesPerGroup == 0 && d.push(_), h.push(_), (_ = _ + S + w)),
                  (t.virtualSize += S + w),
                  (x = S),
                  (T += 1);
              }
            }
            if (
              ((t.virtualSize = Math.max(t.virtualSize, a) + y),
                s && l && ("slide" === n.effect || "coverflow" === n.effect) && (i.style.width = `${t.virtualSize + w}px`),
                n.setWrapperSize && (i.style[e("width")] = `${t.virtualSize + w}px`),
                E && t.grid.updateWrapperSize(S, d, e),
                !n.centeredSlides)
            ) {
              const e = [];
              for (let r = 0; r < d.length; r += 1) {
                let i = d[r];
                n.roundLengths && (i = Math.floor(i)), d[r] <= t.virtualSize - a && e.push(i);
              }
              (d = e), Math.floor(t.virtualSize - a) - Math.floor(d[d.length - 1]) > 1 && d.push(t.virtualSize - a);
            }
            if (c && n.loop) {
              const e = v[0] + w;
              if (n.slidesPerGroup > 1) {
                const r = Math.ceil((t.virtual.slidesBefore + t.virtual.slidesAfter) / n.slidesPerGroup),
                  i = e * n.slidesPerGroup;
                for (let t = 0; t < r; t += 1) d.push(d[d.length - 1] + i);
              }
              for (let r = 0; r < t.virtual.slidesBefore + t.virtual.slidesAfter; r += 1) 1 === n.slidesPerGroup && d.push(d[d.length - 1] + e), h.push(h[h.length - 1] + e), (t.virtualSize += e);
            }
            if ((0 === d.length && (d = [0]), 0 !== w)) {
              const r = t.isHorizontal() && s ? "marginLeft" : e("marginRight");
              p.filter((t, e) => !(n.cssMode && !n.loop) || e !== p.length - 1).forEach((t) => {
                t.style[r] = `${w}px`;
              });
            }
            if (n.centeredSlides && n.centeredSlidesBounds) {
              let t = 0;
              v.forEach((e) => {
                t += e + (w || 0);
              }),
                (t -= w);
              const e = t - a;
              d = d.map((t) => (t <= 0 ? -m : t > e ? e + y : t));
            }
            if (n.centerInsufficientSlides) {
              let t = 0;
              if (
                (v.forEach((e) => {
                  t += e + (w || 0);
                }),
                  (t -= w),
                  t < a)
              ) {
                const e = (a - t) / 2;
                d.forEach((t, r) => {
                  d[r] = t - e;
                }),
                  h.forEach((t, r) => {
                    h[r] = t + e;
                  });
              }
            }
            if ((Object.assign(t, { slides: p, snapGrid: d, slidesGrid: h, slidesSizesGrid: v }), n.centeredSlides && n.cssMode && !n.centeredSlidesBounds)) {
              F(i, "--swiper-centered-offset-before", -d[0] + "px"), F(i, "--swiper-centered-offset-after", t.size / 2 - v[v.length - 1] / 2 + "px");
              const e = -t.snapGrid[0],
                r = -t.slidesGrid[0];
              (t.snapGrid = t.snapGrid.map((t) => t + e)), (t.slidesGrid = t.slidesGrid.map((t) => t + r));
            }
            if (
              (f !== u && t.emit("slidesLengthChange"),
                d.length !== g && (t.params.watchOverflow && t.checkOverflow(), t.emit("snapGridLengthChange")),
                h.length !== b && t.emit("slidesGridLengthChange"),
                n.watchSlidesProgress && t.updateSlidesOffset(),
                !(c || n.cssMode || ("slide" !== n.effect && "fade" !== n.effect)))
            ) {
              const e = `${n.containerModifierClass}backface-hidden`,
                r = t.el.classList.contains(e);
              f <= n.maxBackfaceHiddenSlides ? r || t.el.classList.add(e) : r && t.el.classList.remove(e);
            }
          },
          updateAutoHeight: function (t) {
            const e = this,
              r = [],
              n = e.virtual && e.params.virtual.enabled;
            let i,
              o = 0;
            "number" == typeof t ? e.setTransition(t) : !0 === t && e.setTransition(e.params.speed);
            const a = (t) => (n ? e.slides[e.getSlideIndexByData(t)] : e.slides[t]);
            if ("auto" !== e.params.slidesPerView && e.params.slidesPerView > 1)
              if (e.params.centeredSlides)
                (e.visibleSlides || []).forEach((t) => {
                  r.push(t);
                });
              else
                for (i = 0; i < Math.ceil(e.params.slidesPerView); i += 1) {
                  const t = e.activeIndex + i;
                  if (t > e.slides.length && !n) break;
                  r.push(a(t));
                }
            else r.push(a(e.activeIndex));
            for (i = 0; i < r.length; i += 1)
              if (void 0 !== r[i]) {
                const t = r[i].offsetHeight;
                o = t > o ? t : o;
              }
            (o || 0 === o) && (e.wrapperEl.style.height = `${o}px`);
          },
          updateSlidesOffset: function () {
            const t = this,
              e = t.slides,
              r = t.isElement ? (t.isHorizontal() ? t.wrapperEl.offsetLeft : t.wrapperEl.offsetTop) : 0;
            for (let n = 0; n < e.length; n += 1) e[n].swiperSlideOffset = (t.isHorizontal() ? e[n].offsetLeft : e[n].offsetTop) - r - t.cssOverflowAdjustment();
          },
          updateSlidesProgress: function (t = (this && this.translate) || 0) {
            const e = this,
              r = e.params,
              { slides: n, rtlTranslate: i, snapGrid: o } = e;
            if (0 === n.length) return;
            void 0 === n[0].swiperSlideOffset && e.updateSlidesOffset();
            let a = -t;
            i && (a = t),
              n.forEach((t) => {
                t.classList.remove(r.slideVisibleClass);
              }),
              (e.visibleSlidesIndexes = []),
              (e.visibleSlides = []);
            let s = r.spaceBetween;
            "string" == typeof s && s.indexOf("%") >= 0 ? (s = (parseFloat(s.replace("%", "")) / 100) * e.size) : "string" == typeof s && (s = parseFloat(s));
            for (let t = 0; t < n.length; t += 1) {
              const l = n[t];
              let c = l.swiperSlideOffset;
              r.cssMode && r.centeredSlides && (c -= n[0].swiperSlideOffset);
              const u = (a + (r.centeredSlides ? e.minTranslate() : 0) - c) / (l.swiperSlideSize + s),
                p = (a - o[0] + (r.centeredSlides ? e.minTranslate() : 0) - c) / (l.swiperSlideSize + s),
                f = -(a - c),
                d = f + e.slidesSizesGrid[t];
              ((f >= 0 && f < e.size - 1) || (d > 1 && d <= e.size) || (f <= 0 && d >= e.size)) && (e.visibleSlides.push(l), e.visibleSlidesIndexes.push(t), n[t].classList.add(r.slideVisibleClass)),
                (l.progress = i ? -u : u),
                (l.originalProgress = i ? -p : p);
            }
          },
          updateProgress: function (t) {
            const e = this;
            if (void 0 === t) {
              const r = e.rtlTranslate ? -1 : 1;
              t = (e && e.translate && e.translate * r) || 0;
            }
            const r = e.params,
              n = e.maxTranslate() - e.minTranslate();
            let { progress: i, isBeginning: o, isEnd: a, progressLoop: s } = e;
            const l = o,
              c = a;
            if (0 === n) (i = 0), (o = !0), (a = !0);
            else {
              i = (t - e.minTranslate()) / n;
              const r = Math.abs(t - e.minTranslate()) < 1,
                s = Math.abs(t - e.maxTranslate()) < 1;
              (o = r || i <= 0), (a = s || i >= 1), r && (i = 0), s && (i = 1);
            }
            if (r.loop) {
              const r = e.getSlideIndexByData(0),
                n = e.getSlideIndexByData(e.slides.length - 1),
                i = e.slidesGrid[r],
                o = e.slidesGrid[n],
                a = e.slidesGrid[e.slidesGrid.length - 1],
                l = Math.abs(t);
              (s = l >= i ? (l - i) / a : (l + a - o) / a), s > 1 && (s -= 1);
            }
            Object.assign(e, { progress: i, progressLoop: s, isBeginning: o, isEnd: a }),
              (r.watchSlidesProgress || (r.centeredSlides && r.autoHeight)) && e.updateSlidesProgress(t),
              o && !l && e.emit("reachBeginning toEdge"),
              a && !c && e.emit("reachEnd toEdge"),
              ((l && !o) || (c && !a)) && e.emit("fromEdge"),
              e.emit("progress", i);
          },
          updateSlidesClasses: function () {
            const t = this,
              { slides: e, params: r, slidesEl: n, activeIndex: i } = t,
              o = t.virtual && r.virtual.enabled,
              a = (t) => N(n, `.${r.slideClass}${t}, swiper-slide${t}`)[0];
            let s;
            if (
              (e.forEach((t) => {
                t.classList.remove(r.slideActiveClass, r.slideNextClass, r.slidePrevClass);
              }),
                o)
            )
              if (r.loop) {
                let e = i - t.virtual.slidesBefore;
                e < 0 && (e = t.virtual.slides.length + e), e >= t.virtual.slides.length && (e -= t.virtual.slides.length), (s = a(`[data-swiper-slide-index="${e}"]`));
              } else s = a(`[data-swiper-slide-index="${i}"]`);
            else s = e[i];
            if (s) {
              s.classList.add(r.slideActiveClass);
              let t = (function (t, e) {
                const r = [];
                for (; t.nextElementSibling;) {
                  const n = t.nextElementSibling;
                  e ? n.matches(e) && r.push(n) : r.push(n), (t = n);
                }
                return r;
              })(s, `.${r.slideClass}, swiper-slide`)[0];
              r.loop && !t && (t = e[0]), t && t.classList.add(r.slideNextClass);
              let n = (function (t, e) {
                const r = [];
                for (; t.previousElementSibling;) {
                  const n = t.previousElementSibling;
                  e ? n.matches(e) && r.push(n) : r.push(n), (t = n);
                }
                return r;
              })(s, `.${r.slideClass}, swiper-slide`)[0];
              r.loop && 0 === !n && (n = e[e.length - 1]), n && n.classList.add(r.slidePrevClass);
            }
            t.emitSlidesClasses();
          },
          updateActiveIndex: function (t) {
            const e = this,
              r = e.rtlTranslate ? e.translate : -e.translate,
              { snapGrid: n, params: i, activeIndex: o, realIndex: a, snapIndex: s } = e;
            let l,
              c = t;
            const u = (t) => {
              let r = t - e.virtual.slidesBefore;
              return r < 0 && (r = e.virtual.slides.length + r), r >= e.virtual.slides.length && (r -= e.virtual.slides.length), r;
            };
            if (
              (void 0 === c &&
                (c = (function (t) {
                  const { slidesGrid: e, params: r } = t,
                    n = t.rtlTranslate ? t.translate : -t.translate;
                  let i;
                  for (let t = 0; t < e.length; t += 1) void 0 !== e[t + 1] ? (n >= e[t] && n < e[t + 1] - (e[t + 1] - e[t]) / 2 ? (i = t) : n >= e[t] && n < e[t + 1] && (i = t + 1)) : n >= e[t] && (i = t);
                  return r.normalizeSlideIndex && (i < 0 || void 0 === i) && (i = 0), i;
                })(e)),
                n.indexOf(r) >= 0)
            )
              l = n.indexOf(r);
            else {
              const t = Math.min(i.slidesPerGroupSkip, c);
              l = t + Math.floor((c - t) / i.slidesPerGroup);
            }
            if ((l >= n.length && (l = n.length - 1), c === o)) return l !== s && ((e.snapIndex = l), e.emit("snapIndexChange")), void (e.params.loop && e.virtual && e.params.virtual.enabled && (e.realIndex = u(c)));
            let p;
            (p = e.virtual && i.virtual.enabled && i.loop ? u(c) : e.slides[c] ? parseInt(e.slides[c].getAttribute("data-swiper-slide-index") || c, 10) : c),
              Object.assign(e, { previousSnapIndex: s, snapIndex: l, previousRealIndex: a, realIndex: p, previousIndex: o, activeIndex: c }),
              e.initialized && tt(e),
              e.emit("activeIndexChange"),
              e.emit("snapIndexChange"),
              a !== p && e.emit("realIndexChange"),
              (e.initialized || e.params.runCallbacksOnInit) && e.emit("slideChange");
          },
          updateClickedSlide: function (t) {
            const e = this,
              r = e.params,
              n = t.closest(`.${r.slideClass}, swiper-slide`);
            let i,
              o = !1;
            if (n)
              for (let t = 0; t < e.slides.length; t += 1)
                if (e.slides[t] === n) {
                  (o = !0), (i = t);
                  break;
                }
            if (!n || !o) return (e.clickedSlide = void 0), void (e.clickedIndex = void 0);
            (e.clickedSlide = n),
              e.virtual && e.params.virtual.enabled ? (e.clickedIndex = parseInt(n.getAttribute("data-swiper-slide-index"), 10)) : (e.clickedIndex = i),
              r.slideToClickedSlide && void 0 !== e.clickedIndex && e.clickedIndex !== e.activeIndex && e.slideToClickedSlide();
          },
        };
      function rt({ swiper: t, runCallbacks: e, direction: r, step: n }) {
        const { activeIndex: i, previousIndex: o } = t;
        let a = r;
        if ((a || (a = i > o ? "next" : i < o ? "prev" : "reset"), t.emit(`transition${n}`), e && i !== o)) {
          if ("reset" === a) return void t.emit(`slideResetTransition${n}`);
          t.emit(`slideChangeTransition${n}`), "next" === a ? t.emit(`slideNextTransition${n}`) : t.emit(`slidePrevTransition${n}`);
        }
      }
      const nt = {
        slideTo: function (t = 0, e = this.params.speed, r = !0, n, i) {
          "string" == typeof t && (t = parseInt(t, 10));
          const o = this;
          let a = t;
          a < 0 && (a = 0);
          const { params: s, snapGrid: l, slidesGrid: c, previousIndex: u, activeIndex: p, rtlTranslate: f, wrapperEl: d, enabled: h } = o;
          if ((o.animating && s.preventInteractionOnTransition) || (!h && !n && !i)) return !1;
          const v = Math.min(o.params.slidesPerGroupSkip, a);
          let m = v + Math.floor((a - v) / o.params.slidesPerGroup);
          m >= l.length && (m = l.length - 1);
          const y = -l[m];
          if (s.normalizeSlideIndex)
            for (let t = 0; t < c.length; t += 1) {
              const e = -Math.floor(100 * y),
                r = Math.floor(100 * c[t]),
                n = Math.floor(100 * c[t + 1]);
              void 0 !== c[t + 1] ? (e >= r && e < n - (n - r) / 2 ? (a = t) : e >= r && e < n && (a = t + 1)) : e >= r && (a = t);
            }
          if (o.initialized && a !== p) {
            if (!o.allowSlideNext && (f ? y > o.translate && y > o.minTranslate() : y < o.translate && y < o.minTranslate())) return !1;
            if (!o.allowSlidePrev && y > o.translate && y > o.maxTranslate() && (p || 0) !== a) return !1;
          }
          let g;
          if ((a !== (u || 0) && r && o.emit("beforeSlideChangeStart"), o.updateProgress(y), (g = a > p ? "next" : a < p ? "prev" : "reset"), (f && -y === o.translate) || (!f && y === o.translate)))
            return o.updateActiveIndex(a), s.autoHeight && o.updateAutoHeight(), o.updateSlidesClasses(), "slide" !== s.effect && o.setTranslate(y), "reset" !== g && (o.transitionStart(r, g), o.transitionEnd(r, g)), !1;
          if (s.cssMode) {
            const t = o.isHorizontal(),
              r = f ? y : -y;
            if (0 === e) {
              const e = o.virtual && o.params.virtual.enabled;
              e && ((o.wrapperEl.style.scrollSnapType = "none"), (o._immediateVirtual = !0)),
                e && !o._cssModeVirtualInitialSet && o.params.initialSlide > 0
                  ? ((o._cssModeVirtualInitialSet = !0),
                    requestAnimationFrame(() => {
                      d[t ? "scrollLeft" : "scrollTop"] = r;
                    }))
                  : (d[t ? "scrollLeft" : "scrollTop"] = r),
                e &&
                requestAnimationFrame(() => {
                  (o.wrapperEl.style.scrollSnapType = ""), (o._immediateVirtual = !1);
                });
            } else {
              if (!o.support.smoothScroll) return G({ swiper: o, targetPosition: r, side: t ? "left" : "top" }), !0;
              d.scrollTo({ [t ? "left" : "top"]: r, behavior: "smooth" });
            }
            return !0;
          }
          return (
            o.setTransition(e),
            o.setTranslate(y),
            o.updateActiveIndex(a),
            o.updateSlidesClasses(),
            o.emit("beforeTransitionStart", e, n),
            o.transitionStart(r, g),
            0 === e
              ? o.transitionEnd(r, g)
              : o.animating ||
              ((o.animating = !0),
                o.onSlideToWrapperTransitionEnd ||
                (o.onSlideToWrapperTransitionEnd = function (t) {
                  o &&
                    !o.destroyed &&
                    t.target === this &&
                    (o.wrapperEl.removeEventListener("transitionend", o.onSlideToWrapperTransitionEnd), (o.onSlideToWrapperTransitionEnd = null), delete o.onSlideToWrapperTransitionEnd, o.transitionEnd(r, g));
                }),
                o.wrapperEl.addEventListener("transitionend", o.onSlideToWrapperTransitionEnd)),
            !0
          );
        },
        slideToLoop: function (t = 0, e = this.params.speed, r = !0, n) {
          "string" == typeof t && (t = parseInt(t, 10));
          const i = this;
          let o = t;
          return i.params.loop && (i.virtual && i.params.virtual.enabled ? (o += i.virtual.slidesBefore) : (o = i.getSlideIndexByData(o))), i.slideTo(o, e, r, n);
        },
        slideNext: function (t = this.params.speed, e = !0, r) {
          const n = this,
            { enabled: i, params: o, animating: a } = n;
          if (!i) return n;
          let s = o.slidesPerGroup;
          "auto" === o.slidesPerView && 1 === o.slidesPerGroup && o.slidesPerGroupAuto && (s = Math.max(n.slidesPerViewDynamic("current", !0), 1));
          const l = n.activeIndex < o.slidesPerGroupSkip ? 1 : s,
            c = n.virtual && o.virtual.enabled;
          if (o.loop) {
            if (a && !c && o.loopPreventsSliding) return !1;
            n.loopFix({ direction: "next" }), (n._clientLeft = n.wrapperEl.clientLeft);
          }
          return o.rewind && n.isEnd ? n.slideTo(0, t, e, r) : n.slideTo(n.activeIndex + l, t, e, r);
        },
        slidePrev: function (t = this.params.speed, e = !0, r) {
          const n = this,
            { params: i, snapGrid: o, slidesGrid: a, rtlTranslate: s, enabled: l, animating: c } = n;
          if (!l) return n;
          const u = n.virtual && i.virtual.enabled;
          if (i.loop) {
            if (c && !u && i.loopPreventsSliding) return !1;
            n.loopFix({ direction: "prev" }), (n._clientLeft = n.wrapperEl.clientLeft);
          }
          function p(t) {
            return t < 0 ? -Math.floor(Math.abs(t)) : Math.floor(t);
          }
          const f = p(s ? n.translate : -n.translate),
            d = o.map((t) => p(t));
          let h = o[d.indexOf(f) - 1];
          if (void 0 === h && i.cssMode) {
            let t;
            o.forEach((e, r) => {
              f >= e && (t = r);
            }),
              void 0 !== t && (h = o[t > 0 ? t - 1 : t]);
          }
          let v = 0;
          if (
            (void 0 !== h &&
              ((v = a.indexOf(h)),
                v < 0 && (v = n.activeIndex - 1),
                "auto" === i.slidesPerView && 1 === i.slidesPerGroup && i.slidesPerGroupAuto && ((v = v - n.slidesPerViewDynamic("previous", !0) + 1), (v = Math.max(v, 0)))),
              i.rewind && n.isBeginning)
          ) {
            const i = n.params.virtual && n.params.virtual.enabled && n.virtual ? n.virtual.slides.length - 1 : n.slides.length - 1;
            return n.slideTo(i, t, e, r);
          }
          return n.slideTo(v, t, e, r);
        },
        slideReset: function (t = this.params.speed, e = !0, r) {
          return this.slideTo(this.activeIndex, t, e, r);
        },
        slideToClosest: function (t = this.params.speed, e = !0, r, n = 0.5) {
          const i = this;
          let o = i.activeIndex;
          const a = Math.min(i.params.slidesPerGroupSkip, o),
            s = a + Math.floor((o - a) / i.params.slidesPerGroup),
            l = i.rtlTranslate ? i.translate : -i.translate;
          if (l >= i.snapGrid[s]) {
            const t = i.snapGrid[s];
            l - t > (i.snapGrid[s + 1] - t) * n && (o += i.params.slidesPerGroup);
          } else {
            const t = i.snapGrid[s - 1];
            l - t <= (i.snapGrid[s] - t) * n && (o -= i.params.slidesPerGroup);
          }
          return (o = Math.max(o, 0)), (o = Math.min(o, i.slidesGrid.length - 1)), i.slideTo(o, t, e, r);
        },
        slideToClickedSlide: function () {
          const t = this,
            { params: e, slidesEl: r } = t,
            n = "auto" === e.slidesPerView ? t.slidesPerViewDynamic() : e.slidesPerView;
          let i,
            o = t.clickedIndex;
          const a = t.isElement ? "swiper-slide" : `.${e.slideClass}`;
          if (e.loop) {
            if (t.animating) return;
            (i = parseInt(t.clickedSlide.getAttribute("data-swiper-slide-index"), 10)),
              e.centeredSlides
                ? o < t.loopedSlides - n / 2 || o > t.slides.length - t.loopedSlides + n / 2
                  ? (t.loopFix(),
                    (o = t.getSlideIndex(N(r, `${a}[data-swiper-slide-index="${i}"]`)[0])),
                    I(() => {
                      t.slideTo(o);
                    }))
                  : t.slideTo(o)
                : o > t.slides.length - n
                  ? (t.loopFix(),
                    (o = t.getSlideIndex(N(r, `${a}[data-swiper-slide-index="${i}"]`)[0])),
                    I(() => {
                      t.slideTo(o);
                    }))
                  : t.slideTo(o);
          } else t.slideTo(o);
        },
      },
        it = {
          loopCreate: function (t) {
            const e = this,
              { params: r, slidesEl: n } = e;
            !r.loop ||
              (e.virtual && e.params.virtual.enabled) ||
              (N(n, `.${r.slideClass}, swiper-slide`).forEach((t, e) => {
                t.setAttribute("data-swiper-slide-index", e);
              }),
                e.loopFix({ slideRealIndex: t, direction: r.centeredSlides ? void 0 : "next" }));
          },
          loopFix: function ({ slideRealIndex: t, slideTo: e = !0, direction: r, setTranslate: n, activeSlideIndex: i, byController: o, byMousewheel: a } = {}) {
            const s = this;
            if (!s.params.loop) return;
            s.emit("beforeLoopFix");
            const { slides: l, allowSlidePrev: c, allowSlideNext: u, slidesEl: p, params: f } = s;
            if (((s.allowSlidePrev = !0), (s.allowSlideNext = !0), s.virtual && f.virtual.enabled))
              return (
                e &&
                (f.centeredSlides || 0 !== s.snapIndex
                  ? f.centeredSlides && s.snapIndex < f.slidesPerView
                    ? s.slideTo(s.virtual.slides.length + s.snapIndex, 0, !1, !0)
                    : s.snapIndex === s.snapGrid.length - 1 && s.slideTo(s.virtual.slidesBefore, 0, !1, !0)
                  : s.slideTo(s.virtual.slides.length, 0, !1, !0)),
                (s.allowSlidePrev = c),
                (s.allowSlideNext = u),
                void s.emit("loopFix")
              );
            const d = "auto" === f.slidesPerView ? s.slidesPerViewDynamic() : Math.ceil(parseFloat(f.slidesPerView, 10));
            let h = f.loopedSlides || d;
            h % f.slidesPerGroup != 0 && (h += f.slidesPerGroup - (h % f.slidesPerGroup)), (s.loopedSlides = h);
            const v = [],
              m = [];
            let y = s.activeIndex;
            void 0 === i ? (i = s.getSlideIndex(s.slides.filter((t) => t.classList.contains(f.slideActiveClass))[0])) : (y = i);
            const g = "next" === r || !r,
              b = "prev" === r || !r;
            let w = 0,
              _ = 0;
            if (i < h) {
              w = Math.max(h - i, f.slidesPerGroup);
              for (let t = 0; t < h - i; t += 1) {
                const e = t - Math.floor(t / l.length) * l.length;
                v.push(l.length - e - 1);
              }
            } else if (i > s.slides.length - 2 * h) {
              _ = Math.max(i - (s.slides.length - 2 * h), f.slidesPerGroup);
              for (let t = 0; t < _; t += 1) {
                const e = t - Math.floor(t / l.length) * l.length;
                m.push(e);
              }
            }
            if (
              (b &&
                v.forEach((t) => {
                  (s.slides[t].swiperLoopMoveDOM = !0), p.prepend(s.slides[t]), (s.slides[t].swiperLoopMoveDOM = !1);
                }),
                g &&
                m.forEach((t) => {
                  (s.slides[t].swiperLoopMoveDOM = !0), p.append(s.slides[t]), (s.slides[t].swiperLoopMoveDOM = !1);
                }),
                s.recalcSlides(),
                "auto" === f.slidesPerView && s.updateSlides(),
                f.watchSlidesProgress && s.updateSlidesOffset(),
                e)
            )
              if (v.length > 0 && b)
                if (void 0 === t) {
                  const t = s.slidesGrid[y],
                    e = s.slidesGrid[y + w] - t;
                  a ? s.setTranslate(s.translate - e) : (s.slideTo(y + w, 0, !1, !0), n && (s.touches[s.isHorizontal() ? "startX" : "startY"] += e));
                } else n && s.slideToLoop(t, 0, !1, !0);
              else if (m.length > 0 && g)
                if (void 0 === t) {
                  const t = s.slidesGrid[y],
                    e = s.slidesGrid[y - _] - t;
                  a ? s.setTranslate(s.translate - e) : (s.slideTo(y - _, 0, !1, !0), n && (s.touches[s.isHorizontal() ? "startX" : "startY"] += e));
                } else s.slideToLoop(t, 0, !1, !0);
            if (((s.allowSlidePrev = c), (s.allowSlideNext = u), s.controller && s.controller.control && !o)) {
              const e = { slideRealIndex: t, slideTo: !1, direction: r, setTranslate: n, activeSlideIndex: i, byController: !0 };
              Array.isArray(s.controller.control)
                ? s.controller.control.forEach((t) => {
                  !t.destroyed && t.params.loop && t.loopFix(e);
                })
                : s.controller.control instanceof s.constructor && s.controller.control.params.loop && s.controller.control.loopFix(e);
            }
            s.emit("loopFix");
          },
          loopDestroy: function () {
            const t = this,
              { params: e, slidesEl: r } = t;
            if (!e.loop || (t.virtual && t.params.virtual.enabled)) return;
            t.recalcSlides();
            const n = [];
            t.slides.forEach((t) => {
              const e = void 0 === t.swiperSlideIndex ? 1 * t.getAttribute("data-swiper-slide-index") : t.swiperSlideIndex;
              n[e] = t;
            }),
              t.slides.forEach((t) => {
                t.removeAttribute("data-swiper-slide-index");
              }),
              n.forEach((t) => {
                r.append(t);
              }),
              t.recalcSlides(),
              t.slideTo(t.realIndex, 0);
          },
        };
      function ot(t) {
        const e = this,
          r = M(),
          n = R(),
          i = e.touchEventsData;
        i.evCache.push(t);
        const { params: o, touches: a, enabled: s } = e;
        if (!s) return;
        if (!o.simulateTouch && "mouse" === t.pointerType) return;
        if (e.animating && o.preventInteractionOnTransition) return;
        !e.animating && o.cssMode && o.loop && e.loopFix();
        let l = t;
        l.originalEvent && (l = l.originalEvent);
        let c = l.target;
        if ("wrapper" === o.touchEventsTarget && !e.wrapperEl.contains(c)) return;
        if ("which" in l && 3 === l.which) return;
        if ("button" in l && l.button > 0) return;
        if (i.isTouched && i.isMoved) return;
        const u = !!o.noSwipingClass && "" !== o.noSwipingClass,
          p = t.composedPath ? t.composedPath() : t.path;
        u && l.target && l.target.shadowRoot && p && (c = p[0]);
        const f = o.noSwipingSelector ? o.noSwipingSelector : `.${o.noSwipingClass}`,
          d = !(!l.target || !l.target.shadowRoot);
        if (
          o.noSwiping &&
          (d
            ? (function (t, e = this) {
              return (function e(r) {
                if (!r || r === M() || r === R()) return null;
                r.assignedSlot && (r = r.assignedSlot);
                const n = r.closest(t);
                return n || r.getRootNode ? n || e(r.getRootNode().host) : null;
              })(e);
            })(f, c)
            : c.closest(f))
        )
          return void (e.allowClick = !0);
        if (o.swipeHandler && !c.closest(o.swipeHandler)) return;
        (a.currentX = l.pageX), (a.currentY = l.pageY);
        const h = a.currentX,
          v = a.currentY,
          m = o.edgeSwipeDetection || o.iOSEdgeSwipeDetection,
          y = o.edgeSwipeThreshold || o.iOSEdgeSwipeThreshold;
        if (m && (h <= y || h >= n.innerWidth - y)) {
          if ("prevent" !== m) return;
          t.preventDefault();
        }
        Object.assign(i, { isTouched: !0, isMoved: !1, allowTouchCallbacks: !0, isScrolling: void 0, startMoving: void 0 }),
          (a.startX = h),
          (a.startY = v),
          (i.touchStartTime = z()),
          (e.allowClick = !0),
          e.updateSize(),
          (e.swipeDirection = void 0),
          o.threshold > 0 && (i.allowThresholdMove = !1);
        let g = !0;
        c.matches(i.focusableElements) && ((g = !1), "SELECT" === c.nodeName && (i.isTouched = !1)), r.activeElement && r.activeElement.matches(i.focusableElements) && r.activeElement !== c && r.activeElement.blur();
        const b = g && e.allowTouchMove && o.touchStartPreventDefault;
        (!o.touchStartForcePreventDefault && !b) || c.isContentEditable || l.preventDefault(), o.freeMode && o.freeMode.enabled && e.freeMode && e.animating && !o.cssMode && e.freeMode.onTouchStart(), e.emit("touchStart", l);
      }
      function at(t) {
        const e = M(),
          r = this,
          n = r.touchEventsData,
          { params: i, touches: o, rtlTranslate: a, enabled: s } = r;
        if (!s) return;
        if (!i.simulateTouch && "mouse" === t.pointerType) return;
        let l = t;
        if ((l.originalEvent && (l = l.originalEvent), !n.isTouched)) return void (n.startMoving && n.isScrolling && r.emit("touchMoveOpposite", l));
        const c = n.evCache.findIndex((t) => t.pointerId === l.pointerId);
        c >= 0 && (n.evCache[c] = l);
        const u = n.evCache.length > 1 ? n.evCache[0] : l,
          p = u.pageX,
          f = u.pageY;
        if (l.preventedByNestedSwiper) return (o.startX = p), void (o.startY = f);
        if (!r.allowTouchMove)
          return (
            l.target.matches(n.focusableElements) || (r.allowClick = !1),
            void (n.isTouched && (Object.assign(o, { startX: p, startY: f, prevX: r.touches.currentX, prevY: r.touches.currentY, currentX: p, currentY: f }), (n.touchStartTime = z())))
          );
        if (i.touchReleaseOnEdges && !i.loop)
          if (r.isVertical()) {
            if ((f < o.startY && r.translate <= r.maxTranslate()) || (f > o.startY && r.translate >= r.minTranslate())) return (n.isTouched = !1), void (n.isMoved = !1);
          } else if ((p < o.startX && r.translate <= r.maxTranslate()) || (p > o.startX && r.translate >= r.minTranslate())) return;
        if (e.activeElement && l.target === e.activeElement && l.target.matches(n.focusableElements)) return (n.isMoved = !0), void (r.allowClick = !1);
        if ((n.allowTouchCallbacks && r.emit("touchMove", l), l.targetTouches && l.targetTouches.length > 1)) return;
        (o.currentX = p), (o.currentY = f);
        const d = o.currentX - o.startX,
          h = o.currentY - o.startY;
        if (r.params.threshold && Math.sqrt(d ** 2 + h ** 2) < r.params.threshold) return;
        if (void 0 === n.isScrolling) {
          let t;
          (r.isHorizontal() && o.currentY === o.startY) || (r.isVertical() && o.currentX === o.startX)
            ? (n.isScrolling = !1)
            : d * d + h * h >= 25 && ((t = (180 * Math.atan2(Math.abs(h), Math.abs(d))) / Math.PI), (n.isScrolling = r.isHorizontal() ? t > i.touchAngle : 90 - t > i.touchAngle));
        }
        if (
          (n.isScrolling && r.emit("touchMoveOpposite", l),
            void 0 === n.startMoving && ((o.currentX === o.startX && o.currentY === o.startY) || (n.startMoving = !0)),
            n.isScrolling || (r.zoom && r.params.zoom && r.params.zoom.enabled && n.evCache.length > 1))
        )
          return void (n.isTouched = !1);
        if (!n.startMoving) return;
        (r.allowClick = !1), !i.cssMode && l.cancelable && l.preventDefault(), i.touchMoveStopPropagation && !i.nested && l.stopPropagation();
        let v = r.isHorizontal() ? d : h,
          m = r.isHorizontal() ? o.currentX - o.previousX : o.currentY - o.previousY;
        i.oneWayMovement && ((v = Math.abs(v) * (a ? 1 : -1)), (m = Math.abs(m) * (a ? 1 : -1))), (o.diff = v), (v *= i.touchRatio), a && ((v = -v), (m = -m));
        const y = r.touchesDirection;
        (r.swipeDirection = v > 0 ? "prev" : "next"), (r.touchesDirection = m > 0 ? "prev" : "next");
        const g = r.params.loop && !i.cssMode;
        if (!n.isMoved) {
          if ((g && r.loopFix({ direction: r.swipeDirection }), (n.startTranslate = r.getTranslate()), r.setTransition(0), r.animating)) {
            const t = new window.CustomEvent("transitionend", { bubbles: !0, cancelable: !0 });
            r.wrapperEl.dispatchEvent(t);
          }
          (n.allowMomentumBounce = !1), !i.grabCursor || (!0 !== r.allowSlideNext && !0 !== r.allowSlidePrev) || r.setGrabCursor(!0), r.emit("sliderFirstMove", l);
        }
        let b;
        n.isMoved && y !== r.touchesDirection && g && Math.abs(v) >= 1 && (r.loopFix({ direction: r.swipeDirection, setTranslate: !0 }), (b = !0)),
          r.emit("sliderMove", l),
          (n.isMoved = !0),
          (n.currentTranslate = v + n.startTranslate);
        let w = !0,
          _ = i.resistanceRatio;
        if (
          (i.touchReleaseOnEdges && (_ = 0),
            v > 0
              ? (g && !b && n.currentTranslate > (i.centeredSlides ? r.minTranslate() - r.size / 2 : r.minTranslate()) && r.loopFix({ direction: "prev", setTranslate: !0, activeSlideIndex: 0 }),
                n.currentTranslate > r.minTranslate() && ((w = !1), i.resistance && (n.currentTranslate = r.minTranslate() - 1 + (-r.minTranslate() + n.startTranslate + v) ** _)))
              : v < 0 &&
              (g &&
                !b &&
                n.currentTranslate < (i.centeredSlides ? r.maxTranslate() + r.size / 2 : r.maxTranslate()) &&
                r.loopFix({ direction: "next", setTranslate: !0, activeSlideIndex: r.slides.length - ("auto" === i.slidesPerView ? r.slidesPerViewDynamic() : Math.ceil(parseFloat(i.slidesPerView, 10))) }),
                n.currentTranslate < r.maxTranslate() && ((w = !1), i.resistance && (n.currentTranslate = r.maxTranslate() + 1 - (r.maxTranslate() - n.startTranslate - v) ** _))),
            w && (l.preventedByNestedSwiper = !0),
            !r.allowSlideNext && "next" === r.swipeDirection && n.currentTranslate < n.startTranslate && (n.currentTranslate = n.startTranslate),
            !r.allowSlidePrev && "prev" === r.swipeDirection && n.currentTranslate > n.startTranslate && (n.currentTranslate = n.startTranslate),
            r.allowSlidePrev || r.allowSlideNext || (n.currentTranslate = n.startTranslate),
            i.threshold > 0)
        ) {
          if (!(Math.abs(v) > i.threshold || n.allowThresholdMove)) return void (n.currentTranslate = n.startTranslate);
          if (!n.allowThresholdMove)
            return (n.allowThresholdMove = !0), (o.startX = o.currentX), (o.startY = o.currentY), (n.currentTranslate = n.startTranslate), void (o.diff = r.isHorizontal() ? o.currentX - o.startX : o.currentY - o.startY);
        }
        i.followFinger &&
          !i.cssMode &&
          (((i.freeMode && i.freeMode.enabled && r.freeMode) || i.watchSlidesProgress) && (r.updateActiveIndex(), r.updateSlidesClasses()),
            i.freeMode && i.freeMode.enabled && r.freeMode && r.freeMode.onTouchMove(),
            r.updateProgress(n.currentTranslate),
            r.setTranslate(n.currentTranslate));
      }
      function st(t) {
        const e = this,
          r = e.touchEventsData,
          n = r.evCache.findIndex((e) => e.pointerId === t.pointerId);
        if ((n >= 0 && r.evCache.splice(n, 1), ["pointercancel", "pointerout", "pointerleave"].includes(t.type) && ("pointercancel" !== t.type || (!e.browser.isSafari && !e.browser.isWebView)))) return;
        const { params: i, touches: o, rtlTranslate: a, slidesGrid: s, enabled: l } = e;
        if (!l) return;
        if (!i.simulateTouch && "mouse" === t.pointerType) return;
        let c = t;
        if ((c.originalEvent && (c = c.originalEvent), r.allowTouchCallbacks && e.emit("touchEnd", c), (r.allowTouchCallbacks = !1), !r.isTouched))
          return r.isMoved && i.grabCursor && e.setGrabCursor(!1), (r.isMoved = !1), void (r.startMoving = !1);
        i.grabCursor && r.isMoved && r.isTouched && (!0 === e.allowSlideNext || !0 === e.allowSlidePrev) && e.setGrabCursor(!1);
        const u = z(),
          p = u - r.touchStartTime;
        if (e.allowClick) {
          const t = c.path || (c.composedPath && c.composedPath());
          e.updateClickedSlide((t && t[0]) || c.target), e.emit("tap click", c), p < 300 && u - r.lastClickTime < 300 && e.emit("doubleTap doubleClick", c);
        }
        if (
          ((r.lastClickTime = z()),
            I(() => {
              e.destroyed || (e.allowClick = !0);
            }),
            !r.isTouched || !r.isMoved || !e.swipeDirection || 0 === o.diff || r.currentTranslate === r.startTranslate)
        )
          return (r.isTouched = !1), (r.isMoved = !1), void (r.startMoving = !1);
        let f;
        if (((r.isTouched = !1), (r.isMoved = !1), (r.startMoving = !1), (f = i.followFinger ? (a ? e.translate : -e.translate) : -r.currentTranslate), i.cssMode)) return;
        if (i.freeMode && i.freeMode.enabled) return void e.freeMode.onTouchEnd({ currentPos: f });
        let d = 0,
          h = e.slidesSizesGrid[0];
        for (let t = 0; t < s.length; t += t < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup) {
          const e = t < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
          void 0 !== s[t + e] ? f >= s[t] && f < s[t + e] && ((d = t), (h = s[t + e] - s[t])) : f >= s[t] && ((d = t), (h = s[s.length - 1] - s[s.length - 2]));
        }
        let v = null,
          m = null;
        i.rewind && (e.isBeginning ? (m = i.virtual && i.virtual.enabled && e.virtual ? e.virtual.slides.length - 1 : e.slides.length - 1) : e.isEnd && (v = 0));
        const y = (f - s[d]) / h,
          g = d < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
        if (p > i.longSwipesMs) {
          if (!i.longSwipes) return void e.slideTo(e.activeIndex);
          "next" === e.swipeDirection && (y >= i.longSwipesRatio ? e.slideTo(i.rewind && e.isEnd ? v : d + g) : e.slideTo(d)),
            "prev" === e.swipeDirection && (y > 1 - i.longSwipesRatio ? e.slideTo(d + g) : null !== m && y < 0 && Math.abs(y) > i.longSwipesRatio ? e.slideTo(m) : e.slideTo(d));
        } else {
          if (!i.shortSwipes) return void e.slideTo(e.activeIndex);
          !e.navigation || (c.target !== e.navigation.nextEl && c.target !== e.navigation.prevEl)
            ? ("next" === e.swipeDirection && e.slideTo(null !== v ? v : d + g), "prev" === e.swipeDirection && e.slideTo(null !== m ? m : d))
            : c.target === e.navigation.nextEl
              ? e.slideTo(d + g)
              : e.slideTo(d);
        }
      }
      function lt() {
        const t = this,
          { params: e, el: r } = t;
        if (r && 0 === r.offsetWidth) return;
        e.breakpoints && t.setBreakpoint();
        const { allowSlideNext: n, allowSlidePrev: i, snapGrid: o } = t,
          a = t.virtual && t.params.virtual.enabled;
        (t.allowSlideNext = !0), (t.allowSlidePrev = !0), t.updateSize(), t.updateSlides(), t.updateSlidesClasses();
        const s = a && e.loop;
        !("auto" === e.slidesPerView || e.slidesPerView > 1) || !t.isEnd || t.isBeginning || t.params.centeredSlides || s
          ? t.params.loop && !a
            ? t.slideToLoop(t.realIndex, 0, !1, !0)
            : t.slideTo(t.activeIndex, 0, !1, !0)
          : t.slideTo(t.slides.length - 1, 0, !1, !0),
          t.autoplay &&
          t.autoplay.running &&
          t.autoplay.paused &&
          (clearTimeout(t.autoplay.resizeTimeout),
            (t.autoplay.resizeTimeout = setTimeout(() => {
              t.autoplay && t.autoplay.running && t.autoplay.paused && t.autoplay.resume();
            }, 500))),
          (t.allowSlidePrev = i),
          (t.allowSlideNext = n),
          t.params.watchOverflow && o !== t.snapGrid && t.checkOverflow();
      }
      function ct(t) {
        const e = this;
        e.enabled && (e.allowClick || (e.params.preventClicks && t.preventDefault(), e.params.preventClicksPropagation && e.animating && (t.stopPropagation(), t.stopImmediatePropagation())));
      }
      function ut() {
        const t = this,
          { wrapperEl: e, rtlTranslate: r, enabled: n } = t;
        if (!n) return;
        let i;
        (t.previousTranslate = t.translate), t.isHorizontal() ? (t.translate = -e.scrollLeft) : (t.translate = -e.scrollTop), 0 === t.translate && (t.translate = 0), t.updateActiveIndex(), t.updateSlidesClasses();
        const o = t.maxTranslate() - t.minTranslate();
        (i = 0 === o ? 0 : (t.translate - t.minTranslate()) / o), i !== t.progress && t.updateProgress(r ? -t.translate : t.translate), t.emit("setTranslate", t.translate, !1);
      }
      function pt(t) {
        const e = this;
        K(e, t.target), e.params.cssMode || ("auto" !== e.params.slidesPerView && !e.params.autoHeight) || e.update();
      }
      let ft = !1;
      function dt() { }
      const ht = (t, e) => {
        const r = M(),
          { params: n, el: i, wrapperEl: o, device: a } = t,
          s = !!n.nested,
          l = "on" === e ? "addEventListener" : "removeEventListener",
          c = e;
        i[l]("pointerdown", t.onTouchStart, { passive: !1 }),
          r[l]("pointermove", t.onTouchMove, { passive: !1, capture: s }),
          r[l]("pointerup", t.onTouchEnd, { passive: !0 }),
          r[l]("pointercancel", t.onTouchEnd, { passive: !0 }),
          r[l]("pointerout", t.onTouchEnd, { passive: !0 }),
          r[l]("pointerleave", t.onTouchEnd, { passive: !0 }),
          (n.preventClicks || n.preventClicksPropagation) && i[l]("click", t.onClick, !0),
          n.cssMode && o[l]("scroll", t.onScroll),
          n.updateOnWindowResize ? t[c](a.ios || a.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", lt, !0) : t[c]("observerUpdate", lt, !0),
          i[l]("load", t.onLoad, { capture: !0 });
      },
        vt = (t, e) => t.grid && e.grid && e.grid.rows > 1,
        mt = {
          init: !0,
          direction: "horizontal",
          oneWayMovement: !1,
          touchEventsTarget: "wrapper",
          initialSlide: 0,
          speed: 300,
          cssMode: !1,
          updateOnWindowResize: !0,
          resizeObserver: !0,
          nested: !1,
          createElements: !1,
          enabled: !0,
          focusableElements: "input, select, option, textarea, button, video, label",
          width: null,
          height: null,
          preventInteractionOnTransition: !1,
          userAgent: null,
          url: null,
          edgeSwipeDetection: !1,
          edgeSwipeThreshold: 20,
          autoHeight: !1,
          setWrapperSize: !1,
          virtualTranslate: !1,
          effect: "slide",
          breakpoints: void 0,
          breakpointsBase: "window",
          spaceBetween: 0,
          slidesPerView: 1,
          slidesPerGroup: 1,
          slidesPerGroupSkip: 0,
          slidesPerGroupAuto: !1,
          centeredSlides: !1,
          centeredSlidesBounds: !1,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          normalizeSlideIndex: !0,
          centerInsufficientSlides: !1,
          watchOverflow: !0,
          roundLengths: !1,
          touchRatio: 1,
          touchAngle: 45,
          simulateTouch: !0,
          shortSwipes: !0,
          longSwipes: !0,
          longSwipesRatio: 0.5,
          longSwipesMs: 300,
          followFinger: !0,
          allowTouchMove: !0,
          threshold: 5,
          touchMoveStopPropagation: !1,
          touchStartPreventDefault: !0,
          touchStartForcePreventDefault: !1,
          touchReleaseOnEdges: !1,
          uniqueNavElements: !0,
          resistance: !0,
          resistanceRatio: 0.85,
          watchSlidesProgress: !1,
          grabCursor: !1,
          preventClicks: !0,
          preventClicksPropagation: !0,
          slideToClickedSlide: !1,
          loop: !1,
          loopedSlides: null,
          loopPreventsSliding: !0,
          rewind: !1,
          allowSlidePrev: !0,
          allowSlideNext: !0,
          swipeHandler: null,
          noSwiping: !0,
          noSwipingClass: "swiper-no-swiping",
          noSwipingSelector: null,
          passiveListeners: !0,
          maxBackfaceHiddenSlides: 10,
          containerModifierClass: "swiper-",
          slideClass: "swiper-slide",
          slideActiveClass: "swiper-slide-active",
          slideVisibleClass: "swiper-slide-visible",
          slideNextClass: "swiper-slide-next",
          slidePrevClass: "swiper-slide-prev",
          wrapperClass: "swiper-wrapper",
          lazyPreloaderClass: "swiper-lazy-preloader",
          lazyPreloadPrevNext: 0,
          runCallbacksOnInit: !0,
          _emitClasses: !1,
        };
      function yt(t, e) {
        return function (r = {}) {
          const n = Object.keys(r)[0],
            i = r[n];
          "object" == typeof i && null !== i
            ? (["navigation", "pagination", "scrollbar"].indexOf(n) >= 0 && !0 === t[n] && (t[n] = { auto: !0 }),
              n in t && "enabled" in i ? (!0 === t[n] && (t[n] = { enabled: !0 }), "object" != typeof t[n] || "enabled" in t[n] || (t[n].enabled = !0), t[n] || (t[n] = { enabled: !1 }), B(e, r)) : B(e, r))
            : B(e, r);
        };
      }
      const gt = {
        eventsEmitter: Q,
        update: et,
        translate: {
          getTranslate: function (t = this.isHorizontal() ? "x" : "y") {
            const { params: e, rtlTranslate: r, translate: n, wrapperEl: i } = this;
            if (e.virtualTranslate) return r ? -n : n;
            if (e.cssMode) return n;
            let o = (function (t, e = "x") {
              const r = R();
              let n, i, o;
              const a = (function (t) {
                const e = R();
                let r;
                return e.getComputedStyle && (r = e.getComputedStyle(t, null)), !r && t.currentStyle && (r = t.currentStyle), r || (r = t.style), r;
              })(t);
              return (
                r.WebKitCSSMatrix
                  ? ((i = a.transform || a.webkitTransform),
                    i.split(",").length > 6 &&
                    (i = i
                      .split(", ")
                      .map((t) => t.replace(",", "."))
                      .join(", ")),
                    (o = new r.WebKitCSSMatrix("none" === i ? "" : i)))
                  : ((o = a.MozTransform || a.OTransform || a.MsTransform || a.msTransform || a.transform || a.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")), (n = o.toString().split(","))),
                "x" === e && (i = r.WebKitCSSMatrix ? o.m41 : 16 === n.length ? parseFloat(n[12]) : parseFloat(n[4])),
                "y" === e && (i = r.WebKitCSSMatrix ? o.m42 : 16 === n.length ? parseFloat(n[13]) : parseFloat(n[5])),
                i || 0
              );
            })(i, t);
            return (o += this.cssOverflowAdjustment()), r && (o = -o), o || 0;
          },
          setTranslate: function (t, e) {
            const r = this,
              { rtlTranslate: n, params: i, wrapperEl: o, progress: a } = r;
            let s,
              l = 0,
              c = 0;
            r.isHorizontal() ? (l = n ? -t : t) : (c = t),
              i.roundLengths && ((l = Math.floor(l)), (c = Math.floor(c))),
              (r.previousTranslate = r.translate),
              (r.translate = r.isHorizontal() ? l : c),
              i.cssMode
                ? (o[r.isHorizontal() ? "scrollLeft" : "scrollTop"] = r.isHorizontal() ? -l : -c)
                : i.virtualTranslate || (r.isHorizontal() ? (l -= r.cssOverflowAdjustment()) : (c -= r.cssOverflowAdjustment()), (o.style.transform = `translate3d(${l}px, ${c}px, 0px)`));
            const u = r.maxTranslate() - r.minTranslate();
            (s = 0 === u ? 0 : (t - r.minTranslate()) / u), s !== a && r.updateProgress(t), r.emit("setTranslate", r.translate, e);
          },
          minTranslate: function () {
            return -this.snapGrid[0];
          },
          maxTranslate: function () {
            return -this.snapGrid[this.snapGrid.length - 1];
          },
          translateTo: function (t = 0, e = this.params.speed, r = !0, n = !0, i) {
            const o = this,
              { params: a, wrapperEl: s } = o;
            if (o.animating && a.preventInteractionOnTransition) return !1;
            const l = o.minTranslate(),
              c = o.maxTranslate();
            let u;
            if (((u = n && t > l ? l : n && t < c ? c : t), o.updateProgress(u), a.cssMode)) {
              const t = o.isHorizontal();
              if (0 === e) s[t ? "scrollLeft" : "scrollTop"] = -u;
              else {
                if (!o.support.smoothScroll) return G({ swiper: o, targetPosition: -u, side: t ? "left" : "top" }), !0;
                s.scrollTo({ [t ? "left" : "top"]: -u, behavior: "smooth" });
              }
              return !0;
            }
            return (
              0 === e
                ? (o.setTransition(0), o.setTranslate(u), r && (o.emit("beforeTransitionStart", e, i), o.emit("transitionEnd")))
                : (o.setTransition(e),
                  o.setTranslate(u),
                  r && (o.emit("beforeTransitionStart", e, i), o.emit("transitionStart")),
                  o.animating ||
                  ((o.animating = !0),
                    o.onTranslateToWrapperTransitionEnd ||
                    (o.onTranslateToWrapperTransitionEnd = function (t) {
                      o &&
                        !o.destroyed &&
                        t.target === this &&
                        (o.wrapperEl.removeEventListener("transitionend", o.onTranslateToWrapperTransitionEnd),
                          (o.onTranslateToWrapperTransitionEnd = null),
                          delete o.onTranslateToWrapperTransitionEnd,
                          r && o.emit("transitionEnd"));
                    }),
                    o.wrapperEl.addEventListener("transitionend", o.onTranslateToWrapperTransitionEnd))),
              !0
            );
          },
        },
        transition: {
          setTransition: function (t, e) {
            const r = this;
            r.params.cssMode || (r.wrapperEl.style.transitionDuration = `${t}ms`), r.emit("setTransition", t, e);
          },
          transitionStart: function (t = !0, e) {
            const r = this,
              { params: n } = r;
            n.cssMode || (n.autoHeight && r.updateAutoHeight(), rt({ swiper: r, runCallbacks: t, direction: e, step: "Start" }));
          },
          transitionEnd: function (t = !0, e) {
            const r = this,
              { params: n } = r;
            (r.animating = !1), n.cssMode || (r.setTransition(0), rt({ swiper: r, runCallbacks: t, direction: e, step: "End" }));
          },
        },
        slide: nt,
        loop: it,
        grabCursor: {
          setGrabCursor: function (t) {
            const e = this;
            if (!e.params.simulateTouch || (e.params.watchOverflow && e.isLocked) || e.params.cssMode) return;
            const r = "container" === e.params.touchEventsTarget ? e.el : e.wrapperEl;
            e.isElement && (e.__preventObserver__ = !0),
              (r.style.cursor = "move"),
              (r.style.cursor = t ? "grabbing" : "grab"),
              e.isElement &&
              requestAnimationFrame(() => {
                e.__preventObserver__ = !1;
              });
          },
          unsetGrabCursor: function () {
            const t = this;
            (t.params.watchOverflow && t.isLocked) ||
              t.params.cssMode ||
              (t.isElement && (t.__preventObserver__ = !0),
                (t["container" === t.params.touchEventsTarget ? "el" : "wrapperEl"].style.cursor = ""),
                t.isElement &&
                requestAnimationFrame(() => {
                  t.__preventObserver__ = !1;
                }));
          },
        },
        events: {
          attachEvents: function () {
            const t = this,
              e = M(),
              { params: r } = t;
            (t.onTouchStart = ot.bind(t)),
              (t.onTouchMove = at.bind(t)),
              (t.onTouchEnd = st.bind(t)),
              r.cssMode && (t.onScroll = ut.bind(t)),
              (t.onClick = ct.bind(t)),
              (t.onLoad = pt.bind(t)),
              ft || (e.addEventListener("touchstart", dt), (ft = !0)),
              ht(t, "on");
          },
          detachEvents: function () {
            ht(this, "off");
          },
        },
        breakpoints: {
          setBreakpoint: function () {
            const t = this,
              { realIndex: e, initialized: r, params: n, el: i } = t,
              o = n.breakpoints;
            if (!o || (o && 0 === Object.keys(o).length)) return;
            const a = t.getBreakpoint(o, t.params.breakpointsBase, t.el);
            if (!a || t.currentBreakpoint === a) return;
            const s = (a in o ? o[a] : void 0) || t.originalParams,
              l = vt(t, n),
              c = vt(t, s),
              u = n.enabled;
            l && !c
              ? (i.classList.remove(`${n.containerModifierClass}grid`, `${n.containerModifierClass}grid-column`), t.emitContainerClasses())
              : !l &&
              c &&
              (i.classList.add(`${n.containerModifierClass}grid`),
                ((s.grid.fill && "column" === s.grid.fill) || (!s.grid.fill && "column" === n.grid.fill)) && i.classList.add(`${n.containerModifierClass}grid-column`),
                t.emitContainerClasses()),
              ["navigation", "pagination", "scrollbar"].forEach((e) => {
                if (void 0 === s[e]) return;
                const r = n[e] && n[e].enabled,
                  i = s[e] && s[e].enabled;
                r && !i && t[e].disable(), !r && i && t[e].enable();
              });
            const p = s.direction && s.direction !== n.direction,
              f = n.loop && (s.slidesPerView !== n.slidesPerView || p);
            p && r && t.changeDirection(), B(t.params, s);
            const d = t.params.enabled;
            Object.assign(t, { allowTouchMove: t.params.allowTouchMove, allowSlideNext: t.params.allowSlideNext, allowSlidePrev: t.params.allowSlidePrev }),
              u && !d ? t.disable() : !u && d && t.enable(),
              (t.currentBreakpoint = a),
              t.emit("_beforeBreakpoint", s),
              f && r && (t.loopDestroy(), t.loopCreate(e), t.updateSlides()),
              t.emit("breakpoint", s);
          },
          getBreakpoint: function (t, e = "window", r) {
            if (!t || ("container" === e && !r)) return;
            let n = !1;
            const i = R(),
              o = "window" === e ? i.innerHeight : r.clientHeight,
              a = Object.keys(t).map((t) => {
                if ("string" == typeof t && 0 === t.indexOf("@")) {
                  const e = parseFloat(t.substr(1));
                  return { value: o * e, point: t };
                }
                return { value: t, point: t };
              });
            a.sort((t, e) => parseInt(t.value, 10) - parseInt(e.value, 10));
            for (let t = 0; t < a.length; t += 1) {
              const { point: o, value: s } = a[t];
              "window" === e ? i.matchMedia(`(min-width: ${s}px)`).matches && (n = o) : s <= r.clientWidth && (n = o);
            }
            return n || "max";
          },
        },
        checkOverflow: {
          checkOverflow: function () {
            const t = this,
              { isLocked: e, params: r } = t,
              { slidesOffsetBefore: n } = r;
            if (n) {
              const e = t.slides.length - 1,
                r = t.slidesGrid[e] + t.slidesSizesGrid[e] + 2 * n;
              t.isLocked = t.size > r;
            } else t.isLocked = 1 === t.snapGrid.length;
            !0 === r.allowSlideNext && (t.allowSlideNext = !t.isLocked),
              !0 === r.allowSlidePrev && (t.allowSlidePrev = !t.isLocked),
              e && e !== t.isLocked && (t.isEnd = !1),
              e !== t.isLocked && t.emit(t.isLocked ? "lock" : "unlock");
          },
        },
        classes: {
          addClasses: function () {
            const t = this,
              { classNames: e, params: r, rtl: n, el: i, device: o } = t,
              a = (function (t, e) {
                const r = [];
                return (
                  t.forEach((t) => {
                    "object" == typeof t
                      ? Object.keys(t).forEach((n) => {
                        t[n] && r.push(e + n);
                      })
                      : "string" == typeof t && r.push(e + t);
                  }),
                  r
                );
              })(
                [
                  "initialized",
                  r.direction,
                  { "free-mode": t.params.freeMode && r.freeMode.enabled },
                  { autoheight: r.autoHeight },
                  { rtl: n },
                  { grid: r.grid && r.grid.rows > 1 },
                  { "grid-column": r.grid && r.grid.rows > 1 && "column" === r.grid.fill },
                  { android: o.android },
                  { ios: o.ios },
                  { "css-mode": r.cssMode },
                  { centered: r.cssMode && r.centeredSlides },
                  { "watch-progress": r.watchSlidesProgress },
                ],
                r.containerModifierClass
              );
            e.push(...a), i.classList.add(...e), t.emitContainerClasses();
          },
          removeClasses: function () {
            const { el: t, classNames: e } = this;
            t.classList.remove(...e), this.emitContainerClasses();
          },
        },
      },
        bt = {};
      class wt {
        constructor(...t) {
          let e, r;
          1 === t.length && t[0].constructor && "Object" === Object.prototype.toString.call(t[0]).slice(8, -1) ? (r = t[0]) : ([e, r] = t), r || (r = {}), (r = B({}, r)), e && !r.el && (r.el = e);
          const n = M();
          if (r.el && "string" == typeof r.el && n.querySelectorAll(r.el).length > 1) {
            const t = [];
            return (
              n.querySelectorAll(r.el).forEach((e) => {
                const n = B({}, r, { el: e });
                t.push(new wt(n));
              }),
              t
            );
          }
          const i = this;
          (i.__swiper__ = !0),
            (i.support = Z()),
            (i.device = (function (t = {}) {
              return (
                W ||
                (W = (function ({ userAgent: t } = {}) {
                  const e = Z(),
                    r = R(),
                    n = r.navigator.platform,
                    i = t || r.navigator.userAgent,
                    o = { ios: !1, android: !1 },
                    a = r.screen.width,
                    s = r.screen.height,
                    l = i.match(/(Android);?[\s\/]+([\d.]+)?/);
                  let c = i.match(/(iPad).*OS\s([\d_]+)/);
                  const u = i.match(/(iPod)(.*OS\s([\d_]+))?/),
                    p = !c && i.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
                    f = "Win32" === n;
                  let d = "MacIntel" === n;
                  return (
                    !c &&
                    d &&
                    e.touch &&
                    ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"].indexOf(`${a}x${s}`) >= 0 &&
                    ((c = i.match(/(Version)\/([\d.]+)/)), c || (c = [0, 1, "13_0_0"]), (d = !1)),
                    l && !f && ((o.os = "android"), (o.android = !0)),
                    (c || p || u) && ((o.os = "ios"), (o.ios = !0)),
                    o
                  );
                })(t)),
                W
              );
            })({ userAgent: r.userAgent })),
            (i.browser =
              (U ||
                (U = (function () {
                  const t = R();
                  let e = !1;
                  function r() {
                    const e = t.navigator.userAgent.toLowerCase();
                    return e.indexOf("safari") >= 0 && e.indexOf("chrome") < 0 && e.indexOf("android") < 0;
                  }
                  if (r()) {
                    const r = String(t.navigator.userAgent);
                    if (r.includes("Version/")) {
                      const [t, n] = r
                        .split("Version/")[1]
                        .split(" ")[0]
                        .split(".")
                        .map((t) => Number(t));
                      e = t < 16 || (16 === t && n < 2);
                    }
                  }
                  return { isSafari: e || r(), needPerspectiveFix: e, isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent) };
                })()),
                U)),
            (i.eventsListeners = {}),
            (i.eventsAnyListeners = []),
            (i.modules = [...i.__modules__]),
            r.modules && Array.isArray(r.modules) && i.modules.push(...r.modules);
          const o = {};
          i.modules.forEach((t) => {
            t({ params: r, swiper: i, extendParams: yt(r, o), on: i.on.bind(i), once: i.once.bind(i), off: i.off.bind(i), emit: i.emit.bind(i) });
          });
          const a = B({}, mt, o);
          return (
            (i.params = B({}, a, bt, r)),
            (i.originalParams = B({}, i.params)),
            (i.passedParams = B({}, r)),
            i.params &&
            i.params.on &&
            Object.keys(i.params.on).forEach((t) => {
              i.on(t, i.params.on[t]);
            }),
            i.params && i.params.onAny && i.onAny(i.params.onAny),
            Object.assign(i, {
              enabled: i.params.enabled,
              el: e,
              classNames: [],
              slides: [],
              slidesGrid: [],
              snapGrid: [],
              slidesSizesGrid: [],
              isHorizontal: () => "horizontal" === i.params.direction,
              isVertical: () => "vertical" === i.params.direction,
              activeIndex: 0,
              realIndex: 0,
              isBeginning: !0,
              isEnd: !1,
              translate: 0,
              previousTranslate: 0,
              progress: 0,
              velocity: 0,
              animating: !1,
              cssOverflowAdjustment() {
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
              },
              allowSlideNext: i.params.allowSlideNext,
              allowSlidePrev: i.params.allowSlidePrev,
              touchEventsData: {
                isTouched: void 0,
                isMoved: void 0,
                allowTouchCallbacks: void 0,
                touchStartTime: void 0,
                isScrolling: void 0,
                currentTranslate: void 0,
                startTranslate: void 0,
                allowThresholdMove: void 0,
                focusableElements: i.params.focusableElements,
                lastClickTime: 0,
                clickTimeout: void 0,
                velocities: [],
                allowMomentumBounce: void 0,
                startMoving: void 0,
                evCache: [],
              },
              allowClick: !0,
              allowTouchMove: i.params.allowTouchMove,
              touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
              imagesToLoad: [],
              imagesLoaded: 0,
            }),
            i.emit("_swiper"),
            i.params.init && i.init(),
            i
          );
        }
        getSlideIndex(t) {
          const { slidesEl: e, params: r } = this,
            n = V(N(e, `.${r.slideClass}, swiper-slide`)[0]);
          return V(t) - n;
        }
        getSlideIndexByData(t) {
          return this.getSlideIndex(this.slides.filter((e) => 1 * e.getAttribute("data-swiper-slide-index") === t)[0]);
        }
        recalcSlides() {
          const { slidesEl: t, params: e } = this;
          this.slides = N(t, `.${e.slideClass}, swiper-slide`);
        }
        enable() {
          const t = this;
          t.enabled || ((t.enabled = !0), t.params.grabCursor && t.setGrabCursor(), t.emit("enable"));
        }
        disable() {
          const t = this;
          t.enabled && ((t.enabled = !1), t.params.grabCursor && t.unsetGrabCursor(), t.emit("disable"));
        }
        setProgress(t, e) {
          const r = this;
          t = Math.min(Math.max(t, 0), 1);
          const n = r.minTranslate(),
            i = (r.maxTranslate() - n) * t + n;
          r.translateTo(i, void 0 === e ? 0 : e), r.updateActiveIndex(), r.updateSlidesClasses();
        }
        emitContainerClasses() {
          const t = this;
          if (!t.params._emitClasses || !t.el) return;
          const e = t.el.className.split(" ").filter((e) => 0 === e.indexOf("swiper") || 0 === e.indexOf(t.params.containerModifierClass));
          t.emit("_containerClasses", e.join(" "));
        }
        getSlideClasses(t) {
          const e = this;
          return e.destroyed
            ? ""
            : t.className
              .split(" ")
              .filter((t) => 0 === t.indexOf("swiper-slide") || 0 === t.indexOf(e.params.slideClass))
              .join(" ");
        }
        emitSlidesClasses() {
          const t = this;
          if (!t.params._emitClasses || !t.el) return;
          const e = [];
          t.slides.forEach((r) => {
            const n = t.getSlideClasses(r);
            e.push({ slideEl: r, classNames: n }), t.emit("_slideClass", r, n);
          }),
            t.emit("_slideClasses", e);
        }
        slidesPerViewDynamic(t = "current", e = !1) {
          const { params: r, slides: n, slidesGrid: i, slidesSizesGrid: o, size: a, activeIndex: s } = this;
          let l = 1;
          if (r.centeredSlides) {
            let t,
              e = n[s] ? n[s].swiperSlideSize : 0;
            for (let r = s + 1; r < n.length; r += 1) n[r] && !t && ((e += n[r].swiperSlideSize), (l += 1), e > a && (t = !0));
            for (let r = s - 1; r >= 0; r -= 1) n[r] && !t && ((e += n[r].swiperSlideSize), (l += 1), e > a && (t = !0));
          } else if ("current" === t) for (let t = s + 1; t < n.length; t += 1) (e ? i[t] + o[t] - i[s] < a : i[t] - i[s] < a) && (l += 1);
          else for (let t = s - 1; t >= 0; t -= 1) i[s] - i[t] < a && (l += 1);
          return l;
        }
        update() {
          const t = this;
          if (!t || t.destroyed) return;
          const { snapGrid: e, params: r } = t;
          function n() {
            const e = t.rtlTranslate ? -1 * t.translate : t.translate,
              r = Math.min(Math.max(e, t.maxTranslate()), t.minTranslate());
            t.setTranslate(r), t.updateActiveIndex(), t.updateSlidesClasses();
          }
          let i;
          if (
            (r.breakpoints && t.setBreakpoint(),
              [...t.el.querySelectorAll('[loading="lazy"]')].forEach((e) => {
                e.complete && K(t, e);
              }),
              t.updateSize(),
              t.updateSlides(),
              t.updateProgress(),
              t.updateSlidesClasses(),
              r.freeMode && r.freeMode.enabled && !r.cssMode)
          )
            n(), r.autoHeight && t.updateAutoHeight();
          else {
            if (("auto" === r.slidesPerView || r.slidesPerView > 1) && t.isEnd && !r.centeredSlides) {
              const e = t.virtual && r.virtual.enabled ? t.virtual.slides : t.slides;
              i = t.slideTo(e.length - 1, 0, !1, !0);
            } else i = t.slideTo(t.activeIndex, 0, !1, !0);
            i || n();
          }
          r.watchOverflow && e !== t.snapGrid && t.checkOverflow(), t.emit("update");
        }
        changeDirection(t, e = !0) {
          const r = this,
            n = r.params.direction;
          return (
            t || (t = "horizontal" === n ? "vertical" : "horizontal"),
            t === n ||
            ("horizontal" !== t && "vertical" !== t) ||
            (r.el.classList.remove(`${r.params.containerModifierClass}${n}`),
              r.el.classList.add(`${r.params.containerModifierClass}${t}`),
              r.emitContainerClasses(),
              (r.params.direction = t),
              r.slides.forEach((e) => {
                "vertical" === t ? (e.style.width = "") : (e.style.height = "");
              }),
              r.emit("changeDirection"),
              e && r.update()),
            r
          );
        }
        changeLanguageDirection(t) {
          const e = this;
          (e.rtl && "rtl" === t) ||
            (!e.rtl && "ltr" === t) ||
            ((e.rtl = "rtl" === t),
              (e.rtlTranslate = "horizontal" === e.params.direction && e.rtl),
              e.rtl ? (e.el.classList.add(`${e.params.containerModifierClass}rtl`), (e.el.dir = "rtl")) : (e.el.classList.remove(`${e.params.containerModifierClass}rtl`), (e.el.dir = "ltr")),
              e.update());
        }
        mount(t) {
          const e = this;
          if (e.mounted) return !0;
          let r = t || e.params.el;
          if (("string" == typeof r && (r = document.querySelector(r)), !r)) return !1;
          (r.swiper = e), r.shadowEl && (e.isElement = !0);
          const n = () => `.${(e.params.wrapperClass || "").trim().split(" ").join(".")}`;
          let i = r && r.shadowRoot && r.shadowRoot.querySelector ? r.shadowRoot.querySelector(n()) : N(r, n())[0];
          return (
            !i &&
            e.params.createElements &&
            ((i = Y("div", e.params.wrapperClass)),
              r.append(i),
              N(r, `.${e.params.slideClass}`).forEach((t) => {
                i.append(t);
              })),
            Object.assign(e, {
              el: r,
              wrapperEl: i,
              slidesEl: e.isElement ? r : i,
              mounted: !0,
              rtl: "rtl" === r.dir.toLowerCase() || "rtl" === H(r, "direction"),
              rtlTranslate: "horizontal" === e.params.direction && ("rtl" === r.dir.toLowerCase() || "rtl" === H(r, "direction")),
              wrongRTL: "-webkit-box" === H(i, "display"),
            }),
            !0
          );
        }
        init(t) {
          const e = this;
          return (
            e.initialized ||
            !1 === e.mount(t) ||
            (e.emit("beforeInit"),
              e.params.breakpoints && e.setBreakpoint(),
              e.addClasses(),
              e.updateSize(),
              e.updateSlides(),
              e.params.watchOverflow && e.checkOverflow(),
              e.params.grabCursor && e.enabled && e.setGrabCursor(),
              e.params.loop && e.virtual && e.params.virtual.enabled
                ? e.slideTo(e.params.initialSlide + e.virtual.slidesBefore, 0, e.params.runCallbacksOnInit, !1, !0)
                : e.slideTo(e.params.initialSlide, 0, e.params.runCallbacksOnInit, !1, !0),
              e.params.loop && e.loopCreate(),
              e.attachEvents(),
              [...e.el.querySelectorAll('[loading="lazy"]')].forEach((t) => {
                t.complete
                  ? K(e, t)
                  : t.addEventListener("load", (t) => {
                    K(e, t.target);
                  });
              }),
              tt(e),
              (e.initialized = !0),
              tt(e),
              e.emit("init"),
              e.emit("afterInit")),
            e
          );
        }
        destroy(t = !0, e = !0) {
          const r = this,
            { params: n, el: i, wrapperEl: o, slides: a } = r;
          return (
            void 0 === r.params ||
            r.destroyed ||
            (r.emit("beforeDestroy"),
              (r.initialized = !1),
              r.detachEvents(),
              n.loop && r.loopDestroy(),
              e &&
              (r.removeClasses(),
                i.removeAttribute("style"),
                o.removeAttribute("style"),
                a &&
                a.length &&
                a.forEach((t) => {
                  t.classList.remove(n.slideVisibleClass, n.slideActiveClass, n.slideNextClass, n.slidePrevClass), t.removeAttribute("style"), t.removeAttribute("data-swiper-slide-index");
                })),
              r.emit("destroy"),
              Object.keys(r.eventsListeners).forEach((t) => {
                r.off(t);
              }),
              !1 !== t &&
              ((r.el.swiper = null),
                (function (t) {
                  const e = t;
                  Object.keys(e).forEach((t) => {
                    try {
                      e[t] = null;
                    } catch (t) { }
                    try {
                      delete e[t];
                    } catch (t) { }
                  });
                })(r)),
              (r.destroyed = !0)),
            null
          );
        }
        static extendDefaults(t) {
          B(bt, t);
        }
        static get extendedDefaults() {
          return bt;
        }
        static get defaults() {
          return mt;
        }
        static installModule(t) {
          wt.prototype.__modules__ || (wt.prototype.__modules__ = []);
          const e = wt.prototype.__modules__;
          "function" == typeof t && e.indexOf(t) < 0 && e.push(t);
        }
        static use(t) {
          return Array.isArray(t) ? (t.forEach((t) => wt.installModule(t)), wt) : (wt.installModule(t), wt);
        }
      }
      Object.keys(gt).forEach((t) => {
        Object.keys(gt[t]).forEach((e) => {
          wt.prototype[e] = gt[t][e];
        });
      }),
        wt.use([
          function ({ swiper: t, on: e, emit: r }) {
            const n = R();
            let i = null,
              o = null;
            const a = () => {
              t && !t.destroyed && t.initialized && (r("beforeResize"), r("resize"));
            },
              s = () => {
                t && !t.destroyed && t.initialized && r("orientationchange");
              };
            e("init", () => {
              t.params.resizeObserver && void 0 !== n.ResizeObserver
                ? t &&
                !t.destroyed &&
                t.initialized &&
                ((i = new ResizeObserver((e) => {
                  o = n.requestAnimationFrame(() => {
                    const { width: r, height: n } = t;
                    let i = r,
                      o = n;
                    e.forEach(({ contentBoxSize: e, contentRect: r, target: n }) => {
                      (n && n !== t.el) || ((i = r ? r.width : (e[0] || e).inlineSize), (o = r ? r.height : (e[0] || e).blockSize));
                    }),
                      (i === r && o === n) || a();
                  });
                })),
                  i.observe(t.el))
                : (n.addEventListener("resize", a), n.addEventListener("orientationchange", s));
            }),
              e("destroy", () => {
                o && n.cancelAnimationFrame(o), i && i.unobserve && t.el && (i.unobserve(t.el), (i = null)), n.removeEventListener("resize", a), n.removeEventListener("orientationchange", s);
              });
          },
          function ({ swiper: t, extendParams: e, on: r, emit: n }) {
            const i = [],
              o = R(),
              a = (e, r = {}) => {
                const a = new (o.MutationObserver || o.WebkitMutationObserver)((e) => {
                  if (t.__preventObserver__) return;
                  if (1 === e.length) return void n("observerUpdate", e[0]);
                  const r = function () {
                    n("observerUpdate", e[0]);
                  };
                  o.requestAnimationFrame ? o.requestAnimationFrame(r) : o.setTimeout(r, 0);
                });
                a.observe(e, { attributes: void 0 === r.attributes || r.attributes, childList: void 0 === r.childList || r.childList, characterData: void 0 === r.characterData || r.characterData }), i.push(a);
              };
            e({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
              r("init", () => {
                if (t.params.observer) {
                  if (t.params.observeParents) {
                    const e = q(t.el);
                    for (let t = 0; t < e.length; t += 1) a(e[t]);
                  }
                  a(t.el, { childList: t.params.observeSlideChildren }), a(t.wrapperEl, { attributes: !1 });
                }
              }),
              r("destroy", () => {
                i.forEach((t) => {
                  t.disconnect();
                }),
                  i.splice(0, i.length);
              });
          },
        ]);
      const _t = wt;
      function xt({ swiper: t, extendParams: e, on: r, emit: n }) {
        const i = R();
        let o;
        e({ mousewheel: { enabled: !1, releaseOnEdges: !1, invert: !1, forceToAxis: !1, sensitivity: 1, eventsTarget: "container", thresholdDelta: null, thresholdTime: null, noMousewheelClass: "swiper-no-mousewheel" } }),
          (t.mousewheel = { enabled: !1 });
        let a,
          s = z();
        const l = [];
        function c() {
          t.enabled && (t.mouseEntered = !0);
        }
        function u() {
          t.enabled && (t.mouseEntered = !1);
        }
        function p(e) {
          return !(
            (t.params.mousewheel.thresholdDelta && e.delta < t.params.mousewheel.thresholdDelta) ||
            (t.params.mousewheel.thresholdTime && z() - s < t.params.mousewheel.thresholdTime) ||
            (!(e.delta >= 6 && z() - s < 60) &&
              (e.direction < 0 ? (t.isEnd && !t.params.loop) || t.animating || (t.slideNext(), n("scroll", e.raw)) : (t.isBeginning && !t.params.loop) || t.animating || (t.slidePrev(), n("scroll", e.raw)),
                (s = new i.Date().getTime()),
                1))
          );
        }
        function f(e) {
          let r = e,
            i = !0;
          if (!t.enabled) return;
          if (e.target.closest(`.${t.params.mousewheel.noMousewheelClass}`)) return;
          const s = t.params.mousewheel;
          t.params.cssMode && r.preventDefault();
          let c = t.el;
          "container" !== t.params.mousewheel.eventsTarget && (c = document.querySelector(t.params.mousewheel.eventsTarget));
          const u = c && c.contains(r.target);
          if (!t.mouseEntered && !u && !s.releaseOnEdges) return !0;
          r.originalEvent && (r = r.originalEvent);
          let f = 0;
          const d = t.rtlTranslate ? -1 : 1,
            h = (function (t) {
              let e = 0,
                r = 0,
                n = 0,
                i = 0;
              return (
                "detail" in t && (r = t.detail),
                "wheelDelta" in t && (r = -t.wheelDelta / 120),
                "wheelDeltaY" in t && (r = -t.wheelDeltaY / 120),
                "wheelDeltaX" in t && (e = -t.wheelDeltaX / 120),
                "axis" in t && t.axis === t.HORIZONTAL_AXIS && ((e = r), (r = 0)),
                (n = 10 * e),
                (i = 10 * r),
                "deltaY" in t && (i = t.deltaY),
                "deltaX" in t && (n = t.deltaX),
                t.shiftKey && !n && ((n = i), (i = 0)),
                (n || i) && t.deltaMode && (1 === t.deltaMode ? ((n *= 40), (i *= 40)) : ((n *= 800), (i *= 800))),
                n && !e && (e = n < 1 ? -1 : 1),
                i && !r && (r = i < 1 ? -1 : 1),
                { spinX: e, spinY: r, pixelX: n, pixelY: i }
              );
            })(r);
          if (s.forceToAxis)
            if (t.isHorizontal()) {
              if (!(Math.abs(h.pixelX) > Math.abs(h.pixelY))) return !0;
              f = -h.pixelX * d;
            } else {
              if (!(Math.abs(h.pixelY) > Math.abs(h.pixelX))) return !0;
              f = -h.pixelY;
            }
          else f = Math.abs(h.pixelX) > Math.abs(h.pixelY) ? -h.pixelX * d : -h.pixelY;
          if (0 === f) return !0;
          s.invert && (f = -f);
          let v = t.getTranslate() + f * s.sensitivity;
          if (
            (v >= t.minTranslate() && (v = t.minTranslate()),
              v <= t.maxTranslate() && (v = t.maxTranslate()),
              (i = !!t.params.loop || !(v === t.minTranslate() || v === t.maxTranslate())),
              i && t.params.nested && r.stopPropagation(),
              t.params.freeMode && t.params.freeMode.enabled)
          ) {
            const e = { time: z(), delta: Math.abs(f), direction: Math.sign(f) },
              i = a && e.time < a.time + 500 && e.delta <= a.delta && e.direction === a.direction;
            if (!i) {
              a = void 0;
              let c = t.getTranslate() + f * s.sensitivity;
              const u = t.isBeginning,
                p = t.isEnd;
              if (
                (c >= t.minTranslate() && (c = t.minTranslate()),
                  c <= t.maxTranslate() && (c = t.maxTranslate()),
                  t.setTransition(0),
                  t.setTranslate(c),
                  t.updateProgress(),
                  t.updateActiveIndex(),
                  t.updateSlidesClasses(),
                  ((!u && t.isBeginning) || (!p && t.isEnd)) && t.updateSlidesClasses(),
                  t.params.loop && t.loopFix({ direction: e.direction < 0 ? "next" : "prev", byMousewheel: !0 }),
                  t.params.freeMode.sticky)
              ) {
                clearTimeout(o), (o = void 0), l.length >= 15 && l.shift();
                const r = l.length ? l[l.length - 1] : void 0,
                  n = l[0];
                if ((l.push(e), r && (e.delta > r.delta || e.direction !== r.direction))) l.splice(0);
                else if (l.length >= 15 && e.time - n.time < 500 && n.delta - e.delta >= 1 && e.delta <= 6) {
                  const r = f > 0 ? 0.8 : 0.2;
                  (a = e),
                    l.splice(0),
                    (o = I(() => {
                      t.slideToClosest(t.params.speed, !0, void 0, r);
                    }, 0));
                }
                o ||
                  (o = I(() => {
                    (a = e), l.splice(0), t.slideToClosest(t.params.speed, !0, void 0, 0.5);
                  }, 500));
              }
              if ((i || n("scroll", r), t.params.autoplay && t.params.autoplayDisableOnInteraction && t.autoplay.stop(), c === t.minTranslate() || c === t.maxTranslate())) return !0;
            }
          } else {
            const r = { time: z(), delta: Math.abs(f), direction: Math.sign(f), raw: e };
            l.length >= 2 && l.shift();
            const n = l.length ? l[l.length - 1] : void 0;
            if (
              (l.push(r),
                n ? (r.direction !== n.direction || r.delta > n.delta || r.time > n.time + 150) && p(r) : p(r),
                (function (e) {
                  const r = t.params.mousewheel;
                  if (e.direction < 0) {
                    if (t.isEnd && !t.params.loop && r.releaseOnEdges) return !0;
                  } else if (t.isBeginning && !t.params.loop && r.releaseOnEdges) return !0;
                  return !1;
                })(r))
            )
              return !0;
          }
          return r.preventDefault ? r.preventDefault() : (r.returnValue = !1), !1;
        }
        function d(e) {
          let r = t.el;
          "container" !== t.params.mousewheel.eventsTarget && (r = document.querySelector(t.params.mousewheel.eventsTarget)), r[e]("mouseenter", c), r[e]("mouseleave", u), r[e]("wheel", f);
        }
        function h() {
          return t.params.cssMode ? (t.wrapperEl.removeEventListener("wheel", f), !0) : !t.mousewheel.enabled && (d("addEventListener"), (t.mousewheel.enabled = !0), !0);
        }
        function v() {
          return t.params.cssMode ? (t.wrapperEl.addEventListener(event, f), !0) : !!t.mousewheel.enabled && (d("removeEventListener"), (t.mousewheel.enabled = !1), !0);
        }
        r("init", () => {
          !t.params.mousewheel.enabled && t.params.cssMode && v(), t.params.mousewheel.enabled && h();
        }),
          r("destroy", () => {
            t.params.cssMode && h(), t.mousewheel.enabled && v();
          }),
          Object.assign(t.mousewheel, { enable: h, disable: v });
      }
      function Tt(t, e, r, n) {
        return (
          t.params.createElements &&
          Object.keys(n).forEach((i) => {
            if (!r[i] && !0 === r.auto) {
              let o = N(t.el, `.${n[i]}`)[0];
              o || ((o = Y("div", n[i])), (o.className = n[i]), t.el.append(o)), (r[i] = o), (e[i] = o);
            }
          }),
          r
        );
      }
      function Et({ swiper: t, extendParams: e, on: r, emit: n }) {
        e({
          navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: !1,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled",
          },
        }),
          (t.navigation = { nextEl: null, prevEl: null });
        const i = (t) => (Array.isArray(t) || (t = [t].filter((t) => !!t)), t);
        function o(e) {
          let r;
          return e && "string" == typeof e && t.isElement && ((r = t.el.shadowRoot.querySelector(e)), r)
            ? r
            : (e && ("string" == typeof e && (r = [...document.querySelectorAll(e)]), t.params.uniqueNavElements && "string" == typeof e && r.length > 1 && 1 === t.el.querySelectorAll(e).length && (r = t.el.querySelector(e))),
              e && !r ? e : r);
        }
        function a(e, r) {
          const n = t.params.navigation;
          (e = i(e)).forEach((e) => {
            e && (e.classList[r ? "add" : "remove"](...n.disabledClass.split(" ")), "BUTTON" === e.tagName && (e.disabled = r), t.params.watchOverflow && t.enabled && e.classList[t.isLocked ? "add" : "remove"](n.lockClass));
          });
        }
        function s() {
          const { nextEl: e, prevEl: r } = t.navigation;
          if (t.params.loop) return a(r, !1), void a(e, !1);
          a(r, t.isBeginning && !t.params.rewind), a(e, t.isEnd && !t.params.rewind);
        }
        function l(e) {
          e.preventDefault(), (!t.isBeginning || t.params.loop || t.params.rewind) && (t.slidePrev(), n("navigationPrev"));
        }
        function c(e) {
          e.preventDefault(), (!t.isEnd || t.params.loop || t.params.rewind) && (t.slideNext(), n("navigationNext"));
        }
        function u() {
          const e = t.params.navigation;
          if (((t.params.navigation = Tt(t, t.originalParams.navigation, t.params.navigation, { nextEl: "swiper-button-next", prevEl: "swiper-button-prev" })), !e.nextEl && !e.prevEl)) return;
          let r = o(e.nextEl),
            n = o(e.prevEl);
          Object.assign(t.navigation, { nextEl: r, prevEl: n }), (r = i(r)), (n = i(n));
          const a = (r, n) => {
            r && r.addEventListener("click", "next" === n ? c : l), !t.enabled && r && r.classList.add(...e.lockClass.split(" "));
          };
          r.forEach((t) => a(t, "next")), n.forEach((t) => a(t, "prev"));
        }
        function p() {
          let { nextEl: e, prevEl: r } = t.navigation;
          (e = i(e)), (r = i(r));
          const n = (e, r) => {
            e.removeEventListener("click", "next" === r ? c : l), e.classList.remove(...t.params.navigation.disabledClass.split(" "));
          };
          e.forEach((t) => n(t, "next")), r.forEach((t) => n(t, "prev"));
        }
        r("init", () => {
          !1 === t.params.navigation.enabled ? f() : (u(), s());
        }),
          r("toEdge fromEdge lock unlock", () => {
            s();
          }),
          r("destroy", () => {
            p();
          }),
          r("enable disable", () => {
            let { nextEl: e, prevEl: r } = t.navigation;
            (e = i(e)), (r = i(r)), [...e, ...r].filter((t) => !!t).forEach((e) => e.classList[t.enabled ? "remove" : "add"](t.params.navigation.lockClass));
          }),
          r("click", (e, r) => {
            let { nextEl: o, prevEl: a } = t.navigation;
            (o = i(o)), (a = i(a));
            const s = r.target;
            if (t.params.navigation.hideOnClick && !a.includes(s) && !o.includes(s)) {
              if (t.pagination && t.params.pagination && t.params.pagination.clickable && (t.pagination.el === s || t.pagination.el.contains(s))) return;
              let e;
              o.length ? (e = o[0].classList.contains(t.params.navigation.hiddenClass)) : a.length && (e = a[0].classList.contains(t.params.navigation.hiddenClass)),
                n(!0 === e ? "navigationShow" : "navigationHide"),
                [...o, ...a].filter((t) => !!t).forEach((e) => e.classList.toggle(t.params.navigation.hiddenClass));
            }
          });
        const f = () => {
          t.el.classList.add(...t.params.navigation.navigationDisabledClass.split(" ")), p();
        };
        Object.assign(t.navigation, {
          enable: () => {
            t.el.classList.remove(...t.params.navigation.navigationDisabledClass.split(" ")), u(), s();
          },
          disable: f,
          update: s,
          init: u,
          destroy: p,
        });
      }
      function St(t = "") {
        return `.${t
          .trim()
          .replace(/([\.:!+\/])/g, "\\$1")
          .replace(/ /g, ".")}`;
      }
      function Ot({ swiper: t, extendParams: e, on: r, emit: n }) {
        const i = "swiper-pagination";
        let o;
        e({
          pagination: {
            el: null,
            bulletElement: "span",
            clickable: !1,
            hideOnClick: !1,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: !1,
            type: "bullets",
            dynamicBullets: !1,
            dynamicMainBullets: 1,
            formatFractionCurrent: (t) => t,
            formatFractionTotal: (t) => t,
            bulletClass: `${i}-bullet`,
            bulletActiveClass: `${i}-bullet-active`,
            modifierClass: `${i}-`,
            currentClass: `${i}-current`,
            totalClass: `${i}-total`,
            hiddenClass: `${i}-hidden`,
            progressbarFillClass: `${i}-progressbar-fill`,
            progressbarOppositeClass: `${i}-progressbar-opposite`,
            clickableClass: `${i}-clickable`,
            lockClass: `${i}-lock`,
            horizontalClass: `${i}-horizontal`,
            verticalClass: `${i}-vertical`,
            paginationDisabledClass: `${i}-disabled`,
          },
        }),
          (t.pagination = { el: null, bullets: [] });
        let a = 0;
        const s = (t) => (Array.isArray(t) || (t = [t].filter((t) => !!t)), t);
        function l() {
          return !t.params.pagination.el || !t.pagination.el || (Array.isArray(t.pagination.el) && 0 === t.pagination.el.length);
        }
        function c(e, r) {
          const { bulletActiveClass: n } = t.params.pagination;
          e && (e = e[("prev" === r ? "previous" : "next") + "ElementSibling"]) && (e.classList.add(`${n}-${r}`), (e = e[("prev" === r ? "previous" : "next") + "ElementSibling"]) && e.classList.add(`${n}-${r}-${r}`));
        }
        function u(e) {
          const r = e.target.closest(St(t.params.pagination.bulletClass));
          if (!r) return;
          e.preventDefault();
          const n = V(r) * t.params.slidesPerGroup;
          if (t.params.loop) {
            if (t.realIndex === n) return;
            const e = t.getSlideIndexByData(n),
              r = t.getSlideIndexByData(t.realIndex);
            e > t.slides.length - t.loopedSlides && t.loopFix({ direction: e > r ? "next" : "prev", activeSlideIndex: e, slideTo: !1 }), t.slideToLoop(n);
          } else t.slideTo(n);
        }
        function p() {
          const e = t.rtl,
            r = t.params.pagination;
          if (l()) return;
          let i,
            u,
            p = t.pagination.el;
          p = s(p);
          const f = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length,
            d = t.params.loop ? Math.ceil(f / t.params.slidesPerGroup) : t.snapGrid.length;
          if (
            (t.params.loop
              ? ((u = t.previousRealIndex || 0), (i = t.params.slidesPerGroup > 1 ? Math.floor(t.realIndex / t.params.slidesPerGroup) : t.realIndex))
              : void 0 !== t.snapIndex
                ? ((i = t.snapIndex), (u = t.previousSnapIndex))
                : ((u = t.previousIndex || 0), (i = t.activeIndex || 0)),
              "bullets" === r.type && t.pagination.bullets && t.pagination.bullets.length > 0)
          ) {
            const n = t.pagination.bullets;
            let s, l, f;
            if (
              (r.dynamicBullets &&
                ((o = $(n[0], t.isHorizontal() ? "width" : "height", !0)),
                  p.forEach((e) => {
                    e.style[t.isHorizontal() ? "width" : "height"] = o * (r.dynamicMainBullets + 4) + "px";
                  }),
                  r.dynamicMainBullets > 1 && void 0 !== u && ((a += i - (u || 0)), a > r.dynamicMainBullets - 1 ? (a = r.dynamicMainBullets - 1) : a < 0 && (a = 0)),
                  (s = Math.max(i - a, 0)),
                  (l = s + (Math.min(n.length, r.dynamicMainBullets) - 1)),
                  (f = (l + s) / 2)),
                n.forEach((t) => {
                  const e = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((t) => `${r.bulletActiveClass}${t}`)].map((t) => ("string" == typeof t && t.includes(" ") ? t.split(" ") : t)).flat();
                  t.classList.remove(...e);
                }),
                p.length > 1)
            )
              n.forEach((e) => {
                const n = V(e);
                n === i ? e.classList.add(...r.bulletActiveClass.split(" ")) : t.isElement && e.setAttribute("part", "bullet"),
                  r.dynamicBullets && (n >= s && n <= l && e.classList.add(...`${r.bulletActiveClass}-main`.split(" ")), n === s && c(e, "prev"), n === l && c(e, "next"));
              });
            else {
              const e = n[i];
              if (
                (e && e.classList.add(...r.bulletActiveClass.split(" ")),
                  t.isElement &&
                  n.forEach((t, e) => {
                    t.setAttribute("part", e === i ? "bullet-active" : "bullet");
                  }),
                  r.dynamicBullets)
              ) {
                const t = n[s],
                  e = n[l];
                for (let t = s; t <= l; t += 1) n[t] && n[t].classList.add(...`${r.bulletActiveClass}-main`.split(" "));
                c(t, "prev"), c(e, "next");
              }
            }
            if (r.dynamicBullets) {
              const i = Math.min(n.length, r.dynamicMainBullets + 4),
                a = (o * i - o) / 2 - f * o,
                s = e ? "right" : "left";
              n.forEach((e) => {
                e.style[t.isHorizontal() ? s : "top"] = `${a}px`;
              });
            }
          }
          p.forEach((e, o) => {
            if (
              ("fraction" === r.type &&
                (e.querySelectorAll(St(r.currentClass)).forEach((t) => {
                  t.textContent = r.formatFractionCurrent(i + 1);
                }),
                  e.querySelectorAll(St(r.totalClass)).forEach((t) => {
                    t.textContent = r.formatFractionTotal(d);
                  })),
                "progressbar" === r.type)
            ) {
              let n;
              n = r.progressbarOpposite ? (t.isHorizontal() ? "vertical" : "horizontal") : t.isHorizontal() ? "horizontal" : "vertical";
              const o = (i + 1) / d;
              let a = 1,
                s = 1;
              "horizontal" === n ? (a = o) : (s = o),
                e.querySelectorAll(St(r.progressbarFillClass)).forEach((e) => {
                  (e.style.transform = `translate3d(0,0,0) scaleX(${a}) scaleY(${s})`), (e.style.transitionDuration = `${t.params.speed}ms`);
                });
            }
            "custom" === r.type && r.renderCustom ? ((e.innerHTML = r.renderCustom(t, i + 1, d)), 0 === o && n("paginationRender", e)) : (0 === o && n("paginationRender", e), n("paginationUpdate", e)),
              t.params.watchOverflow && t.enabled && e.classList[t.isLocked ? "add" : "remove"](r.lockClass);
          });
        }
        function f() {
          const e = t.params.pagination;
          if (l()) return;
          const r = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length;
          let i = t.pagination.el;
          i = s(i);
          let o = "";
          if ("bullets" === e.type) {
            let n = t.params.loop ? Math.ceil(r / t.params.slidesPerGroup) : t.snapGrid.length;
            t.params.freeMode && t.params.freeMode.enabled && n > r && (n = r);
            for (let r = 0; r < n; r += 1) e.renderBullet ? (o += e.renderBullet.call(t, r, e.bulletClass)) : (o += `<${e.bulletElement} ${t.isElement ? 'part="bullet"' : ""} class="${e.bulletClass}"></${e.bulletElement}>`);
          }
          "fraction" === e.type && (o = e.renderFraction ? e.renderFraction.call(t, e.currentClass, e.totalClass) : `<span class="${e.currentClass}"></span> / <span class="${e.totalClass}"></span>`),
            "progressbar" === e.type && (o = e.renderProgressbar ? e.renderProgressbar.call(t, e.progressbarFillClass) : `<span class="${e.progressbarFillClass}"></span>`),
            (t.pagination.bullets = []),
            i.forEach((r) => {
              "custom" !== e.type && (r.innerHTML = o || ""), "bullets" === e.type && t.pagination.bullets.push(...r.querySelectorAll(St(e.bulletClass)));
            }),
            "custom" !== e.type && n("paginationRender", i[0]);
        }
        function d() {
          t.params.pagination = Tt(t, t.originalParams.pagination, t.params.pagination, { el: "swiper-pagination" });
          const e = t.params.pagination;
          if (!e.el) return;
          let r;
          "string" == typeof e.el && t.isElement && (r = t.el.shadowRoot.querySelector(e.el)),
            r || "string" != typeof e.el || (r = [...document.querySelectorAll(e.el)]),
            r || (r = e.el),
            r &&
            0 !== r.length &&
            (t.params.uniqueNavElements && "string" == typeof e.el && Array.isArray(r) && r.length > 1 && ((r = [...t.el.querySelectorAll(e.el)]), r.length > 1 && (r = r.filter((e) => q(e, ".swiper")[0] === t.el)[0])),
              Array.isArray(r) && 1 === r.length && (r = r[0]),
              Object.assign(t.pagination, { el: r }),
              (r = s(r)),
              r.forEach((r) => {
                "bullets" === e.type && e.clickable && r.classList.add(e.clickableClass),
                  r.classList.add(e.modifierClass + e.type),
                  r.classList.add(t.isHorizontal() ? e.horizontalClass : e.verticalClass),
                  "bullets" === e.type && e.dynamicBullets && (r.classList.add(`${e.modifierClass}${e.type}-dynamic`), (a = 0), e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)),
                  "progressbar" === e.type && e.progressbarOpposite && r.classList.add(e.progressbarOppositeClass),
                  e.clickable && r.addEventListener("click", u),
                  t.enabled || r.classList.add(e.lockClass);
              }));
        }
        function h() {
          const e = t.params.pagination;
          if (l()) return;
          let r = t.pagination.el;
          r &&
            ((r = s(r)),
              r.forEach((r) => {
                r.classList.remove(e.hiddenClass), r.classList.remove(e.modifierClass + e.type), r.classList.remove(t.isHorizontal() ? e.horizontalClass : e.verticalClass), e.clickable && r.removeEventListener("click", u);
              })),
            t.pagination.bullets && t.pagination.bullets.forEach((t) => t.classList.remove(...e.bulletActiveClass.split(" ")));
        }
        r("changeDirection", () => {
          if (!t.pagination || !t.pagination.el) return;
          const e = t.params.pagination;
          let { el: r } = t.pagination;
          (r = s(r)),
            r.forEach((r) => {
              r.classList.remove(e.horizontalClass, e.verticalClass), r.classList.add(t.isHorizontal() ? e.horizontalClass : e.verticalClass);
            });
        }),
          r("init", () => {
            !1 === t.params.pagination.enabled ? v() : (d(), f(), p());
          }),
          r("activeIndexChange", () => {
            void 0 === t.snapIndex && p();
          }),
          r("snapIndexChange", () => {
            p();
          }),
          r("snapGridLengthChange", () => {
            f(), p();
          }),
          r("destroy", () => {
            h();
          }),
          r("enable disable", () => {
            let { el: e } = t.pagination;
            e && ((e = s(e)), e.forEach((e) => e.classList[t.enabled ? "remove" : "add"](t.params.pagination.lockClass)));
          }),
          r("lock unlock", () => {
            p();
          }),
          r("click", (e, r) => {
            const i = r.target;
            let { el: o } = t.pagination;
            if ((Array.isArray(o) || (o = [o].filter((t) => !!t)), t.params.pagination.el && t.params.pagination.hideOnClick && o && o.length > 0 && !i.classList.contains(t.params.pagination.bulletClass))) {
              if (t.navigation && ((t.navigation.nextEl && i === t.navigation.nextEl) || (t.navigation.prevEl && i === t.navigation.prevEl))) return;
              const e = o[0].classList.contains(t.params.pagination.hiddenClass);
              n(!0 === e ? "paginationShow" : "paginationHide"), o.forEach((e) => e.classList.toggle(t.params.pagination.hiddenClass));
            }
          });
        const v = () => {
          t.el.classList.add(t.params.pagination.paginationDisabledClass);
          let { el: e } = t.pagination;
          e && ((e = s(e)), e.forEach((e) => e.classList.add(t.params.pagination.paginationDisabledClass))), h();
        };
        Object.assign(t.pagination, {
          enable: () => {
            t.el.classList.remove(t.params.pagination.paginationDisabledClass);
            let { el: e } = t.pagination;
            e && ((e = s(e)), e.forEach((e) => e.classList.remove(t.params.pagination.paginationDisabledClass))), d(), f(), p();
          },
          disable: v,
          render: f,
          update: p,
          init: d,
          destroy: h,
        });
      }
      function Pt({ swiper: t, extendParams: e, on: r, emit: n }) {
        const i = M();
        let o,
          a,
          s,
          l,
          c = !1,
          u = null,
          p = null;
        function f() {
          if (!t.params.scrollbar.el || !t.scrollbar.el) return;
          const { scrollbar: e, rtlTranslate: r } = t,
            { dragEl: n, el: i } = e,
            o = t.params.scrollbar,
            l = t.params.loop ? t.progressLoop : t.progress;
          let c = a,
            p = (s - a) * l;
          r ? ((p = -p), p > 0 ? ((c = a - p), (p = 0)) : -p + a > s && (c = s + p)) : p < 0 ? ((c = a + p), (p = 0)) : p + a > s && (c = s - p),
            t.isHorizontal() ? ((n.style.transform = `translate3d(${p}px, 0, 0)`), (n.style.width = `${c}px`)) : ((n.style.transform = `translate3d(0px, ${p}px, 0)`), (n.style.height = `${c}px`)),
            o.hide &&
            (clearTimeout(u),
              (i.style.opacity = 1),
              (u = setTimeout(() => {
                (i.style.opacity = 0), (i.style.transitionDuration = "400ms");
              }, 1e3)));
        }
        function d() {
          if (!t.params.scrollbar.el || !t.scrollbar.el) return;
          const { scrollbar: e } = t,
            { dragEl: r, el: n } = e;
          (r.style.width = ""),
            (r.style.height = ""),
            (s = t.isHorizontal() ? n.offsetWidth : n.offsetHeight),
            (l = t.size / (t.virtualSize + t.params.slidesOffsetBefore - (t.params.centeredSlides ? t.snapGrid[0] : 0))),
            (a = "auto" === t.params.scrollbar.dragSize ? s * l : parseInt(t.params.scrollbar.dragSize, 10)),
            t.isHorizontal() ? (r.style.width = `${a}px`) : (r.style.height = `${a}px`),
            (n.style.display = l >= 1 ? "none" : ""),
            t.params.scrollbar.hide && (n.style.opacity = 0),
            t.params.watchOverflow && t.enabled && e.el.classList[t.isLocked ? "add" : "remove"](t.params.scrollbar.lockClass);
        }
        function h(e) {
          return t.isHorizontal() ? e.clientX : e.clientY;
        }
        function v(e) {
          const { scrollbar: r, rtlTranslate: n } = t,
            { el: i } = r;
          let l;
          (l =
            (h(e) -
              (function (t) {
                const e = R(),
                  r = M(),
                  n = t.getBoundingClientRect(),
                  i = r.body,
                  o = t.clientTop || i.clientTop || 0,
                  a = t.clientLeft || i.clientLeft || 0,
                  s = t === e ? e.scrollY : t.scrollTop,
                  l = t === e ? e.scrollX : t.scrollLeft;
                return { top: n.top + s - o, left: n.left + l - a };
              })(i)[t.isHorizontal() ? "left" : "top"] -
              (null !== o ? o : a / 2)) /
            (s - a)),
            (l = Math.max(Math.min(l, 1), 0)),
            n && (l = 1 - l);
          const c = t.minTranslate() + (t.maxTranslate() - t.minTranslate()) * l;
          t.updateProgress(c), t.setTranslate(c), t.updateActiveIndex(), t.updateSlidesClasses();
        }
        function m(e) {
          const r = t.params.scrollbar,
            { scrollbar: i, wrapperEl: a } = t,
            { el: s, dragEl: l } = i;
          (c = !0),
            (o = e.target === l ? h(e) - e.target.getBoundingClientRect()[t.isHorizontal() ? "left" : "top"] : null),
            e.preventDefault(),
            e.stopPropagation(),
            (a.style.transitionDuration = "100ms"),
            (l.style.transitionDuration = "100ms"),
            v(e),
            clearTimeout(p),
            (s.style.transitionDuration = "0ms"),
            r.hide && (s.style.opacity = 1),
            t.params.cssMode && (t.wrapperEl.style["scroll-snap-type"] = "none"),
            n("scrollbarDragStart", e);
        }
        function y(e) {
          const { scrollbar: r, wrapperEl: i } = t,
            { el: o, dragEl: a } = r;
          c && (e.preventDefault ? e.preventDefault() : (e.returnValue = !1), v(e), (i.style.transitionDuration = "0ms"), (o.style.transitionDuration = "0ms"), (a.style.transitionDuration = "0ms"), n("scrollbarDragMove", e));
        }
        function g(e) {
          const r = t.params.scrollbar,
            { scrollbar: i, wrapperEl: o } = t,
            { el: a } = i;
          c &&
            ((c = !1),
              t.params.cssMode && ((t.wrapperEl.style["scroll-snap-type"] = ""), (o.style.transitionDuration = "")),
              r.hide &&
              (clearTimeout(p),
                (p = I(() => {
                  (a.style.opacity = 0), (a.style.transitionDuration = "400ms");
                }, 1e3))),
              n("scrollbarDragEnd", e),
              r.snapOnRelease && t.slideToClosest());
        }
        function b(e) {
          const { scrollbar: r, params: n } = t,
            o = r.el;
          if (!o) return;
          const a = o,
            s = !!n.passiveListeners && { passive: !1, capture: !1 },
            l = !!n.passiveListeners && { passive: !0, capture: !1 };
          if (!a) return;
          const c = "on" === e ? "addEventListener" : "removeEventListener";
          a[c]("pointerdown", m, s), i[c]("pointermove", y, s), i[c]("pointerup", g, l);
        }
        function w() {
          const { scrollbar: e, el: r } = t;
          t.params.scrollbar = Tt(t, t.originalParams.scrollbar, t.params.scrollbar, { el: "swiper-scrollbar" });
          const n = t.params.scrollbar;
          if (!n.el) return;
          let o, a;
          "string" == typeof n.el && t.isElement && (o = t.el.shadowRoot.querySelector(n.el)),
            o || "string" != typeof n.el ? o || (o = n.el) : (o = i.querySelectorAll(n.el)),
            t.params.uniqueNavElements && "string" == typeof n.el && o.length > 1 && 1 === r.querySelectorAll(n.el).length && (o = r.querySelector(n.el)),
            o.length > 0 && (o = o[0]),
            o.classList.add(t.isHorizontal() ? n.horizontalClass : n.verticalClass),
            o && ((a = o.querySelector(`.${t.params.scrollbar.dragClass}`)), a || ((a = Y("div", t.params.scrollbar.dragClass)), o.append(a))),
            Object.assign(e, { el: o, dragEl: a }),
            n.draggable && t.params.scrollbar.el && t.scrollbar.el && b("on"),
            o && o.classList[t.enabled ? "remove" : "add"](t.params.scrollbar.lockClass);
        }
        function _() {
          const e = t.params.scrollbar,
            r = t.scrollbar.el;
          r && r.classList.remove(t.isHorizontal() ? e.horizontalClass : e.verticalClass), t.params.scrollbar.el && t.scrollbar.el && b("off");
        }
        e({
          scrollbar: {
            el: null,
            dragSize: "auto",
            hide: !1,
            draggable: !1,
            snapOnRelease: !0,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag",
            scrollbarDisabledClass: "swiper-scrollbar-disabled",
            horizontalClass: "swiper-scrollbar-horizontal",
            verticalClass: "swiper-scrollbar-vertical",
          },
        }),
          (t.scrollbar = { el: null, dragEl: null }),
          r("init", () => {
            !1 === t.params.scrollbar.enabled ? x() : (w(), d(), f());
          }),
          r("update resize observerUpdate lock unlock", () => {
            d();
          }),
          r("setTranslate", () => {
            f();
          }),
          r("setTransition", (e, r) => {
            !(function (e) {
              t.params.scrollbar.el && t.scrollbar.el && (t.scrollbar.dragEl.style.transitionDuration = `${e}ms`);
            })(r);
          }),
          r("enable disable", () => {
            const { el: e } = t.scrollbar;
            e && e.classList[t.enabled ? "remove" : "add"](t.params.scrollbar.lockClass);
          }),
          r("destroy", () => {
            _();
          });
        const x = () => {
          t.el.classList.add(t.params.scrollbar.scrollbarDisabledClass), t.scrollbar.el && t.scrollbar.el.classList.add(t.params.scrollbar.scrollbarDisabledClass), _();
        };
        Object.assign(t.scrollbar, {
          enable: () => {
            t.el.classList.remove(t.params.scrollbar.scrollbarDisabledClass), t.scrollbar.el && t.scrollbar.el.classList.remove(t.params.scrollbar.scrollbarDisabledClass), w(), d(), f();
          },
          disable: x,
          updateSize: d,
          setTranslate: f,
          init: w,
          destroy: _,
        });
      }
      function At({ swiper: t, extendParams: e, on: r }) {
        e({ thumbs: { swiper: null, multipleActiveThumbs: !0, autoScrollOffset: 0, slideThumbActiveClass: "swiper-slide-thumb-active", thumbsContainerClass: "swiper-thumbs" } });
        let n = !1,
          i = !1;
        function o() {
          const e = t.thumbs.swiper;
          if (!e || e.destroyed) return;
          const r = e.clickedIndex,
            n = e.clickedSlide;
          if (n && n.classList.contains(t.params.thumbs.slideThumbActiveClass)) return;
          if (null == r) return;
          let i;
          (i = e.params.loop ? parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10) : r), t.params.loop ? t.slideToLoop(i) : t.slideTo(i);
        }
        function a() {
          const { thumbs: e } = t.params;
          if (n) return !1;
          n = !0;
          const r = t.constructor;
          if (e.swiper instanceof r)
            (t.thumbs.swiper = e.swiper),
              Object.assign(t.thumbs.swiper.originalParams, { watchSlidesProgress: !0, slideToClickedSlide: !1 }),
              Object.assign(t.thumbs.swiper.params, { watchSlidesProgress: !0, slideToClickedSlide: !1 }),
              t.thumbs.swiper.update();
          else if (D(e.swiper)) {
            const n = Object.assign({}, e.swiper);
            Object.assign(n, { watchSlidesProgress: !0, slideToClickedSlide: !1 }), (t.thumbs.swiper = new r(n)), (i = !0);
          }
          return t.thumbs.swiper.el.classList.add(t.params.thumbs.thumbsContainerClass), t.thumbs.swiper.on("tap", o), !0;
        }
        function s(e) {
          const r = t.thumbs.swiper;
          if (!r || r.destroyed) return;
          const n = "auto" === r.params.slidesPerView ? r.slidesPerViewDynamic() : r.params.slidesPerView;
          let i = 1;
          const o = t.params.thumbs.slideThumbActiveClass;
          if (
            (t.params.slidesPerView > 1 && !t.params.centeredSlides && (i = t.params.slidesPerView),
              t.params.thumbs.multipleActiveThumbs || (i = 1),
              (i = Math.floor(i)),
              r.slides.forEach((t) => t.classList.remove(o)),
              r.params.loop || (r.params.virtual && r.params.virtual.enabled))
          )
            for (let e = 0; e < i; e += 1)
              N(r.slidesEl, `[data-swiper-slide-index="${t.realIndex + e}"]`).forEach((t) => {
                t.classList.add(o);
              });
          else for (let e = 0; e < i; e += 1) r.slides[t.realIndex + e] && r.slides[t.realIndex + e].classList.add(o);
          const a = t.params.thumbs.autoScrollOffset,
            s = a && !r.params.loop;
          if (t.realIndex !== r.realIndex || s) {
            const i = r.activeIndex;
            let o, l;
            if (r.params.loop) {
              const e = r.slides.filter((e) => e.getAttribute("data-swiper-slide-index") === `${t.realIndex}`)[0];
              (o = r.slides.indexOf(e)), (l = t.activeIndex > t.previousIndex ? "next" : "prev");
            } else (o = t.realIndex), (l = o > t.previousIndex ? "next" : "prev");
            s && (o += "next" === l ? a : -1 * a),
              r.visibleSlidesIndexes &&
              r.visibleSlidesIndexes.indexOf(o) < 0 &&
              (r.params.centeredSlides ? (o = o > i ? o - Math.floor(n / 2) + 1 : o + Math.floor(n / 2) - 1) : o > i && r.params.slidesPerGroup, r.slideTo(o, e ? 0 : void 0));
          }
        }
        (t.thumbs = { swiper: null }),
          r("beforeInit", () => {
            const { thumbs: e } = t.params;
            if (e && e.swiper)
              if ("string" == typeof e.swiper || e.swiper instanceof HTMLElement) {
                const r = M(),
                  n = () => {
                    const n = "string" == typeof e.swiper ? r.querySelector(e.swiper) : e.swiper;
                    if (n && n.swiper) (e.swiper = n.swiper), a(), s(!0);
                    else if (n) {
                      const r = (i) => {
                        (e.swiper = i.detail[0]), n.removeEventListener("init", r), a(), s(!0), e.swiper.update(), t.update();
                      };
                      n.addEventListener("init", r);
                    }
                    return n;
                  },
                  i = () => {
                    t.destroyed || n() || requestAnimationFrame(i);
                  };
                requestAnimationFrame(i);
              } else a(), s(!0);
          }),
          r("slideChange update resize observerUpdate", () => {
            s();
          }),
          r("setTransition", (e, r) => {
            const n = t.thumbs.swiper;
            n && !n.destroyed && n.setTransition(r);
          }),
          r("beforeDestroy", () => {
            const e = t.thumbs.swiper;
            e && !e.destroyed && i && e.destroy();
          }),
          Object.assign(t.thumbs, { init: a, update: s });
      }
      var Ct = r(379),
        Lt = r.n(Ct),
        kt = r(795),
        Mt = r.n(kt),
        jt = r(569),
        Rt = r.n(jt),
        It = r(565),
        zt = r.n(It),
        Dt = r(216),
        Bt = r.n(Dt),
        Ft = r(589),
        Gt = r.n(Ft),
        Nt = r(147),
        Yt = {};
      (Yt.styleTagTransform = Gt()), (Yt.setAttributes = zt()), (Yt.insert = Rt().bind(null, "head")), (Yt.domAPI = Mt()), (Yt.insertStyleElement = Bt()), Lt()(Nt.Z, Yt), Nt.Z && Nt.Z.locals && Nt.Z.locals;
      var Ht = r(35),
        Vt = {};
      function qt(t) {
        return (
          (qt =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                return typeof t;
              }
              : function (t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
              }),
          qt(t)
        );
      }
      function $t(t, e) {
        if (e && ("object" === qt(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return Xt(t);
      }
      function Xt(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }
      function Wt(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
          (Wt = function (t) {
            if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
            var r;
            if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== e) {
              if (e.has(t)) return e.get(t);
              e.set(t, n);
            }
            function n() {
              return Ut(t, arguments, Kt(this).constructor);
            }
            return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), Qt(n, t);
          }),
          Wt(t)
        );
      }
      function Ut(t, e, r) {
        return (
          (Ut = Zt()
            ? Reflect.construct.bind()
            : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && Qt(i, r.prototype), i;
            }),
          Ut.apply(null, arguments)
        );
      }
      function Zt() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { })), !0;
        } catch (t) {
          return !1;
        }
      }
      function Qt(t, e) {
        return (
          (Qt = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (t, e) {
              return (t.__proto__ = e), t;
            }),
          Qt(t, e)
        );
      }
      function Kt(t) {
        return (
          (Kt = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
          Kt(t)
        );
      }
      (Vt.styleTagTransform = Gt()), (Vt.setAttributes = zt()), (Vt.insert = Rt().bind(null, "head")), (Vt.domAPI = Mt()), (Vt.insertStyleElement = Bt()), Lt()(Ht.Z, Vt), Ht.Z && Ht.Z.locals && Ht.Z.locals;
      var Jt = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Qt(t, e);
        })(a, t);
        var e,
          r,
          n,
          o =
            ((e = a),
              (r = Zt()),
              function () {
                var t,
                  n = Kt(e);
                if (r) {
                  var i = Kt(this).constructor;
                  t = Reflect.construct(n, arguments, i);
                } else t = n.apply(this, arguments);
                return $t(this, t);
              });
        function a() {
          var t;
          !(function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          })(this, a);
          var e = i("[data-article-carousel]", Xt((t = o.call(this))));
          return (
            new _t(e, {
              modules: [Et],
              slidesPerView: 1,
              spaceBetween: 24,
              loop: !0,
              on: {
                init: function (t) {
                  var e = t.slides.length,
                    r = "".concat((2 / e) * 100, "%"),
                    n = t.el.closest("[data-carousel-container]"),
                    o = i("[data-progress]", n),
                    a = i("[data-prev-article]", n),
                    s = i("[data-next-article]", n);
                  a.listen("click", function () {
                    t.el.swiper.slidePrev();
                  }),
                    s.listen("click", function () {
                      t.el.swiper.slideNext();
                    }),
                    (o.style.width = r);
                },
                slideChange: function (t) {
                  var e = t.slides.length / 2,
                    r = t.realIndex + 1;
                  r > e && (r -= e);
                  var n = (r / e) * 100;
                  t.el.closest("[data-carousel-container]").querySelector("[data-progress]").style.width = "".concat(n, "%");
                },
              },
            }),
            t
          );
        }
        return (n = a), Object.defineProperty(n, "prototype", { writable: !1 }), n;
      })(Wt(HTMLElement));
      function te(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }
      function ee(t, e) {
        (t.prototype = Object.create(e.prototype)), (t.prototype.constructor = t), (t.__proto__ = e);
      }
      var re,
        ne,
        ie,
        oe,
        ae,
        se,
        le,
        ce,
        ue,
        pe,
        fe,
        de,
        he,
        ve,
        me,
        ye = { autoSleep: 120, force3D: "auto", nullTargetWarn: 1, units: { lineHeight: "" } },
        ge = { duration: 0.5, overwrite: !1, delay: 0 },
        be = 1e8,
        we = 1e-8,
        _e = 2 * Math.PI,
        xe = _e / 4,
        Te = 0,
        Ee = Math.sqrt,
        Se = Math.cos,
        Oe = Math.sin,
        Pe = function (t) {
          return "string" == typeof t;
        },
        Ae = function (t) {
          return "function" == typeof t;
        },
        Ce = function (t) {
          return "number" == typeof t;
        },
        Le = function (t) {
          return void 0 === t;
        },
        ke = function (t) {
          return "object" == typeof t;
        },
        Me = function (t) {
          return !1 !== t;
        },
        je = function () {
          return "undefined" != typeof window;
        },
        Re = function (t) {
          return Ae(t) || Pe(t);
        },
        Ie = ("function" == typeof ArrayBuffer && ArrayBuffer.isView) || function () { },
        ze = Array.isArray,
        De = /(?:-?\.?\d|\.)+/gi,
        Be = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
        Fe = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
        Ge = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
        Ne = /[+-]=-?[.\d]+/,
        Ye = /[^,'"\[\]\s]+/gi,
        He = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,
        Ve = {},
        qe = {},
        $e = function (t) {
          return (qe = _r(t, Ve)) && Ti;
        },
        Xe = function (t, e) {
          return console.warn("Invalid property", t, "set to", e, "Missing plugin? gsap.registerPlugin()");
        },
        We = function (t, e) {
          return !e && console.warn(t);
        },
        Ue = function (t, e) {
          return (t && (Ve[t] = e) && qe && (qe[t] = e)) || Ve;
        },
        Ze = function () {
          return 0;
        },
        Qe = { suppressEvents: !0, isStart: !0, kill: !1 },
        Ke = { suppressEvents: !0, kill: !1 },
        Je = { suppressEvents: !0 },
        tr = {},
        er = [],
        rr = {},
        nr = {},
        ir = {},
        or = 30,
        ar = [],
        sr = "",
        lr = function (t) {
          var e,
            r,
            n = t[0];
          if ((ke(n) || Ae(n) || (t = [t]), !(e = (n._gsap || {}).harness))) {
            for (r = ar.length; r-- && !ar[r].targetTest(n););
            e = ar[r];
          }
          for (r = t.length; r--;) (t[r] && (t[r]._gsap || (t[r]._gsap = new Dn(t[r], e)))) || t.splice(r, 1);
          return t;
        },
        cr = function (t) {
          return t._gsap || lr(Jr(t))[0]._gsap;
        },
        ur = function (t, e, r) {
          return (r = t[e]) && Ae(r) ? t[e]() : (Le(r) && t.getAttribute && t.getAttribute(e)) || r;
        },
        pr = function (t, e) {
          return (t = t.split(",")).forEach(e) || t;
        },
        fr = function (t) {
          return Math.round(1e5 * t) / 1e5 || 0;
        },
        dr = function (t) {
          return Math.round(1e7 * t) / 1e7 || 0;
        },
        hr = function (t, e) {
          var r = e.charAt(0),
            n = parseFloat(e.substr(2));
          return (t = parseFloat(t)), "+" === r ? t + n : "-" === r ? t - n : "*" === r ? t * n : t / n;
        },
        vr = function (t, e) {
          for (var r = e.length, n = 0; t.indexOf(e[n]) < 0 && ++n < r;);
          return n < r;
        },
        mr = function () {
          var t,
            e,
            r = er.length,
            n = er.slice(0);
          for (rr = {}, er.length = 0, t = 0; t < r; t++) (e = n[t]) && e._lazy && (e.render(e._lazy[0], e._lazy[1], !0)._lazy = 0);
        },
        yr = function (t, e, r, n) {
          er.length && !ne && mr(), t.render(e, r, n || (ne && e < 0 && (t._initted || t._startAt))), er.length && !ne && mr();
        },
        gr = function (t) {
          var e = parseFloat(t);
          return (e || 0 === e) && (t + "").match(Ye).length < 2 ? e : Pe(t) ? t.trim() : t;
        },
        br = function (t) {
          return t;
        },
        wr = function (t, e) {
          for (var r in e) r in t || (t[r] = e[r]);
          return t;
        },
        _r = function (t, e) {
          for (var r in e) t[r] = e[r];
          return t;
        },
        xr = function t(e, r) {
          for (var n in r) "__proto__" !== n && "constructor" !== n && "prototype" !== n && (e[n] = ke(r[n]) ? t(e[n] || (e[n] = {}), r[n]) : r[n]);
          return e;
        },
        Tr = function (t, e) {
          var r,
            n = {};
          for (r in t) r in e || (n[r] = t[r]);
          return n;
        },
        Er = function (t) {
          var e,
            r = t.parent || oe,
            n = t.keyframes
              ? ((e = ze(t.keyframes)),
                function (t, r) {
                  for (var n in r) n in t || ("duration" === n && e) || "ease" === n || (t[n] = r[n]);
                })
              : wr;
          if (Me(t.inherit)) for (; r;) n(t, r.vars.defaults), (r = r.parent || r._dp);
          return t;
        },
        Sr = function (t, e, r, n, i) {
          void 0 === r && (r = "_first"), void 0 === n && (n = "_last");
          var o,
            a = t[n];
          if (i) for (o = e[i]; a && a[i] > o;) a = a._prev;
          return a ? ((e._next = a._next), (a._next = e)) : ((e._next = t[r]), (t[r] = e)), e._next ? (e._next._prev = e) : (t[n] = e), (e._prev = a), (e.parent = e._dp = t), e;
        },
        Or = function (t, e, r, n) {
          void 0 === r && (r = "_first"), void 0 === n && (n = "_last");
          var i = e._prev,
            o = e._next;
          i ? (i._next = o) : t[r] === e && (t[r] = o), o ? (o._prev = i) : t[n] === e && (t[n] = i), (e._next = e._prev = e.parent = null);
        },
        Pr = function (t, e) {
          t.parent && (!e || t.parent.autoRemoveChildren) && t.parent.remove && t.parent.remove(t), (t._act = 0);
        },
        Ar = function (t, e) {
          if (t && (!e || e._end > t._dur || e._start < 0)) for (var r = t; r;) (r._dirty = 1), (r = r.parent);
          return t;
        },
        Cr = function (t) {
          for (var e = t.parent; e && e.parent;) (e._dirty = 1), e.totalDuration(), (e = e.parent);
          return t;
        },
        Lr = function (t, e, r, n) {
          return t._startAt && (ne ? t._startAt.revert(Ke) : (t.vars.immediateRender && !t.vars.autoRevert) || t._startAt.render(e, !0, n));
        },
        kr = function t(e) {
          return !e || (e._ts && t(e.parent));
        },
        Mr = function (t) {
          return t._repeat ? jr(t._tTime, (t = t.duration() + t._rDelay)) * t : 0;
        },
        jr = function (t, e) {
          var r = Math.floor((t /= e));
          return t && r === t ? r - 1 : r;
        },
        Rr = function (t, e) {
          return (t - e._start) * e._ts + (e._ts >= 0 ? 0 : e._dirty ? e.totalDuration() : e._tDur);
        },
        Ir = function (t) {
          return (t._end = dr(t._start + (t._tDur / Math.abs(t._ts || t._rts || we) || 0)));
        },
        zr = function (t, e) {
          var r = t._dp;
          return r && r.smoothChildTiming && t._ts && ((t._start = dr(r._time - (t._ts > 0 ? e / t._ts : ((t._dirty ? t.totalDuration() : t._tDur) - e) / -t._ts))), Ir(t), r._dirty || Ar(r, t)), t;
        },
        Dr = function (t, e) {
          var r;
          if (
            ((e._time || (!e._dur && e._initted) || (e._start < t._time && (e._dur || !e.add))) && ((r = Rr(t.rawTime(), e)), (!e._dur || Ur(0, e.totalDuration(), r) - e._tTime > we) && e.render(r, !0)),
              Ar(t, e)._dp && t._initted && t._time >= t._dur && t._ts)
          ) {
            if (t._dur < t.duration()) for (r = t; r._dp;) r.rawTime() >= 0 && r.totalTime(r._tTime), (r = r._dp);
            t._zTime = -1e-8;
          }
        },
        Br = function (t, e, r, n) {
          return (
            e.parent && Pr(e),
            (e._start = dr((Ce(r) ? r : r || t !== oe ? $r(t, r, e) : t._time) + e._delay)),
            (e._end = dr(e._start + (e.totalDuration() / Math.abs(e.timeScale()) || 0))),
            Sr(t, e, "_first", "_last", t._sort ? "_start" : 0),
            Yr(e) || (t._recent = e),
            n || Dr(t, e),
            t._ts < 0 && zr(t, t._tTime),
            t
          );
        },
        Fr = function (t, e) {
          return (Ve.ScrollTrigger || Xe("scrollTrigger", e)) && Ve.ScrollTrigger.create(e, t);
        },
        Gr = function (t, e, r, n, i) {
          return qn(t, e, i), t._initted ? (!r && t._pt && !ne && ((t._dur && !1 !== t.vars.lazy) || (!t._dur && t.vars.lazy)) && ue !== En.frame ? (er.push(t), (t._lazy = [i, n]), 1) : void 0) : 1;
        },
        Nr = function t(e) {
          var r = e.parent;
          return r && r._ts && r._initted && !r._lock && (r.rawTime() < 0 || t(r));
        },
        Yr = function (t) {
          var e = t.data;
          return "isFromStart" === e || "isStart" === e;
        },
        Hr = function (t, e, r, n) {
          var i = t._repeat,
            o = dr(e) || 0,
            a = t._tTime / t._tDur;
          return a && !n && (t._time *= o / t._dur), (t._dur = o), (t._tDur = i ? (i < 0 ? 1e10 : dr(o * (i + 1) + t._rDelay * i)) : o), a > 0 && !n && zr(t, (t._tTime = t._tDur * a)), t.parent && Ir(t), r || Ar(t.parent, t), t;
        },
        Vr = function (t) {
          return t instanceof Fn ? Ar(t) : Hr(t, t._dur);
        },
        qr = { _start: 0, endTime: Ze, totalDuration: Ze },
        $r = function t(e, r, n) {
          var i,
            o,
            a,
            s = e.labels,
            l = e._recent || qr,
            c = e.duration() >= be ? l.endTime(!1) : e._dur;
          return Pe(r) && (isNaN(r) || r in s)
            ? ((o = r.charAt(0)),
              (a = "%" === r.substr(-1)),
              (i = r.indexOf("=")),
              "<" === o || ">" === o
                ? (i >= 0 && (r = r.replace(/=/, "")), ("<" === o ? l._start : l.endTime(l._repeat >= 0)) + (parseFloat(r.substr(1)) || 0) * (a ? (i < 0 ? l : n).totalDuration() / 100 : 1))
                : i < 0
                  ? (r in s || (s[r] = c), s[r])
                  : ((o = parseFloat(r.charAt(i - 1) + r.substr(i + 1))), a && n && (o = (o / 100) * (ze(n) ? n[0] : n).totalDuration()), i > 1 ? t(e, r.substr(0, i - 1), n) + o : c + o))
            : null == r
              ? c
              : +r;
        },
        Xr = function (t, e, r) {
          var n,
            i,
            o = Ce(e[1]),
            a = (o ? 2 : 1) + (t < 2 ? 0 : 1),
            s = e[a];
          if ((o && (s.duration = e[1]), (s.parent = r), t)) {
            for (n = s, i = r; i && !("immediateRender" in n);) (n = i.vars.defaults || {}), (i = Me(i.vars.inherit) && i.parent);
            (s.immediateRender = Me(n.immediateRender)), t < 2 ? (s.runBackwards = 1) : (s.startAt = e[a - 1]);
          }
          return new Zn(e[0], s, e[a + 1]);
        },
        Wr = function (t, e) {
          return t || 0 === t ? e(t) : e;
        },
        Ur = function (t, e, r) {
          return r < t ? t : r > e ? e : r;
        },
        Zr = function (t, e) {
          return Pe(t) && (e = He.exec(t)) ? e[1] : "";
        },
        Qr = [].slice,
        Kr = function (t, e) {
          return t && ke(t) && "length" in t && ((!e && !t.length) || (t.length - 1 in t && ke(t[0]))) && !t.nodeType && t !== ae;
        },
        Jr = function (t, e, r) {
          return ie && !e && ie.selector
            ? ie.selector(t)
            : !Pe(t) || r || (!se && Sn())
              ? ze(t)
                ? (function (t, e, r) {
                  return (
                    void 0 === r && (r = []),
                    t.forEach(function (t) {
                      var n;
                      return (Pe(t) && !e) || Kr(t, 1) ? (n = r).push.apply(n, Jr(t)) : r.push(t);
                    }) || r
                  );
                })(t, r)
                : Kr(t)
                  ? Qr.call(t, 0)
                  : t
                    ? [t]
                    : []
              : Qr.call((e || le).querySelectorAll(t), 0);
        },
        tn = function (t) {
          return (
            (t = Jr(t)[0] || We("Invalid scope") || {}),
            function (e) {
              var r = t.current || t.nativeElement || t;
              return Jr(e, r.querySelectorAll ? r : r === t ? We("Invalid scope") || le.createElement("div") : t);
            }
          );
        },
        en = function (t) {
          return t.sort(function () {
            return 0.5 - Math.random();
          });
        },
        rn = function (t) {
          if (Ae(t)) return t;
          var e = ke(t) ? t : { each: t },
            r = Mn(e.ease),
            n = e.from || 0,
            i = parseFloat(e.base) || 0,
            o = {},
            a = n > 0 && n < 1,
            s = isNaN(n) || a,
            l = e.axis,
            c = n,
            u = n;
          return (
            Pe(n) ? (c = u = { center: 0.5, edges: 0.5, end: 1 }[n] || 0) : !a && s && ((c = n[0]), (u = n[1])),
            function (t, a, p) {
              var f,
                d,
                h,
                v,
                m,
                y,
                g,
                b,
                w,
                _ = (p || e).length,
                x = o[_];
              if (!x) {
                if (!(w = "auto" === e.grid ? 0 : (e.grid || [1, be])[1])) {
                  for (g = -be; g < (g = p[w++].getBoundingClientRect().left) && w < _;);
                  w--;
                }
                for (x = o[_] = [], f = s ? Math.min(w, _) * c - 0.5 : n % w, d = w === be ? 0 : s ? (_ * u) / w - 0.5 : (n / w) | 0, g = 0, b = be, y = 0; y < _; y++)
                  (h = (y % w) - f), (v = d - ((y / w) | 0)), (x[y] = m = l ? Math.abs("y" === l ? v : h) : Ee(h * h + v * v)), m > g && (g = m), m < b && (b = m);
                "random" === n && en(x),
                  (x.max = g - b),
                  (x.min = b),
                  (x.v = _ = (parseFloat(e.amount) || parseFloat(e.each) * (w > _ ? _ - 1 : l ? ("y" === l ? _ / w : w) : Math.max(w, _ / w)) || 0) * ("edges" === n ? -1 : 1)),
                  (x.b = _ < 0 ? i - _ : i),
                  (x.u = Zr(e.amount || e.each) || 0),
                  (r = r && _ < 0 ? Ln(r) : r);
              }
              return (_ = (x[t] - x.min) / x.max || 0), dr(x.b + (r ? r(_) : _) * x.v) + x.u;
            }
          );
        },
        nn = function (t) {
          var e = Math.pow(10, ((t + "").split(".")[1] || "").length);
          return function (r) {
            var n = dr(Math.round(parseFloat(r) / t) * t * e);
            return (n - (n % 1)) / e + (Ce(r) ? 0 : Zr(r));
          };
        },
        on = function (t, e) {
          var r,
            n,
            i = ze(t);
          return (
            !i && ke(t) && ((r = i = t.radius || be), t.values ? ((t = Jr(t.values)), (n = !Ce(t[0])) && (r *= r)) : (t = nn(t.increment))),
            Wr(
              e,
              i
                ? Ae(t)
                  ? function (e) {
                    return (n = t(e)), Math.abs(n - e) <= r ? n : e;
                  }
                  : function (e) {
                    for (var i, o, a = parseFloat(n ? e.x : e), s = parseFloat(n ? e.y : 0), l = be, c = 0, u = t.length; u--;)
                      (i = n ? (i = t[u].x - a) * i + (o = t[u].y - s) * o : Math.abs(t[u] - a)) < l && ((l = i), (c = u));
                    return (c = !r || l <= r ? t[c] : e), n || c === e || Ce(e) ? c : c + Zr(e);
                  }
                : nn(t)
            )
          );
        },
        an = function (t, e, r, n) {
          return Wr(ze(t) ? !e : !0 === r ? !!(r = 0) : !n, function () {
            return ze(t) ? t[~~(Math.random() * t.length)] : (r = r || 1e-5) && (n = r < 1 ? Math.pow(10, (r + "").length - 2) : 1) && Math.floor(Math.round((t - r / 2 + Math.random() * (e - t + 0.99 * r)) / r) * r * n) / n;
          });
        },
        sn = function (t, e, r) {
          return Wr(r, function (r) {
            return t[~~e(r)];
          });
        },
        ln = function (t) {
          for (var e, r, n, i, o = 0, a = ""; ~(e = t.indexOf("random(", o));)
            (n = t.indexOf(")", e)), (i = "[" === t.charAt(e + 7)), (r = t.substr(e + 7, n - e - 7).match(i ? Ye : De)), (a += t.substr(o, e - o) + an(i ? r : +r[0], i ? 0 : +r[1], +r[2] || 1e-5)), (o = n + 1);
          return a + t.substr(o, t.length - o);
        },
        cn = function (t, e, r, n, i) {
          var o = e - t,
            a = n - r;
          return Wr(i, function (e) {
            return r + (((e - t) / o) * a || 0);
          });
        },
        un = function (t, e, r) {
          var n,
            i,
            o,
            a = t.labels,
            s = be;
          for (n in a) (i = a[n] - e) < 0 == !!r && i && s > (i = Math.abs(i)) && ((o = n), (s = i));
          return o;
        },
        pn = function (t, e, r) {
          var n,
            i,
            o,
            a = t.vars,
            s = a[e],
            l = ie,
            c = t._ctx;
          if (s) return (n = a[e + "Params"]), (i = a.callbackScope || t), r && er.length && mr(), c && (ie = c), (o = n ? s.apply(i, n) : s.call(i)), (ie = l), o;
        },
        fn = function (t) {
          return Pr(t), t.scrollTrigger && t.scrollTrigger.kill(!!ne), t.progress() < 1 && pn(t, "onInterrupt"), t;
        },
        dn = [],
        hn = function (t) {
          if (je() && t) {
            var e = (t = (!t.name && t.default) || t).name,
              r = Ae(t),
              n =
                e && !r && t.init
                  ? function () {
                    this._props = [];
                  }
                  : t,
              i = { init: Ze, render: oi, add: Hn, kill: si, modifier: ai, rawVars: 0 },
              o = { targetTest: 0, get: 0, getSetter: ei, aliases: {}, register: 0 };
            if ((Sn(), t !== n)) {
              if (nr[e]) return;
              wr(n, wr(Tr(t, i), o)), _r(n.prototype, _r(i, Tr(t, o))), (nr[(n.prop = e)] = n), t.targetTest && (ar.push(n), (tr[e] = 1)), (e = ("css" === e ? "CSS" : e.charAt(0).toUpperCase() + e.substr(1)) + "Plugin");
            }
            Ue(e, n), t.register && t.register(Ti, n, ui);
          } else t && dn.push(t);
        },
        vn = 255,
        mn = {
          aqua: [0, vn, vn],
          lime: [0, vn, 0],
          silver: [192, 192, 192],
          black: [0, 0, 0],
          maroon: [128, 0, 0],
          teal: [0, 128, 128],
          blue: [0, 0, vn],
          navy: [0, 0, 128],
          white: [vn, vn, vn],
          olive: [128, 128, 0],
          yellow: [vn, vn, 0],
          orange: [vn, 165, 0],
          gray: [128, 128, 128],
          purple: [128, 0, 128],
          green: [0, 128, 0],
          red: [vn, 0, 0],
          pink: [vn, 192, 203],
          cyan: [0, vn, vn],
          transparent: [vn, vn, vn, 0],
        },
        yn = function (t, e, r) {
          return ((6 * (t += t < 0 ? 1 : t > 1 ? -1 : 0) < 1 ? e + (r - e) * t * 6 : t < 0.5 ? r : 3 * t < 2 ? e + (r - e) * (2 / 3 - t) * 6 : e) * vn + 0.5) | 0;
        },
        gn = function (t, e, r) {
          var n,
            i,
            o,
            a,
            s,
            l,
            c,
            u,
            p,
            f,
            d = t ? (Ce(t) ? [t >> 16, (t >> 8) & vn, t & vn] : 0) : mn.black;
          if (!d) {
            if (("," === t.substr(-1) && (t = t.substr(0, t.length - 1)), mn[t])) d = mn[t];
            else if ("#" === t.charAt(0)) {
              if ((t.length < 6 && ((n = t.charAt(1)), (i = t.charAt(2)), (o = t.charAt(3)), (t = "#" + n + n + i + i + o + o + (5 === t.length ? t.charAt(4) + t.charAt(4) : ""))), 9 === t.length))
                return [(d = parseInt(t.substr(1, 6), 16)) >> 16, (d >> 8) & vn, d & vn, parseInt(t.substr(7), 16) / 255];
              d = [(t = parseInt(t.substr(1), 16)) >> 16, (t >> 8) & vn, t & vn];
            } else if ("hsl" === t.substr(0, 3))
              if (((d = f = t.match(De)), e)) {
                if (~t.indexOf("=")) return (d = t.match(Be)), r && d.length < 4 && (d[3] = 1), d;
              } else
                (a = (+d[0] % 360) / 360),
                  (s = +d[1] / 100),
                  (n = 2 * (l = +d[2] / 100) - (i = l <= 0.5 ? l * (s + 1) : l + s - l * s)),
                  d.length > 3 && (d[3] *= 1),
                  (d[0] = yn(a + 1 / 3, n, i)),
                  (d[1] = yn(a, n, i)),
                  (d[2] = yn(a - 1 / 3, n, i));
            else d = t.match(De) || mn.transparent;
            d = d.map(Number);
          }
          return (
            e &&
            !f &&
            ((n = d[0] / vn),
              (i = d[1] / vn),
              (o = d[2] / vn),
              (l = ((c = Math.max(n, i, o)) + (u = Math.min(n, i, o))) / 2),
              c === u ? (a = s = 0) : ((p = c - u), (s = l > 0.5 ? p / (2 - c - u) : p / (c + u)), (a = c === n ? (i - o) / p + (i < o ? 6 : 0) : c === i ? (o - n) / p + 2 : (n - i) / p + 4), (a *= 60)),
              (d[0] = ~~(a + 0.5)),
              (d[1] = ~~(100 * s + 0.5)),
              (d[2] = ~~(100 * l + 0.5))),
            r && d.length < 4 && (d[3] = 1),
            d
          );
        },
        bn = function (t) {
          var e = [],
            r = [],
            n = -1;
          return (
            t.split(_n).forEach(function (t) {
              var i = t.match(Fe) || [];
              e.push.apply(e, i), r.push((n += i.length + 1));
            }),
            (e.c = r),
            e
          );
        },
        wn = function (t, e, r) {
          var n,
            i,
            o,
            a,
            s = "",
            l = (t + s).match(_n),
            c = e ? "hsla(" : "rgba(",
            u = 0;
          if (!l) return t;
          if (
            ((l = l.map(function (t) {
              return (t = gn(t, e, 1)) && c + (e ? t[0] + "," + t[1] + "%," + t[2] + "%," + t[3] : t.join(",")) + ")";
            })),
              r && ((o = bn(t)), (n = r.c).join(s) !== o.c.join(s)))
          )
            for (a = (i = t.replace(_n, "1").split(Fe)).length - 1; u < a; u++) s += i[u] + (~n.indexOf(u) ? l.shift() || c + "0,0,0,0)" : (o.length ? o : l.length ? l : r).shift());
          if (!i) for (a = (i = t.split(_n)).length - 1; u < a; u++) s += i[u] + l[u];
          return s + i[a];
        },
        _n = (function () {
          var t,
            e = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b";
          for (t in mn) e += "|" + t + "\\b";
          return new RegExp(e + ")", "gi");
        })(),
        xn = /hsl[a]?\(/,
        Tn = function (t) {
          var e,
            r = t.join(" ");
          if (((_n.lastIndex = 0), _n.test(r))) return (e = xn.test(r)), (t[1] = wn(t[1], e)), (t[0] = wn(t[0], e, bn(t[1]))), !0;
        },
        En = (function () {
          var t,
            e,
            r,
            n,
            i,
            o,
            a = Date.now,
            s = 500,
            l = 33,
            c = a(),
            u = c,
            p = 1e3 / 240,
            f = p,
            d = [],
            h = function r(h) {
              var v,
                m,
                y,
                g,
                b = a() - u,
                w = !0 === h;
              if ((b > s && (c += b - l), ((v = (y = (u += b) - c) - f) > 0 || w) && ((g = ++n.frame), (i = y - 1e3 * n.time), (n.time = y /= 1e3), (f += v + (v >= p ? 4 : p - v)), (m = 1)), w || (t = e(r)), m))
                for (o = 0; o < d.length; o++) d[o](y, i, g, h);
            };
          return (n = {
            time: 0,
            frame: 0,
            tick: function () {
              h(!0);
            },
            deltaRatio: function (t) {
              return i / (1e3 / (t || 60));
            },
            wake: function () {
              ce &&
                (!se &&
                  je() &&
                  ((ae = se = window),
                    (le = ae.document || {}),
                    (Ve.gsap = Ti),
                    (ae.gsapVersions || (ae.gsapVersions = [])).push(Ti.version),
                    $e(qe || ae.GreenSockGlobals || (!ae.gsap && ae) || {}),
                    (r = ae.requestAnimationFrame),
                    dn.forEach(hn)),
                  t && n.sleep(),
                  (e =
                    r ||
                    function (t) {
                      return setTimeout(t, (f - 1e3 * n.time + 1) | 0);
                    }),
                  (fe = 1),
                  h(2));
            },
            sleep: function () {
              (r ? ae.cancelAnimationFrame : clearTimeout)(t), (fe = 0), (e = Ze);
            },
            lagSmoothing: function (t, e) {
              (s = t || 1 / 0), (l = Math.min(e || 33, s));
            },
            fps: function (t) {
              (p = 1e3 / (t || 240)), (f = 1e3 * n.time + p);
            },
            add: function (t, e, r) {
              var i = e
                ? function (e, r, o, a) {
                  t(e, r, o, a), n.remove(i);
                }
                : t;
              return n.remove(t), d[r ? "unshift" : "push"](i), Sn(), i;
            },
            remove: function (t, e) {
              ~(e = d.indexOf(t)) && d.splice(e, 1) && o >= e && o--;
            },
            _listeners: d,
          });
        })(),
        Sn = function () {
          return !fe && En.wake();
        },
        On = {},
        Pn = /^[\d.\-M][\d.\-,\s]/,
        An = /["']/g,
        Cn = function (t) {
          for (var e, r, n, i = {}, o = t.substr(1, t.length - 3).split(":"), a = o[0], s = 1, l = o.length; s < l; s++)
            (r = o[s]), (e = s !== l - 1 ? r.lastIndexOf(",") : r.length), (n = r.substr(0, e)), (i[a] = isNaN(n) ? n.replace(An, "").trim() : +n), (a = r.substr(e + 1).trim());
          return i;
        },
        Ln = function (t) {
          return function (e) {
            return 1 - t(1 - e);
          };
        },
        kn = function t(e, r) {
          for (var n, i = e._first; i;)
            i instanceof Fn ? t(i, r) : !i.vars.yoyoEase || (i._yoyo && i._repeat) || i._yoyo === r || (i.timeline ? t(i.timeline, r) : ((n = i._ease), (i._ease = i._yEase), (i._yEase = n), (i._yoyo = r))), (i = i._next);
        },
        Mn = function (t, e) {
          return (
            (t &&
              (Ae(t)
                ? t
                : On[t] ||
                (function (t) {
                  var e,
                    r,
                    n,
                    i,
                    o = (t + "").split("("),
                    a = On[o[0]];
                  return a && o.length > 1 && a.config
                    ? a.config.apply(
                      null,
                      ~t.indexOf("{") ? [Cn(o[1])] : ((e = t), (r = e.indexOf("(") + 1), (n = e.indexOf(")")), (i = e.indexOf("(", r)), e.substring(r, ~i && i < n ? e.indexOf(")", n + 1) : n)).split(",").map(gr)
                    )
                    : On._CE && Pn.test(t)
                      ? On._CE("", t)
                      : a;
                })(t))) ||
            e
          );
        },
        jn = function (t, e, r, n) {
          void 0 === r &&
            (r = function (t) {
              return 1 - e(1 - t);
            }),
            void 0 === n &&
            (n = function (t) {
              return t < 0.5 ? e(2 * t) / 2 : 1 - e(2 * (1 - t)) / 2;
            });
          var i,
            o = { easeIn: e, easeOut: r, easeInOut: n };
          return (
            pr(t, function (t) {
              for (var e in ((On[t] = Ve[t] = o), (On[(i = t.toLowerCase())] = r), o)) On[i + ("easeIn" === e ? ".in" : "easeOut" === e ? ".out" : ".inOut")] = On[t + "." + e] = o[e];
            }),
            o
          );
        },
        Rn = function (t) {
          return function (e) {
            return e < 0.5 ? (1 - t(1 - 2 * e)) / 2 : 0.5 + t(2 * (e - 0.5)) / 2;
          };
        },
        In = function t(e, r, n) {
          var i = r >= 1 ? r : 1,
            o = (n || (e ? 0.3 : 0.45)) / (r < 1 ? r : 1),
            a = (o / _e) * (Math.asin(1 / i) || 0),
            s = function (t) {
              return 1 === t ? 1 : i * Math.pow(2, -10 * t) * Oe((t - a) * o) + 1;
            },
            l =
              "out" === e
                ? s
                : "in" === e
                  ? function (t) {
                    return 1 - s(1 - t);
                  }
                  : Rn(s);
          return (
            (o = _e / o),
            (l.config = function (r, n) {
              return t(e, r, n);
            }),
            l
          );
        },
        zn = function t(e, r) {
          void 0 === r && (r = 1.70158);
          var n = function (t) {
            return t ? --t * t * ((r + 1) * t + r) + 1 : 0;
          },
            i =
              "out" === e
                ? n
                : "in" === e
                  ? function (t) {
                    return 1 - n(1 - t);
                  }
                  : Rn(n);
          return (
            (i.config = function (r) {
              return t(e, r);
            }),
            i
          );
        };
      pr("Linear,Quad,Cubic,Quart,Quint,Strong", function (t, e) {
        var r = e < 5 ? e + 1 : e;
        jn(
          t + ",Power" + (r - 1),
          e
            ? function (t) {
              return Math.pow(t, r);
            }
            : function (t) {
              return t;
            },
          function (t) {
            return 1 - Math.pow(1 - t, r);
          },
          function (t) {
            return t < 0.5 ? Math.pow(2 * t, r) / 2 : 1 - Math.pow(2 * (1 - t), r) / 2;
          }
        );
      }),
        (On.Linear.easeNone = On.none = On.Linear.easeIn),
        jn("Elastic", In("in"), In("out"), In()),
        (de = 7.5625),
        (ve = 1 / (he = 2.75)),
        jn(
          "Bounce",
          function (t) {
            return 1 - me(1 - t);
          },
          (me = function (t) {
            return t < ve ? de * t * t : t < 0.7272727272727273 ? de * Math.pow(t - 1.5 / he, 2) + 0.75 : t < 0.9090909090909092 ? de * (t -= 2.25 / he) * t + 0.9375 : de * Math.pow(t - 2.625 / he, 2) + 0.984375;
          })
        ),
        jn("Expo", function (t) {
          return t ? Math.pow(2, 10 * (t - 1)) : 0;
        }),
        jn("Circ", function (t) {
          return -(Ee(1 - t * t) - 1);
        }),
        jn("Sine", function (t) {
          return 1 === t ? 1 : 1 - Se(t * xe);
        }),
        jn("Back", zn("in"), zn("out"), zn()),
        (On.SteppedEase = On.steps = Ve.SteppedEase = {
          config: function (t, e) {
            void 0 === t && (t = 1);
            var r = 1 / t,
              n = t + (e ? 0 : 1),
              i = e ? 1 : 0;
            return function (t) {
              return (((n * Ur(0, 0.99999999, t)) | 0) + i) * r;
            };
          },
        }),
        (ge.ease = On["quad.out"]),
        pr("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function (t) {
          return (sr += t + "," + t + "Params,");
        });
      var Dn = function (t, e) {
        (this.id = Te++), (t._gsap = this), (this.target = t), (this.harness = e), (this.get = e ? e.get : ur), (this.set = e ? e.getSetter : ei);
      },
        Bn = (function () {
          function t(t) {
            (this.vars = t),
              (this._delay = +t.delay || 0),
              (this._repeat = t.repeat === 1 / 0 ? -2 : t.repeat || 0) && ((this._rDelay = t.repeatDelay || 0), (this._yoyo = !!t.yoyo || !!t.yoyoEase)),
              (this._ts = 1),
              Hr(this, +t.duration, 1, 1),
              (this.data = t.data),
              ie && ((this._ctx = ie), ie.data.push(this)),
              fe || En.wake();
          }
          var e = t.prototype;
          return (
            (e.delay = function (t) {
              return t || 0 === t ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + t - this._delay), (this._delay = t), this) : this._delay;
            }),
            (e.duration = function (t) {
              return arguments.length ? this.totalDuration(this._repeat > 0 ? t + (t + this._rDelay) * this._repeat : t) : this.totalDuration() && this._dur;
            }),
            (e.totalDuration = function (t) {
              return arguments.length ? ((this._dirty = 0), Hr(this, this._repeat < 0 ? t : (t - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
            }),
            (e.totalTime = function (t, e) {
              if ((Sn(), !arguments.length)) return this._tTime;
              var r = this._dp;
              if (r && r.smoothChildTiming && this._ts) {
                for (zr(this, t), !r._dp || r.parent || Dr(r, this); r && r.parent;)
                  r.parent._time !== r._start + (r._ts >= 0 ? r._tTime / r._ts : (r.totalDuration() - r._tTime) / -r._ts) && r.totalTime(r._tTime, !0), (r = r.parent);
                !this.parent && this._dp.autoRemoveChildren && ((this._ts > 0 && t < this._tDur) || (this._ts < 0 && t > 0) || (!this._tDur && !t)) && Br(this._dp, this, this._start - this._delay);
              }
              return (
                (this._tTime !== t || (!this._dur && !e) || (this._initted && Math.abs(this._zTime) === we) || (!t && !this._initted && (this.add || this._ptLookup))) && (this._ts || (this._pTime = t), yr(this, t, e)), this
              );
            }),
            (e.time = function (t, e) {
              return arguments.length ? this.totalTime(Math.min(this.totalDuration(), t + Mr(this)) % (this._dur + this._rDelay) || (t ? this._dur : 0), e) : this._time;
            }),
            (e.totalProgress = function (t, e) {
              return arguments.length ? this.totalTime(this.totalDuration() * t, e) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.ratio;
            }),
            (e.progress = function (t, e) {
              return arguments.length ? this.totalTime(this.duration() * (!this._yoyo || 1 & this.iteration() ? t : 1 - t) + Mr(this), e) : this.duration() ? Math.min(1, this._time / this._dur) : this.ratio;
            }),
            (e.iteration = function (t, e) {
              var r = this.duration() + this._rDelay;
              return arguments.length ? this.totalTime(this._time + (t - 1) * r, e) : this._repeat ? jr(this._tTime, r) + 1 : 1;
            }),
            (e.timeScale = function (t) {
              if (!arguments.length) return -1e-8 === this._rts ? 0 : this._rts;
              if (this._rts === t) return this;
              var e = this.parent && this._ts ? Rr(this.parent._time, this) : this._tTime;
              return (this._rts = +t || 0), (this._ts = this._ps || -1e-8 === t ? 0 : this._rts), this.totalTime(Ur(-Math.abs(this._delay), this._tDur, e), !0), Ir(this), Cr(this);
            }),
            (e.paused = function (t) {
              return arguments.length
                ? (this._ps !== t &&
                  ((this._ps = t),
                    t
                      ? ((this._pTime = this._tTime || Math.max(-this._delay, this.rawTime())), (this._ts = this._act = 0))
                      : (Sn(),
                        (this._ts = this._rts),
                        this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, 1 === this.progress() && Math.abs(this._zTime) !== we && (this._tTime -= we)))),
                  this)
                : this._ps;
            }),
            (e.startTime = function (t) {
              if (arguments.length) {
                this._start = t;
                var e = this.parent || this._dp;
                return e && (e._sort || !this.parent) && Br(e, this, t - this._delay), this;
              }
              return this._start;
            }),
            (e.endTime = function (t) {
              return this._start + (Me(t) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
            }),
            (e.rawTime = function (t) {
              var e = this.parent || this._dp;
              return e ? (t && (!this._ts || (this._repeat && this._time && this.totalProgress() < 1)) ? this._tTime % (this._dur + this._rDelay) : this._ts ? Rr(e.rawTime(t), this) : this._tTime) : this._tTime;
            }),
            (e.revert = function (t) {
              void 0 === t && (t = Je);
              var e = ne;
              return (ne = t), (this._initted || this._startAt) && (this.timeline && this.timeline.revert(t), this.totalTime(-0.01, t.suppressEvents)), "nested" !== this.data && !1 !== t.kill && this.kill(), (ne = e), this;
            }),
            (e.globalTime = function (t) {
              for (var e = this, r = arguments.length ? t : e.rawTime(); e;) (r = e._start + r / (e._ts || 1)), (e = e._dp);
              return !this.parent && this._sat ? (this._sat.vars.immediateRender ? -1 / 0 : this._sat.globalTime(t)) : r;
            }),
            (e.repeat = function (t) {
              return arguments.length ? ((this._repeat = t === 1 / 0 ? -2 : t), Vr(this)) : -2 === this._repeat ? 1 / 0 : this._repeat;
            }),
            (e.repeatDelay = function (t) {
              if (arguments.length) {
                var e = this._time;
                return (this._rDelay = t), Vr(this), e ? this.time(e) : this;
              }
              return this._rDelay;
            }),
            (e.yoyo = function (t) {
              return arguments.length ? ((this._yoyo = t), this) : this._yoyo;
            }),
            (e.seek = function (t, e) {
              return this.totalTime($r(this, t), Me(e));
            }),
            (e.restart = function (t, e) {
              return this.play().totalTime(t ? -this._delay : 0, Me(e));
            }),
            (e.play = function (t, e) {
              return null != t && this.seek(t, e), this.reversed(!1).paused(!1);
            }),
            (e.reverse = function (t, e) {
              return null != t && this.seek(t || this.totalDuration(), e), this.reversed(!0).paused(!1);
            }),
            (e.pause = function (t, e) {
              return null != t && this.seek(t, e), this.paused(!0);
            }),
            (e.resume = function () {
              return this.paused(!1);
            }),
            (e.reversed = function (t) {
              return arguments.length ? (!!t !== this.reversed() && this.timeScale(-this._rts || (t ? -1e-8 : 0)), this) : this._rts < 0;
            }),
            (e.invalidate = function () {
              return (this._initted = this._act = 0), (this._zTime = -1e-8), this;
            }),
            (e.isActive = function () {
              var t,
                e = this.parent || this._dp,
                r = this._start;
              return !(e && !(this._ts && this._initted && e.isActive() && (t = e.rawTime(!0)) >= r && t < this.endTime(!0) - we));
            }),
            (e.eventCallback = function (t, e, r) {
              var n = this.vars;
              return arguments.length > 1 ? (e ? ((n[t] = e), r && (n[t + "Params"] = r), "onUpdate" === t && (this._onUpdate = e)) : delete n[t], this) : n[t];
            }),
            (e.then = function (t) {
              var e = this;
              return new Promise(function (r) {
                var n = Ae(t) ? t : br,
                  i = function () {
                    var t = e.then;
                    (e.then = null), Ae(n) && (n = n(e)) && (n.then || n === e) && (e.then = t), r(n), (e.then = t);
                  };
                (e._initted && 1 === e.totalProgress() && e._ts >= 0) || (!e._tTime && e._ts < 0) ? i() : (e._prom = i);
              });
            }),
            (e.kill = function () {
              fn(this);
            }),
            t
          );
        })();
      wr(Bn.prototype, { _time: 0, _start: 0, _end: 0, _tTime: 0, _tDur: 0, _dirty: 0, _repeat: 0, _yoyo: !1, parent: null, _initted: !1, _rDelay: 0, _ts: 1, _dp: 0, ratio: 0, _zTime: -1e-8, _prom: 0, _ps: !1, _rts: 1 });
      var Fn = (function (t) {
        function e(e, r) {
          var n;
          return (
            void 0 === e && (e = {}),
            ((n = t.call(this, e) || this).labels = {}),
            (n.smoothChildTiming = !!e.smoothChildTiming),
            (n.autoRemoveChildren = !!e.autoRemoveChildren),
            (n._sort = Me(e.sortChildren)),
            oe && Br(e.parent || oe, te(n), r),
            e.reversed && n.reverse(),
            e.paused && n.paused(!0),
            e.scrollTrigger && Fr(te(n), e.scrollTrigger),
            n
          );
        }
        ee(e, t);
        var r = e.prototype;
        return (
          (r.to = function (t, e, r) {
            return Xr(0, arguments, this), this;
          }),
          (r.from = function (t, e, r) {
            return Xr(1, arguments, this), this;
          }),
          (r.fromTo = function (t, e, r, n) {
            return Xr(2, arguments, this), this;
          }),
          (r.set = function (t, e, r) {
            return (e.duration = 0), (e.parent = this), Er(e).repeatDelay || (e.repeat = 0), (e.immediateRender = !!e.immediateRender), new Zn(t, e, $r(this, r), 1), this;
          }),
          (r.call = function (t, e, r) {
            return Br(this, Zn.delayedCall(0, t, e), r);
          }),
          (r.staggerTo = function (t, e, r, n, i, o, a) {
            return (r.duration = e), (r.stagger = r.stagger || n), (r.onComplete = o), (r.onCompleteParams = a), (r.parent = this), new Zn(t, r, $r(this, i)), this;
          }),
          (r.staggerFrom = function (t, e, r, n, i, o, a) {
            return (r.runBackwards = 1), (Er(r).immediateRender = Me(r.immediateRender)), this.staggerTo(t, e, r, n, i, o, a);
          }),
          (r.staggerFromTo = function (t, e, r, n, i, o, a, s) {
            return (n.startAt = r), (Er(n).immediateRender = Me(n.immediateRender)), this.staggerTo(t, e, n, i, o, a, s);
          }),
          (r.render = function (t, e, r) {
            var n,
              i,
              o,
              a,
              s,
              l,
              c,
              u,
              p,
              f,
              d,
              h,
              v = this._time,
              m = this._dirty ? this.totalDuration() : this._tDur,
              y = this._dur,
              g = t <= 0 ? 0 : dr(t),
              b = this._zTime < 0 != t < 0 && (this._initted || !y);
            if ((this !== oe && g > m && t >= 0 && (g = m), g !== this._tTime || r || b)) {
              if ((v !== this._time && y && ((g += this._time - v), (t += this._time - v)), (n = g), (p = this._start), (l = !(u = this._ts)), b && (y || (v = this._zTime), (t || !e) && (this._zTime = t)), this._repeat)) {
                if (((d = this._yoyo), (s = y + this._rDelay), this._repeat < -1 && t < 0)) return this.totalTime(100 * s + t, e, r);
                if (
                  ((n = dr(g % s)),
                    g === m ? ((a = this._repeat), (n = y)) : ((a = ~~(g / s)) && a === g / s && ((n = y), a--), n > y && (n = y)),
                    (f = jr(this._tTime, s)),
                    !v && this._tTime && f !== a && this._tTime - f * s - this._dur <= 0 && (f = a),
                    d && 1 & a && ((n = y - n), (h = 1)),
                    a !== f && !this._lock)
                ) {
                  var w = d && 1 & f,
                    _ = w === (d && 1 & a);
                  if (
                    (a < f && (w = !w),
                      (v = w ? 0 : g % y ? y : g),
                      (this._lock = 1),
                      (this.render(v || (h ? 0 : dr(a * s)), e, !y)._lock = 0),
                      (this._tTime = g),
                      !e && this.parent && pn(this, "onRepeat"),
                      this.vars.repeatRefresh && !h && (this.invalidate()._lock = 1),
                      (v && v !== this._time) || l !== !this._ts || (this.vars.onRepeat && !this.parent && !this._act))
                  )
                    return this;
                  if (((y = this._dur), (m = this._tDur), _ && ((this._lock = 2), (v = w ? y : -1e-4), this.render(v, !0), this.vars.repeatRefresh && !h && this.invalidate()), (this._lock = 0), !this._ts && !l))
                    return this;
                  kn(this, h);
                }
              }
              if (
                (this._hasPause &&
                  !this._forcing &&
                  this._lock < 2 &&
                  ((c = (function (t, e, r) {
                    var n;
                    if (r > e)
                      for (n = t._first; n && n._start <= r;) {
                        if ("isPause" === n.data && n._start > e) return n;
                        n = n._next;
                      }
                    else
                      for (n = t._last; n && n._start >= r;) {
                        if ("isPause" === n.data && n._start < e) return n;
                        n = n._prev;
                      }
                  })(this, dr(v), dr(n))),
                    c && (g -= n - (n = c._start))),
                  (this._tTime = g),
                  (this._time = n),
                  (this._act = !u),
                  this._initted || ((this._onUpdate = this.vars.onUpdate), (this._initted = 1), (this._zTime = t), (v = 0)),
                  !v && n && !e && !a && (pn(this, "onStart"), this._tTime !== g))
              )
                return this;
              if (n >= v && t >= 0)
                for (i = this._first; i;) {
                  if (((o = i._next), (i._act || n >= i._start) && i._ts && c !== i)) {
                    if (i.parent !== this) return this.render(t, e, r);
                    if ((i.render(i._ts > 0 ? (n - i._start) * i._ts : (i._dirty ? i.totalDuration() : i._tDur) + (n - i._start) * i._ts, e, r), n !== this._time || (!this._ts && !l))) {
                      (c = 0), o && (g += this._zTime = -1e-8);
                      break;
                    }
                  }
                  i = o;
                }
              else {
                i = this._last;
                for (var x = t < 0 ? t : n; i;) {
                  if (((o = i._prev), (i._act || x <= i._end) && i._ts && c !== i)) {
                    if (i.parent !== this) return this.render(t, e, r);
                    if (
                      (i.render(i._ts > 0 ? (x - i._start) * i._ts : (i._dirty ? i.totalDuration() : i._tDur) + (x - i._start) * i._ts, e, r || (ne && (i._initted || i._startAt))),
                        n !== this._time || (!this._ts && !l))
                    ) {
                      (c = 0), o && (g += this._zTime = x ? -1e-8 : we);
                      break;
                    }
                  }
                  i = o;
                }
              }
              if (c && !e && (this.pause(), (c.render(n >= v ? 0 : -1e-8)._zTime = n >= v ? 1 : -1), this._ts)) return (this._start = p), Ir(this), this.render(t, e, r);
              this._onUpdate && !e && pn(this, "onUpdate", !0),
                ((g === m && this._tTime >= this.totalDuration()) || (!g && v)) &&
                ((p !== this._start && Math.abs(u) === Math.abs(this._ts)) ||
                  this._lock ||
                  ((t || !y) && ((g === m && this._ts > 0) || (!g && this._ts < 0)) && Pr(this, 1),
                    e || (t < 0 && !v) || (!g && !v && m) || (pn(this, g === m && t >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(g < m && this.timeScale() > 0) && this._prom())));
            }
            return this;
          }),
          (r.add = function (t, e) {
            var r = this;
            if ((Ce(e) || (e = $r(this, e, t)), !(t instanceof Bn))) {
              if (ze(t))
                return (
                  t.forEach(function (t) {
                    return r.add(t, e);
                  }),
                  this
                );
              if (Pe(t)) return this.addLabel(t, e);
              if (!Ae(t)) return this;
              t = Zn.delayedCall(0, t);
            }
            return this !== t ? Br(this, t, e) : this;
          }),
          (r.getChildren = function (t, e, r, n) {
            void 0 === t && (t = !0), void 0 === e && (e = !0), void 0 === r && (r = !0), void 0 === n && (n = -be);
            for (var i = [], o = this._first; o;) o._start >= n && (o instanceof Zn ? e && i.push(o) : (r && i.push(o), t && i.push.apply(i, o.getChildren(!0, e, r)))), (o = o._next);
            return i;
          }),
          (r.getById = function (t) {
            for (var e = this.getChildren(1, 1, 1), r = e.length; r--;) if (e[r].vars.id === t) return e[r];
          }),
          (r.remove = function (t) {
            return Pe(t) ? this.removeLabel(t) : Ae(t) ? this.killTweensOf(t) : (Or(this, t), t === this._recent && (this._recent = this._last), Ar(this));
          }),
          (r.totalTime = function (e, r) {
            return arguments.length
              ? ((this._forcing = 1),
                !this._dp && this._ts && (this._start = dr(En.time - (this._ts > 0 ? e / this._ts : (this.totalDuration() - e) / -this._ts))),
                t.prototype.totalTime.call(this, e, r),
                (this._forcing = 0),
                this)
              : this._tTime;
          }),
          (r.addLabel = function (t, e) {
            return (this.labels[t] = $r(this, e)), this;
          }),
          (r.removeLabel = function (t) {
            return delete this.labels[t], this;
          }),
          (r.addPause = function (t, e, r) {
            var n = Zn.delayedCall(0, e || Ze, r);
            return (n.data = "isPause"), (this._hasPause = 1), Br(this, n, $r(this, t));
          }),
          (r.removePause = function (t) {
            var e = this._first;
            for (t = $r(this, t); e;) e._start === t && "isPause" === e.data && Pr(e), (e = e._next);
          }),
          (r.killTweensOf = function (t, e, r) {
            for (var n = this.getTweensOf(t, r), i = n.length; i--;) Gn !== n[i] && n[i].kill(t, e);
            return this;
          }),
          (r.getTweensOf = function (t, e) {
            for (var r, n = [], i = Jr(t), o = this._first, a = Ce(e); o;)
              o instanceof Zn
                ? vr(o._targets, i) && (a ? (!Gn || (o._initted && o._ts)) && o.globalTime(0) <= e && o.globalTime(o.totalDuration()) > e : !e || o.isActive()) && n.push(o)
                : (r = o.getTweensOf(i, e)).length && n.push.apply(n, r),
                (o = o._next);
            return n;
          }),
          (r.tweenTo = function (t, e) {
            e = e || {};
            var r,
              n = this,
              i = $r(n, t),
              o = e,
              a = o.startAt,
              s = o.onStart,
              l = o.onStartParams,
              c = o.immediateRender,
              u = Zn.to(
                n,
                wr(
                  {
                    ease: e.ease || "none",
                    lazy: !1,
                    immediateRender: !1,
                    time: i,
                    overwrite: "auto",
                    duration: e.duration || Math.abs((i - (a && "time" in a ? a.time : n._time)) / n.timeScale()) || we,
                    onStart: function () {
                      if ((n.pause(), !r)) {
                        var t = e.duration || Math.abs((i - (a && "time" in a ? a.time : n._time)) / n.timeScale());
                        u._dur !== t && Hr(u, t, 0, 1).render(u._time, !0, !0), (r = 1);
                      }
                      s && s.apply(u, l || []);
                    },
                  },
                  e
                )
              );
            return c ? u.render(0) : u;
          }),
          (r.tweenFromTo = function (t, e, r) {
            return this.tweenTo(e, wr({ startAt: { time: $r(this, t) } }, r));
          }),
          (r.recent = function () {
            return this._recent;
          }),
          (r.nextLabel = function (t) {
            return void 0 === t && (t = this._time), un(this, $r(this, t));
          }),
          (r.previousLabel = function (t) {
            return void 0 === t && (t = this._time), un(this, $r(this, t), 1);
          }),
          (r.currentLabel = function (t) {
            return arguments.length ? this.seek(t, !0) : this.previousLabel(this._time + we);
          }),
          (r.shiftChildren = function (t, e, r) {
            void 0 === r && (r = 0);
            for (var n, i = this._first, o = this.labels; i;) i._start >= r && ((i._start += t), (i._end += t)), (i = i._next);
            if (e) for (n in o) o[n] >= r && (o[n] += t);
            return Ar(this);
          }),
          (r.invalidate = function (e) {
            var r = this._first;
            for (this._lock = 0; r;) r.invalidate(e), (r = r._next);
            return t.prototype.invalidate.call(this, e);
          }),
          (r.clear = function (t) {
            void 0 === t && (t = !0);
            for (var e, r = this._first; r;) (e = r._next), this.remove(r), (r = e);
            return this._dp && (this._time = this._tTime = this._pTime = 0), t && (this.labels = {}), Ar(this);
          }),
          (r.totalDuration = function (t) {
            var e,
              r,
              n,
              i = 0,
              o = this,
              a = o._last,
              s = be;
            if (arguments.length) return o.timeScale((o._repeat < 0 ? o.duration() : o.totalDuration()) / (o.reversed() ? -t : t));
            if (o._dirty) {
              for (n = o.parent; a;)
                (e = a._prev),
                  a._dirty && a.totalDuration(),
                  (r = a._start) > s && o._sort && a._ts && !o._lock ? ((o._lock = 1), (Br(o, a, r - a._delay, 1)._lock = 0)) : (s = r),
                  r < 0 && a._ts && ((i -= r), ((!n && !o._dp) || (n && n.smoothChildTiming)) && ((o._start += r / o._ts), (o._time -= r), (o._tTime -= r)), o.shiftChildren(-r, !1, -Infinity), (s = 0)),
                  a._end > i && a._ts && (i = a._end),
                  (a = e);
              Hr(o, o === oe && o._time > i ? o._time : i, 1, 1), (o._dirty = 0);
            }
            return o._tDur;
          }),
          (e.updateRoot = function (t) {
            if ((oe._ts && (yr(oe, Rr(t, oe)), (ue = En.frame)), En.frame >= or)) {
              or += ye.autoSleep || 120;
              var e = oe._first;
              if ((!e || !e._ts) && ye.autoSleep && En._listeners.length < 2) {
                for (; e && !e._ts;) e = e._next;
                e || En.sleep();
              }
            }
          }),
          e
        );
      })(Bn);
      wr(Fn.prototype, { _lock: 0, _hasPause: 0, _forcing: 0 });
      var Gn,
        Nn,
        Yn = function (t, e, r, n, i, o, a) {
          var s,
            l,
            c,
            u,
            p,
            f,
            d,
            h,
            v = new ui(this._pt, t, e, 0, 1, ii, null, i),
            m = 0,
            y = 0;
          for (v.b = r, v.e = n, r += "", (d = ~(n += "").indexOf("random(")) && (n = ln(n)), o && (o((h = [r, n]), t, e), (r = h[0]), (n = h[1])), l = r.match(Ge) || []; (s = Ge.exec(n));)
            (u = s[0]),
              (p = n.substring(m, s.index)),
              c ? (c = (c + 1) % 5) : "rgba(" === p.substr(-5) && (c = 1),
              u !== l[y++] &&
              ((f = parseFloat(l[y - 1]) || 0), (v._pt = { _next: v._pt, p: p || 1 === y ? p : ",", s: f, c: "=" === u.charAt(1) ? hr(f, u) - f : parseFloat(u) - f, m: c && c < 4 ? Math.round : 0 }), (m = Ge.lastIndex));
          return (v.c = m < n.length ? n.substring(m, n.length) : ""), (v.fp = a), (Ne.test(n) || d) && (v.e = 0), (this._pt = v), v;
        },
        Hn = function (t, e, r, n, i, o, a, s, l, c) {
          Ae(n) && (n = n(i || 0, t, o));
          var u,
            p = t[e],
            f = "get" !== r ? r : Ae(p) ? (l ? t[e.indexOf("set") || !Ae(t["get" + e.substr(3)]) ? e : "get" + e.substr(3)](l) : t[e]()) : p,
            d = Ae(p) ? (l ? Jn : Kn) : Qn;
          if ((Pe(n) && (~n.indexOf("random(") && (n = ln(n)), "=" === n.charAt(1) && ((u = hr(f, n) + (Zr(f) || 0)) || 0 === u) && (n = u)), !c || f !== n || Nn))
            return isNaN(f * n) || "" === n
              ? (!p && !(e in t) && Xe(e, n), Yn.call(this, t, e, f, n, d, s || ye.stringFilter, l))
              : ((u = new ui(this._pt, t, e, +f || 0, n - (f || 0), "boolean" == typeof p ? ni : ri, 0, d)), l && (u.fp = l), a && u.modifier(a, this, t), (this._pt = u));
        },
        Vn = function (t, e, r, n, i, o) {
          var a, s, l, c;
          if (
            nr[t] &&
            !1 !==
            (a = new nr[t]()).init(
              i,
              a.rawVars
                ? e[t]
                : (function (t, e, r, n, i) {
                  if ((Ae(t) && (t = Xn(t, i, e, r, n)), !ke(t) || (t.style && t.nodeType) || ze(t) || Ie(t))) return Pe(t) ? Xn(t, i, e, r, n) : t;
                  var o,
                    a = {};
                  for (o in t) a[o] = Xn(t[o], i, e, r, n);
                  return a;
                })(e[t], n, i, o, r),
              r,
              n,
              o
            ) &&
            ((r._pt = s = new ui(r._pt, i, t, 0, 1, a.render, a, 0, a.priority)), r !== pe)
          )
            for (l = r._ptLookup[r._targets.indexOf(i)], c = a._props.length; c--;) l[a._props[c]] = s;
          return a;
        },
        qn = function t(e, r, n) {
          var i,
            o,
            a,
            s,
            l,
            c,
            u,
            p,
            f,
            d,
            h,
            v,
            m,
            y = e.vars,
            g = y.ease,
            b = y.startAt,
            w = y.immediateRender,
            _ = y.lazy,
            x = y.onUpdate,
            T = y.onUpdateParams,
            E = y.callbackScope,
            S = y.runBackwards,
            O = y.yoyoEase,
            P = y.keyframes,
            A = y.autoRevert,
            C = e._dur,
            L = e._startAt,
            k = e._targets,
            M = e.parent,
            j = M && "nested" === M.data ? M.vars.targets : k,
            R = "auto" === e._overwrite && !re,
            I = e.timeline;
          if (
            (I && (!P || !g) && (g = "none"),
              (e._ease = Mn(g, ge.ease)),
              (e._yEase = O ? Ln(Mn(!0 === O ? g : O, ge.ease)) : 0),
              O && e._yoyo && !e._repeat && ((O = e._yEase), (e._yEase = e._ease), (e._ease = O)),
              (e._from = !I && !!y.runBackwards),
              !I || (P && !y.stagger))
          ) {
            if (((v = (p = k[0] ? cr(k[0]).harness : 0) && y[p.prop]), (i = Tr(y, tr)), L && (L._zTime < 0 && L.progress(1), r < 0 && S && w && !A ? L.render(-1, !0) : L.revert(S && C ? Ke : Qe), (L._lazy = 0)), b)) {
              if (
                (Pr(
                  (e._startAt = Zn.set(
                    k,
                    wr({ data: "isStart", overwrite: !1, parent: M, immediateRender: !0, lazy: !L && Me(_), startAt: null, delay: 0, onUpdate: x, onUpdateParams: T, callbackScope: E, stagger: 0 }, b)
                  ))
                ),
                  (e._startAt._dp = 0),
                  (e._startAt._sat = e),
                  r < 0 && (ne || (!w && !A)) && e._startAt.revert(Ke),
                  w && C && r <= 0 && n <= 0)
              )
                return void (r && (e._zTime = r));
            } else if (S && C && !L)
              if (
                (r && (w = !1),
                  (a = wr({ overwrite: !1, data: "isFromStart", lazy: w && !L && Me(_), immediateRender: w, stagger: 0, parent: M }, i)),
                  v && (a[p.prop] = v),
                  Pr((e._startAt = Zn.set(k, a))),
                  (e._startAt._dp = 0),
                  (e._startAt._sat = e),
                  r < 0 && (ne ? e._startAt.revert(Ke) : e._startAt.render(-1, !0)),
                  (e._zTime = r),
                  w)
              ) {
                if (!r) return;
              } else t(e._startAt, we, we);
            for (e._pt = e._ptCache = 0, _ = (C && Me(_)) || (_ && !C), o = 0; o < k.length; o++) {
              if (
                ((u = (l = k[o])._gsap || lr(k)[o]._gsap),
                  (e._ptLookup[o] = d = {}),
                  rr[u.id] && er.length && mr(),
                  (h = j === k ? o : j.indexOf(l)),
                  p &&
                  !1 !== (f = new p()).init(l, v || i, e, h, j) &&
                  ((e._pt = s = new ui(e._pt, l, f.name, 0, 1, f.render, f, 0, f.priority)),
                    f._props.forEach(function (t) {
                      d[t] = s;
                    }),
                    f.priority && (c = 1)),
                  !p || v)
              )
                for (a in i) nr[a] && (f = Vn(a, i, e, h, l, j)) ? f.priority && (c = 1) : (d[a] = s = Hn.call(e, l, a, "get", i[a], h, j, 0, y.stringFilter));
              e._op && e._op[o] && e.kill(l, e._op[o]), R && e._pt && ((Gn = e), oe.killTweensOf(l, d, e.globalTime(r)), (m = !e.parent), (Gn = 0)), e._pt && _ && (rr[u.id] = 1);
            }
            c && ci(e), e._onInit && e._onInit(e);
          }
          (e._onUpdate = x), (e._initted = (!e._op || e._pt) && !m), P && r <= 0 && I.render(be, !0, !0);
        },
        $n = function (t, e, r, n) {
          var i,
            o,
            a = e.ease || n || "power1.inOut";
          if (ze(e))
            (o = r[t] || (r[t] = [])),
              e.forEach(function (t, r) {
                return o.push({ t: (r / (e.length - 1)) * 100, v: t, e: a });
              });
          else for (i in e) (o = r[i] || (r[i] = [])), "ease" === i || o.push({ t: parseFloat(t), v: e[i], e: a });
        },
        Xn = function (t, e, r, n, i) {
          return Ae(t) ? t.call(e, r, n, i) : Pe(t) && ~t.indexOf("random(") ? ln(t) : t;
        },
        Wn = sr + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert",
        Un = {};
      pr(Wn + ",id,stagger,delay,duration,paused,scrollTrigger", function (t) {
        return (Un[t] = 1);
      });
      var Zn = (function (t) {
        function e(e, r, n, i) {
          var o;
          "number" == typeof r && ((n.duration = r), (r = n), (n = null));
          var a,
            s,
            l,
            c,
            u,
            p,
            f,
            d,
            h = (o = t.call(this, i ? r : Er(r)) || this).vars,
            v = h.duration,
            m = h.delay,
            y = h.immediateRender,
            g = h.stagger,
            b = h.overwrite,
            w = h.keyframes,
            _ = h.defaults,
            x = h.scrollTrigger,
            T = h.yoyoEase,
            E = r.parent || oe,
            S = (ze(e) || Ie(e) ? Ce(e[0]) : "length" in r) ? [e] : Jr(e);
          if (((o._targets = S.length ? lr(S) : We("GSAP target " + e + " not found. https://greensock.com", !ye.nullTargetWarn) || []), (o._ptLookup = []), (o._overwrite = b), w || g || Re(v) || Re(m))) {
            if (((r = o.vars), (a = o.timeline = new Fn({ data: "nested", defaults: _ || {}, targets: E && "nested" === E.data ? E.vars.targets : S })).kill(), (a.parent = a._dp = te(o)), (a._start = 0), g || Re(v) || Re(m))) {
              if (((c = S.length), (f = g && rn(g)), ke(g))) for (u in g) ~Wn.indexOf(u) && (d || (d = {}), (d[u] = g[u]));
              for (s = 0; s < c; s++)
                ((l = Tr(r, Un)).stagger = 0),
                  T && (l.yoyoEase = T),
                  d && _r(l, d),
                  (p = S[s]),
                  (l.duration = +Xn(v, te(o), s, p, S)),
                  (l.delay = (+Xn(m, te(o), s, p, S) || 0) - o._delay),
                  !g && 1 === c && l.delay && ((o._delay = m = l.delay), (o._start += m), (l.delay = 0)),
                  a.to(p, l, f ? f(s, p, S) : 0),
                  (a._ease = On.none);
              a.duration() ? (v = m = 0) : (o.timeline = 0);
            } else if (w) {
              Er(wr(a.vars.defaults, { ease: "none" })), (a._ease = Mn(w.ease || r.ease || "none"));
              var O,
                P,
                A,
                C = 0;
              if (ze(w))
                w.forEach(function (t) {
                  return a.to(S, t, ">");
                }),
                  a.duration();
              else {
                for (u in ((l = {}), w)) "ease" === u || "easeEach" === u || $n(u, w[u], l, w.easeEach);
                for (u in l)
                  for (
                    O = l[u].sort(function (t, e) {
                      return t.t - e.t;
                    }),
                    C = 0,
                    s = 0;
                    s < O.length;
                    s++
                  )
                    ((A = { ease: (P = O[s]).e, duration: ((P.t - (s ? O[s - 1].t : 0)) / 100) * v })[u] = P.v), a.to(S, A, C), (C += A.duration);
                a.duration() < v && a.to({}, { duration: v - a.duration() });
              }
            }
            v || o.duration((v = a.duration()));
          } else o.timeline = 0;
          return (
            !0 !== b || re || ((Gn = te(o)), oe.killTweensOf(S), (Gn = 0)),
            Br(E, te(o), n),
            r.reversed && o.reverse(),
            r.paused && o.paused(!0),
            (y || (!v && !w && o._start === dr(E._time) && Me(y) && kr(te(o)) && "nested" !== E.data)) && ((o._tTime = -1e-8), o.render(Math.max(0, -m) || 0)),
            x && Fr(te(o), x),
            o
          );
        }
        ee(e, t);
        var r = e.prototype;
        return (
          (r.render = function (t, e, r) {
            var n,
              i,
              o,
              a,
              s,
              l,
              c,
              u,
              p,
              f = this._time,
              d = this._tDur,
              h = this._dur,
              v = t < 0,
              m = t > d - we && !v ? d : t < we ? 0 : t;
            if (h) {
              if (m !== this._tTime || !t || r || (!this._initted && this._tTime) || (this._startAt && this._zTime < 0 !== v)) {
                if (((n = m), (u = this.timeline), this._repeat)) {
                  if (((a = h + this._rDelay), this._repeat < -1 && v)) return this.totalTime(100 * a + t, e, r);
                  if (
                    ((n = dr(m % a)),
                      m === d ? ((o = this._repeat), (n = h)) : ((o = ~~(m / a)) && o === m / a && ((n = h), o--), n > h && (n = h)),
                      (l = this._yoyo && 1 & o) && ((p = this._yEase), (n = h - n)),
                      (s = jr(this._tTime, a)),
                      n === f && !r && this._initted)
                  )
                    return (this._tTime = m), this;
                  o !== s && (u && this._yEase && kn(u, l), !this.vars.repeatRefresh || l || this._lock || ((this._lock = r = 1), (this.render(dr(a * o), !0).invalidate()._lock = 0)));
                }
                if (!this._initted) {
                  if (Gr(this, v ? t : n, r, e, m)) return (this._tTime = 0), this;
                  if (f !== this._time) return this;
                  if (h !== this._dur) return this.render(t, e, r);
                }
                if (
                  ((this._tTime = m),
                    (this._time = n),
                    !this._act && this._ts && ((this._act = 1), (this._lazy = 0)),
                    (this.ratio = c = (p || this._ease)(n / h)),
                    this._from && (this.ratio = c = 1 - c),
                    n && !f && !e && !o && (pn(this, "onStart"), this._tTime !== m))
                )
                  return this;
                for (i = this._pt; i;) i.r(c, i.d), (i = i._next);
                (u && u.render(t < 0 ? t : !n && l ? -1e-8 : u._dur * u._ease(n / this._dur), e, r)) || (this._startAt && (this._zTime = t)),
                  this._onUpdate && !e && (v && Lr(this, t, 0, r), pn(this, "onUpdate")),
                  this._repeat && o !== s && this.vars.onRepeat && !e && this.parent && pn(this, "onRepeat"),
                  (m !== this._tDur && m) ||
                  this._tTime !== m ||
                  (v && !this._onUpdate && Lr(this, t, 0, !0),
                    (t || !h) && ((m === this._tDur && this._ts > 0) || (!m && this._ts < 0)) && Pr(this, 1),
                    e || (v && !f) || !(m || f || l) || (pn(this, m === d ? "onComplete" : "onReverseComplete", !0), this._prom && !(m < d && this.timeScale() > 0) && this._prom()));
              }
            } else
              !(function (t, e, r, n) {
                var i,
                  o,
                  a,
                  s = t.ratio,
                  l = e < 0 || (!e && ((!t._start && Nr(t) && (t._initted || !Yr(t))) || ((t._ts < 0 || t._dp._ts < 0) && !Yr(t)))) ? 0 : 1,
                  c = t._rDelay,
                  u = 0;
                if (
                  (c && t._repeat && ((u = Ur(0, t._tDur, e)), (o = jr(u, c)), t._yoyo && 1 & o && (l = 1 - l), o !== jr(t._tTime, c) && ((s = 1 - l), t.vars.repeatRefresh && t._initted && t.invalidate())),
                    l !== s || ne || n || t._zTime === we || (!e && t._zTime))
                ) {
                  if (!t._initted && Gr(t, e, n, r, u)) return;
                  for (a = t._zTime, t._zTime = e || (r ? we : 0), r || (r = e && !a), t.ratio = l, t._from && (l = 1 - l), t._time = 0, t._tTime = u, i = t._pt; i;) i.r(l, i.d), (i = i._next);
                  e < 0 && Lr(t, e, 0, !0),
                    t._onUpdate && !r && pn(t, "onUpdate"),
                    u && t._repeat && !r && t.parent && pn(t, "onRepeat"),
                    (e >= t._tDur || e < 0) && t.ratio === l && (l && Pr(t, 1), r || ne || (pn(t, l ? "onComplete" : "onReverseComplete", !0), t._prom && t._prom()));
                } else t._zTime || (t._zTime = e);
              })(this, t, e, r);
            return this;
          }),
          (r.targets = function () {
            return this._targets;
          }),
          (r.invalidate = function (e) {
            return (
              (!e || !this.vars.runBackwards) && (this._startAt = 0),
              (this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0),
              (this._ptLookup = []),
              this.timeline && this.timeline.invalidate(e),
              t.prototype.invalidate.call(this, e)
            );
          }),
          (r.resetTo = function (t, e, r, n) {
            fe || En.wake(), this._ts || this.play();
            var i = Math.min(this._dur, (this._dp._time - this._start) * this._ts);
            return (
              this._initted || qn(this, i),
              (function (t, e, r, n, i, o, a) {
                var s,
                  l,
                  c,
                  u,
                  p = ((t._pt && t._ptCache) || (t._ptCache = {}))[e];
                if (!p)
                  for (p = t._ptCache[e] = [], c = t._ptLookup, u = t._targets.length; u--;) {
                    if ((s = c[u][e]) && s.d && s.d._pt) for (s = s.d._pt; s && s.p !== e && s.fp !== e;) s = s._next;
                    if (!s) return (Nn = 1), (t.vars[e] = "+=0"), qn(t, a), (Nn = 0), 1;
                    p.push(s);
                  }
                for (u = p.length; u--;) ((s = (l = p[u])._pt || l).s = (!n && 0 !== n) || i ? s.s + (n || 0) + o * s.c : n), (s.c = r - s.s), l.e && (l.e = fr(r) + Zr(l.e)), l.b && (l.b = s.s + Zr(l.b));
              })(this, t, e, r, n, this._ease(i / this._dur), i)
                ? this.resetTo(t, e, r, n)
                : (zr(this, 0), this.parent || Sr(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0))
            );
          }),
          (r.kill = function (t, e) {
            if ((void 0 === e && (e = "all"), !(t || (e && "all" !== e)))) return (this._lazy = this._pt = 0), this.parent ? fn(this) : this;
            if (this.timeline) {
              var r = this.timeline.totalDuration();
              return this.timeline.killTweensOf(t, e, Gn && !0 !== Gn.vars.overwrite)._first || fn(this), this.parent && r !== this.timeline.totalDuration() && Hr(this, (this._dur * this.timeline._tDur) / r, 0, 1), this;
            }
            var n,
              i,
              o,
              a,
              s,
              l,
              c,
              u = this._targets,
              p = t ? Jr(t) : u,
              f = this._ptLookup,
              d = this._pt;
            if (
              (!e || "all" === e) &&
              (function (t, e) {
                for (var r = t.length, n = r === e.length; n && r-- && t[r] === e[r];);
                return r < 0;
              })(u, p)
            )
              return "all" === e && (this._pt = 0), fn(this);
            for (
              n = this._op = this._op || [],
              "all" !== e &&
              (Pe(e) &&
                ((s = {}),
                  pr(e, function (t) {
                    return (s[t] = 1);
                  }),
                  (e = s)),
                (e = (function (t, e) {
                  var r,
                    n,
                    i,
                    o,
                    a = t[0] ? cr(t[0]).harness : 0,
                    s = a && a.aliases;
                  if (!s) return e;
                  for (n in ((r = _r({}, e)), s)) if ((n in r)) for (i = (o = s[n].split(",")).length; i--;) r[o[i]] = r[n];
                  return r;
                })(u, e))),
              c = u.length;
              c--;

            )
              if (~p.indexOf(u[c]))
                for (s in ((i = f[c]), "all" === e ? ((n[c] = e), (a = i), (o = {})) : ((o = n[c] = n[c] || {}), (a = e)), a))
                  (l = i && i[s]) && (("kill" in l.d && !0 !== l.d.kill(s)) || Or(this, l, "_pt"), delete i[s]), "all" !== o && (o[s] = 1);
            return this._initted && !this._pt && d && fn(this), this;
          }),
          (e.to = function (t, r) {
            return new e(t, r, arguments[2]);
          }),
          (e.from = function (t, e) {
            return Xr(1, arguments);
          }),
          (e.delayedCall = function (t, r, n, i) {
            return new e(r, 0, { immediateRender: !1, lazy: !1, overwrite: !1, delay: t, onComplete: r, onReverseComplete: r, onCompleteParams: n, onReverseCompleteParams: n, callbackScope: i });
          }),
          (e.fromTo = function (t, e, r) {
            return Xr(2, arguments);
          }),
          (e.set = function (t, r) {
            return (r.duration = 0), r.repeatDelay || (r.repeat = 0), new e(t, r);
          }),
          (e.killTweensOf = function (t, e, r) {
            return oe.killTweensOf(t, e, r);
          }),
          e
        );
      })(Bn);
      wr(Zn.prototype, { _targets: [], _lazy: 0, _startAt: 0, _op: 0, _onInit: 0 }),
        pr("staggerTo,staggerFrom,staggerFromTo", function (t) {
          Zn[t] = function () {
            var e = new Fn(),
              r = Qr.call(arguments, 0);
            return r.splice("staggerFromTo" === t ? 5 : 4, 0, 0), e[t].apply(e, r);
          };
        });
      var Qn = function (t, e, r) {
        return (t[e] = r);
      },
        Kn = function (t, e, r) {
          return t[e](r);
        },
        Jn = function (t, e, r, n) {
          return t[e](n.fp, r);
        },
        ti = function (t, e, r) {
          return t.setAttribute(e, r);
        },
        ei = function (t, e) {
          return Ae(t[e]) ? Kn : Le(t[e]) && t.setAttribute ? ti : Qn;
        },
        ri = function (t, e) {
          return e.set(e.t, e.p, Math.round(1e6 * (e.s + e.c * t)) / 1e6, e);
        },
        ni = function (t, e) {
          return e.set(e.t, e.p, !!(e.s + e.c * t), e);
        },
        ii = function (t, e) {
          var r = e._pt,
            n = "";
          if (!t && e.b) n = e.b;
          else if (1 === t && e.e) n = e.e;
          else {
            for (; r;) (n = r.p + (r.m ? r.m(r.s + r.c * t) : Math.round(1e4 * (r.s + r.c * t)) / 1e4) + n), (r = r._next);
            n += e.c;
          }
          e.set(e.t, e.p, n, e);
        },
        oi = function (t, e) {
          for (var r = e._pt; r;) r.r(t, r.d), (r = r._next);
        },
        ai = function (t, e, r, n) {
          for (var i, o = this._pt; o;) (i = o._next), o.p === n && o.modifier(t, e, r), (o = i);
        },
        si = function (t) {
          for (var e, r, n = this._pt; n;) (r = n._next), (n.p === t && !n.op) || n.op === t ? Or(this, n, "_pt") : n.dep || (e = 1), (n = r);
          return !e;
        },
        li = function (t, e, r, n) {
          n.mSet(t, e, n.m.call(n.tween, r, n.mt), n);
        },
        ci = function (t) {
          for (var e, r, n, i, o = t._pt; o;) {
            for (e = o._next, r = n; r && r.pr > o.pr;) r = r._next;
            (o._prev = r ? r._prev : i) ? (o._prev._next = o) : (n = o), (o._next = r) ? (r._prev = o) : (i = o), (o = e);
          }
          t._pt = n;
        },
        ui = (function () {
          function t(t, e, r, n, i, o, a, s, l) {
            (this.t = e), (this.s = n), (this.c = i), (this.p = r), (this.r = o || ri), (this.d = a || this), (this.set = s || Qn), (this.pr = l || 0), (this._next = t), t && (t._prev = this);
          }
          return (
            (t.prototype.modifier = function (t, e, r) {
              (this.mSet = this.mSet || this.set), (this.set = li), (this.m = t), (this.mt = r), (this.tween = e);
            }),
            t
          );
        })();
      pr(
        sr +
        "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger",
        function (t) {
          return (tr[t] = 1);
        }
      ),
        (Ve.TweenMax = Ve.TweenLite = Zn),
        (Ve.TimelineLite = Ve.TimelineMax = Fn),
        (oe = new Fn({ sortChildren: !1, defaults: ge, autoRemoveChildren: !0, id: "root", smoothChildTiming: !0 })),
        (ye.stringFilter = Tn);
      var pi = [],
        fi = {},
        di = [],
        hi = 0,
        vi = 0,
        mi = function (t) {
          return (fi[t] || di).map(function (t) {
            return t();
          });
        },
        yi = function () {
          var t = Date.now(),
            e = [];
          t - hi > 2 &&
            (mi("matchMediaInit"),
              pi.forEach(function (t) {
                var r,
                  n,
                  i,
                  o,
                  a = t.queries,
                  s = t.conditions;
                for (n in a) (r = ae.matchMedia(a[n]).matches) && (i = 1), r !== s[n] && ((s[n] = r), (o = 1));
                o && (t.revert(), i && e.push(t));
              }),
              mi("matchMediaRevert"),
              e.forEach(function (t) {
                return t.onMatch(t);
              }),
              (hi = t),
              mi("matchMedia"));
        },
        gi = (function () {
          function t(t, e) {
            (this.selector = e && tn(e)), (this.data = []), (this._r = []), (this.isReverted = !1), (this.id = vi++), t && this.add(t);
          }
          var e = t.prototype;
          return (
            (e.add = function (t, e, r) {
              Ae(t) && ((r = e), (e = t), (t = Ae));
              var n = this,
                i = function () {
                  var t,
                    i = ie,
                    o = n.selector;
                  return i && i !== n && i.data.push(n), r && (n.selector = tn(r)), (ie = n), (t = e.apply(n, arguments)), Ae(t) && n._r.push(t), (ie = i), (n.selector = o), (n.isReverted = !1), t;
                };
              return (n.last = i), t === Ae ? i(n) : t ? (n[t] = i) : i;
            }),
            (e.ignore = function (t) {
              var e = ie;
              (ie = null), t(this), (ie = e);
            }),
            (e.getTweens = function () {
              var e = [];
              return (
                this.data.forEach(function (r) {
                  return r instanceof t ? e.push.apply(e, r.getTweens()) : r instanceof Zn && !(r.parent && "nested" === r.parent.data) && e.push(r);
                }),
                e
              );
            }),
            (e.clear = function () {
              this._r.length = this.data.length = 0;
            }),
            (e.kill = function (t, e) {
              var r = this;
              if (t) {
                var n = this.getTweens();
                this.data.forEach(function (t) {
                  "isFlip" === t.data &&
                    (t.revert(),
                      t.getChildren(!0, !0, !1).forEach(function (t) {
                        return n.splice(n.indexOf(t), 1);
                      }));
                }),
                  n
                    .map(function (t) {
                      return { g: t.globalTime(0), t };
                    })
                    .sort(function (t, e) {
                      return e.g - t.g || -1 / 0;
                    })
                    .forEach(function (e) {
                      return e.t.revert(t);
                    }),
                  this.data.forEach(function (e) {
                    return !(e instanceof Zn) && e.revert && e.revert(t);
                  }),
                  this._r.forEach(function (e) {
                    return e(t, r);
                  }),
                  (this.isReverted = !0);
              } else
                this.data.forEach(function (t) {
                  return t.kill && t.kill();
                });
              if ((this.clear(), e)) for (var i = pi.length; i--;) pi[i].id === this.id && pi.splice(i, 1);
            }),
            (e.revert = function (t) {
              this.kill(t || {});
            }),
            t
          );
        })(),
        bi = (function () {
          function t(t) {
            (this.contexts = []), (this.scope = t);
          }
          var e = t.prototype;
          return (
            (e.add = function (t, e, r) {
              ke(t) || (t = { matches: t });
              var n,
                i,
                o,
                a = new gi(0, r || this.scope),
                s = (a.conditions = {});
              for (i in (ie && !a.selector && (a.selector = ie.selector), this.contexts.push(a), (e = a.add("onMatch", e)), (a.queries = t), t))
                "all" === i ? (o = 1) : (n = ae.matchMedia(t[i])) && (pi.indexOf(a) < 0 && pi.push(a), (s[i] = n.matches) && (o = 1), n.addListener ? n.addListener(yi) : n.addEventListener("change", yi));
              return o && e(a), this;
            }),
            (e.revert = function (t) {
              this.kill(t || {});
            }),
            (e.kill = function (t) {
              this.contexts.forEach(function (e) {
                return e.kill(t, !0);
              });
            }),
            t
          );
        })(),
        wi = {
          registerPlugin: function () {
            for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++) e[r] = arguments[r];
            e.forEach(function (t) {
              return hn(t);
            });
          },
          timeline: function (t) {
            return new Fn(t);
          },
          getTweensOf: function (t, e) {
            return oe.getTweensOf(t, e);
          },
          getProperty: function (t, e, r, n) {
            Pe(t) && (t = Jr(t)[0]);
            var i = cr(t || {}).get,
              o = r ? br : gr;
            return (
              "native" === r && (r = ""),
              t
                ? e
                  ? o(((nr[e] && nr[e].get) || i)(t, e, r, n))
                  : function (e, r, n) {
                    return o(((nr[e] && nr[e].get) || i)(t, e, r, n));
                  }
                : t
            );
          },
          quickSetter: function (t, e, r) {
            if ((t = Jr(t)).length > 1) {
              var n = t.map(function (t) {
                return Ti.quickSetter(t, e, r);
              }),
                i = n.length;
              return function (t) {
                for (var e = i; e--;) n[e](t);
              };
            }
            t = t[0] || {};
            var o = nr[e],
              a = cr(t),
              s = (a.harness && (a.harness.aliases || {})[e]) || e,
              l = o
                ? function (e) {
                  var n = new o();
                  (pe._pt = 0), n.init(t, r ? e + r : e, pe, 0, [t]), n.render(1, n), pe._pt && oi(1, pe);
                }
                : a.set(t, s);
            return o
              ? l
              : function (e) {
                return l(t, s, r ? e + r : e, a, 1);
              };
          },
          quickTo: function (t, e, r) {
            var n,
              i = Ti.to(t, _r((((n = {})[e] = "+=0.1"), (n.paused = !0), n), r || {})),
              o = function (t, r, n) {
                return i.resetTo(e, t, r, n);
              };
            return (o.tween = i), o;
          },
          isTweening: function (t) {
            return oe.getTweensOf(t, !0).length > 0;
          },
          defaults: function (t) {
            return t && t.ease && (t.ease = Mn(t.ease, ge.ease)), xr(ge, t || {});
          },
          config: function (t) {
            return xr(ye, t || {});
          },
          registerEffect: function (t) {
            var e = t.name,
              r = t.effect,
              n = t.plugins,
              i = t.defaults,
              o = t.extendTimeline;
            (n || "").split(",").forEach(function (t) {
              return t && !nr[t] && !Ve[t] && We(e + " effect requires " + t + " plugin.");
            }),
              (ir[e] = function (t, e, n) {
                return r(Jr(t), wr(e || {}, i), n);
              }),
              o &&
              (Fn.prototype[e] = function (t, r, n) {
                return this.add(ir[e](t, ke(r) ? r : (n = r) && {}, this), n);
              });
          },
          registerEase: function (t, e) {
            On[t] = Mn(e);
          },
          parseEase: function (t, e) {
            return arguments.length ? Mn(t, e) : On;
          },
          getById: function (t) {
            return oe.getById(t);
          },
          exportRoot: function (t, e) {
            void 0 === t && (t = {});
            var r,
              n,
              i = new Fn(t);
            for (i.smoothChildTiming = Me(t.smoothChildTiming), oe.remove(i), i._dp = 0, i._time = i._tTime = oe._time, r = oe._first; r;)
              (n = r._next), (!e && !r._dur && r instanceof Zn && r.vars.onComplete === r._targets[0]) || Br(i, r, r._start - r._delay), (r = n);
            return Br(oe, i, 0), i;
          },
          context: function (t, e) {
            return t ? new gi(t, e) : ie;
          },
          matchMedia: function (t) {
            return new bi(t);
          },
          matchMediaRefresh: function () {
            return (
              pi.forEach(function (t) {
                var e,
                  r,
                  n = t.conditions;
                for (r in n) n[r] && ((n[r] = !1), (e = 1));
                e && t.revert();
              }) || yi()
            );
          },
          addEventListener: function (t, e) {
            var r = fi[t] || (fi[t] = []);
            ~r.indexOf(e) || r.push(e);
          },
          removeEventListener: function (t, e) {
            var r = fi[t],
              n = r && r.indexOf(e);
            n >= 0 && r.splice(n, 1);
          },
          utils: {
            wrap: function t(e, r, n) {
              var i = r - e;
              return ze(e)
                ? sn(e, t(0, e.length), r)
                : Wr(n, function (t) {
                  return ((i + ((t - e) % i)) % i) + e;
                });
            },
            wrapYoyo: function t(e, r, n) {
              var i = r - e,
                o = 2 * i;
              return ze(e)
                ? sn(e, t(0, e.length - 1), r)
                : Wr(n, function (t) {
                  return e + ((t = (o + ((t - e) % o)) % o || 0) > i ? o - t : t);
                });
            },
            distribute: rn,
            random: an,
            snap: on,
            normalize: function (t, e, r) {
              return cn(t, e, 0, 1, r);
            },
            getUnit: Zr,
            clamp: function (t, e, r) {
              return Wr(r, function (r) {
                return Ur(t, e, r);
              });
            },
            splitColor: gn,
            toArray: Jr,
            selector: tn,
            mapRange: cn,
            pipe: function () {
              for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++) e[r] = arguments[r];
              return function (t) {
                return e.reduce(function (t, e) {
                  return e(t);
                }, t);
              };
            },
            unitize: function (t, e) {
              return function (r) {
                return t(parseFloat(r)) + (e || Zr(r));
              };
            },
            interpolate: function t(e, r, n, i) {
              var o = isNaN(e + r)
                ? 0
                : function (t) {
                  return (1 - t) * e + t * r;
                };
              if (!o) {
                var a,
                  s,
                  l,
                  c,
                  u,
                  p = Pe(e),
                  f = {};
                if ((!0 === n && (i = 1) && (n = null), p)) (e = { p: e }), (r = { p: r });
                else if (ze(e) && !ze(r)) {
                  for (l = [], c = e.length, u = c - 2, s = 1; s < c; s++) l.push(t(e[s - 1], e[s]));
                  c--,
                    (o = function (t) {
                      t *= c;
                      var e = Math.min(u, ~~t);
                      return l[e](t - e);
                    }),
                    (n = r);
                } else i || (e = _r(ze(e) ? [] : {}, e));
                if (!l) {
                  for (a in r) Hn.call(f, e, a, "get", r[a]);
                  o = function (t) {
                    return oi(t, f) || (p ? e.p : e);
                  };
                }
              }
              return Wr(n, o);
            },
            shuffle: en,
          },
          install: $e,
          effects: ir,
          ticker: En,
          updateRoot: Fn.updateRoot,
          plugins: nr,
          globalTimeline: oe,
          core: {
            PropTween: ui,
            globals: Ue,
            Tween: Zn,
            Timeline: Fn,
            Animation: Bn,
            getCache: cr,
            _removeLinkedListItem: Or,
            reverting: function () {
              return ne;
            },
            context: function (t) {
              return t && ie && (ie.data.push(t), (t._ctx = ie)), ie;
            },
            suppressOverwrites: function (t) {
              return (re = t);
            },
          },
        };
      pr("to,from,fromTo,delayedCall,set,killTweensOf", function (t) {
        return (wi[t] = Zn[t]);
      }),
        En.add(Fn.updateRoot),
        (pe = wi.to({}, { duration: 0 }));
      var _i = function (t, e) {
        for (var r = t._pt; r && r.p !== e && r.op !== e && r.fp !== e;) r = r._next;
        return r;
      },
        xi = function (t, e) {
          return {
            name: t,
            rawVars: 1,
            init: function (t, r, n) {
              n._onInit = function (t) {
                var n, i;
                if (
                  (Pe(r) &&
                    ((n = {}),
                      pr(r, function (t) {
                        return (n[t] = 1);
                      }),
                      (r = n)),
                    e)
                ) {
                  for (i in ((n = {}), r)) n[i] = e(r[i]);
                  r = n;
                }
                !(function (t, e) {
                  var r,
                    n,
                    i,
                    o = t._targets;
                  for (r in e) for (n = o.length; n--;) (i = t._ptLookup[n][r]) && (i = i.d) && (i._pt && (i = _i(i, r)), i && i.modifier && i.modifier(e[r], t, o[n], r));
                })(t, r);
              };
            },
          };
        },
        Ti =
          wi.registerPlugin(
            {
              name: "attr",
              init: function (t, e, r, n, i) {
                var o, a, s;
                for (o in ((this.tween = r), e)) (s = t.getAttribute(o) || ""), ((a = this.add(t, "setAttribute", (s || 0) + "", e[o], n, i, 0, 0, o)).op = o), (a.b = s), this._props.push(o);
              },
              render: function (t, e) {
                for (var r = e._pt; r;) ne ? r.set(r.t, r.p, r.b, r) : r.r(t, r.d), (r = r._next);
              },
            },
            {
              name: "endArray",
              init: function (t, e) {
                for (var r = e.length; r--;) this.add(t, r, t[r] || 0, e[r], 0, 0, 0, 0, 0, 1);
              },
            },
            xi("roundProps", nn),
            xi("modifiers"),
            xi("snap", on)
          ) || wi;
      (Zn.version = Fn.version = Ti.version = "3.12.2"),
        (ce = 1),
        je() && Sn(),
        On.Power0,
        On.Power1,
        On.Power2,
        On.Power3,
        On.Power4,
        On.Linear,
        On.Quad,
        On.Cubic,
        On.Quart,
        On.Quint,
        On.Strong,
        On.Elastic,
        On.Back,
        On.SteppedEase,
        On.Bounce,
        On.Sine,
        On.Expo,
        On.Circ;
      var Ei,
        Si,
        Oi,
        Pi,
        Ai,
        Ci,
        Li,
        ki,
        Mi = {},
        ji = 180 / Math.PI,
        Ri = Math.PI / 180,
        Ii = Math.atan2,
        zi = /([A-Z])/g,
        Di = /(left|right|width|margin|padding|x)/i,
        Bi = /[\s,\(]\S/,
        Fi = { autoAlpha: "opacity,visibility", scale: "scaleX,scaleY", alpha: "opacity" },
        Gi = function (t, e) {
          return e.set(e.t, e.p, Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u, e);
        },
        Ni = function (t, e) {
          return e.set(e.t, e.p, 1 === t ? e.e : Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u, e);
        },
        Yi = function (t, e) {
          return e.set(e.t, e.p, t ? Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u : e.b, e);
        },
        Hi = function (t, e) {
          var r = e.s + e.c * t;
          e.set(e.t, e.p, ~~(r + (r < 0 ? -0.5 : 0.5)) + e.u, e);
        },
        Vi = function (t, e) {
          return e.set(e.t, e.p, t ? e.e : e.b, e);
        },
        qi = function (t, e) {
          return e.set(e.t, e.p, 1 !== t ? e.b : e.e, e);
        },
        $i = function (t, e, r) {
          return (t.style[e] = r);
        },
        Xi = function (t, e, r) {
          return t.style.setProperty(e, r);
        },
        Wi = function (t, e, r) {
          return (t._gsap[e] = r);
        },
        Ui = function (t, e, r) {
          return (t._gsap.scaleX = t._gsap.scaleY = r);
        },
        Zi = function (t, e, r, n, i) {
          var o = t._gsap;
          (o.scaleX = o.scaleY = r), o.renderTransform(i, o);
        },
        Qi = function (t, e, r, n, i) {
          var o = t._gsap;
          (o[e] = r), o.renderTransform(i, o);
        },
        Ki = "transform",
        Ji = Ki + "Origin",
        to = function t(e, r) {
          var n = this,
            i = this.target,
            o = i.style;
          if (e in Mi && o) {
            if (((this.tfm = this.tfm || {}), "transform" === e))
              return Fi.transform.split(",").forEach(function (e) {
                return t.call(n, e, r);
              });
            if (
              (~(e = Fi[e] || e).indexOf(",")
                ? e.split(",").forEach(function (t) {
                  return (n.tfm[t] = bo(i, t));
                })
                : (this.tfm[e] = i._gsap.x ? i._gsap[e] : bo(i, e)),
                this.props.indexOf(Ki) >= 0)
            )
              return;
            i._gsap.svg && ((this.svgo = i.getAttribute("data-svg-origin")), this.props.push(Ji, r, "")), (e = Ki);
          }
          (o || r) && this.props.push(e, r, o[e]);
        },
        eo = function (t) {
          t.translate && (t.removeProperty("translate"), t.removeProperty("scale"), t.removeProperty("rotate"));
        },
        ro = function () {
          var t,
            e,
            r = this.props,
            n = this.target,
            i = n.style,
            o = n._gsap;
          for (t = 0; t < r.length; t += 3) r[t + 1] ? (n[r[t]] = r[t + 2]) : r[t + 2] ? (i[r[t]] = r[t + 2]) : i.removeProperty("--" === r[t].substr(0, 2) ? r[t] : r[t].replace(zi, "-$1").toLowerCase());
          if (this.tfm) {
            for (e in this.tfm) o[e] = this.tfm[e];
            o.svg && (o.renderTransform(), n.setAttribute("data-svg-origin", this.svgo || "")), ((t = Li()) && t.isStart) || i[Ki] || (eo(i), (o.uncache = 1));
          }
        },
        no = function (t, e) {
          var r = { target: t, props: [], revert: ro, save: to };
          return (
            t._gsap || Ti.core.getCache(t),
            e &&
            e.split(",").forEach(function (t) {
              return r.save(t);
            }),
            r
          );
        },
        io = function (t, e) {
          var r = Si.createElementNS ? Si.createElementNS((e || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), t) : Si.createElement(t);
          return r.style ? r : Si.createElement(t);
        },
        oo = function t(e, r, n) {
          var i = getComputedStyle(e);
          return i[r] || i.getPropertyValue(r.replace(zi, "-$1").toLowerCase()) || i.getPropertyValue(r) || (!n && t(e, so(r) || r, 1)) || "";
        },
        ao = "O,Moz,ms,Ms,Webkit".split(","),
        so = function (t, e, r) {
          var n = (e || Ai).style,
            i = 5;
          if (t in n && !r) return t;
          for (t = t.charAt(0).toUpperCase() + t.substr(1); i-- && !(ao[i] + t in n););
          return i < 0 ? null : (3 === i ? "ms" : i >= 0 ? ao[i] : "") + t;
        },
        lo = function () {
          "undefined" != typeof window &&
            window.document &&
            ((Ei = window),
              (Si = Ei.document),
              (Oi = Si.documentElement),
              (Ai = io("div") || { style: {} }),
              io("div"),
              (Ki = so(Ki)),
              (Ji = Ki + "Origin"),
              (Ai.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"),
              (ki = !!so("perspective")),
              (Li = Ti.core.reverting),
              (Pi = 1));
        },
        co = function t(e) {
          var r,
            n = io("svg", (this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns")) || "http://www.w3.org/2000/svg"),
            i = this.parentNode,
            o = this.nextSibling,
            a = this.style.cssText;
          if ((Oi.appendChild(n), n.appendChild(this), (this.style.display = "block"), e))
            try {
              (r = this.getBBox()), (this._gsapBBox = this.getBBox), (this.getBBox = t);
            } catch (t) { }
          else this._gsapBBox && (r = this._gsapBBox());
          return i && (o ? i.insertBefore(this, o) : i.appendChild(this)), Oi.removeChild(n), (this.style.cssText = a), r;
        },
        uo = function (t, e) {
          for (var r = e.length; r--;) if (t.hasAttribute(e[r])) return t.getAttribute(e[r]);
        },
        po = function (t) {
          var e;
          try {
            e = t.getBBox();
          } catch (r) {
            e = co.call(t, !0);
          }
          return (e && (e.width || e.height)) || t.getBBox === co || (e = co.call(t, !0)), !e || e.width || e.x || e.y ? e : { x: +uo(t, ["x", "cx", "x1"]) || 0, y: +uo(t, ["y", "cy", "y1"]) || 0, width: 0, height: 0 };
        },
        fo = function (t) {
          return !(!t.getCTM || (t.parentNode && !t.ownerSVGElement) || !po(t));
        },
        ho = function (t, e) {
          if (e) {
            var r = t.style;
            e in Mi && e !== Ji && (e = Ki), r.removeProperty ? (("ms" !== e.substr(0, 2) && "webkit" !== e.substr(0, 6)) || (e = "-" + e), r.removeProperty(e.replace(zi, "-$1").toLowerCase())) : r.removeAttribute(e);
          }
        },
        vo = function (t, e, r, n, i, o) {
          var a = new ui(t._pt, e, r, 0, 1, o ? qi : Vi);
          return (t._pt = a), (a.b = n), (a.e = i), t._props.push(r), a;
        },
        mo = { deg: 1, rad: 1, turn: 1 },
        yo = { grid: 1, flex: 1 },
        go = function t(e, r, n, i) {
          var o,
            a,
            s,
            l,
            c = parseFloat(n) || 0,
            u = (n + "").trim().substr((c + "").length) || "px",
            p = Ai.style,
            f = Di.test(r),
            d = "svg" === e.tagName.toLowerCase(),
            h = (d ? "client" : "offset") + (f ? "Width" : "Height"),
            v = 100,
            m = "px" === i,
            y = "%" === i;
          return i === u || !c || mo[i] || mo[u]
            ? c
            : ("px" !== u && !m && (c = t(e, r, n, "px")),
              (l = e.getCTM && fo(e)),
              (!y && "%" !== u) || (!Mi[r] && !~r.indexOf("adius"))
                ? ((p[f ? "width" : "height"] = v + (m ? u : i)),
                  (a = ~r.indexOf("adius") || ("em" === i && e.appendChild && !d) ? e : e.parentNode),
                  l && (a = (e.ownerSVGElement || {}).parentNode),
                  (a && a !== Si && a.appendChild) || (a = Si.body),
                  (s = a._gsap) && y && s.width && f && s.time === En.time && !s.uncache
                    ? fr((c / s.width) * v)
                    : ((y || "%" === u) && !yo[oo(a, "display")] && (p.position = oo(e, "position")),
                      a === e && (p.position = "static"),
                      a.appendChild(Ai),
                      (o = Ai[h]),
                      a.removeChild(Ai),
                      (p.position = "absolute"),
                      f && y && (((s = cr(a)).time = En.time), (s.width = a[h])),
                      fr(m ? (o * c) / v : o && c ? (v / o) * c : 0)))
                : ((o = l ? e.getBBox()[f ? "width" : "height"] : e[h]), fr(y ? (c / o) * v : (c / 100) * o)));
        },
        bo = function (t, e, r, n) {
          var i;
          return (
            Pi || lo(),
            e in Fi && "transform" !== e && ~(e = Fi[e]).indexOf(",") && (e = e.split(",")[0]),
            Mi[e] && "transform" !== e
              ? ((i = Lo(t, n)), (i = "transformOrigin" !== e ? i[e] : i.svg ? i.origin : ko(oo(t, Ji)) + " " + i.zOrigin + "px"))
              : (!(i = t.style[e]) || "auto" === i || n || ~(i + "").indexOf("calc(")) && (i = (To[e] && To[e](t, e, r)) || oo(t, e) || ur(t, e) || ("opacity" === e ? 1 : 0)),
            r && !~(i + "").trim().indexOf(" ") ? go(t, e, i, r) + r : i
          );
        },
        wo = function (t, e, r, n) {
          if (!r || "none" === r) {
            var i = so(e, t, 1),
              o = i && oo(t, i, 1);
            o && o !== r ? ((e = i), (r = o)) : "borderColor" === e && (r = oo(t, "borderTopColor"));
          }
          var a,
            s,
            l,
            c,
            u,
            p,
            f,
            d,
            h,
            v,
            m,
            y = new ui(this._pt, t.style, e, 0, 1, ii),
            g = 0,
            b = 0;
          if (((y.b = r), (y.e = n), (r += ""), "auto" == (n += "") && ((t.style[e] = n), (n = oo(t, e) || n), (t.style[e] = r)), Tn((a = [r, n])), (n = a[1]), (l = (r = a[0]).match(Fe) || []), (n.match(Fe) || []).length)) {
            for (; (s = Fe.exec(n));)
              (f = s[0]),
                (h = n.substring(g, s.index)),
                u ? (u = (u + 1) % 5) : ("rgba(" !== h.substr(-5) && "hsla(" !== h.substr(-5)) || (u = 1),
                f !== (p = l[b++] || "") &&
                ((c = parseFloat(p) || 0),
                  (m = p.substr((c + "").length)),
                  "=" === f.charAt(1) && (f = hr(c, f) + m),
                  (d = parseFloat(f)),
                  (v = f.substr((d + "").length)),
                  (g = Fe.lastIndex - v.length),
                  v || ((v = v || ye.units[e] || m), g === n.length && ((n += v), (y.e += v))),
                  m !== v && (c = go(t, e, p, v) || 0),
                  (y._pt = { _next: y._pt, p: h || 1 === b ? h : ",", s: c, c: d - c, m: (u && u < 4) || "zIndex" === e ? Math.round : 0 }));
            y.c = g < n.length ? n.substring(g, n.length) : "";
          } else y.r = "display" === e && "none" === n ? qi : Vi;
          return Ne.test(n) && (y.e = 0), (this._pt = y), y;
        },
        _o = { top: "0%", bottom: "100%", left: "0%", right: "100%", center: "50%" },
        xo = function (t, e) {
          if (e.tween && e.tween._time === e.tween._dur) {
            var r,
              n,
              i,
              o = e.t,
              a = o.style,
              s = e.u,
              l = o._gsap;
            if ("all" === s || !0 === s) (a.cssText = ""), (n = 1);
            else for (i = (s = s.split(",")).length; --i > -1;) (r = s[i]), Mi[r] && ((n = 1), (r = "transformOrigin" === r ? Ji : Ki)), ho(o, r);
            n && (ho(o, Ki), l && (l.svg && o.removeAttribute("transform"), Lo(o, 1), (l.uncache = 1), eo(a)));
          }
        },
        To = {
          clearProps: function (t, e, r, n, i) {
            if ("isFromStart" !== i.data) {
              var o = (t._pt = new ui(t._pt, e, r, 0, 0, xo));
              return (o.u = n), (o.pr = -10), (o.tween = i), t._props.push(r), 1;
            }
          },
        },
        Eo = [1, 0, 0, 1, 0, 0],
        So = {},
        Oo = function (t) {
          return "matrix(1, 0, 0, 1, 0, 0)" === t || "none" === t || !t;
        },
        Po = function (t) {
          var e = oo(t, Ki);
          return Oo(e) ? Eo : e.substr(7).match(Be).map(fr);
        },
        Ao = function (t, e) {
          var r,
            n,
            i,
            o,
            a = t._gsap || cr(t),
            s = t.style,
            l = Po(t);
          return a.svg && t.getAttribute("transform")
            ? "1,0,0,1,0,0" === (l = [(i = t.transform.baseVal.consolidate().matrix).a, i.b, i.c, i.d, i.e, i.f]).join(",")
              ? Eo
              : l
            : (l !== Eo ||
              t.offsetParent ||
              t === Oi ||
              a.svg ||
              ((i = s.display),
                (s.display = "block"),
                ((r = t.parentNode) && t.offsetParent) || ((o = 1), (n = t.nextElementSibling), Oi.appendChild(t)),
                (l = Po(t)),
                i ? (s.display = i) : ho(t, "display"),
                o && (n ? r.insertBefore(t, n) : r ? r.appendChild(t) : Oi.removeChild(t))),
              e && l.length > 6 ? [l[0], l[1], l[4], l[5], l[12], l[13]] : l);
        },
        Co = function (t, e, r, n, i, o) {
          var a,
            s,
            l,
            c = t._gsap,
            u = i || Ao(t, !0),
            p = c.xOrigin || 0,
            f = c.yOrigin || 0,
            d = c.xOffset || 0,
            h = c.yOffset || 0,
            v = u[0],
            m = u[1],
            y = u[2],
            g = u[3],
            b = u[4],
            w = u[5],
            _ = e.split(" "),
            x = parseFloat(_[0]) || 0,
            T = parseFloat(_[1]) || 0;
          r
            ? u !== Eo && (s = v * g - m * y) && ((l = x * (-m / s) + T * (v / s) - (v * w - m * b) / s), (x = x * (g / s) + T * (-y / s) + (y * w - g * b) / s), (T = l))
            : ((x = (a = po(t)).x + (~_[0].indexOf("%") ? (x / 100) * a.width : x)), (T = a.y + (~(_[1] || _[0]).indexOf("%") ? (T / 100) * a.height : T))),
            n || (!1 !== n && c.smooth) ? ((b = x - p), (w = T - f), (c.xOffset = d + (b * v + w * y) - b), (c.yOffset = h + (b * m + w * g) - w)) : (c.xOffset = c.yOffset = 0),
            (c.xOrigin = x),
            (c.yOrigin = T),
            (c.smooth = !!n),
            (c.origin = e),
            (c.originIsAbsolute = !!r),
            (t.style[Ji] = "0px 0px"),
            o && (vo(o, c, "xOrigin", p, x), vo(o, c, "yOrigin", f, T), vo(o, c, "xOffset", d, c.xOffset), vo(o, c, "yOffset", h, c.yOffset)),
            t.setAttribute("data-svg-origin", x + " " + T);
        },
        Lo = function (t, e) {
          var r = t._gsap || new Dn(t);
          if ("x" in r && !e && !r.uncache) return r;
          var n,
            i,
            o,
            a,
            s,
            l,
            c,
            u,
            p,
            f,
            d,
            h,
            v,
            m,
            y,
            g,
            b,
            w,
            _,
            x,
            T,
            E,
            S,
            O,
            P,
            A,
            C,
            L,
            k,
            M,
            j,
            R,
            I = t.style,
            z = r.scaleX < 0,
            D = "px",
            B = "deg",
            F = getComputedStyle(t),
            G = oo(t, Ji) || "0";
          return (
            (n = i = o = l = c = u = p = f = d = 0),
            (a = s = 1),
            (r.svg = !(!t.getCTM || !fo(t))),
            F.translate &&
            (("none" === F.translate && "none" === F.scale && "none" === F.rotate) ||
              (I[Ki] =
                ("none" !== F.translate ? "translate3d(" + (F.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") +
                ("none" !== F.rotate ? "rotate(" + F.rotate + ") " : "") +
                ("none" !== F.scale ? "scale(" + F.scale.split(" ").join(",") + ") " : "") +
                ("none" !== F[Ki] ? F[Ki] : "")),
              (I.scale = I.rotate = I.translate = "none")),
            (m = Ao(t, r.svg)),
            r.svg &&
            (r.uncache ? ((P = t.getBBox()), (G = r.xOrigin - P.x + "px " + (r.yOrigin - P.y) + "px"), (O = "")) : (O = !e && t.getAttribute("data-svg-origin")), Co(t, O || G, !!O || r.originIsAbsolute, !1 !== r.smooth, m)),
            (h = r.xOrigin || 0),
            (v = r.yOrigin || 0),
            m !== Eo &&
            ((w = m[0]),
              (_ = m[1]),
              (x = m[2]),
              (T = m[3]),
              (n = E = m[4]),
              (i = S = m[5]),
              6 === m.length
                ? ((a = Math.sqrt(w * w + _ * _)),
                  (s = Math.sqrt(T * T + x * x)),
                  (l = w || _ ? Ii(_, w) * ji : 0),
                  (p = x || T ? Ii(x, T) * ji + l : 0) && (s *= Math.abs(Math.cos(p * Ri))),
                  r.svg && ((n -= h - (h * w + v * x)), (i -= v - (h * _ + v * T))))
                : ((R = m[6]),
                  (M = m[7]),
                  (C = m[8]),
                  (L = m[9]),
                  (k = m[10]),
                  (j = m[11]),
                  (n = m[12]),
                  (i = m[13]),
                  (o = m[14]),
                  (c = (y = Ii(R, k)) * ji),
                  y &&
                  ((O = E * (g = Math.cos(-y)) + C * (b = Math.sin(-y))),
                    (P = S * g + L * b),
                    (A = R * g + k * b),
                    (C = E * -b + C * g),
                    (L = S * -b + L * g),
                    (k = R * -b + k * g),
                    (j = M * -b + j * g),
                    (E = O),
                    (S = P),
                    (R = A)),
                  (u = (y = Ii(-x, k)) * ji),
                  y && ((g = Math.cos(-y)), (j = T * (b = Math.sin(-y)) + j * g), (w = O = w * g - C * b), (_ = P = _ * g - L * b), (x = A = x * g - k * b)),
                  (l = (y = Ii(_, w)) * ji),
                  y && ((O = w * (g = Math.cos(y)) + _ * (b = Math.sin(y))), (P = E * g + S * b), (_ = _ * g - w * b), (S = S * g - E * b), (w = O), (E = P)),
                  c && Math.abs(c) + Math.abs(l) > 359.9 && ((c = l = 0), (u = 180 - u)),
                  (a = fr(Math.sqrt(w * w + _ * _ + x * x))),
                  (s = fr(Math.sqrt(S * S + R * R))),
                  (y = Ii(E, S)),
                  (p = Math.abs(y) > 2e-4 ? y * ji : 0),
                  (d = j ? 1 / (j < 0 ? -j : j) : 0)),
              r.svg && ((O = t.getAttribute("transform")), (r.forceCSS = t.setAttribute("transform", "") || !Oo(oo(t, Ki))), O && t.setAttribute("transform", O))),
            Math.abs(p) > 90 && Math.abs(p) < 270 && (z ? ((a *= -1), (p += l <= 0 ? 180 : -180), (l += l <= 0 ? 180 : -180)) : ((s *= -1), (p += p <= 0 ? 180 : -180))),
            (e = e || r.uncache),
            (r.x = n - ((r.xPercent = n && ((!e && r.xPercent) || (Math.round(t.offsetWidth / 2) === Math.round(-n) ? -50 : 0))) ? (t.offsetWidth * r.xPercent) / 100 : 0) + D),
            (r.y = i - ((r.yPercent = i && ((!e && r.yPercent) || (Math.round(t.offsetHeight / 2) === Math.round(-i) ? -50 : 0))) ? (t.offsetHeight * r.yPercent) / 100 : 0) + D),
            (r.z = o + D),
            (r.scaleX = fr(a)),
            (r.scaleY = fr(s)),
            (r.rotation = fr(l) + B),
            (r.rotationX = fr(c) + B),
            (r.rotationY = fr(u) + B),
            (r.skewX = p + B),
            (r.skewY = f + B),
            (r.transformPerspective = d + D),
            (r.zOrigin = parseFloat(G.split(" ")[2]) || 0) && (I[Ji] = ko(G)),
            (r.xOffset = r.yOffset = 0),
            (r.force3D = ye.force3D),
            (r.renderTransform = r.svg ? Bo : ki ? Do : jo),
            (r.uncache = 0),
            r
          );
        },
        ko = function (t) {
          return (t = t.split(" "))[0] + " " + t[1];
        },
        Mo = function (t, e, r) {
          var n = Zr(e);
          return fr(parseFloat(e) + parseFloat(go(t, "x", r + "px", n))) + n;
        },
        jo = function (t, e) {
          (e.z = "0px"), (e.rotationY = e.rotationX = "0deg"), (e.force3D = 0), Do(t, e);
        },
        Ro = "0deg",
        Io = "0px",
        zo = ") ",
        Do = function (t, e) {
          var r = e || this,
            n = r.xPercent,
            i = r.yPercent,
            o = r.x,
            a = r.y,
            s = r.z,
            l = r.rotation,
            c = r.rotationY,
            u = r.rotationX,
            p = r.skewX,
            f = r.skewY,
            d = r.scaleX,
            h = r.scaleY,
            v = r.transformPerspective,
            m = r.force3D,
            y = r.target,
            g = r.zOrigin,
            b = "",
            w = ("auto" === m && t && 1 !== t) || !0 === m;
          if (g && (u !== Ro || c !== Ro)) {
            var _,
              x = parseFloat(c) * Ri,
              T = Math.sin(x),
              E = Math.cos(x);
            (x = parseFloat(u) * Ri), (_ = Math.cos(x)), (o = Mo(y, o, T * _ * -g)), (a = Mo(y, a, -Math.sin(x) * -g)), (s = Mo(y, s, E * _ * -g + g));
          }
          v !== Io && (b += "perspective(" + v + zo),
            (n || i) && (b += "translate(" + n + "%, " + i + "%) "),
            (w || o !== Io || a !== Io || s !== Io) && (b += s !== Io || w ? "translate3d(" + o + ", " + a + ", " + s + ") " : "translate(" + o + ", " + a + zo),
            l !== Ro && (b += "rotate(" + l + zo),
            c !== Ro && (b += "rotateY(" + c + zo),
            u !== Ro && (b += "rotateX(" + u + zo),
            (p === Ro && f === Ro) || (b += "skew(" + p + ", " + f + zo),
            (1 === d && 1 === h) || (b += "scale(" + d + ", " + h + zo),
            (y.style[Ki] = b || "translate(0, 0)");
        },
        Bo = function (t, e) {
          var r,
            n,
            i,
            o,
            a,
            s = e || this,
            l = s.xPercent,
            c = s.yPercent,
            u = s.x,
            p = s.y,
            f = s.rotation,
            d = s.skewX,
            h = s.skewY,
            v = s.scaleX,
            m = s.scaleY,
            y = s.target,
            g = s.xOrigin,
            b = s.yOrigin,
            w = s.xOffset,
            _ = s.yOffset,
            x = s.forceCSS,
            T = parseFloat(u),
            E = parseFloat(p);
          (f = parseFloat(f)),
            (d = parseFloat(d)),
            (h = parseFloat(h)) && ((d += h = parseFloat(h)), (f += h)),
            f || d
              ? ((f *= Ri),
                (d *= Ri),
                (r = Math.cos(f) * v),
                (n = Math.sin(f) * v),
                (i = Math.sin(f - d) * -m),
                (o = Math.cos(f - d) * m),
                d && ((h *= Ri), (a = Math.tan(d - h)), (i *= a = Math.sqrt(1 + a * a)), (o *= a), h && ((a = Math.tan(h)), (r *= a = Math.sqrt(1 + a * a)), (n *= a))),
                (r = fr(r)),
                (n = fr(n)),
                (i = fr(i)),
                (o = fr(o)))
              : ((r = v), (o = m), (n = i = 0)),
            ((T && !~(u + "").indexOf("px")) || (E && !~(p + "").indexOf("px"))) && ((T = go(y, "x", u, "px")), (E = go(y, "y", p, "px"))),
            (g || b || w || _) && ((T = fr(T + g - (g * r + b * i) + w)), (E = fr(E + b - (g * n + b * o) + _))),
            (l || c) && ((a = y.getBBox()), (T = fr(T + (l / 100) * a.width)), (E = fr(E + (c / 100) * a.height))),
            (a = "matrix(" + r + "," + n + "," + i + "," + o + "," + T + "," + E + ")"),
            y.setAttribute("transform", a),
            x && (y.style[Ki] = a);
        },
        Fo = function (t, e, r, n, i) {
          var o,
            a,
            s = 360,
            l = Pe(i),
            c = parseFloat(i) * (l && ~i.indexOf("rad") ? ji : 1) - n,
            u = n + c + "deg";
          return (
            l &&
            ("short" === (o = i.split("_")[1]) && (c %= s) != c % 180 && (c += c < 0 ? s : -360),
              "cw" === o && c < 0 ? (c = ((c + 36e9) % s) - ~~(c / s) * s) : "ccw" === o && c > 0 && (c = ((c - 36e9) % s) - ~~(c / s) * s)),
            (t._pt = a = new ui(t._pt, e, r, n, c, Ni)),
            (a.e = u),
            (a.u = "deg"),
            t._props.push(r),
            a
          );
        },
        Go = function (t, e) {
          for (var r in e) t[r] = e[r];
          return t;
        },
        No = function (t, e, r) {
          var n,
            i,
            o,
            a,
            s,
            l,
            c,
            u = Go({}, r._gsap),
            p = r.style;
          for (i in (u.svg
            ? ((o = r.getAttribute("transform")), r.setAttribute("transform", ""), (p[Ki] = e), (n = Lo(r, 1)), ho(r, Ki), r.setAttribute("transform", o))
            : ((o = getComputedStyle(r)[Ki]), (p[Ki] = e), (n = Lo(r, 1)), (p[Ki] = o)),
            Mi))
            (o = u[i]) !== (a = n[i]) &&
              "perspective,force3D,transformOrigin,svgOrigin".indexOf(i) < 0 &&
              ((s = Zr(o) !== (c = Zr(a)) ? go(r, i, o, c) : parseFloat(o)), (l = parseFloat(a)), (t._pt = new ui(t._pt, n, i, s, l - s, Gi)), (t._pt.u = c || 0), t._props.push(i));
          Go(n, u);
        };
      pr("padding,margin,Width,Radius", function (t, e) {
        var r = "Top",
          n = "Right",
          i = "Bottom",
          o = "Left",
          a = (e < 3 ? [r, n, i, o] : [r + o, r + n, i + n, i + o]).map(function (r) {
            return e < 2 ? t + r : "border" + r + t;
          });
        To[e > 1 ? "border" + t : t] = function (t, e, r, n, i) {
          var o, s;
          if (arguments.length < 4)
            return (
              (o = a.map(function (e) {
                return bo(t, e, r);
              })),
              5 === (s = o.join(" ")).split(o[0]).length ? o[0] : s
            );
          (o = (n + "").split(" ")),
            (s = {}),
            a.forEach(function (t, e) {
              return (s[t] = o[e] = o[e] || o[((e - 1) / 2) | 0]);
            }),
            t.init(e, s, i);
        };
      });
      var Yo,
        Ho,
        Vo = {
          name: "css",
          register: lo,
          targetTest: function (t) {
            return t.style && t.nodeType;
          },
          init: function (t, e, r, n, i) {
            var o,
              a,
              s,
              l,
              c,
              u,
              p,
              f,
              d,
              h,
              v,
              m,
              y,
              g,
              b,
              w,
              _,
              x,
              T,
              E,
              S = this._props,
              O = t.style,
              P = r.vars.startAt;
            for (p in (Pi || lo(), (this.styles = this.styles || no(t)), (w = this.styles.props), (this.tween = r), e))
              if ("autoRound" !== p && ((a = e[p]), !nr[p] || !Vn(p, e, r, n, t, i)))
                if (((c = typeof a), (u = To[p]), "function" === c && (c = typeof (a = a.call(r, n, t, i))), "string" === c && ~a.indexOf("random(") && (a = ln(a)), u)) u(this, t, p, a, r) && (b = 1);
                else if ("--" === p.substr(0, 2))
                  (o = (getComputedStyle(t).getPropertyValue(p) + "").trim()),
                    (a += ""),
                    (_n.lastIndex = 0),
                    _n.test(o) || ((f = Zr(o)), (d = Zr(a))),
                    d ? f !== d && (o = go(t, p, o, d) + d) : f && (a += f),
                    this.add(O, "setProperty", o, a, n, i, 0, 0, p),
                    S.push(p),
                    w.push(p, 0, O[p]);
                else if ("undefined" !== c) {
                  if (
                    (P && p in P
                      ? ((o = "function" == typeof P[p] ? P[p].call(r, n, t, i) : P[p]),
                        Pe(o) && ~o.indexOf("random(") && (o = ln(o)),
                        Zr(o + "") || (o += ye.units[p] || Zr(bo(t, p)) || ""),
                        "=" === (o + "").charAt(1) && (o = bo(t, p)))
                      : (o = bo(t, p)),
                      (l = parseFloat(o)),
                      (h = "string" === c && "=" === a.charAt(1) && a.substr(0, 2)) && (a = a.substr(2)),
                      (s = parseFloat(a)),
                      p in Fi &&
                      ("autoAlpha" === p &&
                        (1 === l && "hidden" === bo(t, "visibility") && s && (l = 0), w.push("visibility", 0, O.visibility), vo(this, O, "visibility", l ? "inherit" : "hidden", s ? "inherit" : "hidden", !s)),
                        "scale" !== p && "transform" !== p && ~(p = Fi[p]).indexOf(",") && (p = p.split(",")[0])),
                      (v = p in Mi))
                  )
                    if (
                      (this.styles.save(p),
                        m ||
                        (((y = t._gsap).renderTransform && !e.parseTransform) || Lo(t, e.parseTransform),
                          (g = !1 !== e.smoothOrigin && y.smooth),
                          ((m = this._pt = new ui(this._pt, O, Ki, 0, 1, y.renderTransform, y, 0, -1)).dep = 1)),
                        "scale" === p)
                    )
                      (this._pt = new ui(this._pt, y, "scaleY", y.scaleY, (h ? hr(y.scaleY, h + s) : s) - y.scaleY || 0, Gi)), (this._pt.u = 0), S.push("scaleY", p), (p += "X");
                    else {
                      if ("transformOrigin" === p) {
                        w.push(Ji, 0, O[Ji]),
                          (x = void 0),
                          (T = void 0),
                          (E = void 0),
                          (T = (x = (_ = a).split(" "))[0]),
                          (E = x[1] || "50%"),
                          ("top" !== T && "bottom" !== T && "left" !== E && "right" !== E) || ((_ = T), (T = E), (E = _)),
                          (x[0] = _o[T] || T),
                          (x[1] = _o[E] || E),
                          (a = x.join(" ")),
                          y.svg ? Co(t, a, 0, g, 0, this) : ((d = parseFloat(a.split(" ")[2]) || 0) !== y.zOrigin && vo(this, y, "zOrigin", y.zOrigin, d), vo(this, O, p, ko(o), ko(a)));
                        continue;
                      }
                      if ("svgOrigin" === p) {
                        Co(t, a, 1, g, 0, this);
                        continue;
                      }
                      if (p in So) {
                        Fo(this, y, p, l, h ? hr(l, h + a) : a);
                        continue;
                      }
                      if ("smoothOrigin" === p) {
                        vo(this, y, "smooth", y.smooth, a);
                        continue;
                      }
                      if ("force3D" === p) {
                        y[p] = a;
                        continue;
                      }
                      if ("transform" === p) {
                        No(this, a, t);
                        continue;
                      }
                    }
                  else p in O || (p = so(p) || p);
                  if (v || ((s || 0 === s) && (l || 0 === l) && !Bi.test(a) && p in O))
                    s || (s = 0),
                      (f = (o + "").substr((l + "").length)) !== (d = Zr(a) || (p in ye.units ? ye.units[p] : f)) && (l = go(t, p, o, d)),
                      (this._pt = new ui(this._pt, v ? y : O, p, l, (h ? hr(l, h + s) : s) - l, v || ("px" !== d && "zIndex" !== p) || !1 === e.autoRound ? Gi : Hi)),
                      (this._pt.u = d || 0),
                      f !== d && "%" !== d && ((this._pt.b = o), (this._pt.r = Yi));
                  else if (p in O) wo.call(this, t, p, o, h ? h + a : a);
                  else if (p in t) this.add(t, p, o || t[p], h ? h + a : a, n, i);
                  else if ("parseTransform" !== p) {
                    Xe(p, a);
                    continue;
                  }
                  v || (p in O ? w.push(p, 0, O[p]) : w.push(p, 1, o || t[p])), S.push(p);
                }
            b && ci(this);
          },
          render: function (t, e) {
            if (e.tween._time || !Li()) for (var r = e._pt; r;) r.r(t, r.d), (r = r._next);
            else e.styles.revert();
          },
          get: bo,
          aliases: Fi,
          getSetter: function (t, e, r) {
            var n = Fi[e];
            return (
              n && n.indexOf(",") < 0 && (e = n),
              e in Mi && e !== Ji && (t._gsap.x || bo(t, "x")) ? (r && Ci === r ? ("scale" === e ? Ui : Wi) : (Ci = r || {}) && ("scale" === e ? Zi : Qi)) : t.style && !Le(t.style[e]) ? $i : ~e.indexOf("-") ? Xi : ei(t, e)
            );
          },
          core: { _removeProperty: ho, _getMatrix: Ao },
        };
      (Ti.utils.checkPrefix = so),
        (Ti.core.getStyleSaver = no),
        (Ho = pr("x,y,z,scale,scaleX,scaleY,xPercent,yPercent" + "," + (Yo = "rotation,rotationX,rotationY,skewX,skewY") + ",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", function (t) {
          Mi[t] = 1;
        })),
        pr(Yo, function (t) {
          (ye.units[t] = "deg"), (So[t] = 1);
        }),
        (Fi[Ho[13]] = "x,y,z,scale,scaleX,scaleY,xPercent,yPercent," + Yo),
        pr("0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY", function (t) {
          var e = t.split(":");
          Fi[e[1]] = Ho[e[0]];
        }),
        pr("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function (t) {
          ye.units[t] = "px";
        }),
        Ti.registerPlugin(Vo);
      var qo = Ti.registerPlugin(Vo) || Ti;
      function $o(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          (n.enumerable = n.enumerable || !1), (n.configurable = !0), "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }
      qo.core.Tween;
      var Xo,
        Wo,
        Uo,
        Zo,
        Qo,
        Ko,
        Jo,
        ta,
        ea,
        ra,
        na,
        ia,
        oa,
        aa = function () {
          return Xo || ("undefined" != typeof window && (Xo = window.gsap) && Xo.registerPlugin && Xo);
        },
        sa = 1,
        la = [],
        ca = [],
        ua = [],
        pa = Date.now,
        fa = function (t, e) {
          return e;
        },
        da = function (t, e) {
          return ~ua.indexOf(t) && ua[ua.indexOf(t) + 1][e];
        },
        ha = function (t) {
          return !!~ra.indexOf(t);
        },
        va = function (t, e, r, n, i) {
          return t.addEventListener(e, r, { passive: !n, capture: !!i });
        },
        ma = function (t, e, r, n) {
          return t.removeEventListener(e, r, !!n);
        },
        ya = "scrollLeft",
        ga = "scrollTop",
        ba = function () {
          return (na && na.isPressed) || ca.cache++;
        },
        wa = function (t, e) {
          var r = function r(n) {
            if (n || 0 === n) {
              sa && (Uo.history.scrollRestoration = "manual");
              var i = na && na.isPressed;
              (n = r.v = Math.round(n) || (na && na.iOS ? 1 : 0)), t(n), (r.cacheID = ca.cache), i && fa("ss", n);
            } else (e || ca.cache !== r.cacheID || fa("ref")) && ((r.cacheID = ca.cache), (r.v = t()));
            return r.v + r.offset;
          };
          return (r.offset = 0), t && r;
        },
        _a = {
          s: ya,
          p: "left",
          p2: "Left",
          os: "right",
          os2: "Right",
          d: "width",
          d2: "Width",
          a: "x",
          sc: wa(function (t) {
            return arguments.length ? Uo.scrollTo(t, xa.sc()) : Uo.pageXOffset || Zo[ya] || Qo[ya] || Ko[ya] || 0;
          }),
        },
        xa = {
          s: ga,
          p: "top",
          p2: "Top",
          os: "bottom",
          os2: "Bottom",
          d: "height",
          d2: "Height",
          a: "y",
          op: _a,
          sc: wa(function (t) {
            return arguments.length ? Uo.scrollTo(_a.sc(), t) : Uo.pageYOffset || Zo[ga] || Qo[ga] || Ko[ga] || 0;
          }),
        },
        Ta = function (t, e) {
          return ((e && e._ctx && e._ctx.selector) || Xo.utils.toArray)(t)[0] || ("string" == typeof t && !1 !== Xo.config().nullTargetWarn ? console.warn("Element not found:", t) : null);
        },
        Ea = function (t, e) {
          var r = e.s,
            n = e.sc;
          ha(t) && (t = Zo.scrollingElement || Qo);
          var i = ca.indexOf(t),
            o = n === xa.sc ? 1 : 2;
          !~i && (i = ca.push(t) - 1), ca[i + o] || va(t, "scroll", ba);
          var a = ca[i + o],
            s =
              a ||
              (ca[i + o] =
                wa(da(t, r), !0) ||
                (ha(t)
                  ? n
                  : wa(function (e) {
                    return arguments.length ? (t[r] = e) : t[r];
                  })));
          return (s.target = t), a || (s.smooth = "smooth" === Xo.getProperty(t, "scrollBehavior")), s;
        },
        Sa = function (t, e, r) {
          var n = t,
            i = t,
            o = pa(),
            a = o,
            s = e || 50,
            l = Math.max(500, 3 * s),
            c = function (t, e) {
              var l = pa();
              e || l - o > s ? ((i = n), (n = t), (a = o), (o = l)) : r ? (n += t) : (n = i + ((t - i) / (l - a)) * (o - a));
            };
          return {
            update: c,
            reset: function () {
              (i = n = r ? 0 : n), (a = o = 0);
            },
            getVelocity: function (t) {
              var e = a,
                s = i,
                u = pa();
              return (t || 0 === t) && t !== n && c(t), o === a || u - a > l ? 0 : ((n + (r ? s : -s)) / ((r ? u : o) - e)) * 1e3;
            },
          };
        },
        Oa = function (t, e) {
          return e && !t._gsapAllow && t.preventDefault(), t.changedTouches ? t.changedTouches[0] : t;
        },
        Pa = function (t) {
          var e = Math.max.apply(Math, t),
            r = Math.min.apply(Math, t);
          return Math.abs(e) >= Math.abs(r) ? e : r;
        },
        Aa = function () {
          (ea = Xo.core.globals().ScrollTrigger) &&
            ea.core &&
            (function () {
              var t = ea.core,
                e = t.bridge || {},
                r = t._scrollers,
                n = t._proxies;
              r.push.apply(r, ca),
                n.push.apply(n, ua),
                (ca = r),
                (ua = n),
                (fa = function (t, r) {
                  return e[t](r);
                });
            })();
        },
        Ca = function (t) {
          return (
            (Xo = t || aa()) &&
            "undefined" != typeof document &&
            document.body &&
            ((Uo = window),
              (Zo = document),
              (Qo = Zo.documentElement),
              (Ko = Zo.body),
              (ra = [Uo, Zo, Qo, Ko]),
              Xo.utils.clamp,
              (oa = Xo.core.context || function () { }),
              (ta = "onpointerenter" in Ko ? "pointer" : "mouse"),
              (Jo = La.isTouch = Uo.matchMedia && Uo.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in Uo || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0),
              (ia = La.eventTypes = ("ontouchstart" in Qo
                ? "touchstart,touchmove,touchcancel,touchend"
                : "onpointerdown" in Qo
                  ? "pointerdown,pointermove,pointercancel,pointerup"
                  : "mousedown,mousemove,mouseup,mouseup"
              ).split(",")),
              setTimeout(function () {
                return (sa = 0);
              }, 500),
              Aa(),
              (Wo = 1)),
            Wo
          );
        };
      (_a.op = xa), (ca.cache = 0);
      var La = (function () {
        function t(t) {
          this.init(t);
        }
        var e, r;
        return (
          (t.prototype.init = function (t) {
            Wo || Ca(Xo) || console.warn("Please gsap.registerPlugin(Observer)"), ea || Aa();
            var e = t.tolerance,
              r = t.dragMinimum,
              n = t.type,
              i = t.target,
              o = t.lineHeight,
              a = t.debounce,
              s = t.preventDefault,
              l = t.onStop,
              c = t.onStopDelay,
              u = t.ignore,
              p = t.wheelSpeed,
              f = t.event,
              d = t.onDragStart,
              h = t.onDragEnd,
              v = t.onDrag,
              m = t.onPress,
              y = t.onRelease,
              g = t.onRight,
              b = t.onLeft,
              w = t.onUp,
              _ = t.onDown,
              x = t.onChangeX,
              T = t.onChangeY,
              E = t.onChange,
              S = t.onToggleX,
              O = t.onToggleY,
              P = t.onHover,
              A = t.onHoverEnd,
              C = t.onMove,
              L = t.ignoreCheck,
              k = t.isNormalizer,
              M = t.onGestureStart,
              j = t.onGestureEnd,
              R = t.onWheel,
              I = t.onEnable,
              z = t.onDisable,
              D = t.onClick,
              B = t.scrollSpeed,
              F = t.capture,
              G = t.allowClicks,
              N = t.lockAxis,
              Y = t.onLockAxis;
            (this.target = i = Ta(i) || Qo),
              (this.vars = t),
              u && (u = Xo.utils.toArray(u)),
              (e = e || 1e-9),
              (r = r || 0),
              (p = p || 1),
              (B = B || 1),
              (n = n || "wheel,touch,pointer"),
              (a = !1 !== a),
              o || (o = parseFloat(Uo.getComputedStyle(Ko).lineHeight) || 22);
            var H,
              V,
              q,
              $,
              X,
              W,
              U,
              Z = this,
              Q = 0,
              K = 0,
              J = Ea(i, _a),
              tt = Ea(i, xa),
              et = J(),
              rt = tt(),
              nt = ~n.indexOf("touch") && !~n.indexOf("pointer") && "pointerdown" === ia[0],
              it = ha(i),
              ot = i.ownerDocument || Zo,
              at = [0, 0, 0],
              st = [0, 0, 0],
              lt = 0,
              ct = function () {
                return (lt = pa());
              },
              ut = function (t, e) {
                return ((Z.event = t) && u && ~u.indexOf(t.target)) || (e && nt && "touch" !== t.pointerType) || (L && L(t, e));
              },
              pt = function () {
                var t = (Z.deltaX = Pa(at)),
                  r = (Z.deltaY = Pa(st)),
                  n = Math.abs(t) >= e,
                  i = Math.abs(r) >= e;
                E && (n || i) && E(Z, t, r, at, st),
                  n && (g && Z.deltaX > 0 && g(Z), b && Z.deltaX < 0 && b(Z), x && x(Z), S && Z.deltaX < 0 != Q < 0 && S(Z), (Q = Z.deltaX), (at[0] = at[1] = at[2] = 0)),
                  i && (_ && Z.deltaY > 0 && _(Z), w && Z.deltaY < 0 && w(Z), T && T(Z), O && Z.deltaY < 0 != K < 0 && O(Z), (K = Z.deltaY), (st[0] = st[1] = st[2] = 0)),
                  ($ || q) && (C && C(Z), q && (v(Z), (q = !1)), ($ = !1)),
                  W && !(W = !1) && Y && Y(Z),
                  X && (R(Z), (X = !1)),
                  (H = 0);
              },
              ft = function (t, e, r) {
                (at[r] += t), (st[r] += e), Z._vx.update(t), Z._vy.update(e), a ? H || (H = requestAnimationFrame(pt)) : pt();
              },
              dt = function (t, e) {
                N && !U && ((Z.axis = U = Math.abs(t) > Math.abs(e) ? "x" : "y"), (W = !0)),
                  "y" !== U && ((at[2] += t), Z._vx.update(t, !0)),
                  "x" !== U && ((st[2] += e), Z._vy.update(e, !0)),
                  a ? H || (H = requestAnimationFrame(pt)) : pt();
              },
              ht = function (t) {
                if (!ut(t, 1)) {
                  var e = (t = Oa(t, s)).clientX,
                    n = t.clientY,
                    i = e - Z.x,
                    o = n - Z.y,
                    a = Z.isDragging;
                  (Z.x = e), (Z.y = n), (a || Math.abs(Z.startX - e) >= r || Math.abs(Z.startY - n) >= r) && (v && (q = !0), a || (Z.isDragging = !0), dt(i, o), a || (d && d(Z)));
                }
              },
              vt = (Z.onPress = function (t) {
                ut(t, 1) ||
                  (t && t.button) ||
                  ((Z.axis = U = null),
                    V.pause(),
                    (Z.isPressed = !0),
                    (t = Oa(t)),
                    (Q = K = 0),
                    (Z.startX = Z.x = t.clientX),
                    (Z.startY = Z.y = t.clientY),
                    Z._vx.reset(),
                    Z._vy.reset(),
                    va(k ? i : ot, ia[1], ht, s, !0),
                    (Z.deltaX = Z.deltaY = 0),
                    m && m(Z));
              }),
              mt = (Z.onRelease = function (t) {
                if (!ut(t, 1)) {
                  ma(k ? i : ot, ia[1], ht, !0);
                  var e = !isNaN(Z.y - Z.startY),
                    r = Z.isDragging && (Math.abs(Z.x - Z.startX) > 3 || Math.abs(Z.y - Z.startY) > 3),
                    n = Oa(t);
                  !r &&
                    e &&
                    (Z._vx.reset(),
                      Z._vy.reset(),
                      s &&
                      G &&
                      Xo.delayedCall(0.08, function () {
                        if (pa() - lt > 300 && !t.defaultPrevented)
                          if (t.target.click) t.target.click();
                          else if (ot.createEvent) {
                            var e = ot.createEvent("MouseEvents");
                            e.initMouseEvent("click", !0, !0, Uo, 1, n.screenX, n.screenY, n.clientX, n.clientY, !1, !1, !1, !1, 0, null), t.target.dispatchEvent(e);
                          }
                      })),
                    (Z.isDragging = Z.isGesturing = Z.isPressed = !1),
                    l && !k && V.restart(!0),
                    h && r && h(Z),
                    y && y(Z, r);
                }
              }),
              yt = function (t) {
                return t.touches && t.touches.length > 1 && (Z.isGesturing = !0) && M(t, Z.isDragging);
              },
              gt = function () {
                return (Z.isGesturing = !1) || j(Z);
              },
              bt = function (t) {
                if (!ut(t)) {
                  var e = J(),
                    r = tt();
                  ft((e - et) * B, (r - rt) * B, 1), (et = e), (rt = r), l && V.restart(!0);
                }
              },
              wt = function (t) {
                if (!ut(t)) {
                  (t = Oa(t, s)), R && (X = !0);
                  var e = (1 === t.deltaMode ? o : 2 === t.deltaMode ? Uo.innerHeight : 1) * p;
                  ft(t.deltaX * e, t.deltaY * e, 0), l && !k && V.restart(!0);
                }
              },
              _t = function (t) {
                if (!ut(t)) {
                  var e = t.clientX,
                    r = t.clientY,
                    n = e - Z.x,
                    i = r - Z.y;
                  (Z.x = e), (Z.y = r), ($ = !0), (n || i) && dt(n, i);
                }
              },
              xt = function (t) {
                (Z.event = t), P(Z);
              },
              Tt = function (t) {
                (Z.event = t), A(Z);
              },
              Et = function (t) {
                return ut(t) || (Oa(t, s) && D(Z));
              };
            (V = Z._dc = Xo.delayedCall(c || 0.25, function () {
              Z._vx.reset(), Z._vy.reset(), V.pause(), l && l(Z);
            }).pause()),
              (Z.deltaX = Z.deltaY = 0),
              (Z._vx = Sa(0, 50, !0)),
              (Z._vy = Sa(0, 50, !0)),
              (Z.scrollX = J),
              (Z.scrollY = tt),
              (Z.isDragging = Z.isGesturing = Z.isPressed = !1),
              oa(this),
              (Z.enable = function (t) {
                return (
                  Z.isEnabled ||
                  (va(it ? ot : i, "scroll", ba),
                    n.indexOf("scroll") >= 0 && va(it ? ot : i, "scroll", bt, s, F),
                    n.indexOf("wheel") >= 0 && va(i, "wheel", wt, s, F),
                    ((n.indexOf("touch") >= 0 && Jo) || n.indexOf("pointer") >= 0) &&
                    (va(i, ia[0], vt, s, F),
                      va(ot, ia[2], mt),
                      va(ot, ia[3], mt),
                      G && va(i, "click", ct, !1, !0),
                      D && va(i, "click", Et),
                      M && va(ot, "gesturestart", yt),
                      j && va(ot, "gestureend", gt),
                      P && va(i, ta + "enter", xt),
                      A && va(i, ta + "leave", Tt),
                      C && va(i, ta + "move", _t)),
                    (Z.isEnabled = !0),
                    t && t.type && vt(t),
                    I && I(Z)),
                  Z
                );
              }),
              (Z.disable = function () {
                Z.isEnabled &&
                  (la.filter(function (t) {
                    return t !== Z && ha(t.target);
                  }).length || ma(it ? ot : i, "scroll", ba),
                    Z.isPressed && (Z._vx.reset(), Z._vy.reset(), ma(k ? i : ot, ia[1], ht, !0)),
                    ma(it ? ot : i, "scroll", bt, F),
                    ma(i, "wheel", wt, F),
                    ma(i, ia[0], vt, F),
                    ma(ot, ia[2], mt),
                    ma(ot, ia[3], mt),
                    ma(i, "click", ct, !0),
                    ma(i, "click", Et),
                    ma(ot, "gesturestart", yt),
                    ma(ot, "gestureend", gt),
                    ma(i, ta + "enter", xt),
                    ma(i, ta + "leave", Tt),
                    ma(i, ta + "move", _t),
                    (Z.isEnabled = Z.isPressed = Z.isDragging = !1),
                    z && z(Z));
              }),
              (Z.kill = Z.revert = function () {
                Z.disable();
                var t = la.indexOf(Z);
                t >= 0 && la.splice(t, 1), na === Z && (na = 0);
              }),
              la.push(Z),
              k && ha(i) && (na = Z),
              Z.enable(f);
          }),
          (e = t),
          (r = [
            {
              key: "velocityX",
              get: function () {
                return this._vx.getVelocity();
              },
            },
            {
              key: "velocityY",
              get: function () {
                return this._vy.getVelocity();
              },
            },
          ]) && $o(e.prototype, r),
          t
        );
      })();
      (La.version = "3.12.2"),
        (La.create = function (t) {
          return new La(t);
        }),
        (La.register = Ca),
        (La.getAll = function () {
          return la.slice();
        }),
        (La.getById = function (t) {
          return la.filter(function (e) {
            return e.vars.id === t;
          })[0];
        }),
        aa() && Xo.registerPlugin(La);
      var ka,
        Ma,
        ja,
        Ra,
        Ia,
        za,
        Da,
        Ba,
        Fa,
        Ga,
        Na,
        Ya,
        Ha,
        Va,
        qa,
        $a,
        Xa,
        Wa,
        Ua,
        Za,
        Qa,
        Ka,
        Ja,
        ts,
        es,
        rs,
        ns,
        is,
        os,
        as,
        ss,
        ls,
        cs,
        us,
        ps,
        fs,
        ds = 1,
        hs = Date.now,
        vs = hs(),
        ms = 0,
        ys = 0,
        gs = function (t, e, r) {
          var n = Ms(t) && ("clamp(" === t.substr(0, 6) || t.indexOf("max") > -1);
          return (r["_" + e + "Clamp"] = n), n ? t.substr(6, t.length - 7) : t;
        },
        bs = function (t, e) {
          return !e || (Ms(t) && "clamp(" === t.substr(0, 6)) ? t : "clamp(" + t + ")";
        },
        ws = function t() {
          return ys && requestAnimationFrame(t);
        },
        _s = function () {
          return (Va = 1);
        },
        xs = function () {
          return (Va = 0);
        },
        Ts = function (t) {
          return t;
        },
        Es = function (t) {
          return Math.round(1e5 * t) / 1e5 || 0;
        },
        Ss = function () {
          return "undefined" != typeof window;
        },
        Os = function () {
          return ka || (Ss() && (ka = window.gsap) && ka.registerPlugin && ka);
        },
        Ps = function (t) {
          return !!~Da.indexOf(t);
        },
        As = function (t) {
          return ("Height" === t ? ss : ja["inner" + t]) || Ia["client" + t] || za["client" + t];
        },
        Cs = function (t) {
          return (
            da(t, "getBoundingClientRect") ||
            (Ps(t)
              ? function () {
                return (Nl.width = ja.innerWidth), (Nl.height = ss), Nl;
              }
              : function () {
                return el(t);
              })
          );
        },
        Ls = function (t, e) {
          var r = e.s,
            n = e.d2,
            i = e.d,
            o = e.a;
          return Math.max(0, (r = "scroll" + n) && (o = da(t, r)) ? o() - Cs(t)()[i] : Ps(t) ? (Ia[r] || za[r]) - As(n) : t[r] - t["offset" + n]);
        },
        ks = function (t, e) {
          for (var r = 0; r < Ua.length; r += 3) (!e || ~e.indexOf(Ua[r + 1])) && t(Ua[r], Ua[r + 1], Ua[r + 2]);
        },
        Ms = function (t) {
          return "string" == typeof t;
        },
        js = function (t) {
          return "function" == typeof t;
        },
        Rs = function (t) {
          return "number" == typeof t;
        },
        Is = function (t) {
          return "object" == typeof t;
        },
        zs = function (t, e, r) {
          return t && t.progress(e ? 0 : 1) && r && t.pause();
        },
        Ds = function (t, e) {
          if (t.enabled) {
            var r = e(t);
            r && r.totalTime && (t.callbackAnimation = r);
          }
        },
        Bs = Math.abs,
        Fs = "left",
        Gs = "right",
        Ns = "bottom",
        Ys = "width",
        Hs = "height",
        Vs = "Right",
        qs = "Left",
        $s = "Top",
        Xs = "Bottom",
        Ws = "padding",
        Us = "margin",
        Zs = "Width",
        Qs = "Height",
        Ks = "px",
        Js = function (t) {
          return ja.getComputedStyle(t);
        },
        tl = function (t, e) {
          for (var r in e) r in t || (t[r] = e[r]);
          return t;
        },
        el = function (t, e) {
          var r = e && "matrix(1, 0, 0, 1, 0, 0)" !== Js(t)[qa] && ka.to(t, { x: 0, y: 0, xPercent: 0, yPercent: 0, rotation: 0, rotationX: 0, rotationY: 0, scale: 1, skewX: 0, skewY: 0 }).progress(1),
            n = t.getBoundingClientRect();
          return r && r.progress(0).kill(), n;
        },
        rl = function (t, e) {
          var r = e.d2;
          return t["offset" + r] || t["client" + r] || 0;
        },
        nl = function (t) {
          var e,
            r = [],
            n = t.labels,
            i = t.duration();
          for (e in n) r.push(n[e] / i);
          return r;
        },
        il = function (t) {
          var e = ka.utils.snap(t),
            r =
              Array.isArray(t) &&
              t.slice(0).sort(function (t, e) {
                return t - e;
              });
          return r
            ? function (t, n, i) {
              var o;
              if ((void 0 === i && (i = 0.001), !n)) return e(t);
              if (n > 0) {
                for (t -= i, o = 0; o < r.length; o++) if (r[o] >= t) return r[o];
                return r[o - 1];
              }
              for (o = r.length, t += i; o--;) if (r[o] <= t) return r[o];
              return r[0];
            }
            : function (r, n, i) {
              void 0 === i && (i = 0.001);
              var o = e(r);
              return !n || Math.abs(o - r) < i || o - r < 0 == n < 0 ? o : e(n < 0 ? r - t : r + t);
            };
        },
        ol = function (t, e, r, n) {
          return r.split(",").forEach(function (r) {
            return t(e, r, n);
          });
        },
        al = function (t, e, r, n, i) {
          return t.addEventListener(e, r, { passive: !n, capture: !!i });
        },
        sl = function (t, e, r, n) {
          return t.removeEventListener(e, r, !!n);
        },
        ll = function (t, e, r) {
          (r = r && r.wheelHandler) && (t(e, "wheel", r), t(e, "touchmove", r));
        },
        cl = { startColor: "green", endColor: "red", indent: 0, fontSize: "16px", fontWeight: "normal" },
        ul = { toggleActions: "play", anticipatePin: 0 },
        pl = { top: 0, left: 0, center: 0.5, bottom: 1, right: 1 },
        fl = function (t, e) {
          if (Ms(t)) {
            var r = t.indexOf("="),
              n = ~r ? +(t.charAt(r - 1) + 1) * parseFloat(t.substr(r + 1)) : 0;
            ~r && (t.indexOf("%") > r && (n *= e / 100), (t = t.substr(0, r - 1))), (t = n + (t in pl ? pl[t] * e : ~t.indexOf("%") ? (parseFloat(t) * e) / 100 : parseFloat(t) || 0));
          }
          return t;
        },
        dl = function (t, e, r, n, i, o, a, s) {
          var l = i.startColor,
            c = i.endColor,
            u = i.fontSize,
            p = i.indent,
            f = i.fontWeight,
            d = Ra.createElement("div"),
            h = Ps(r) || "fixed" === da(r, "pinType"),
            v = -1 !== t.indexOf("scroller"),
            m = h ? za : r,
            y = -1 !== t.indexOf("start"),
            g = y ? l : c,
            b =
              "border-color:" +
              g +
              ";font-size:" +
              u +
              ";color:" +
              g +
              ";font-weight:" +
              f +
              ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
          return (
            (b += "position:" + ((v || s) && h ? "fixed;" : "absolute;")),
            (v || s || !h) && (b += (n === xa ? Gs : Ns) + ":" + (o + parseFloat(p)) + "px;"),
            a && (b += "box-sizing:border-box;text-align:left;width:" + a.offsetWidth + "px;"),
            (d._isStart = y),
            d.setAttribute("class", "gsap-marker-" + t + (e ? " marker-" + e : "")),
            (d.style.cssText = b),
            (d.innerText = e || 0 === e ? t + "-" + e : t),
            m.children[0] ? m.insertBefore(d, m.children[0]) : m.appendChild(d),
            (d._offset = d["offset" + n.op.d2]),
            hl(d, 0, n, y),
            d
          );
        },
        hl = function (t, e, r, n) {
          var i = { display: "block" },
            o = r[n ? "os2" : "p2"],
            a = r[n ? "p2" : "os2"];
          (t._isFlipped = n), (i[r.a + "Percent"] = n ? -100 : 0), (i[r.a] = n ? "1px" : 0), (i["border" + o + Zs] = 1), (i["border" + a + Zs] = 0), (i[r.p] = e + "px"), ka.set(t, i);
        },
        vl = [],
        ml = {},
        yl = function () {
          return hs() - ms > 34 && (cs || (cs = requestAnimationFrame(Rl)));
        },
        gl = function () {
          (!Ja || !Ja.isPressed || Ja.startX > za.clientWidth) && (ca.cache++, Ja ? cs || (cs = requestAnimationFrame(Rl)) : Rl(), ms || El("scrollStart"), (ms = hs()));
        },
        bl = function () {
          (rs = ja.innerWidth), (es = ja.innerHeight);
        },
        wl = function () {
          ca.cache++, !Ha && !Ka && !Ra.fullscreenElement && !Ra.webkitFullscreenElement && (!ts || rs !== ja.innerWidth || Math.abs(ja.innerHeight - es) > 0.25 * ja.innerHeight) && Ba.restart(!0);
        },
        _l = {},
        xl = [],
        Tl = function t() {
          return sl(Wl, "scrollEnd", t) || kl(!0);
        },
        El = function (t) {
          return (
            (_l[t] &&
              _l[t].map(function (t) {
                return t();
              })) ||
            xl
          );
        },
        Sl = [],
        Ol = function (t) {
          for (var e = 0; e < Sl.length; e += 5) (!t || (Sl[e + 4] && Sl[e + 4].query === t)) && ((Sl[e].style.cssText = Sl[e + 1]), Sl[e].getBBox && Sl[e].setAttribute("transform", Sl[e + 2] || ""), (Sl[e + 3].uncache = 1));
        },
        Pl = function (t, e) {
          var r;
          for ($a = 0; $a < vl.length; $a++) !(r = vl[$a]) || (e && r._ctx !== e) || (t ? r.kill(1) : r.revert(!0, !0));
          e && Ol(e), e || El("revert");
        },
        Al = function (t, e) {
          ca.cache++,
            (e || !us) &&
            ca.forEach(function (t) {
              return js(t) && t.cacheID++ && (t.rec = 0);
            }),
            Ms(t) && (ja.history.scrollRestoration = os = t);
        },
        Cl = 0,
        Ll = function () {
          za.appendChild(as), (ss = as.offsetHeight || ja.innerHeight), za.removeChild(as);
        },
        kl = function (t, e) {
          if (!ms || t) {
            Ll(),
              (us = Wl.isRefreshing = !0),
              ca.forEach(function (t) {
                return js(t) && ++t.cacheID && (t.rec = t());
              });
            var r = El("refreshInit");
            Za && Wl.sort(),
              e || Pl(),
              ca.forEach(function (t) {
                js(t) && (t.smooth && (t.target.style.scrollBehavior = "auto"), t(0));
              }),
              vl.slice(0).forEach(function (t) {
                return t.refresh();
              }),
              vl.forEach(function (t, e) {
                if (t._subPinOffset && t.pin) {
                  var r = t.vars.horizontal ? "offsetWidth" : "offsetHeight",
                    n = t.pin[r];
                  t.revert(!0, 1), t.adjustPinSpacing(t.pin[r] - n), t.refresh();
                }
              }),
              vl.forEach(function (t) {
                var e = Ls(t.scroller, t._dir);
                ("max" === t.vars.end || (t._endClamp && t.end > e)) && t.setPositions(t.start, Math.max(t.start + 1, e), !0);
              }),
              r.forEach(function (t) {
                return t && t.render && t.render(-1);
              }),
              ca.forEach(function (t) {
                js(t) &&
                  (t.smooth &&
                    requestAnimationFrame(function () {
                      return (t.target.style.scrollBehavior = "smooth");
                    }),
                    t.rec && t(t.rec));
              }),
              Al(os, 1),
              Ba.pause(),
              Cl++,
              (us = 2),
              Rl(2),
              vl.forEach(function (t) {
                return js(t.vars.onRefresh) && t.vars.onRefresh(t);
              }),
              (us = Wl.isRefreshing = !1),
              El("refresh");
          } else al(Wl, "scrollEnd", Tl);
        },
        Ml = 0,
        jl = 1,
        Rl = function (t) {
          if (!us || 2 === t) {
            (Wl.isUpdating = !0), fs && fs.update(0);
            var e = vl.length,
              r = hs(),
              n = r - vs >= 50,
              i = e && vl[0].scroll();
            if (((jl = Ml > i ? -1 : 1), us || (Ml = i), n && (ms && !Va && r - ms > 200 && ((ms = 0), El("scrollEnd")), (Na = vs), (vs = r)), jl < 0)) {
              for ($a = e; $a-- > 0;) vl[$a] && vl[$a].update(0, n);
              jl = 1;
            } else for ($a = 0; $a < e; $a++) vl[$a] && vl[$a].update(0, n);
            Wl.isUpdating = !1;
          }
          cs = 0;
        },
        Il = [
          Fs,
          "top",
          Ns,
          Gs,
          Us + Xs,
          Us + Vs,
          Us + $s,
          Us + qs,
          "display",
          "flexShrink",
          "float",
          "zIndex",
          "gridColumnStart",
          "gridColumnEnd",
          "gridRowStart",
          "gridRowEnd",
          "gridArea",
          "justifySelf",
          "alignSelf",
          "placeSelf",
          "order",
        ],
        zl = Il.concat([Ys, Hs, "boxSizing", "max" + Zs, "max" + Qs, "position", Us, Ws, Ws + $s, Ws + Vs, Ws + Xs, Ws + qs]),
        Dl = function (t, e, r, n) {
          if (!t._gsap.swappedIn) {
            for (var i, o = Il.length, a = e.style, s = t.style; o--;) a[(i = Il[o])] = r[i];
            (a.position = "absolute" === r.position ? "absolute" : "relative"),
              "inline" === r.display && (a.display = "inline-block"),
              (s[Ns] = s[Gs] = "auto"),
              (a.flexBasis = r.flexBasis || "auto"),
              (a.overflow = "visible"),
              (a.boxSizing = "border-box"),
              (a[Ys] = rl(t, _a) + Ks),
              (a[Hs] = rl(t, xa) + Ks),
              (a[Ws] = s[Us] = s.top = s[Fs] = "0"),
              Fl(n),
              (s[Ys] = s["max" + Zs] = r[Ys]),
              (s[Hs] = s["max" + Qs] = r[Hs]),
              (s[Ws] = r[Ws]),
              t.parentNode !== e && (t.parentNode.insertBefore(e, t), e.appendChild(t)),
              (t._gsap.swappedIn = !0);
          }
        },
        Bl = /([A-Z])/g,
        Fl = function (t) {
          if (t) {
            var e,
              r,
              n = t.t.style,
              i = t.length,
              o = 0;
            for ((t.t._gsap || ka.core.getCache(t.t)).uncache = 1; o < i; o += 2) (r = t[o + 1]), (e = t[o]), r ? (n[e] = r) : n[e] && n.removeProperty(e.replace(Bl, "-$1").toLowerCase());
          }
        },
        Gl = function (t) {
          for (var e = zl.length, r = t.style, n = [], i = 0; i < e; i++) n.push(zl[i], r[zl[i]]);
          return (n.t = t), n;
        },
        Nl = { left: 0, top: 0 },
        Yl = function (t, e, r, n, i, o, a, s, l, c, u, p, f, d) {
          js(t) && (t = t(s)), Ms(t) && "max" === t.substr(0, 3) && (t = p + ("=" === t.charAt(4) ? fl("0" + t.substr(3), r) : 0));
          var h,
            v,
            m,
            y = f ? f.time() : 0;
          if ((f && f.seek(0), isNaN(t) || (t = +t), Rs(t))) f && (t = ka.utils.mapRange(f.scrollTrigger.start, f.scrollTrigger.end, 0, p, t)), a && hl(a, r, n, !0);
          else {
            js(e) && (e = e(s));
            var g,
              b,
              w,
              _,
              x = (t || "0").split(" ");
            (m = Ta(e, s) || za),
              ((g = el(m) || {}) && (g.left || g.top)) || "none" !== Js(m).display || ((_ = m.style.display), (m.style.display = "block"), (g = el(m)), _ ? (m.style.display = _) : m.style.removeProperty("display")),
              (b = fl(x[0], g[n.d])),
              (w = fl(x[1] || "0", r)),
              (t = g[n.p] - l[n.p] - c + b + i - w),
              a && hl(a, w, n, r - w < 20 || (a._isStart && w > 20)),
              (r -= r - w);
          }
          if ((d && ((s[d] = t || -0.001), t < 0 && (t = 0)), o)) {
            var T = t + r,
              E = o._isStart;
            (h = "scroll" + n.d2), hl(o, T, n, (E && T > 20) || (!E && (u ? Math.max(za[h], Ia[h]) : o.parentNode[h]) <= T + 1)), u && ((l = el(a)), u && (o.style[n.op.p] = l[n.op.p] - n.op.m - o._offset + Ks));
          }
          return f && m && ((h = el(m)), f.seek(p), (v = el(m)), (f._caScrollDist = h[n.p] - v[n.p]), (t = (t / f._caScrollDist) * p)), f && f.seek(y), f ? t : Math.round(t);
        },
        Hl = /(webkit|moz|length|cssText|inset)/i,
        Vl = function (t, e, r, n) {
          if (t.parentNode !== e) {
            var i,
              o,
              a = t.style;
            if (e === za) {
              for (i in ((t._stOrig = a.cssText), (o = Js(t)))) +i || Hl.test(i) || !o[i] || "string" != typeof a[i] || "0" === i || (a[i] = o[i]);
              (a.top = r), (a.left = n);
            } else a.cssText = t._stOrig;
            (ka.core.getCache(t).uncache = 1), e.appendChild(t);
          }
        },
        ql = function (t, e, r) {
          var n = e,
            i = n;
          return function (e) {
            var o = Math.round(t());
            return o !== n && o !== i && Math.abs(o - n) > 3 && Math.abs(o - i) > 3 && ((e = o), r && r()), (i = n), (n = e), e;
          };
        },
        $l = function (t, e, r) {
          var n = {};
          (n[e.p] = "+=" + r), ka.set(t, n);
        },
        Xl = function (t, e) {
          var r = Ea(t, e),
            n = "_scroll" + e.p2,
            i = function e(i, o, a, s, l) {
              var c = e.tween,
                u = o.onComplete,
                p = {};
              a = a || r();
              var f = ql(r, a, function () {
                c.kill(), (e.tween = 0);
              });
              return (
                (l = (s && l) || 0),
                (s = s || i - a),
                c && c.kill(),
                (o[n] = i),
                (o.modifiers = p),
                (p[n] = function () {
                  return f(a + s * c.ratio + l * c.ratio * c.ratio);
                }),
                (o.onUpdate = function () {
                  ca.cache++, Rl();
                }),
                (o.onComplete = function () {
                  (e.tween = 0), u && u.call(c);
                }),
                (c = e.tween = ka.to(t, o))
              );
            };
          return (
            (t[n] = r),
            (r.wheelHandler = function () {
              return i.tween && i.tween.kill() && (i.tween = 0);
            }),
            al(t, "wheel", r.wheelHandler),
            Wl.isTouch && al(t, "touchmove", r.wheelHandler),
            i
          );
        },
        Wl = (function () {
          function t(e, r) {
            Ma || t.register(ka) || console.warn("Please gsap.registerPlugin(ScrollTrigger)"), is(this), this.init(e, r);
          }
          return (
            (t.prototype.init = function (e, r) {
              if (((this.progress = this.start = 0), this.vars && this.kill(!0, !0), ys)) {
                var n,
                  i,
                  o,
                  a,
                  s,
                  l,
                  c,
                  u,
                  p,
                  f,
                  d,
                  h,
                  v,
                  m,
                  y,
                  g,
                  b,
                  w,
                  _,
                  x,
                  T,
                  E,
                  S,
                  O,
                  P,
                  A,
                  C,
                  L,
                  k,
                  M,
                  j,
                  R,
                  I,
                  z,
                  D,
                  B,
                  F,
                  G,
                  N,
                  Y,
                  H,
                  V,
                  q = (e = tl(Ms(e) || Rs(e) || e.nodeType ? { trigger: e } : e, ul)),
                  $ = q.onUpdate,
                  X = q.toggleClass,
                  W = q.id,
                  U = q.onToggle,
                  Z = q.onRefresh,
                  Q = q.scrub,
                  K = q.trigger,
                  J = q.pin,
                  tt = q.pinSpacing,
                  et = q.invalidateOnRefresh,
                  rt = q.anticipatePin,
                  nt = q.onScrubComplete,
                  it = q.onSnapComplete,
                  ot = q.once,
                  at = q.snap,
                  st = q.pinReparent,
                  lt = q.pinSpacer,
                  ct = q.containerAnimation,
                  ut = q.fastScrollEnd,
                  pt = q.preventOverlaps,
                  ft = e.horizontal || (e.containerAnimation && !1 !== e.horizontal) ? _a : xa,
                  dt = !Q && 0 !== Q,
                  ht = Ta(e.scroller || ja),
                  vt = ka.core.getCache(ht),
                  mt = Ps(ht),
                  yt = "fixed" === ("pinType" in e ? e.pinType : da(ht, "pinType") || (mt && "fixed")),
                  gt = [e.onEnter, e.onLeave, e.onEnterBack, e.onLeaveBack],
                  bt = dt && e.toggleActions.split(" "),
                  wt = "markers" in e ? e.markers : ul.markers,
                  _t = mt ? 0 : parseFloat(Js(ht)["border" + ft.p2 + Zs]) || 0,
                  xt = this,
                  Tt =
                    e.onRefreshInit &&
                    function () {
                      return e.onRefreshInit(xt);
                    },
                  Et = (function (t, e, r) {
                    var n = r.d,
                      i = r.d2,
                      o = r.a;
                    return (o = da(t, "getBoundingClientRect"))
                      ? function () {
                        return o()[n];
                      }
                      : function () {
                        return (e ? As(i) : t["client" + i]) || 0;
                      };
                  })(ht, mt, ft),
                  St = (function (t, e) {
                    return !e || ~ua.indexOf(t)
                      ? Cs(t)
                      : function () {
                        return Nl;
                      };
                  })(ht, mt),
                  Ot = 0,
                  Pt = 0,
                  At = 0,
                  Ct = Ea(ht, ft);
                if (
                  ((xt._startClamp = xt._endClamp = !1),
                    (xt._dir = ft),
                    (rt *= 45),
                    (xt.scroller = ht),
                    (xt.scroll = ct ? ct.time.bind(ct) : Ct),
                    (a = Ct()),
                    (xt.vars = e),
                    (r = r || e.animation),
                    "refreshPriority" in e && ((Za = 1), -9999 === e.refreshPriority && (fs = xt)),
                    (vt.tweenScroll = vt.tweenScroll || { top: Xl(ht, xa), left: Xl(ht, _a) }),
                    (xt.tweenTo = n = vt.tweenScroll[ft.p]),
                    (xt.scrubDuration = function (t) {
                      (I = Rs(t) && t)
                        ? R
                          ? R.duration(t)
                          : (R = ka.to(r, {
                            ease: "expo",
                            totalProgress: "+=0",
                            duration: I,
                            paused: !0,
                            onComplete: function () {
                              return nt && nt(xt);
                            },
                          }))
                        : (R && R.progress(1).kill(), (R = 0));
                    }),
                    r &&
                    ((r.vars.lazy = !1),
                      (r._initted && !xt.isReverted) || (!1 !== r.vars.immediateRender && !1 !== e.immediateRender && r.duration() && r.render(0, !0, !0)),
                      (xt.animation = r.pause()),
                      (r.scrollTrigger = xt),
                      xt.scrubDuration(Q),
                      (M = 0),
                      W || (W = r.vars.id)),
                    at &&
                    ((Is(at) && !at.push) || (at = { snapTo: at }),
                      "scrollBehavior" in za.style && ka.set(mt ? [za, Ia] : ht, { scrollBehavior: "auto" }),
                      ca.forEach(function (t) {
                        return js(t) && t.target === (mt ? Ra.scrollingElement || Ia : ht) && (t.smooth = !1);
                      }),
                      (o = js(at.snapTo)
                        ? at.snapTo
                        : "labels" === at.snapTo
                          ? (function (t) {
                            return function (e) {
                              return ka.utils.snap(nl(t), e);
                            };
                          })(r)
                          : "labelsDirectional" === at.snapTo
                            ? ((Y = r),
                              function (t, e) {
                                return il(nl(Y))(t, e.direction);
                              })
                            : !1 !== at.directional
                              ? function (t, e) {
                                return il(at.snapTo)(t, hs() - Pt < 500 ? 0 : e.direction);
                              }
                              : ka.utils.snap(at.snapTo)),
                      (z = at.duration || { min: 0.1, max: 2 }),
                      (z = Is(z) ? Ga(z.min, z.max) : Ga(z, z)),
                      (D = ka
                        .delayedCall(at.delay || I / 2 || 0.1, function () {
                          var t = Ct(),
                            e = hs() - Pt < 500,
                            i = n.tween;
                          if (!(e || Math.abs(xt.getVelocity()) < 10) || i || Va || Ot === t) xt.isActive && Ot !== t && D.restart(!0);
                          else {
                            var a = (t - l) / m,
                              s = r && !dt ? r.totalProgress() : a,
                              u = e ? 0 : ((s - j) / (hs() - Na)) * 1e3 || 0,
                              p = ka.utils.clamp(-a, 1 - a, (Bs(u / 2) * u) / 0.185),
                              f = a + (!1 === at.inertia ? 0 : p),
                              d = Ga(0, 1, o(f, xt)),
                              h = Math.round(l + d * m),
                              v = at,
                              y = v.onStart,
                              g = v.onInterrupt,
                              b = v.onComplete;
                            if (t <= c && t >= l && h !== t) {
                              if (i && !i._initted && i.data <= Bs(h - t)) return;
                              !1 === at.inertia && (p = d - a),
                                n(
                                  h,
                                  {
                                    duration: z(Bs((0.185 * Math.max(Bs(f - s), Bs(d - s))) / u / 0.05 || 0)),
                                    ease: at.ease || "power3",
                                    data: Bs(h - t),
                                    onInterrupt: function () {
                                      return D.restart(!0) && g && g(xt);
                                    },
                                    onComplete: function () {
                                      xt.update(), (Ot = Ct()), (M = j = r && !dt ? r.totalProgress() : xt.progress), it && it(xt), b && b(xt);
                                    },
                                  },
                                  t,
                                  p * m,
                                  h - t - p * m
                                ),
                                y && y(xt, n.tween);
                            }
                          }
                        })
                        .pause())),
                    W && (ml[W] = xt),
                    (N = (K = xt.trigger = Ta(K || (!0 !== J && J))) && K._gsap && K._gsap.stRevert) && (N = N(xt)),
                    (J = !0 === J ? K : Ta(J)),
                    Ms(X) && (X = { targets: K, className: X }),
                    J &&
                    (!1 === tt || tt === Us || (tt = !(!tt && J.parentNode && J.parentNode.style && "flex" === Js(J.parentNode).display) && Ws),
                      (xt.pin = J),
                      (i = ka.core.getCache(J)).spacer
                        ? (y = i.pinState)
                        : (lt && ((lt = Ta(lt)) && !lt.nodeType && (lt = lt.current || lt.nativeElement), (i.spacerIsNative = !!lt), lt && (i.spacerState = Gl(lt))),
                          (i.spacer = w = lt || Ra.createElement("div")),
                          w.classList.add("pin-spacer"),
                          W && w.classList.add("pin-spacer-" + W),
                          (i.pinState = y = Gl(J))),
                      !1 !== e.force3D && ka.set(J, { force3D: !0 }),
                      (xt.spacer = w = i.spacer),
                      (k = Js(J)),
                      (O = k[tt + ft.os2]),
                      (x = ka.getProperty(J)),
                      (T = ka.quickSetter(J, ft.a, Ks)),
                      Dl(J, w, k),
                      (b = Gl(J))),
                    wt)
                ) {
                  (h = Is(wt) ? tl(wt, cl) : cl), (f = dl("scroller-start", W, ht, ft, h, 0)), (d = dl("scroller-end", W, ht, ft, h, 0, f)), (_ = f["offset" + ft.op.d2]);
                  var Lt = Ta(da(ht, "content") || ht);
                  (u = this.markerStart = dl("start", W, Lt, ft, h, _, 0, ct)),
                    (p = this.markerEnd = dl("end", W, Lt, ft, h, _, 0, ct)),
                    ct && (G = ka.quickSetter([u, p], ft.a, Ks)),
                    yt ||
                    (ua.length && !0 === da(ht, "fixedMarkers")) ||
                    ((V = Js((H = mt ? za : ht)).position),
                      (H.style.position = "absolute" === V || "fixed" === V ? V : "relative"),
                      ka.set([f, d], { force3D: !0 }),
                      (A = ka.quickSetter(f, ft.a, Ks)),
                      (L = ka.quickSetter(d, ft.a, Ks)));
                }
                if (ct) {
                  var kt = ct.vars.onUpdate,
                    Mt = ct.vars.onUpdateParams;
                  ct.eventCallback("onUpdate", function () {
                    xt.update(0, 0, 1), kt && kt.apply(ct, Mt || []);
                  });
                }
                if (
                  ((xt.previous = function () {
                    return vl[vl.indexOf(xt) - 1];
                  }),
                    (xt.next = function () {
                      return vl[vl.indexOf(xt) + 1];
                    }),
                    (xt.revert = function (t, e) {
                      if (!e) return xt.kill(!0);
                      var n = !1 !== t || !xt.enabled,
                        i = Ha;
                      n !== xt.isReverted &&
                        (n && ((B = Math.max(Ct(), xt.scroll.rec || 0)), (At = xt.progress), (F = r && r.progress())),
                          u &&
                          [u, p, f, d].forEach(function (t) {
                            return (t.style.display = n ? "none" : "block");
                          }),
                          n && ((Ha = xt), xt.update(n)),
                          !J ||
                          (st && xt.isActive) ||
                          (n
                            ? (function (t, e, r) {
                              Fl(r);
                              var n = t._gsap;
                              if (n.spacerIsNative) Fl(n.spacerState);
                              else if (t._gsap.swappedIn) {
                                var i = e.parentNode;
                                i && (i.insertBefore(t, e), i.removeChild(e));
                              }
                              t._gsap.swappedIn = !1;
                            })(J, w, y)
                            : Dl(J, w, Js(J), P)),
                          n || xt.update(n),
                          (Ha = i),
                          (xt.isReverted = n));
                    }),
                    (xt.refresh = function (i, o, h, _) {
                      if ((!Ha && xt.enabled) || o)
                        if (J && i && ms) al(t, "scrollEnd", Tl);
                        else {
                          !us && Tt && Tt(xt),
                            (Ha = xt),
                            n.tween && !h && (n.tween.kill(), (n.tween = 0)),
                            R && R.pause(),
                            et && r && r.revert({ kill: !1 }).invalidate(),
                            xt.isReverted || xt.revert(!0, !0),
                            (xt._subPinOffset = !1);
                          var T,
                            O,
                            A,
                            L,
                            k,
                            M,
                            j,
                            I,
                            z,
                            G,
                            N,
                            Y,
                            H,
                            V = Et(),
                            q = St(),
                            $ = ct ? ct.duration() : Ls(ht, ft),
                            X = m <= 0.01,
                            W = 0,
                            U = _ || 0,
                            Q = Is(h) ? h.end : e.end,
                            rt = e.endTrigger || K,
                            nt = Is(h) ? h.start : e.start || (0 !== e.start && K ? (J ? "0 0" : "0 100%") : 0),
                            it = (xt.pinnedContainer = e.pinnedContainer && Ta(e.pinnedContainer, xt)),
                            ot = (K && Math.max(0, vl.indexOf(xt))) || 0,
                            at = ot;
                          for (wt && Is(h) && ((Y = ka.getProperty(f, ft.p)), (H = ka.getProperty(d, ft.p))); at--;)
                            (M = vl[at]).end || M.refresh(0, 1) || (Ha = xt),
                              !(j = M.pin) || (j !== K && j !== J && j !== it) || M.isReverted || (G || (G = []), G.unshift(M), M.revert(!0, !0)),
                              M !== vl[at] && (ot--, at--);
                          for (
                            js(nt) && (nt = nt(xt)),
                            nt = gs(nt, "start", xt),
                            l = Yl(nt, K, V, ft, Ct(), u, f, xt, q, _t, yt, $, ct, xt._startClamp && "_startClamp") || (J ? -0.001 : 0),
                            js(Q) && (Q = Q(xt)),
                            Ms(Q) &&
                            !Q.indexOf("+=") &&
                            (~Q.indexOf(" ")
                              ? (Q = (Ms(nt) ? nt.split(" ")[0] : "") + Q)
                              : ((W = fl(Q.substr(2), V)), (Q = Ms(nt) ? nt : (ct ? ka.utils.mapRange(0, ct.duration(), ct.scrollTrigger.start, ct.scrollTrigger.end, l) : l) + W), (rt = K))),
                            Q = gs(Q, "end", xt),
                            c = Math.max(l, Yl(Q || (rt ? "100% 0" : $), rt, V, ft, Ct() + W, p, d, xt, q, _t, yt, $, ct, xt._endClamp && "_endClamp")) || -0.001,
                            W = 0,
                            at = ot;
                            at--;

                          )
                            (j = (M = vl[at]).pin) &&
                              M.start - M._pinPush <= l &&
                              !ct &&
                              M.end > 0 &&
                              ((T = M.end - (xt._startClamp ? Math.max(0, M.start) : M.start)), ((j === K && M.start - M._pinPush < l) || j === it) && isNaN(nt) && (W += T * (1 - M.progress)), j === J && (U += T));
                          if (
                            ((l += W),
                              (c += W),
                              xt._startClamp && (xt._startClamp += W),
                              xt._endClamp && !us && ((xt._endClamp = c || -0.001), (c = Math.min(c, Ls(ht, ft)))),
                              (m = c - l || ((l -= 0.01) && 0.001)),
                              X && (At = ka.utils.clamp(0, 1, ka.utils.normalize(l, c, B))),
                              (xt._pinPush = U),
                              u && W && (((T = {})[ft.a] = "+=" + W), it && (T[ft.p] = "-=" + Ct()), ka.set([u, p], T)),
                              J)
                          )
                            (T = Js(J)),
                              (L = ft === xa),
                              (A = Ct()),
                              (E = parseFloat(x(ft.a)) + U),
                              !$ &&
                              c > 1 &&
                              ((N = { style: (N = (mt ? Ra.scrollingElement || Ia : ht).style), value: N["overflow" + ft.a.toUpperCase()] }),
                                mt && "scroll" !== Js(za)["overflow" + ft.a.toUpperCase()] && (N.style["overflow" + ft.a.toUpperCase()] = "scroll")),
                              Dl(J, w, T),
                              (b = Gl(J)),
                              (O = el(J, !0)),
                              (I = yt && Ea(ht, L ? _a : xa)()),
                              tt &&
                              (((P = [tt + ft.os2, m + U + Ks]).t = w),
                                (at = tt === Ws ? rl(J, ft) + m + U : 0) && P.push(ft.d, at + Ks),
                                Fl(P),
                                it &&
                                vl.forEach(function (t) {
                                  t.pin === it && !1 !== t.vars.pinSpacing && (t._subPinOffset = !0);
                                }),
                                yt && Ct(B)),
                              yt &&
                              (((k = { top: O.top + (L ? A - l : I) + Ks, left: O.left + (L ? I : A - l) + Ks, boxSizing: "border-box", position: "fixed" })[Ys] = k["max" + Zs] = Math.ceil(O.width) + Ks),
                                (k[Hs] = k["max" + Qs] = Math.ceil(O.height) + Ks),
                                (k[Us] = k[Us + $s] = k[Us + Vs] = k[Us + Xs] = k[Us + qs] = "0"),
                                (k[Ws] = T[Ws]),
                                (k[Ws + $s] = T[Ws + $s]),
                                (k[Ws + Vs] = T[Ws + Vs]),
                                (k[Ws + Xs] = T[Ws + Xs]),
                                (k[Ws + qs] = T[Ws + qs]),
                                (g = (function (t, e, r) {
                                  for (var n, i = [], o = t.length, a = r ? 8 : 0; a < o; a += 2) (n = t[a]), i.push(n, n in e ? e[n] : t[a + 1]);
                                  return (i.t = t.t), i;
                                })(y, k, st)),
                                us && Ct(0)),
                              r
                                ? ((z = r._initted),
                                  Qa(1),
                                  r.render(r.duration(), !0, !0),
                                  (S = x(ft.a) - E + m + U),
                                  (C = Math.abs(m - S) > 1),
                                  yt && C && g.splice(g.length - 2, 2),
                                  r.render(0, !0, !0),
                                  z || r.invalidate(!0),
                                  r.parent || r.totalTime(r.totalTime()),
                                  Qa(0))
                                : (S = m),
                              N && (N.value ? (N.style["overflow" + ft.a.toUpperCase()] = N.value) : N.style.removeProperty("overflow-" + ft.a));
                          else if (K && Ct() && !ct) for (O = K.parentNode; O && O !== za;) O._pinOffset && ((l -= O._pinOffset), (c -= O._pinOffset)), (O = O.parentNode);
                          G &&
                            G.forEach(function (t) {
                              return t.revert(!1, !0);
                            }),
                            (xt.start = l),
                            (xt.end = c),
                            (a = s = us ? B : Ct()),
                            ct || us || (a < B && Ct(B), (xt.scroll.rec = 0)),
                            xt.revert(!1, !0),
                            (Pt = hs()),
                            D && ((Ot = -1), D.restart(!0)),
                            (Ha = 0),
                            r && dt && (r._initted || F) && r.progress() !== F && r.progress(F || 0, !0).render(r.time(), !0, !0),
                            (X || At !== xt.progress || ct) && (r && !dt && r.totalProgress(ct && l < -0.001 && !At ? ka.utils.normalize(l, c, 0) : At, !0), (xt.progress = X || (a - l) / m === At ? 0 : At)),
                            J && tt && (w._pinOffset = Math.round(xt.progress * S)),
                            R && R.invalidate(),
                            isNaN(Y) || ((Y -= ka.getProperty(f, ft.p)), (H -= ka.getProperty(d, ft.p)), $l(f, ft, Y), $l(u, ft, Y - (_ || 0)), $l(d, ft, H), $l(p, ft, H - (_ || 0))),
                            X && !us && xt.update(),
                            !Z || us || v || ((v = !0), Z(xt), (v = !1));
                        }
                    }),
                    (xt.getVelocity = function () {
                      return ((Ct() - s) / (hs() - Na)) * 1e3 || 0;
                    }),
                    (xt.endAnimation = function () {
                      zs(xt.callbackAnimation), r && (R ? R.progress(1) : r.paused() ? dt || zs(r, xt.direction < 0, 1) : zs(r, r.reversed()));
                    }),
                    (xt.labelToScroll = function (t) {
                      return (r && r.labels && (l || xt.refresh() || l) + (r.labels[t] / r.duration()) * m) || 0;
                    }),
                    (xt.getTrailing = function (t) {
                      var e = vl.indexOf(xt),
                        r = xt.direction > 0 ? vl.slice(0, e).reverse() : vl.slice(e + 1);
                      return (Ms(t)
                        ? r.filter(function (e) {
                          return e.vars.preventOverlaps === t;
                        })
                        : r
                      ).filter(function (t) {
                        return xt.direction > 0 ? t.end <= l : t.start >= c;
                      });
                    }),
                    (xt.update = function (t, e, i) {
                      if (!ct || i || t) {
                        var o,
                          u,
                          p,
                          d,
                          h,
                          v,
                          y,
                          _ = !0 === us ? B : xt.scroll(),
                          x = t ? 0 : (_ - l) / m,
                          P = x < 0 ? 0 : x > 1 ? 1 : x || 0,
                          k = xt.progress;
                        if (
                          (e && ((s = a), (a = ct ? Ct() : _), at && ((j = M), (M = r && !dt ? r.totalProgress() : P))),
                            rt && !P && J && !Ha && !ds && ms && l < _ + ((_ - s) / (hs() - Na)) * rt && (P = 1e-4),
                            P !== k && xt.enabled)
                        ) {
                          if (
                            ((d = (h = (o = xt.isActive = !!P && P < 1) != (!!k && k < 1)) || !!P != !!k),
                              (xt.direction = P > k ? 1 : -1),
                              (xt.progress = P),
                              d && !Ha && ((u = P && !k ? 0 : 1 === P ? 1 : 1 === k ? 2 : 3), dt && ((p = (!h && "none" !== bt[u + 1] && bt[u + 1]) || bt[u]), (y = r && ("complete" === p || "reset" === p || p in r)))),
                              pt &&
                              (h || y) &&
                              (y || Q || !r) &&
                              (js(pt)
                                ? pt(xt)
                                : xt.getTrailing(pt).forEach(function (t) {
                                  return t.endAnimation();
                                })),
                              dt ||
                              (!R || Ha || ds
                                ? r && r.totalProgress(P, !(!Ha || (!Pt && !t)))
                                : (R._dp._time - R._start !== R._time && R.render(R._dp._time - R._start),
                                  R.resetTo ? R.resetTo("totalProgress", P, r._tTime / r._tDur) : ((R.vars.totalProgress = P), R.invalidate().restart()))),
                              J)
                          )
                            if ((t && tt && (w.style[tt + ft.os2] = O), yt)) {
                              if (d) {
                                if (((v = !t && P > k && c + 1 > _ && _ + 1 >= Ls(ht, ft)), st))
                                  if (t || (!o && !v)) Vl(J, w);
                                  else {
                                    var I = el(J, !0),
                                      z = _ - l;
                                    Vl(J, za, I.top + (ft === xa ? z : 0) + Ks, I.left + (ft === xa ? 0 : z) + Ks);
                                  }
                                Fl(o || v ? g : b), (C && P < 1 && o) || T(E + (1 !== P || v ? 0 : S));
                              }
                            } else T(Es(E + S * P));
                          at && !n.tween && !Ha && !ds && D.restart(!0),
                            X &&
                            (h || (ot && P && (P < 1 || !ls))) &&
                            Fa(X.targets).forEach(function (t) {
                              return t.classList[o || ot ? "add" : "remove"](X.className);
                            }),
                            $ && !dt && !t && $(xt),
                            d && !Ha
                              ? (dt && (y && ("complete" === p ? r.pause().totalProgress(1) : "reset" === p ? r.restart(!0).pause() : "restart" === p ? r.restart(!0) : r[p]()), $ && $(xt)),
                                (!h && ls) || (U && h && Ds(xt, U), gt[u] && Ds(xt, gt[u]), ot && (1 === P ? xt.kill(!1, 1) : (gt[u] = 0)), h || (gt[(u = 1 === P ? 1 : 3)] && Ds(xt, gt[u]))),
                                ut && !o && Math.abs(xt.getVelocity()) > (Rs(ut) ? ut : 2500) && (zs(xt.callbackAnimation), R ? R.progress(1) : zs(r, "reverse" === p ? 1 : !P, 1)))
                              : dt && $ && !Ha && $(xt);
                        }
                        if (L) {
                          var F = ct ? (_ / ct.duration()) * (ct._caScrollDist || 0) : _;
                          A(F + (f._isFlipped ? 1 : 0)), L(F);
                        }
                        G && G((-_ / ct.duration()) * (ct._caScrollDist || 0));
                      }
                    }),
                    (xt.enable = function (e, r) {
                      xt.enabled ||
                        ((xt.enabled = !0), al(ht, "resize", wl), mt || al(ht, "scroll", gl), Tt && al(t, "refreshInit", Tt), !1 !== e && ((xt.progress = At = 0), (a = s = Ot = Ct())), !1 !== r && xt.refresh());
                    }),
                    (xt.getTween = function (t) {
                      return t && n ? n.tween : R;
                    }),
                    (xt.setPositions = function (t, e, r, n) {
                      if (ct) {
                        var i = ct.scrollTrigger,
                          o = ct.duration(),
                          a = i.end - i.start;
                        (t = i.start + (a * t) / o), (e = i.start + (a * e) / o);
                      }
                      xt.refresh(!1, !1, { start: bs(t, r && !!xt._startClamp), end: bs(e, r && !!xt._endClamp) }, n), xt.update();
                    }),
                    (xt.adjustPinSpacing = function (t) {
                      if (P && t) {
                        var e = P.indexOf(ft.d) + 1;
                        (P[e] = parseFloat(P[e]) + t + Ks), (P[1] = parseFloat(P[1]) + t + Ks), Fl(P);
                      }
                    }),
                    (xt.disable = function (e, r) {
                      if (
                        xt.enabled &&
                        (!1 !== e && xt.revert(!0, !0),
                          (xt.enabled = xt.isActive = !1),
                          r || (R && R.pause()),
                          (B = 0),
                          i && (i.uncache = 1),
                          Tt && sl(t, "refreshInit", Tt),
                          D && (D.pause(), n.tween && n.tween.kill() && (n.tween = 0)),
                          !mt)
                      ) {
                        for (var o = vl.length; o--;) if (vl[o].scroller === ht && vl[o] !== xt) return;
                        sl(ht, "resize", wl), mt || sl(ht, "scroll", gl);
                      }
                    }),
                    (xt.kill = function (t, n) {
                      xt.disable(t, n), R && !n && R.kill(), W && delete ml[W];
                      var o = vl.indexOf(xt);
                      o >= 0 && vl.splice(o, 1),
                        o === $a && jl > 0 && $a--,
                        (o = 0),
                        vl.forEach(function (t) {
                          return t.scroller === xt.scroller && (o = 1);
                        }),
                        o || us || (xt.scroll.rec = 0),
                        r && ((r.scrollTrigger = null), t && r.revert({ kill: !1 }), n || r.kill()),
                        u &&
                        [u, p, f, d].forEach(function (t) {
                          return t.parentNode && t.parentNode.removeChild(t);
                        }),
                        fs === xt && (fs = 0),
                        J &&
                        (i && (i.uncache = 1),
                          (o = 0),
                          vl.forEach(function (t) {
                            return t.pin === J && o++;
                          }),
                          o || (i.spacer = 0)),
                        e.onKill && e.onKill(xt);
                    }),
                    vl.push(xt),
                    xt.enable(!1, !1),
                    N && N(xt),
                    r && r.add && !m)
                ) {
                  var jt = xt.update;
                  (xt.update = function () {
                    (xt.update = jt), l || c || xt.refresh();
                  }),
                    ka.delayedCall(0.01, xt.update),
                    (m = 0.01),
                    (l = c = 0);
                } else xt.refresh();
                J &&
                  (function () {
                    if (ps !== Cl) {
                      var t = (ps = Cl);
                      requestAnimationFrame(function () {
                        return t === Cl && kl(!0);
                      });
                    }
                  })();
              } else this.update = this.refresh = this.kill = Ts;
            }),
            (t.register = function (e) {
              return Ma || ((ka = e || Os()), Ss() && window.document && t.enable(), (Ma = ys)), Ma;
            }),
            (t.defaults = function (t) {
              if (t) for (var e in t) ul[e] = t[e];
              return ul;
            }),
            (t.disable = function (t, e) {
              (ys = 0),
                vl.forEach(function (r) {
                  return r[e ? "kill" : "disable"](t);
                }),
                sl(ja, "wheel", gl),
                sl(Ra, "scroll", gl),
                clearInterval(Ya),
                sl(Ra, "touchcancel", Ts),
                sl(za, "touchstart", Ts),
                ol(sl, Ra, "pointerdown,touchstart,mousedown", _s),
                ol(sl, Ra, "pointerup,touchend,mouseup", xs),
                Ba.kill(),
                ks(sl);
              for (var r = 0; r < ca.length; r += 3) ll(sl, ca[r], ca[r + 1]), ll(sl, ca[r], ca[r + 2]);
            }),
            (t.enable = function () {
              if (
                ((ja = window),
                  (Ra = document),
                  (Ia = Ra.documentElement),
                  (za = Ra.body),
                  ka &&
                  ((Fa = ka.utils.toArray),
                    (Ga = ka.utils.clamp),
                    (is = ka.core.context || Ts),
                    (Qa = ka.core.suppressOverwrites || Ts),
                    (os = ja.history.scrollRestoration || "auto"),
                    (Ml = ja.pageYOffset),
                    ka.core.globals("ScrollTrigger", t),
                    za))
              ) {
                (ys = 1),
                  ((as = document.createElement("div")).style.height = "100vh"),
                  (as.style.position = "absolute"),
                  Ll(),
                  ws(),
                  La.register(ka),
                  (t.isTouch = La.isTouch),
                  (ns = La.isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent)),
                  al(ja, "wheel", gl),
                  (Da = [ja, Ra, Ia, za]),
                  ka.matchMedia
                    ? ((t.matchMedia = function (t) {
                      var e,
                        r = ka.matchMedia();
                      for (e in t) r.add(e, t[e]);
                      return r;
                    }),
                      ka.addEventListener("matchMediaInit", function () {
                        return Pl();
                      }),
                      ka.addEventListener("matchMediaRevert", function () {
                        return Ol();
                      }),
                      ka.addEventListener("matchMedia", function () {
                        kl(0, 1), El("matchMedia");
                      }),
                      ka.matchMedia("(orientation: portrait)", function () {
                        return bl(), bl;
                      }))
                    : console.warn("Requires GSAP 3.11.0 or later"),
                  bl(),
                  al(Ra, "scroll", gl);
                var e,
                  r,
                  n = za.style,
                  i = n.borderTopStyle,
                  o = ka.core.Animation.prototype;
                for (
                  o.revert ||
                  Object.defineProperty(o, "revert", {
                    value: function () {
                      return this.time(-0.01, !0);
                    },
                  }),
                  n.borderTopStyle = "solid",
                  e = el(za),
                  xa.m = Math.round(e.top + xa.sc()) || 0,
                  _a.m = Math.round(e.left + _a.sc()) || 0,
                  i ? (n.borderTopStyle = i) : n.removeProperty("border-top-style"),
                  Ya = setInterval(yl, 250),
                  ka.delayedCall(0.5, function () {
                    return (ds = 0);
                  }),
                  al(Ra, "touchcancel", Ts),
                  al(za, "touchstart", Ts),
                  ol(al, Ra, "pointerdown,touchstart,mousedown", _s),
                  ol(al, Ra, "pointerup,touchend,mouseup", xs),
                  qa = ka.utils.checkPrefix("transform"),
                  zl.push(qa),
                  Ma = hs(),
                  Ba = ka.delayedCall(0.2, kl).pause(),
                  Ua = [
                    Ra,
                    "visibilitychange",
                    function () {
                      var t = ja.innerWidth,
                        e = ja.innerHeight;
                      Ra.hidden ? ((Xa = t), (Wa = e)) : (Xa === t && Wa === e) || wl();
                    },
                    Ra,
                    "DOMContentLoaded",
                    kl,
                    ja,
                    "load",
                    kl,
                    ja,
                    "resize",
                    wl,
                  ],
                  ks(al),
                  vl.forEach(function (t) {
                    return t.enable(0, 1);
                  }),
                  r = 0;
                  r < ca.length;
                  r += 3
                )
                  ll(sl, ca[r], ca[r + 1]), ll(sl, ca[r], ca[r + 2]);
              }
            }),
            (t.config = function (e) {
              "limitCallbacks" in e && (ls = !!e.limitCallbacks);
              var r = e.syncInterval;
              (r && clearInterval(Ya)) || ((Ya = r) && setInterval(yl, r)),
                "ignoreMobileResize" in e && (ts = 1 === t.isTouch && e.ignoreMobileResize),
                "autoRefreshEvents" in e && (ks(sl) || ks(al, e.autoRefreshEvents || "none"), (Ka = -1 === (e.autoRefreshEvents + "").indexOf("resize")));
            }),
            (t.scrollerProxy = function (t, e) {
              var r = Ta(t),
                n = ca.indexOf(r),
                i = Ps(r);
              ~n && ca.splice(n, i ? 6 : 2), e && (i ? ua.unshift(ja, e, za, e, Ia, e) : ua.unshift(r, e));
            }),
            (t.clearMatchMedia = function (t) {
              vl.forEach(function (e) {
                return e._ctx && e._ctx.query === t && e._ctx.kill(!0, !0);
              });
            }),
            (t.isInViewport = function (t, e, r) {
              var n = (Ms(t) ? Ta(t) : t).getBoundingClientRect(),
                i = n[r ? Ys : Hs] * e || 0;
              return r ? n.right - i > 0 && n.left + i < ja.innerWidth : n.bottom - i > 0 && n.top + i < ja.innerHeight;
            }),
            (t.positionInViewport = function (t, e, r) {
              Ms(t) && (t = Ta(t));
              var n = t.getBoundingClientRect(),
                i = n[r ? Ys : Hs],
                o = null == e ? i / 2 : e in pl ? pl[e] * i : ~e.indexOf("%") ? (parseFloat(e) * i) / 100 : parseFloat(e) || 0;
              return r ? (n.left + o) / ja.innerWidth : (n.top + o) / ja.innerHeight;
            }),
            (t.killAll = function (t) {
              if (
                (vl.slice(0).forEach(function (t) {
                  return "ScrollSmoother" !== t.vars.id && t.kill();
                }),
                  !0 !== t)
              ) {
                var e = _l.killAll || [];
                (_l = {}),
                  e.forEach(function (t) {
                    return t();
                  });
              }
            }),
            t
          );
        })();
      (Wl.version = "3.12.2"),
        (Wl.saveStyles = function (t) {
          return t
            ? Fa(t).forEach(function (t) {
              if (t && t.style) {
                var e = Sl.indexOf(t);
                e >= 0 && Sl.splice(e, 5), Sl.push(t, t.style.cssText, t.getBBox && t.getAttribute("transform"), ka.core.getCache(t), is());
              }
            })
            : Sl;
        }),
        (Wl.revert = function (t, e) {
          return Pl(!t, e);
        }),
        (Wl.create = function (t, e) {
          return new Wl(t, e);
        }),
        (Wl.refresh = function (t) {
          return t ? wl() : (Ma || Wl.register()) && kl(!0);
        }),
        (Wl.update = function (t) {
          return ++ca.cache && Rl(!0 === t ? 2 : 0);
        }),
        (Wl.clearScrollMemory = Al),
        (Wl.maxScroll = function (t, e) {
          return Ls(t, e ? _a : xa);
        }),
        (Wl.getScrollFunc = function (t, e) {
          return Ea(Ta(t), e ? _a : xa);
        }),
        (Wl.getById = function (t) {
          return ml[t];
        }),
        (Wl.getAll = function () {
          return vl.filter(function (t) {
            return "ScrollSmoother" !== t.vars.id;
          });
        }),
        (Wl.isScrolling = function () {
          return !!ms;
        }),
        (Wl.snapDirectional = il),
        (Wl.addEventListener = function (t, e) {
          var r = _l[t] || (_l[t] = []);
          ~r.indexOf(e) || r.push(e);
        }),
        (Wl.removeEventListener = function (t, e) {
          var r = _l[t],
            n = r && r.indexOf(e);
          n >= 0 && r.splice(n, 1);
        }),
        (Wl.batch = function (t, e) {
          var r,
            n = [],
            i = {},
            o = e.interval || 0.016,
            a = e.batchMax || 1e9,
            s = function (t, e) {
              var r = [],
                n = [],
                i = ka
                  .delayedCall(o, function () {
                    e(r, n), (r = []), (n = []);
                  })
                  .pause();
              return function (t) {
                r.length || i.restart(!0), r.push(t.trigger), n.push(t), a <= r.length && i.progress(1);
              };
            };
          for (r in e) i[r] = "on" === r.substr(0, 2) && js(e[r]) && "onRefreshInit" !== r ? s(0, e[r]) : e[r];
          return (
            js(a) &&
            ((a = a()),
              al(Wl, "refresh", function () {
                return (a = e.batchMax());
              })),
            Fa(t).forEach(function (t) {
              var e = {};
              for (r in i) e[r] = i[r];
              (e.trigger = t), n.push(Wl.create(e));
            }),
            n
          );
        });
      var Ul,
        Zl = function (t, e, r, n) {
          return e > n ? t(n) : e < 0 && t(0), r > n ? (n - e) / (r - e) : r < 0 ? e / (e - r) : 1;
        },
        Ql = function t(e, r) {
          !0 === r ? e.style.removeProperty("touch-action") : (e.style.touchAction = !0 === r ? "auto" : r ? "pan-" + r + (La.isTouch ? " pinch-zoom" : "") : "none"), e === Ia && t(za, r);
        },
        Kl = { auto: 1, scroll: 1 },
        Jl = function (t) {
          var e,
            r = t.event,
            n = t.target,
            i = t.axis,
            o = (r.changedTouches ? r.changedTouches[0] : r).target,
            a = o._gsap || ka.core.getCache(o),
            s = hs();
          if (!a._isScrollT || s - a._isScrollT > 2e3) {
            for (; o && o !== za && ((o.scrollHeight <= o.clientHeight && o.scrollWidth <= o.clientWidth) || (!Kl[(e = Js(o)).overflowY] && !Kl[e.overflowX]));) o = o.parentNode;
            (a._isScroll = o && o !== n && !Ps(o) && (Kl[(e = Js(o)).overflowY] || Kl[e.overflowX])), (a._isScrollT = s);
          }
          (a._isScroll || "x" === i) && (r.stopPropagation(), (r._gsapAllow = !0));
        },
        tc = function (t, e, r, n) {
          return La.create({
            target: t,
            capture: !0,
            debounce: !1,
            lockAxis: !0,
            type: e,
            onWheel: (n = n && Jl),
            onPress: n,
            onDrag: n,
            onScroll: n,
            onEnable: function () {
              return r && al(Ra, La.eventTypes[0], rc, !1, !0);
            },
            onDisable: function () {
              return sl(Ra, La.eventTypes[0], rc, !0);
            },
          });
        },
        ec = /(input|label|select|textarea)/i,
        rc = function (t) {
          var e = ec.test(t.target.tagName);
          (e || Ul) && ((t._gsapAllow = !0), (Ul = e));
        };
      function nc(t) {
        return (
          (nc =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                return typeof t;
              }
              : function (t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
              }),
          nc(t)
        );
      }
      function ic(t, e) {
        if (e && ("object" === nc(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return oc(t);
      }
      function oc(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }
      function ac(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
          (ac = function (t) {
            if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
            var r;
            if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== e) {
              if (e.has(t)) return e.get(t);
              e.set(t, n);
            }
            function n() {
              return sc(t, arguments, uc(this).constructor);
            }
            return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), cc(n, t);
          }),
          ac(t)
        );
      }
      function sc(t, e, r) {
        return (
          (sc = lc()
            ? Reflect.construct.bind()
            : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && cc(i, r.prototype), i;
            }),
          sc.apply(null, arguments)
        );
      }
      function lc() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { })), !0;
        } catch (t) {
          return !1;
        }
      }
      function cc(t, e) {
        return (
          (cc = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (t, e) {
              return (t.__proto__ = e), t;
            }),
          cc(t, e)
        );
      }
      function uc(t) {
        return (
          (uc = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
          uc(t)
        );
      }
      (Wl.sort = function (t) {
        return vl.sort(
          t ||
          function (t, e) {
            return -1e6 * (t.vars.refreshPriority || 0) + t.start - (e.start + -1e6 * (e.vars.refreshPriority || 0));
          }
        );
      }),
        (Wl.observe = function (t) {
          return new La(t);
        }),
        (Wl.normalizeScroll = function (t) {
          if (void 0 === t) return Ja;
          if (!0 === t && Ja) return Ja.enable();
          if (!1 === t) return Ja && Ja.kill();
          var e =
            t instanceof La
              ? t
              : (function (t) {
                Is(t) || (t = {}), (t.preventDefault = t.isNormalizer = t.allowClicks = !0), t.type || (t.type = "wheel,touch"), (t.debounce = !!t.debounce), (t.id = t.id || "normalizer");
                var e,
                  r,
                  n,
                  i,
                  o,
                  a,
                  s,
                  l,
                  c = t,
                  u = c.normalizeScrollX,
                  p = c.momentum,
                  f = c.allowNestedScroll,
                  d = c.onRelease,
                  h = Ta(t.target) || Ia,
                  v = ka.core.globals().ScrollSmoother,
                  m = v && v.get(),
                  y = ns && ((t.content && Ta(t.content)) || (m && !1 !== t.content && !m.smooth() && m.content())),
                  g = Ea(h, xa),
                  b = Ea(h, _a),
                  w = 1,
                  _ = (La.isTouch && ja.visualViewport ? ja.visualViewport.scale * ja.visualViewport.width : ja.outerWidth) / ja.innerWidth,
                  x = 0,
                  T = js(p)
                    ? function () {
                      return p(e);
                    }
                    : function () {
                      return p || 2.8;
                    },
                  E = tc(h, t.type, !0, f),
                  S = function () {
                    return (i = !1);
                  },
                  O = Ts,
                  P = Ts,
                  A = function () {
                    (r = Ls(h, xa)), (P = Ga(ns ? 1 : 0, r)), u && (O = Ga(0, Ls(h, _a))), (n = Cl);
                  },
                  C = function () {
                    (y._gsap.y = Es(parseFloat(y._gsap.y) + g.offset) + "px"), (y.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + parseFloat(y._gsap.y) + ", 0, 1)"), (g.offset = g.cacheID = 0);
                  },
                  L = function () {
                    A(), o.isActive() && o.vars.scrollY > r && (g() > r ? o.progress(1) && g(r) : o.resetTo("scrollY", r));
                  };
                return (
                  y && ka.set(y, { y: "+=0" }),
                  (t.ignoreCheck = function (t) {
                    return (
                      (ns &&
                        "touchmove" === t.type &&
                        (function () {
                          if (i) {
                            requestAnimationFrame(S);
                            var t = Es(e.deltaY / 2),
                              r = P(g.v - t);
                            if (y && r !== g.v + g.offset) {
                              g.offset = r - g.v;
                              var n = Es((parseFloat(y && y._gsap.y) || 0) - g.offset);
                              (y.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + n + ", 0, 1)"), (y._gsap.y = n + "px"), (g.cacheID = ca.cache), Rl();
                            }
                            return !0;
                          }
                          g.offset && C(), (i = !0);
                        })()) ||
                      (w > 1.05 && "touchstart" !== t.type) ||
                      e.isGesturing ||
                      (t.touches && t.touches.length > 1)
                    );
                  }),
                  (t.onPress = function () {
                    i = !1;
                    var t = w;
                    (w = Es(((ja.visualViewport && ja.visualViewport.scale) || 1) / _)), o.pause(), t !== w && Ql(h, w > 1.01 || (!u && "x")), (a = b()), (s = g()), A(), (n = Cl);
                  }),
                  (t.onRelease = t.onGestureStart = function (t, e) {
                    if ((g.offset && C(), e)) {
                      ca.cache++;
                      var n,
                        i,
                        a = T();
                      u && ((i = (n = b()) + (0.05 * a * -t.velocityX) / 0.227), (a *= Zl(b, n, i, Ls(h, _a))), (o.vars.scrollX = O(i))),
                        (i = (n = g()) + (0.05 * a * -t.velocityY) / 0.227),
                        (a *= Zl(g, n, i, Ls(h, xa))),
                        (o.vars.scrollY = P(i)),
                        o.invalidate().duration(a).play(0.01),
                        ((ns && o.vars.scrollY >= r) || n >= r - 1) && ka.to({}, { onUpdate: L, duration: a });
                    } else l.restart(!0);
                    d && d(t);
                  }),
                  (t.onWheel = function () {
                    o._ts && o.pause(), hs() - x > 1e3 && ((n = 0), (x = hs()));
                  }),
                  (t.onChange = function (t, e, r, i, o) {
                    if ((Cl !== n && A(), e && u && b(O(i[2] === e ? a + (t.startX - t.x) : b() + e - i[1])), r)) {
                      g.offset && C();
                      var l = o[2] === r,
                        c = l ? s + t.startY - t.y : g() + r - o[1],
                        p = P(c);
                      l && c !== p && (s += p - c), g(p);
                    }
                    (r || e) && Rl();
                  }),
                  (t.onEnable = function () {
                    Ql(h, !u && "x"), Wl.addEventListener("refresh", L), al(ja, "resize", L), g.smooth && ((g.target.style.scrollBehavior = "auto"), (g.smooth = b.smooth = !1)), E.enable();
                  }),
                  (t.onDisable = function () {
                    Ql(h, !0), sl(ja, "resize", L), Wl.removeEventListener("refresh", L), E.kill();
                  }),
                  (t.lockAxis = !1 !== t.lockAxis),
                  ((e = new La(t)).iOS = ns),
                  ns && !g() && g(1),
                  ns && ka.ticker.add(Ts),
                  (l = e._dc),
                  (o = ka.to(e, {
                    ease: "power4",
                    paused: !0,
                    scrollX: u ? "+=0.1" : "+=0",
                    scrollY: "+=0.1",
                    modifiers: {
                      scrollY: ql(g, g(), function () {
                        return o.pause();
                      }),
                    },
                    onUpdate: Rl,
                    onComplete: l.vars.onComplete,
                  })),
                  e
                );
              })(t);
          return Ja && Ja.target === e.target && Ja.kill(), Ps(e.target) && (Ja = e), e;
        }),
        (Wl.core = {
          _getVelocityProp: Sa,
          _inputObserver: tc,
          _scrollers: ca,
          _proxies: ua,
          bridge: {
            ss: function () {
              ms || El("scrollStart"), (ms = hs());
            },
            ref: function () {
              return Ha;
            },
          },
        }),
        Os() && ka.registerPlugin(Wl);
      var pc = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && cc(t, e);
        })(a, t);
        var e,
          r,
          n,
          o =
            ((e = a),
              (r = lc()),
              function () {
                var t,
                  n = uc(e);
                if (r) {
                  var i = uc(this).constructor;
                  t = Reflect.construct(n, arguments, i);
                } else t = n.apply(this, arguments);
                return ic(this, t);
              });
        function a() {
          var t;
          !(function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          })(this, a),
            (t = o.call(this)),
            qo.registerPlugin(Wl);
          var e = i("[data-banner]", oc(t)),
            r = i("[data-background]", oc(t)),
            n = i("[data-line-vert]", oc(t)),
            s = i("[data-line-horiz]", oc(t)),
            l = i("[data-text-left]", oc(t)),
            c = i("[data-text-right]", oc(t)),
            u = i("[data-cta]", oc(t)),
            p = i("[data-link-text]", oc(t)),
            f = i("[data-title-text]", oc(t));
          qo.set(n, { yPercent: 100 }),
            qo.set(s, { xPercent: -100 }),
            qo.set(r, { scale: 0.95 }),
            qo.set(l, { y: -30 }),
            qo.set(c, { y: 30 }),
            qo.set(u, { y: 30, opacity: 0 }),
            qo.set(p, { y: 30, opacity: 0 }),
            qo.set(f, { y: -30, opacity: 0 });
          var d = qo.timeline({ scrollTrigger: { trigger: e, start: "top-=400px top", end: "bottom bottom", refreshPriority: -1 } });
          return (
            d.to(n, { yPercent: 0, duration: 2, ease: "power2.out" }),
            d.to(r, { scale: 1, duration: 2, ease: "power2.out" }, "<"),
            d.to(s, { xPercent: 0, duration: 2, ease: "power2.out" }, "<"),
            d.to(l, { y: 0, opacity: 1, duration: 2, ease: "power2.out" }, "<"),
            d.to(c, { y: 0, opacity: 1, duration: 2, ease: "power2.out" }, "<"),
            d.to(p, { y: 0, opacity: 1, duration: 2, ease: "power2.out" }, "<"),
            d.to(u, { y: 0, opacity: 1, duration: 0.5, ease: "power2.out" }, "<"),
            d.to(f, { y: 0, opacity: 1, duration: 2, ease: "power2.out" }, "<"),
            t
          );
        }
        return (n = a), Object.defineProperty(n, "prototype", { writable: !1 }), n;
      })(ac(HTMLElement)),
        fc = r(814),
        dc = {};
      function hc(t) {
        return (
          (hc =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                return typeof t;
              }
              : function (t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
              }),
          hc(t)
        );
      }
      function vc(t, e) {
        if (e && ("object" === hc(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return mc(t);
      }
      function mc(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }
      function yc(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
          (yc = function (t) {
            if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
            var r;
            if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== e) {
              if (e.has(t)) return e.get(t);
              e.set(t, n);
            }
            function n() {
              return gc(t, arguments, _c(this).constructor);
            }
            return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), wc(n, t);
          }),
          yc(t)
        );
      }
      function gc(t, e, r) {
        return (
          (gc = bc()
            ? Reflect.construct.bind()
            : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && wc(i, r.prototype), i;
            }),
          gc.apply(null, arguments)
        );
      }
      function bc() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { })), !0;
        } catch (t) {
          return !1;
        }
      }
      function wc(t, e) {
        return (
          (wc = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (t, e) {
              return (t.__proto__ = e), t;
            }),
          wc(t, e)
        );
      }
      function _c(t) {
        return (
          (_c = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
          _c(t)
        );
      }
      (dc.styleTagTransform = Gt()), (dc.setAttributes = zt()), (dc.insert = Rt().bind(null, "head")), (dc.domAPI = Mt()), (dc.insertStyleElement = Bt()), Lt()(fc.Z, dc), fc.Z && fc.Z.locals && fc.Z.locals;
      var xc = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && wc(t, e);
        })(a, t);
        var e,
          r,
          n,
          o =
            ((e = a),
              (r = bc()),
              function () {
                var t,
                  n = _c(e);
                if (r) {
                  var i = _c(this).constructor;
                  t = Reflect.construct(n, arguments, i);
                } else t = n.apply(this, arguments);
                return vc(this, t);
              });
        function a() {
          var t;
          !(function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          })(this, a);
          var e = i("[data-card-carousel]", mc((t = o.call(this)))),
            r = i("[data-card-video]", mc(t)),
            n = e.dataset.cardsPerRow;
          return (
            new _t(e, {
              modules: [Et, Pt],
              slidesPerView: 1.3,
              spaceBetween: 24,
              loop: !0,
              touchEventsTarget: "container",
              breakpoints: { 768: { slidesPerView: 3, spaceBetween: 28 }, 990: { slidesPerView: n, spaceBetween: 24 } },
              on: {
                init: function (t) {
                  var e = t.slides.length,
                    r = "".concat((2 / e) * 100, "%"),
                    n = t.el.closest("[data-carousel-container]"),
                    o = i("[data-progress]", n),
                    a = i("[data-prev]", n),
                    s = i("[data-next]", n);
                  a.listen("click", function () {
                    t.el.swiper.slidePrev();
                  }),
                    s.listen("click", function () {
                      t.el.swiper.slideNext();
                    }),
                    (o.style.width = r);
                },
                slideChange: function (t) {
                  var e = t.slides.length / 2,
                    r = t.realIndex + 1;
                  r > e && (r -= e);
                  var n = (r / e) * 100;
                  t.el.closest("[data-carousel-container]").querySelector("[data-progress]").style.width = "".concat(n, "%");
                },
              },
            }),
            r.listen("mouseenter", function (t) {
              return t.$node.play();
            }),
            r.listen("mouseleave", function (t) {
              var e = t.$node;
              e.pause(), (e.currentTime = 0);
            }),
            t
          );
        }
        return (n = a), Object.defineProperty(n, "prototype", { writable: !1 }), n;
      })(yc(HTMLElement));
      function Tc(t) {
        return (
          (Tc =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                return typeof t;
              }
              : function (t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
              }),
          Tc(t)
        );
      }
      function Ec() {
        Ec = function () {
          return t;
        };
        var t = {},
          e = Object.prototype,
          r = e.hasOwnProperty,
          n =
            Object.defineProperty ||
            function (t, e, r) {
              t[e] = r.value;
            },
          i = "function" == typeof Symbol ? Symbol : {},
          o = i.iterator || "@@iterator",
          a = i.asyncIterator || "@@asyncIterator",
          s = i.toStringTag || "@@toStringTag";
        function l(t, e, r) {
          return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e];
        }
        try {
          l({}, "");
        } catch (t) {
          l = function (t, e, r) {
            return (t[e] = r);
          };
        }
        function c(t, e, r, i) {
          var o = e && e.prototype instanceof f ? e : f,
            a = Object.create(o.prototype),
            s = new S(i || []);
          return n(a, "_invoke", { value: _(t, r, s) }), a;
        }
        function u(t, e, r) {
          try {
            return { type: "normal", arg: t.call(e, r) };
          } catch (t) {
            return { type: "throw", arg: t };
          }
        }
        t.wrap = c;
        var p = {};
        function f() { }
        function d() { }
        function h() { }
        var v = {};
        l(v, o, function () {
          return this;
        });
        var m = Object.getPrototypeOf,
          y = m && m(m(O([])));
        y && y !== e && r.call(y, o) && (v = y);
        var g = (h.prototype = f.prototype = Object.create(v));
        function b(t) {
          ["next", "throw", "return"].forEach(function (e) {
            l(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }
        function w(t, e) {
          function i(n, o, a, s) {
            var l = u(t[n], t, o);
            if ("throw" !== l.type) {
              var c = l.arg,
                p = c.value;
              return p && "object" == Tc(p) && r.call(p, "__await")
                ? e.resolve(p.__await).then(
                  function (t) {
                    i("next", t, a, s);
                  },
                  function (t) {
                    i("throw", t, a, s);
                  }
                )
                : e.resolve(p).then(
                  function (t) {
                    (c.value = t), a(c);
                  },
                  function (t) {
                    return i("throw", t, a, s);
                  }
                );
            }
            s(l.arg);
          }
          var o;
          n(this, "_invoke", {
            value: function (t, r) {
              function n() {
                return new e(function (e, n) {
                  i(t, r, e, n);
                });
              }
              return (o = o ? o.then(n, n) : n());
            },
          });
        }
        function _(t, e, r) {
          var n = "suspendedStart";
          return function (i, o) {
            if ("executing" === n) throw new Error("Generator is already running");
            if ("completed" === n) {
              if ("throw" === i) throw o;
              return { value: void 0, done: !0 };
            }
            for (r.method = i, r.arg = o; ;) {
              var a = r.delegate;
              if (a) {
                var s = x(a, r);
                if (s) {
                  if (s === p) continue;
                  return s;
                }
              }
              if ("next" === r.method) r.sent = r._sent = r.arg;
              else if ("throw" === r.method) {
                if ("suspendedStart" === n) throw ((n = "completed"), r.arg);
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              n = "executing";
              var l = u(t, e, r);
              if ("normal" === l.type) {
                if (((n = r.done ? "completed" : "suspendedYield"), l.arg === p)) continue;
                return { value: l.arg, done: r.done };
              }
              "throw" === l.type && ((n = "completed"), (r.method = "throw"), (r.arg = l.arg));
            }
          };
        }
        function x(t, e) {
          var r = e.method,
            n = t.iterator[r];
          if (void 0 === n)
            return (
              (e.delegate = null),
              ("throw" === r && t.iterator.return && ((e.method = "return"), (e.arg = void 0), x(t, e), "throw" === e.method)) ||
              ("return" !== r && ((e.method = "throw"), (e.arg = new TypeError("The iterator does not provide a '" + r + "' method")))),
              p
            );
          var i = u(n, t.iterator, e.arg);
          if ("throw" === i.type) return (e.method = "throw"), (e.arg = i.arg), (e.delegate = null), p;
          var o = i.arg;
          return o
            ? o.done
              ? ((e[t.resultName] = o.value), (e.next = t.nextLoc), "return" !== e.method && ((e.method = "next"), (e.arg = void 0)), (e.delegate = null), p)
              : o
            : ((e.method = "throw"), (e.arg = new TypeError("iterator result is not an object")), (e.delegate = null), p);
        }
        function T(t) {
          var e = { tryLoc: t[0] };
          1 in t && (e.catchLoc = t[1]), 2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])), this.tryEntries.push(e);
        }
        function E(t) {
          var e = t.completion || {};
          (e.type = "normal"), delete e.arg, (t.completion = e);
        }
        function S(t) {
          (this.tryEntries = [{ tryLoc: "root" }]), t.forEach(T, this), this.reset(!0);
        }
        function O(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) {
              var n = -1,
                i = function e() {
                  for (; ++n < t.length;) if (r.call(t, n)) return (e.value = t[n]), (e.done = !1), e;
                  return (e.value = void 0), (e.done = !0), e;
                };
              return (i.next = i);
            }
          }
          return { next: P };
        }
        function P() {
          return { value: void 0, done: !0 };
        }
        return (
          (d.prototype = h),
          n(g, "constructor", { value: h, configurable: !0 }),
          n(h, "constructor", { value: d, configurable: !0 }),
          (d.displayName = l(h, s, "GeneratorFunction")),
          (t.isGeneratorFunction = function (t) {
            var e = "function" == typeof t && t.constructor;
            return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
          }),
          (t.mark = function (t) {
            return Object.setPrototypeOf ? Object.setPrototypeOf(t, h) : ((t.__proto__ = h), l(t, s, "GeneratorFunction")), (t.prototype = Object.create(g)), t;
          }),
          (t.awrap = function (t) {
            return { __await: t };
          }),
          b(w.prototype),
          l(w.prototype, a, function () {
            return this;
          }),
          (t.AsyncIterator = w),
          (t.async = function (e, r, n, i, o) {
            void 0 === o && (o = Promise);
            var a = new w(c(e, r, n, i), o);
            return t.isGeneratorFunction(r)
              ? a
              : a.next().then(function (t) {
                return t.done ? t.value : a.next();
              });
          }),
          b(g),
          l(g, s, "Generator"),
          l(g, o, function () {
            return this;
          }),
          l(g, "toString", function () {
            return "[object Generator]";
          }),
          (t.keys = function (t) {
            var e = Object(t),
              r = [];
            for (var n in e) r.push(n);
            return (
              r.reverse(),
              function t() {
                for (; r.length;) {
                  var n = r.pop();
                  if (n in e) return (t.value = n), (t.done = !1), t;
                }
                return (t.done = !0), t;
              }
            );
          }),
          (t.values = O),
          (S.prototype = {
            constructor: S,
            reset: function (t) {
              if (((this.prev = 0), (this.next = 0), (this.sent = this._sent = void 0), (this.done = !1), (this.delegate = null), (this.method = "next"), (this.arg = void 0), this.tryEntries.forEach(E), !t))
                for (var e in this) "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            },
            stop: function () {
              this.done = !0;
              var t = this.tryEntries[0].completion;
              if ("throw" === t.type) throw t.arg;
              return this.rval;
            },
            dispatchException: function (t) {
              if (this.done) throw t;
              var e = this;
              function n(r, n) {
                return (a.type = "throw"), (a.arg = t), (e.next = r), n && ((e.method = "next"), (e.arg = void 0)), !!n;
              }
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var o = this.tryEntries[i],
                  a = o.completion;
                if ("root" === o.tryLoc) return n("end");
                if (o.tryLoc <= this.prev) {
                  var s = r.call(o, "catchLoc"),
                    l = r.call(o, "finallyLoc");
                  if (s && l) {
                    if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
                    if (this.prev < o.finallyLoc) return n(o.finallyLoc);
                  } else if (s) {
                    if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
                  } else {
                    if (!l) throw new Error("try statement without catch or finally");
                    if (this.prev < o.finallyLoc) return n(o.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (t, e) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var i = this.tryEntries[n];
                if (i.tryLoc <= this.prev && r.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                  var o = i;
                  break;
                }
              }
              o && ("break" === t || "continue" === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
              var a = o ? o.completion : {};
              return (a.type = t), (a.arg = e), o ? ((this.method = "next"), (this.next = o.finallyLoc), p) : this.complete(a);
            },
            complete: function (t, e) {
              if ("throw" === t.type) throw t.arg;
              return (
                "break" === t.type || "continue" === t.type
                  ? (this.next = t.arg)
                  : "return" === t.type
                    ? ((this.rval = this.arg = t.arg), (this.method = "return"), (this.next = "end"))
                    : "normal" === t.type && e && (this.next = e),
                p
              );
            },
            finish: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), E(r), p;
              }
            },
            catch: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                  var n = r.completion;
                  if ("throw" === n.type) {
                    var i = n.arg;
                    E(r);
                  }
                  return i;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (t, e, r) {
              return (this.delegate = { iterator: O(t), resultName: e, nextLoc: r }), "next" === this.method && (this.arg = void 0), p;
            },
          }),
          t
        );
      }
      function Sc(t, e, r, n, i, o, a) {
        try {
          var s = t[o](a),
            l = s.value;
        } catch (t) {
          return void r(t);
        }
        s.done ? e(l) : Promise.resolve(l).then(n, i);
      }
      function Oc(t) {
        return function () {
          var e = this,
            r = arguments;
          return new Promise(function (n, i) {
            var o = t.apply(e, r);
            function a(t) {
              Sc(o, n, i, a, s, "next", t);
            }
            function s(t) {
              Sc(o, n, i, a, s, "throw", t);
            }
            a(void 0);
          });
        };
      }
      function Pc(t) {
        return Ac.apply(this, arguments);
      }
      function Ac() {
        return (
          (Ac = Oc(
            Ec().mark(function t(e) {
              var r,
                n,
                i,
                o = arguments;
              return Ec().wrap(
                function (t) {
                  for (; ;)
                    switch ((t.prev = t.next)) {
                      case 0:
                        return (r = o.length > 1 && void 0 !== o[1] ? o[1] : null), (t.prev = 1), (t.next = 4), fetch(e, r);
                      case 4:
                        return (n = t.sent), (t.next = 7), n.json();
                      case 7:
                        return (i = t.sent), t.abrupt("return", i);
                      case 11:
                        (t.prev = 11), (t.t0 = t.catch(1)), console.error(t.t0);
                      case 14:
                      case "end":
                        return t.stop();
                    }
                },
                t,
                null,
                [[1, 11]]
              );
            })
          )),
          Ac.apply(this, arguments)
        );
      }
      function Cc(t, e) {
        return Lc.apply(this, arguments);
      }
      function Lc() {
        return (Lc = Oc(
          Ec().mark(function t(e, r) {
            var n;
            return Ec().wrap(
              function (t) {
                for (; ;)
                  switch ((t.prev = t.next)) {
                    case 0:
                      return (t.prev = 0), (t.next = 3), fetch(e, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(r) });
                    case 3:
                      return (n = t.sent), t.abrupt("return", n.json());
                    case 7:
                      (t.prev = 7), (t.t0 = t.catch(0)), console.error(t.t0);
                    case 10:
                    case "end":
                      return t.stop();
                  }
              },
              t,
              null,
              [[0, 7]]
            );
          })
        )).apply(this, arguments);
      }
      var kc = function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".shopify-section";
        return new DOMParser().parseFromString(t, "text/html").querySelector(e).innerHTML;
      };
      function Mc(t) {
        return (
          (Mc =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                return typeof t;
              }
              : function (t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
              }),
          Mc(t)
        );
      }
      function jc() {
        jc = function () {
          return t;
        };
        var t = {},
          e = Object.prototype,
          r = e.hasOwnProperty,
          n =
            Object.defineProperty ||
            function (t, e, r) {
              t[e] = r.value;
            },
          i = "function" == typeof Symbol ? Symbol : {},
          o = i.iterator || "@@iterator",
          a = i.asyncIterator || "@@asyncIterator",
          s = i.toStringTag || "@@toStringTag";
        function l(t, e, r) {
          return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e];
        }
        try {
          l({}, "");
        } catch (t) {
          l = function (t, e, r) {
            return (t[e] = r);
          };
        }
        function c(t, e, r, i) {
          var o = e && e.prototype instanceof f ? e : f,
            a = Object.create(o.prototype),
            s = new S(i || []);
          return n(a, "_invoke", { value: _(t, r, s) }), a;
        }
        function u(t, e, r) {
          try {
            return { type: "normal", arg: t.call(e, r) };
          } catch (t) {
            return { type: "throw", arg: t };
          }
        }
        t.wrap = c;
        var p = {};
        function f() { }
        function d() { }
        function h() { }
        var v = {};
        l(v, o, function () {
          return this;
        });
        var m = Object.getPrototypeOf,
          y = m && m(m(O([])));
        y && y !== e && r.call(y, o) && (v = y);
        var g = (h.prototype = f.prototype = Object.create(v));
        function b(t) {
          ["next", "throw", "return"].forEach(function (e) {
            l(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }
        function w(t, e) {
          function i(n, o, a, s) {
            var l = u(t[n], t, o);
            if ("throw" !== l.type) {
              var c = l.arg,
                p = c.value;
              return p && "object" == Mc(p) && r.call(p, "__await")
                ? e.resolve(p.__await).then(
                  function (t) {
                    i("next", t, a, s);
                  },
                  function (t) {
                    i("throw", t, a, s);
                  }
                )
                : e.resolve(p).then(
                  function (t) {
                    (c.value = t), a(c);
                  },
                  function (t) {
                    return i("throw", t, a, s);
                  }
                );
            }
            s(l.arg);
          }
          var o;
          n(this, "_invoke", {
            value: function (t, r) {
              function n() {
                return new e(function (e, n) {
                  i(t, r, e, n);
                });
              }
              return (o = o ? o.then(n, n) : n());
            },
          });
        }
        function _(t, e, r) {
          var n = "suspendedStart";
          return function (i, o) {
            if ("executing" === n) throw new Error("Generator is already running");
            if ("completed" === n) {
              if ("throw" === i) throw o;
              return { value: void 0, done: !0 };
            }
            for (r.method = i, r.arg = o; ;) {
              var a = r.delegate;
              if (a) {
                var s = x(a, r);
                if (s) {
                  if (s === p) continue;
                  return s;
                }
              }
              if ("next" === r.method) r.sent = r._sent = r.arg;
              else if ("throw" === r.method) {
                if ("suspendedStart" === n) throw ((n = "completed"), r.arg);
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              n = "executing";
              var l = u(t, e, r);
              if ("normal" === l.type) {
                if (((n = r.done ? "completed" : "suspendedYield"), l.arg === p)) continue;
                return { value: l.arg, done: r.done };
              }
              "throw" === l.type && ((n = "completed"), (r.method = "throw"), (r.arg = l.arg));
            }
          };
        }
        function x(t, e) {
          var r = e.method,
            n = t.iterator[r];
          if (void 0 === n)
            return (
              (e.delegate = null),
              ("throw" === r && t.iterator.return && ((e.method = "return"), (e.arg = void 0), x(t, e), "throw" === e.method)) ||
              ("return" !== r && ((e.method = "throw"), (e.arg = new TypeError("The iterator does not provide a '" + r + "' method")))),
              p
            );
          var i = u(n, t.iterator, e.arg);
          if ("throw" === i.type) return (e.method = "throw"), (e.arg = i.arg), (e.delegate = null), p;
          var o = i.arg;
          return o
            ? o.done
              ? ((e[t.resultName] = o.value), (e.next = t.nextLoc), "return" !== e.method && ((e.method = "next"), (e.arg = void 0)), (e.delegate = null), p)
              : o
            : ((e.method = "throw"), (e.arg = new TypeError("iterator result is not an object")), (e.delegate = null), p);
        }
        function T(t) {
          var e = { tryLoc: t[0] };
          1 in t && (e.catchLoc = t[1]), 2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])), this.tryEntries.push(e);
        }
        function E(t) {
          var e = t.completion || {};
          (e.type = "normal"), delete e.arg, (t.completion = e);
        }
        function S(t) {
          (this.tryEntries = [{ tryLoc: "root" }]), t.forEach(T, this), this.reset(!0);
        }
        function O(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) {
              var n = -1,
                i = function e() {
                  for (; ++n < t.length;) if (r.call(t, n)) return (e.value = t[n]), (e.done = !1), e;
                  return (e.value = void 0), (e.done = !0), e;
                };
              return (i.next = i);
            }
          }
          return { next: P };
        }
        function P() {
          return { value: void 0, done: !0 };
        }
        return (
          (d.prototype = h),
          n(g, "constructor", { value: h, configurable: !0 }),
          n(h, "constructor", { value: d, configurable: !0 }),
          (d.displayName = l(h, s, "GeneratorFunction")),
          (t.isGeneratorFunction = function (t) {
            var e = "function" == typeof t && t.constructor;
            return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
          }),
          (t.mark = function (t) {
            return Object.setPrototypeOf ? Object.setPrototypeOf(t, h) : ((t.__proto__ = h), l(t, s, "GeneratorFunction")), (t.prototype = Object.create(g)), t;
          }),
          (t.awrap = function (t) {
            return { __await: t };
          }),
          b(w.prototype),
          l(w.prototype, a, function () {
            return this;
          }),
          (t.AsyncIterator = w),
          (t.async = function (e, r, n, i, o) {
            void 0 === o && (o = Promise);
            var a = new w(c(e, r, n, i), o);
            return t.isGeneratorFunction(r)
              ? a
              : a.next().then(function (t) {
                return t.done ? t.value : a.next();
              });
          }),
          b(g),
          l(g, s, "Generator"),
          l(g, o, function () {
            return this;
          }),
          l(g, "toString", function () {
            return "[object Generator]";
          }),
          (t.keys = function (t) {
            var e = Object(t),
              r = [];
            for (var n in e) r.push(n);
            return (
              r.reverse(),
              function t() {
                for (; r.length;) {
                  var n = r.pop();
                  if (n in e) return (t.value = n), (t.done = !1), t;
                }
                return (t.done = !0), t;
              }
            );
          }),
          (t.values = O),
          (S.prototype = {
            constructor: S,
            reset: function (t) {
              if (((this.prev = 0), (this.next = 0), (this.sent = this._sent = void 0), (this.done = !1), (this.delegate = null), (this.method = "next"), (this.arg = void 0), this.tryEntries.forEach(E), !t))
                for (var e in this) "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            },
            stop: function () {
              this.done = !0;
              var t = this.tryEntries[0].completion;
              if ("throw" === t.type) throw t.arg;
              return this.rval;
            },
            dispatchException: function (t) {
              if (this.done) throw t;
              var e = this;
              function n(r, n) {
                return (a.type = "throw"), (a.arg = t), (e.next = r), n && ((e.method = "next"), (e.arg = void 0)), !!n;
              }
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var o = this.tryEntries[i],
                  a = o.completion;
                if ("root" === o.tryLoc) return n("end");
                if (o.tryLoc <= this.prev) {
                  var s = r.call(o, "catchLoc"),
                    l = r.call(o, "finallyLoc");
                  if (s && l) {
                    if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
                    if (this.prev < o.finallyLoc) return n(o.finallyLoc);
                  } else if (s) {
                    if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
                  } else {
                    if (!l) throw new Error("try statement without catch or finally");
                    if (this.prev < o.finallyLoc) return n(o.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (t, e) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var i = this.tryEntries[n];
                if (i.tryLoc <= this.prev && r.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                  var o = i;
                  break;
                }
              }
              o && ("break" === t || "continue" === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
              var a = o ? o.completion : {};
              return (a.type = t), (a.arg = e), o ? ((this.method = "next"), (this.next = o.finallyLoc), p) : this.complete(a);
            },
            complete: function (t, e) {
              if ("throw" === t.type) throw t.arg;
              return (
                "break" === t.type || "continue" === t.type
                  ? (this.next = t.arg)
                  : "return" === t.type
                    ? ((this.rval = this.arg = t.arg), (this.method = "return"), (this.next = "end"))
                    : "normal" === t.type && e && (this.next = e),
                p
              );
            },
            finish: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), E(r), p;
              }
            },
            catch: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                  var n = r.completion;
                  if ("throw" === n.type) {
                    var i = n.arg;
                    E(r);
                  }
                  return i;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (t, e, r) {
              return (this.delegate = { iterator: O(t), resultName: e, nextLoc: r }), "next" === this.method && (this.arg = void 0), p;
            },
          }),
          t
        );
      }
      function Rc(t, e, r, n, i, o, a) {
        try {
          var s = t[o](a),
            l = s.value;
        } catch (t) {
          return void r(t);
        }
        s.done ? e(l) : Promise.resolve(l).then(n, i);
      }
      function Ic(t) {
        return function () {
          var e = this,
            r = arguments;
          return new Promise(function (n, i) {
            var o = t.apply(e, r);
            function a(t) {
              Rc(o, n, i, a, s, "next", t);
            }
            function s(t) {
              Rc(o, n, i, a, s, "throw", t);
            }
            a(void 0);
          });
        };
      }
      function zc(t) {
        var e = new CustomEvent("cartUpdated", { detail: { response: t } });
        document.dispatchEvent(e);
      }
      function Dc() {
        return Bc.apply(this, arguments);
      }
      function Bc() {
        return (
          (Bc = Ic(
            jc().mark(function t() {
              var e;
              return jc().wrap(function (t) {
                for (; ;)
                  switch ((t.prev = t.next)) {
                    case 0:
                      return (t.next = 2), Pc("/cart.js");
                    case 2:
                      return (e = t.sent), t.abrupt("return", e);
                    case 4:
                    case "end":
                      return t.stop();
                  }
              }, t);
            })
          )),
          Bc.apply(this, arguments)
        );
      }
      function Fc(t, e, r) {
        return Gc.apply(this, arguments);
      }
      function Gc() {
        return (Gc = Ic(
          jc().mark(function t(e, r, n) {
            var i;
            return jc().wrap(function (t) {
              for (; ;)
                switch ((t.prev = t.next)) {
                  case 0:
                    return (t.next = 2), Cc("/cart/add.js", { items: [{ id: e, quantity: r }], sections: n });
                  case 2:
                    return zc((i = t.sent)), t.abrupt("return", i);
                  case 5:
                  case "end":
                    return t.stop();
                }
            }, t);
          })
        )).apply(this, arguments);
      }
      function Nc(t, e, r, n) {
        return Yc.apply(this, arguments);
      }
      function Yc() {
        return (Yc = Ic(
          jc().mark(function t(e, r, n, i) {
            var o;
            return jc().wrap(function (t) {
              for (; ;)
                switch ((t.prev = t.next)) {
                  case 0:
                    return (t.next = 2), Cc("/cart/change.js", { id: e, quantity: r, sections: n, sections_url: i });
                  case 2:
                    return zc((o = t.sent)), t.abrupt("return", o);
                  case 5:
                  case "end":
                    return t.stop();
                }
            }, t);
          })
        )).apply(this, arguments);
      }
      function Hc(t) {
        return Vc.apply(this, arguments);
      }
      function Vc() {
        return (Vc = Ic(
          jc().mark(function t(e) {
            var r;
            return jc().wrap(function (t) {
              for (; ;)
                switch ((t.prev = t.next)) {
                  case 0:
                    return (t.next = 2), Cc("/cart/change.js", { id: e, quantity: 0 });
                  case 2:
                    return zc((r = t.sent)), t.abrupt("return", r);
                  case 5:
                  case "end":
                    return t.stop();
                }
            }, t);
          })
        )).apply(this, arguments);
      }
      function qc(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : window.Shopify.currency.active,
          r = t / 100;
        return Intl.NumberFormat("en-US", { style: "currency", currency: e }).format(r);
      }
      function $c(t) {
        return (
          ($c =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                return typeof t;
              }
              : function (t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
              }),
          $c(t)
        );
      }
      function Xc() {
        Xc = function () {
          return t;
        };
        var t = {},
          e = Object.prototype,
          r = e.hasOwnProperty,
          n =
            Object.defineProperty ||
            function (t, e, r) {
              t[e] = r.value;
            },
          i = "function" == typeof Symbol ? Symbol : {},
          o = i.iterator || "@@iterator",
          a = i.asyncIterator || "@@asyncIterator",
          s = i.toStringTag || "@@toStringTag";
        function l(t, e, r) {
          return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e];
        }
        try {
          l({}, "");
        } catch (t) {
          l = function (t, e, r) {
            return (t[e] = r);
          };
        }
        function c(t, e, r, i) {
          var o = e && e.prototype instanceof f ? e : f,
            a = Object.create(o.prototype),
            s = new S(i || []);
          return n(a, "_invoke", { value: _(t, r, s) }), a;
        }
        function u(t, e, r) {
          try {
            return { type: "normal", arg: t.call(e, r) };
          } catch (t) {
            return { type: "throw", arg: t };
          }
        }
        t.wrap = c;
        var p = {};
        function f() { }
        function d() { }
        function h() { }
        var v = {};
        l(v, o, function () {
          return this;
        });
        var m = Object.getPrototypeOf,
          y = m && m(m(O([])));
        y && y !== e && r.call(y, o) && (v = y);
        var g = (h.prototype = f.prototype = Object.create(v));
        function b(t) {
          ["next", "throw", "return"].forEach(function (e) {
            l(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }
        function w(t, e) {
          function i(n, o, a, s) {
            var l = u(t[n], t, o);
            if ("throw" !== l.type) {
              var c = l.arg,
                p = c.value;
              return p && "object" == $c(p) && r.call(p, "__await")
                ? e.resolve(p.__await).then(
                  function (t) {
                    i("next", t, a, s);
                  },
                  function (t) {
                    i("throw", t, a, s);
                  }
                )
                : e.resolve(p).then(
                  function (t) {
                    (c.value = t), a(c);
                  },
                  function (t) {
                    return i("throw", t, a, s);
                  }
                );
            }
            s(l.arg);
          }
          var o;
          n(this, "_invoke", {
            value: function (t, r) {
              function n() {
                return new e(function (e, n) {
                  i(t, r, e, n);
                });
              }
              return (o = o ? o.then(n, n) : n());
            },
          });
        }
        function _(t, e, r) {
          var n = "suspendedStart";
          return function (i, o) {
            if ("executing" === n) throw new Error("Generator is already running");
            if ("completed" === n) {
              if ("throw" === i) throw o;
              return { value: void 0, done: !0 };
            }
            for (r.method = i, r.arg = o; ;) {
              var a = r.delegate;
              if (a) {
                var s = x(a, r);
                if (s) {
                  if (s === p) continue;
                  return s;
                }
              }
              if ("next" === r.method) r.sent = r._sent = r.arg;
              else if ("throw" === r.method) {
                if ("suspendedStart" === n) throw ((n = "completed"), r.arg);
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              n = "executing";
              var l = u(t, e, r);
              if ("normal" === l.type) {
                if (((n = r.done ? "completed" : "suspendedYield"), l.arg === p)) continue;
                return { value: l.arg, done: r.done };
              }
              "throw" === l.type && ((n = "completed"), (r.method = "throw"), (r.arg = l.arg));
            }
          };
        }
        function x(t, e) {
          var r = e.method,
            n = t.iterator[r];
          if (void 0 === n)
            return (
              (e.delegate = null),
              ("throw" === r && t.iterator.return && ((e.method = "return"), (e.arg = void 0), x(t, e), "throw" === e.method)) ||
              ("return" !== r && ((e.method = "throw"), (e.arg = new TypeError("The iterator does not provide a '" + r + "' method")))),
              p
            );
          var i = u(n, t.iterator, e.arg);
          if ("throw" === i.type) return (e.method = "throw"), (e.arg = i.arg), (e.delegate = null), p;
          var o = i.arg;
          return o
            ? o.done
              ? ((e[t.resultName] = o.value), (e.next = t.nextLoc), "return" !== e.method && ((e.method = "next"), (e.arg = void 0)), (e.delegate = null), p)
              : o
            : ((e.method = "throw"), (e.arg = new TypeError("iterator result is not an object")), (e.delegate = null), p);
        }
        function T(t) {
          var e = { tryLoc: t[0] };
          1 in t && (e.catchLoc = t[1]), 2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])), this.tryEntries.push(e);
        }
        function E(t) {
          var e = t.completion || {};
          (e.type = "normal"), delete e.arg, (t.completion = e);
        }
        function S(t) {
          (this.tryEntries = [{ tryLoc: "root" }]), t.forEach(T, this), this.reset(!0);
        }
        function O(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) {
              var n = -1,
                i = function e() {
                  for (; ++n < t.length;) if (r.call(t, n)) return (e.value = t[n]), (e.done = !1), e;
                  return (e.value = void 0), (e.done = !0), e;
                };
              return (i.next = i);
            }
          }
          return { next: P };
        }
        function P() {
          return { value: void 0, done: !0 };
        }
        return (
          (d.prototype = h),
          n(g, "constructor", { value: h, configurable: !0 }),
          n(h, "constructor", { value: d, configurable: !0 }),
          (d.displayName = l(h, s, "GeneratorFunction")),
          (t.isGeneratorFunction = function (t) {
            var e = "function" == typeof t && t.constructor;
            return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
          }),
          (t.mark = function (t) {
            return Object.setPrototypeOf ? Object.setPrototypeOf(t, h) : ((t.__proto__ = h), l(t, s, "GeneratorFunction")), (t.prototype = Object.create(g)), t;
          }),
          (t.awrap = function (t) {
            return { __await: t };
          }),
          b(w.prototype),
          l(w.prototype, a, function () {
            return this;
          }),
          (t.AsyncIterator = w),
          (t.async = function (e, r, n, i, o) {
            void 0 === o && (o = Promise);
            var a = new w(c(e, r, n, i), o);
            return t.isGeneratorFunction(r)
              ? a
              : a.next().then(function (t) {
                return t.done ? t.value : a.next();
              });
          }),
          b(g),
          l(g, s, "Generator"),
          l(g, o, function () {
            return this;
          }),
          l(g, "toString", function () {
            return "[object Generator]";
          }),
          (t.keys = function (t) {
            var e = Object(t),
              r = [];
            for (var n in e) r.push(n);
            return (
              r.reverse(),
              function t() {
                for (; r.length;) {
                  var n = r.pop();
                  if (n in e) return (t.value = n), (t.done = !1), t;
                }
                return (t.done = !0), t;
              }
            );
          }),
          (t.values = O),
          (S.prototype = {
            constructor: S,
            reset: function (t) {
              if (((this.prev = 0), (this.next = 0), (this.sent = this._sent = void 0), (this.done = !1), (this.delegate = null), (this.method = "next"), (this.arg = void 0), this.tryEntries.forEach(E), !t))
                for (var e in this) "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            },
            stop: function () {
              this.done = !0;
              var t = this.tryEntries[0].completion;
              if ("throw" === t.type) throw t.arg;
              return this.rval;
            },
            dispatchException: function (t) {
              if (this.done) throw t;
              var e = this;
              function n(r, n) {
                return (a.type = "throw"), (a.arg = t), (e.next = r), n && ((e.method = "next"), (e.arg = void 0)), !!n;
              }
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var o = this.tryEntries[i],
                  a = o.completion;
                if ("root" === o.tryLoc) return n("end");
                if (o.tryLoc <= this.prev) {
                  var s = r.call(o, "catchLoc"),
                    l = r.call(o, "finallyLoc");
                  if (s && l) {
                    if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
                    if (this.prev < o.finallyLoc) return n(o.finallyLoc);
                  } else if (s) {
                    if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
                  } else {
                    if (!l) throw new Error("try statement without catch or finally");
                    if (this.prev < o.finallyLoc) return n(o.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (t, e) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var i = this.tryEntries[n];
                if (i.tryLoc <= this.prev && r.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                  var o = i;
                  break;
                }
              }
              o && ("break" === t || "continue" === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
              var a = o ? o.completion : {};
              return (a.type = t), (a.arg = e), o ? ((this.method = "next"), (this.next = o.finallyLoc), p) : this.complete(a);
            },
            complete: function (t, e) {
              if ("throw" === t.type) throw t.arg;
              return (
                "break" === t.type || "continue" === t.type
                  ? (this.next = t.arg)
                  : "return" === t.type
                    ? ((this.rval = this.arg = t.arg), (this.method = "return"), (this.next = "end"))
                    : "normal" === t.type && e && (this.next = e),
                p
              );
            },
            finish: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), E(r), p;
              }
            },
            catch: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                  var n = r.completion;
                  if ("throw" === n.type) {
                    var i = n.arg;
                    E(r);
                  }
                  return i;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (t, e, r) {
              return (this.delegate = { iterator: O(t), resultName: e, nextLoc: r }), "next" === this.method && (this.arg = void 0), p;
            },
          }),
          t
        );
      }
      function Wc(t, e, r, n, i, o, a) {
        try {
          var s = t[o](a),
            l = s.value;
        } catch (t) {
          return void r(t);
        }
        s.done ? e(l) : Promise.resolve(l).then(n, i);
      }
      function Uc(t, e) {
        if (e && ("object" === $c(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return Zc(t);
      }
      function Zc(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }
      function Qc(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
          (Qc = function (t) {
            if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
            var r;
            if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== e) {
              if (e.has(t)) return e.get(t);
              e.set(t, n);
            }
            function n() {
              return Kc(t, arguments, eu(this).constructor);
            }
            return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), tu(n, t);
          }),
          Qc(t)
        );
      }
      function Kc(t, e, r) {
        return (
          (Kc = Jc()
            ? Reflect.construct.bind()
            : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && tu(i, r.prototype), i;
            }),
          Kc.apply(null, arguments)
        );
      }
      function Jc() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { })), !0;
        } catch (t) {
          return !1;
        }
      }
      function tu(t, e) {
        return (
          (tu = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (t, e) {
              return (t.__proto__ = e), t;
            }),
          tu(t, e)
        );
      }
      function eu(t) {
        return (
          (eu = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
          eu(t)
        );
      }
      var ru = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && tu(t, e);
        })(a, t);
        var e,
          r,
          n,
          o =
            ((e = a),
              (r = Jc()),
              function () {
                var t,
                  n = eu(e);
                if (r) {
                  var i = eu(this).constructor;
                  t = Reflect.construct(n, arguments, i);
                } else t = n.apply(this, arguments);
                return Uc(this, t);
              });
        function a() {
          var t;
          !(function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          })(this, a);
          var e = i("[data-buy-addon]", Zc((t = o.call(this)))),
            r = i("[data-cart-count]"),
            n = i("[data-cart-total]"),
            s = i("[data-cart-notif-button]"),
            l = i("[data-cart-notification-progress]");
          t.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
          var c = i("[data-cart-notif-carousel]", Zc(t));
          new _t(c, { slidesPerView: 2.6, spaceBetween: 12, breakpoints: { 768: { slidesPerView: 4 } } }),
            e.listen(
              "click",
              (function () {
                var e,
                  o =
                    ((e = Xc().mark(function e(o) {
                      var a, c, p, f, d, h, v, m, y;
                      return Xc().wrap(function (e) {
                        for (; ;)
                          switch ((e.prev = e.next)) {
                            case 0:
                              if (((a = o.$node), (c = a.dataset.buyAddon), !(p = i('[data-addon-wrapper="'.concat(c, '"]'), Zc(t))).classList.contains("cart-notification__addon--added"))) {
                                e.next = 9;
                                break;
                              }
                              return (e.next = 6), Hc(c);
                            case 6:
                              e.sent, (e.next = 12);
                              break;
                            case 9:
                              return (e.next = 11), Fc(c, 1, "cart-icon-bubble");
                            case 11:
                              e.sent;
                            case 12:
                              return (e.next = 14), Dc();
                            case 14:
                              (f = e.sent),
                                (d = f.item_count),
                                (h = f.total_price),
                                (v = u.format(h / 100)),
                                (m = Number(l.dataset.cartNotificationProgress)),
                                p.modifyClass("toggle", "cart-notification__addon--added"),
                                (r.textContent = d),
                                (s.textContent = "VIEW CART (".concat(d, ")")),
                                (n.textContent = v),
                                (n.dataset.cartTotal = h),
                                h >= m ? (l.style.width = "100%") : ((y = (h / m) * 100), (l.style.width = "".concat(y, "%")));
                            case 24:
                            case "end":
                              return e.stop();
                          }
                      }, e);
                    })),
                      function () {
                        var t = this,
                          r = arguments;
                        return new Promise(function (n, i) {
                          var o = e.apply(t, r);
                          function a(t) {
                            Wc(o, n, i, a, s, "next", t);
                          }
                          function s(t) {
                            Wc(o, n, i, a, s, "throw", t);
                          }
                          a(void 0);
                        });
                      });
                return function (t) {
                  return o.apply(this, arguments);
                };
              })()
            );
          var u = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
          return t;
        }
        return (n = a), Object.defineProperty(n, "prototype", { writable: !1 }), n;
      })(Qc(HTMLElement));
      function nu(t) {
        return (
          (nu =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                return typeof t;
              }
              : function (t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
              }),
          nu(t)
        );
      }
      function iu() {
        iu = function () {
          return t;
        };
        var t = {},
          e = Object.prototype,
          r = e.hasOwnProperty,
          n =
            Object.defineProperty ||
            function (t, e, r) {
              t[e] = r.value;
            },
          i = "function" == typeof Symbol ? Symbol : {},
          o = i.iterator || "@@iterator",
          a = i.asyncIterator || "@@asyncIterator",
          s = i.toStringTag || "@@toStringTag";
        function l(t, e, r) {
          return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e];
        }
        try {
          l({}, "");
        } catch (t) {
          l = function (t, e, r) {
            return (t[e] = r);
          };
        }
        function c(t, e, r, i) {
          var o = e && e.prototype instanceof f ? e : f,
            a = Object.create(o.prototype),
            s = new S(i || []);
          return n(a, "_invoke", { value: _(t, r, s) }), a;
        }
        function u(t, e, r) {
          try {
            return { type: "normal", arg: t.call(e, r) };
          } catch (t) {
            return { type: "throw", arg: t };
          }
        }
        t.wrap = c;
        var p = {};
        function f() { }
        function d() { }
        function h() { }
        var v = {};
        l(v, o, function () {
          return this;
        });
        var m = Object.getPrototypeOf,
          y = m && m(m(O([])));
        y && y !== e && r.call(y, o) && (v = y);
        var g = (h.prototype = f.prototype = Object.create(v));
        function b(t) {
          ["next", "throw", "return"].forEach(function (e) {
            l(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }
        function w(t, e) {
          function i(n, o, a, s) {
            var l = u(t[n], t, o);
            if ("throw" !== l.type) {
              var c = l.arg,
                p = c.value;
              return p && "object" == nu(p) && r.call(p, "__await")
                ? e.resolve(p.__await).then(
                  function (t) {
                    i("next", t, a, s);
                  },
                  function (t) {
                    i("throw", t, a, s);
                  }
                )
                : e.resolve(p).then(
                  function (t) {
                    (c.value = t), a(c);
                  },
                  function (t) {
                    return i("throw", t, a, s);
                  }
                );
            }
            s(l.arg);
          }
          var o;
          n(this, "_invoke", {
            value: function (t, r) {
              function n() {
                return new e(function (e, n) {
                  i(t, r, e, n);
                });
              }
              return (o = o ? o.then(n, n) : n());
            },
          });
        }
        function _(t, e, r) {
          var n = "suspendedStart";
          return function (i, o) {
            if ("executing" === n) throw new Error("Generator is already running");
            if ("completed" === n) {
              if ("throw" === i) throw o;
              return { value: void 0, done: !0 };
            }
            for (r.method = i, r.arg = o; ;) {
              var a = r.delegate;
              if (a) {
                var s = x(a, r);
                if (s) {
                  if (s === p) continue;
                  return s;
                }
              }
              if ("next" === r.method) r.sent = r._sent = r.arg;
              else if ("throw" === r.method) {
                if ("suspendedStart" === n) throw ((n = "completed"), r.arg);
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              n = "executing";
              var l = u(t, e, r);
              if ("normal" === l.type) {
                if (((n = r.done ? "completed" : "suspendedYield"), l.arg === p)) continue;
                return { value: l.arg, done: r.done };
              }
              "throw" === l.type && ((n = "completed"), (r.method = "throw"), (r.arg = l.arg));
            }
          };
        }
        function x(t, e) {
          var r = e.method,
            n = t.iterator[r];
          if (void 0 === n)
            return (
              (e.delegate = null),
              ("throw" === r && t.iterator.return && ((e.method = "return"), (e.arg = void 0), x(t, e), "throw" === e.method)) ||
              ("return" !== r && ((e.method = "throw"), (e.arg = new TypeError("The iterator does not provide a '" + r + "' method")))),
              p
            );
          var i = u(n, t.iterator, e.arg);
          if ("throw" === i.type) return (e.method = "throw"), (e.arg = i.arg), (e.delegate = null), p;
          var o = i.arg;
          return o
            ? o.done
              ? ((e[t.resultName] = o.value), (e.next = t.nextLoc), "return" !== e.method && ((e.method = "next"), (e.arg = void 0)), (e.delegate = null), p)
              : o
            : ((e.method = "throw"), (e.arg = new TypeError("iterator result is not an object")), (e.delegate = null), p);
        }
        function T(t) {
          var e = { tryLoc: t[0] };
          1 in t && (e.catchLoc = t[1]), 2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])), this.tryEntries.push(e);
        }
        function E(t) {
          var e = t.completion || {};
          (e.type = "normal"), delete e.arg, (t.completion = e);
        }
        function S(t) {
          (this.tryEntries = [{ tryLoc: "root" }]), t.forEach(T, this), this.reset(!0);
        }
        function O(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) {
              var n = -1,
                i = function e() {
                  for (; ++n < t.length;) if (r.call(t, n)) return (e.value = t[n]), (e.done = !1), e;
                  return (e.value = void 0), (e.done = !0), e;
                };
              return (i.next = i);
            }
          }
          return { next: P };
        }
        function P() {
          return { value: void 0, done: !0 };
        }
        return (
          (d.prototype = h),
          n(g, "constructor", { value: h, configurable: !0 }),
          n(h, "constructor", { value: d, configurable: !0 }),
          (d.displayName = l(h, s, "GeneratorFunction")),
          (t.isGeneratorFunction = function (t) {
            var e = "function" == typeof t && t.constructor;
            return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
          }),
          (t.mark = function (t) {
            return Object.setPrototypeOf ? Object.setPrototypeOf(t, h) : ((t.__proto__ = h), l(t, s, "GeneratorFunction")), (t.prototype = Object.create(g)), t;
          }),
          (t.awrap = function (t) {
            return { __await: t };
          }),
          b(w.prototype),
          l(w.prototype, a, function () {
            return this;
          }),
          (t.AsyncIterator = w),
          (t.async = function (e, r, n, i, o) {
            void 0 === o && (o = Promise);
            var a = new w(c(e, r, n, i), o);
            return t.isGeneratorFunction(r)
              ? a
              : a.next().then(function (t) {
                return t.done ? t.value : a.next();
              });
          }),
          b(g),
          l(g, s, "Generator"),
          l(g, o, function () {
            return this;
          }),
          l(g, "toString", function () {
            return "[object Generator]";
          }),
          (t.keys = function (t) {
            var e = Object(t),
              r = [];
            for (var n in e) r.push(n);
            return (
              r.reverse(),
              function t() {
                for (; r.length;) {
                  var n = r.pop();
                  if (n in e) return (t.value = n), (t.done = !1), t;
                }
                return (t.done = !0), t;
              }
            );
          }),
          (t.values = O),
          (S.prototype = {
            constructor: S,
            reset: function (t) {
              if (((this.prev = 0), (this.next = 0), (this.sent = this._sent = void 0), (this.done = !1), (this.delegate = null), (this.method = "next"), (this.arg = void 0), this.tryEntries.forEach(E), !t))
                for (var e in this) "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            },
            stop: function () {
              this.done = !0;
              var t = this.tryEntries[0].completion;
              if ("throw" === t.type) throw t.arg;
              return this.rval;
            },
            dispatchException: function (t) {
              if (this.done) throw t;
              var e = this;
              function n(r, n) {
                return (a.type = "throw"), (a.arg = t), (e.next = r), n && ((e.method = "next"), (e.arg = void 0)), !!n;
              }
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var o = this.tryEntries[i],
                  a = o.completion;
                if ("root" === o.tryLoc) return n("end");
                if (o.tryLoc <= this.prev) {
                  var s = r.call(o, "catchLoc"),
                    l = r.call(o, "finallyLoc");
                  if (s && l) {
                    if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
                    if (this.prev < o.finallyLoc) return n(o.finallyLoc);
                  } else if (s) {
                    if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
                  } else {
                    if (!l) throw new Error("try statement without catch or finally");
                    if (this.prev < o.finallyLoc) return n(o.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (t, e) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var i = this.tryEntries[n];
                if (i.tryLoc <= this.prev && r.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                  var o = i;
                  break;
                }
              }
              o && ("break" === t || "continue" === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
              var a = o ? o.completion : {};
              return (a.type = t), (a.arg = e), o ? ((this.method = "next"), (this.next = o.finallyLoc), p) : this.complete(a);
            },
            complete: function (t, e) {
              if ("throw" === t.type) throw t.arg;
              return (
                "break" === t.type || "continue" === t.type
                  ? (this.next = t.arg)
                  : "return" === t.type
                    ? ((this.rval = this.arg = t.arg), (this.method = "return"), (this.next = "end"))
                    : "normal" === t.type && e && (this.next = e),
                p
              );
            },
            finish: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), E(r), p;
              }
            },
            catch: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                  var n = r.completion;
                  if ("throw" === n.type) {
                    var i = n.arg;
                    E(r);
                  }
                  return i;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (t, e, r) {
              return (this.delegate = { iterator: O(t), resultName: e, nextLoc: r }), "next" === this.method && (this.arg = void 0), p;
            },
          }),
          t
        );
      }
      function ou(t, e, r, n, i, o, a) {
        try {
          var s = t[o](a),
            l = s.value;
        } catch (t) {
          return void r(t);
        }
        s.done ? e(l) : Promise.resolve(l).then(n, i);
      }
      function au(t) {
        return function () {
          var e = this,
            r = arguments;
          return new Promise(function (n, i) {
            var o = t.apply(e, r);
            function a(t) {
              ou(o, n, i, a, s, "next", t);
            }
            function s(t) {
              ou(o, n, i, a, s, "throw", t);
            }
            a(void 0);
          });
        };
      }
      function su(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          (n.enumerable = n.enumerable || !1), (n.configurable = !0), "value" in n && (n.writable = !0), Object.defineProperty(t, mu(n.key), n);
        }
      }
      function lu(t, e) {
        if (e && ("object" === nu(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return cu(t);
      }
      function cu(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }
      function uu(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
          (uu = function (t) {
            if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
            var r;
            if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== e) {
              if (e.has(t)) return e.get(t);
              e.set(t, n);
            }
            function n() {
              return pu(t, arguments, hu(this).constructor);
            }
            return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), du(n, t);
          }),
          uu(t)
        );
      }
      function pu(t, e, r) {
        return (
          (pu = fu()
            ? Reflect.construct.bind()
            : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && du(i, r.prototype), i;
            }),
          pu.apply(null, arguments)
        );
      }
      function fu() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { })), !0;
        } catch (t) {
          return !1;
        }
      }
      function du(t, e) {
        return (
          (du = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (t, e) {
              return (t.__proto__ = e), t;
            }),
          du(t, e)
        );
      }
      function hu(t) {
        return (
          (hu = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
          hu(t)
        );
      }
      function vu(t, e, r) {
        return (e = mu(e)) in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : (t[e] = r), t;
      }
      function mu(t) {
        var e = (function (t, e) {
          if ("object" !== nu(t) || null === t) return t;
          var r = t[Symbol.toPrimitive];
          if (void 0 !== r) {
            var n = r.call(t, "string");
            if ("object" !== nu(n)) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return String(t);
        })(t);
        return "symbol" === nu(e) ? e : String(e);
      }
      var yu = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && du(t, e);
        })(s, t);
        var e,
          r,
          n,
          o,
          a =
            ((e = s),
              (r = fu()),
              function () {
                var t,
                  n = hu(e);
                if (r) {
                  var i = hu(this).constructor;
                  t = Reflect.construct(n, arguments, i);
                } else t = n.apply(this, arguments);
                return lu(this, t);
              });
        function s() {
          var t;
          return (
            (function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            })(this, s),
            vu(cu((t = a.call(this))), "handleDynamicEvent", function (t, e) {
              return function (r) {
                var n = r.target.closest(t);
                n && e({ $node: n });
              };
            }),
            vu(
              cu(t),
              "handleRemove",
              (function () {
                var e = au(
                  iu().mark(function e(r) {
                    var n, i, o;
                    return iu().wrap(function (e) {
                      for (; ;)
                        switch ((e.prev = e.next)) {
                          case 0:
                            return (n = r.$node), (i = n.closest("[data-line-item]").dataset.variantId), (e.next = 4), Nc(i, 0);
                          case 4:
                            if (
                              ((o = e.sent),
                                n.closest("[data-line-item]").classList.add("c-lineItem--removed"),
                                t.updateCartCount(o.item_count),
                                t.updateCartItems(o.items.length),
                                t.updatePrice(o.total_price),
                                o.item_count)
                            ) {
                              e.next = 12;
                              break;
                            }
                            return e.abrupt("return", (window.location = window.location));
                          case 12:
                          case "end":
                            return e.stop();
                        }
                    }, e);
                  })
                );
                return function (t) {
                  return e.apply(this, arguments);
                };
              })()
            ),
            vu(
              cu(t),
              "handleUndo",
              (function () {
                var e = au(
                  iu().mark(function e(r) {
                    var n, o, a, s, l, c, u, p, f, d, h, v;
                    return iu().wrap(function (e) {
                      for (; ;)
                        switch ((e.prev = e.next)) {
                          case 0:
                            return (
                              (n = r.$node),
                              (o = n.closest("[data-line-item]")).classList.remove("c-lineItem--removed"),
                              (a = n.closest("[data-line-item]").dataset.variantId),
                              (s = Number(o.querySelector("[data-qty]").value)),
                              (e.next = 7),
                              Fc(a, s)
                            );
                          case 7:
                            return (
                              (l = e.sent),
                              (c = i("[data-cart-count]")),
                              (u = i("[data-cart-items]")),
                              (p = Number(c.innerHTML)),
                              (f = Number(u.innerHTML)),
                              (d = p + l.items[0].quantity),
                              (h = f + 1),
                              t.updateCartCount(d),
                              t.updateCartItems(h),
                              (e.next = 18),
                              Dc()
                            );
                          case 18:
                            (v = e.sent), t.updatePrice(v.total_price);
                          case 20:
                          case "end":
                            return e.stop();
                        }
                    }, e);
                  })
                );
                return function (t) {
                  return e.apply(this, arguments);
                };
              })()
            ),
            vu(
              cu(t),
              "handleChange",
              (function () {
                var e = au(
                  iu().mark(function e(r) {
                    var n, i, o, a, s, l, c;
                    return iu().wrap(function (e) {
                      for (; ;)
                        switch ((e.prev = e.next)) {
                          case 0:
                            return (n = r.$node), (i = Number(n.value)), (o = n.closest("[data-line-item]").dataset.variantId), (e.next = 5), Nc(o, i);
                          case 5:
                            (a = e.sent),
                              (s = n.closest("[data-line-item]")),
                              t.updateCartCount(a.item_count),
                              t.updateCartItems(a.items.length),
                              t.updatePrice(a.total_price),
                              (l = s.querySelector("[data-line-price]")),
                              (c = a.items.find(function (t) {
                                return t.id === Number(o);
                              })),
                              (l.innerHTML = qc(c.final_line_price));
                          case 13:
                          case "end":
                            return e.stop();
                        }
                    }, e);
                  })
                );
                return function (t) {
                  return e.apply(this, arguments);
                };
              })()
            ),
            vu(
              cu(t),
              "refreshCartPage",
              au(
                iu().mark(function e() {
                  var r, n, i, o;
                  return iu().wrap(function (e) {
                    for (; ;)
                      switch ((e.prev = e.next)) {
                        case 0:
                          return (r = t.dataset.sectionId), (e.next = 3), fetch("/?section_id=".concat(r));
                        case 3:
                          return (e.next = 5), e.sent.text();
                        case 5:
                          (n = e.sent), (i = kc(n, "[data-line-items]")), (o = kc(n, "[data-breakdown]")), (t.querySelector("[data-line-items]").innerHTML = i), (t.querySelector("[data-breakdown]").innerHTML = o);
                        case 10:
                        case "end":
                          return e.stop();
                      }
                  }, e);
                })
              )
            ),
            vu(
              cu(t),
              "handleSave",
              (function () {
                var e = au(
                  iu().mark(function e(r) {
                    var n, o, a, s, l, c;
                    return iu().wrap(function (e) {
                      for (; ;)
                        switch ((e.prev = e.next)) {
                          case 0:
                            return (
                              (n = r.$node),
                              (o = n.dataset),
                              (a = o.productHandle),
                              (s = o.variantId),
                              (l = "".concat(a, "::").concat(s)),
                              (c = JSON.parse(window.localStorage.getItem("elva.savedItems")) || []).includes(l) || c.push(l),
                              (e.next = 7),
                              t.handleRemove({ $node: n })
                            );
                          case 7:
                            return (e.next = 9), window.localStorage.setItem("elva.savedItems", JSON.stringify(c));
                          case 9:
                            i("saved-items").loadSavedItems();
                          case 10:
                          case "end":
                            return e.stop();
                        }
                    }, e);
                  })
                );
                return function (t) {
                  return e.apply(this, arguments);
                };
              })()
            ),
            vu(cu(t), "handleAccordionToggle", function (t) {
              t.$node.closest("[data-accordion]").classList.toggle("c-accordionAlt--open");
            }),
            document.addEventListener("change", t.handleDynamicEvent("[data-qty]", t.handleChange)),
            document.addEventListener("click", t.handleDynamicEvent("[data-remove]", t.handleRemove)),
            document.addEventListener("click", t.handleDynamicEvent("[data-undo]", t.handleUndo)),
            document.addEventListener("click", t.handleDynamicEvent("[data-save]", t.handleSave)),
            document.addEventListener("click", t.handleDynamicEvent("[data-accordion-trigger]", t.handleAccordionToggle)),
            t
          );
        }
        return (
          (n = s),
          (o = [
            {
              key: "updateCartCount",
              value: function (t) {
                i("[data-cart-count]").innerHTML = t;
              },
            },
            {
              key: "updateCartItems",
              value: function (t) {
                i("[data-cart-items]").innerHTML = t;
              },
            },
            {
              key: "updatePrice",
              value: function (t) {
                i("[data-price]").forEach(function (e) {
                  e.innerHTML = qc(t);
                });
              },
            },
          ]) && su(n.prototype, o),
          Object.defineProperty(n, "prototype", { writable: !1 }),
          s
        );
      })(uu(HTMLElement));
      function gu(t) {
        return (
          (gu =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                return typeof t;
              }
              : function (t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
              }),
          gu(t)
        );
      }
      function bu(t, e) {
        if (e && ("object" === gu(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return wu(t);
      }
      function wu(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }
      function _u(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
          (_u = function (t) {
            if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
            var r;
            if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== e) {
              if (e.has(t)) return e.get(t);
              e.set(t, n);
            }
            function n() {
              return xu(t, arguments, Su(this).constructor);
            }
            return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), Eu(n, t);
          }),
          _u(t)
        );
      }
      function xu(t, e, r) {
        return (
          (xu = Tu()
            ? Reflect.construct.bind()
            : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && Eu(i, r.prototype), i;
            }),
          xu.apply(null, arguments)
        );
      }
      function Tu() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { })), !0;
        } catch (t) {
          return !1;
        }
      }
      function Eu(t, e) {
        return (
          (Eu = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (t, e) {
              return (t.__proto__ = e), t;
            }),
          Eu(t, e)
        );
      }
      function Su(t) {
        return (
          (Su = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
          Su(t)
        );
      }
      var Ou = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Eu(t, e);
        })(a, t);
        var e,
          r,
          n,
          o =
            ((e = a),
              (r = Tu()),
              function () {
                var t,
                  n = Su(e);
                if (r) {
                  var i = Su(this).constructor;
                  t = Reflect.construct(n, arguments, i);
                } else t = n.apply(this, arguments);
                return bu(this, t);
              });
        function a() {
          var t;
          !(function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          })(this, a);
          var e = i("[data-sort-opener]", wu((t = o.call(this)))),
            r = i("[data-sort-dropdown]", wu(t)),
            n = i("[data-sort-option]", wu(t)),
            s = i("[data-sort-select]"),
            l = i("#MainContent"),
            c = "c-sort__option--selected",
            u = "c-sort__dropdown--open";
          return (
            e.listen("click", function () {
              r.modifyClass("add", u);
            }),
            n.listen("click", function (t) {
              var r = t.$node,
                i = t.index,
                o = r.textContent;
              n.modifyClass("remove", c), r.modifyClass("add", c), (e.textContent = o), (s.options[i].selected = !0);
            }),
            l.listen("click", function (t) {
              t.e.target.className.includes("c-sort") || r.modifyClass("remove", u);
            }),
            t
          );
        }
        return (n = a), Object.defineProperty(n, "prototype", { writable: !1 }), n;
      })(_u(HTMLElement));
      function Pu(t) {
        return (
          (Pu =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                return typeof t;
              }
              : function (t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
              }),
          Pu(t)
        );
      }
      function Au(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          (n.enumerable = n.enumerable || !1),
            (n.configurable = !0),
            "value" in n && (n.writable = !0),
            Object.defineProperty(
              t,
              (void 0,
                (i = (function (t, e) {
                  if ("object" !== Pu(t) || null === t) return t;
                  var r = t[Symbol.toPrimitive];
                  if (void 0 !== r) {
                    var n = r.call(t, "string");
                    if ("object" !== Pu(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                  }
                  return String(t);
                })(n.key)),
                "symbol" === Pu(i) ? i : String(i)),
              n
            );
        }
        var i;
      }
      function Cu(t, e) {
        if (e && ("object" === Pu(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return Lu(t);
      }
      function Lu(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }
      function ku(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
          (ku = function (t) {
            if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
            var r;
            if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== e) {
              if (e.has(t)) return e.get(t);
              e.set(t, n);
            }
            function n() {
              return Mu(t, arguments, Iu(this).constructor);
            }
            return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), Ru(n, t);
          }),
          ku(t)
        );
      }
      function Mu(t, e, r) {
        return (
          (Mu = ju()
            ? Reflect.construct.bind()
            : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && Ru(i, r.prototype), i;
            }),
          Mu.apply(null, arguments)
        );
      }
      function ju() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { })), !0;
        } catch (t) {
          return !1;
        }
      }
      function Ru(t, e) {
        return (
          (Ru = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (t, e) {
              return (t.__proto__ = e), t;
            }),
          Ru(t, e)
        );
      }
      function Iu(t) {
        return (
          (Iu = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
          Iu(t)
        );
      }
      var zu = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Ru(t, e);
        })(a, t);
        var e,
          r,
          n,
          i,
          o =
            ((e = a),
              (r = ju()),
              function () {
                var t,
                  n = Iu(e);
                if (r) {
                  var i = Iu(this).constructor;
                  t = Reflect.construct(n, arguments, i);
                } else t = n.apply(this, arguments);
                return Cu(this, t);
              });
        function a() {
          var t;
          return (
            (function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            })(this, a),
            ((t = o.call(this)).el = Lu(t)),
            (t.display = t.querySelector("[data-time-display]")),
            (t.block = t.closest(".countdown__block--timer")),
            (t.year = t.el.dataset.year),
            (t.month = t.el.dataset.month),
            (t.day = t.el.dataset.day),
            (t.hour = t.el.dataset.hour),
            (t.minute = t.el.dataset.minute),
            (t.daysPlaceholder = t.querySelector("[date-days-placeholder]")),
            (t.hoursPlaceholder = t.querySelector("[date-hours-placeholder]")),
            (t.minutesPlaceholder = t.querySelector("[date-minutes-placeholder]")),
            (t.secondsPlaceholder = t.querySelector("[date-seconds-placeholder]")),
            (t.messagePlaceholder = t.querySelector("[data-message-placeholder]")),
            (t.preLaunchCta = t.querySelector("[data-pre-cta]")),
            (t.postLaunchCta = t.querySelector("[data-post-cta]")),
            (t.hideTimerOnComplete = t.el.dataset.hideTimer),
            (t.timerComplete = !1),
            t.init(),
            t
          );
        }
        return (
          (n = a),
          (i = [
            {
              key: "init",
              value: function () {
                var t = this;
                setInterval(function () {
                  t.timerComplete || t._calculate();
                }, 1e3);
              },
            },
            {
              key: "_calculate",
              value: function () {
                var t = +new Date("".concat(this.month, "/").concat(this.day, "/").concat(this.year, " ").concat(this.hour, ":").concat(this.minute, ":00")).getTime() - +new Date().getTime();
                if (t > 0) {
                  var e = { days: Math.floor(t / 864e5), hours: Math.floor((t / 36e5) % 24), minutes: Math.floor((t / 1e3 / 60) % 60), seconds: Math.floor((t / 1e3) % 60) };
                  this.daysPlaceholder && (this.daysPlaceholder.innerHTML = e.days),
                    this.hoursPlaceholder && (this.hoursPlaceholder.innerHTML = e.hours),
                    this.minutesPlaceholder && (this.minutesPlaceholder.innerHTML = e.minutes),
                    this.secondsPlaceholder && (this.secondsPlaceholder.innerHTML = e.seconds);
                } else this.preLaunchCta && this.preLaunchCta.classList.add("hidden"), this.postLaunchCta && this.postLaunchCta.classList.remove("hidden"), (this.timerComplete = !0);
              },
            },
          ]) && Au(n.prototype, i),
          Object.defineProperty(n, "prototype", { writable: !1 }),
          a
        );
      })(ku(HTMLElement));
      function Du(t) {
        return (
          (Du =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                return typeof t;
              }
              : function (t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
              }),
          Du(t)
        );
      }
      function Bu(t, e) {
        if (e && ("object" === Du(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return Fu(t);
      }
      function Fu(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }
      function Gu(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
          (Gu = function (t) {
            if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
            var r;
            if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== e) {
              if (e.has(t)) return e.get(t);
              e.set(t, n);
            }
            function n() {
              return Nu(t, arguments, Vu(this).constructor);
            }
            return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), Hu(n, t);
          }),
          Gu(t)
        );
      }
      function Nu(t, e, r) {
        return (
          (Nu = Yu()
            ? Reflect.construct.bind()
            : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && Hu(i, r.prototype), i;
            }),
          Nu.apply(null, arguments)
        );
      }
      function Yu() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { })), !0;
        } catch (t) {
          return !1;
        }
      }
      function Hu(t, e) {
        return (
          (Hu = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (t, e) {
              return (t.__proto__ = e), t;
            }),
          Hu(t, e)
        );
      }
      function Vu(t) {
        return (
          (Vu = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
          Vu(t)
        );
      }
      var qu = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Hu(t, e);
        })(a, t);
        var e,
          r,
          n,
          o =
            ((e = a),
              (r = Yu()),
              function () {
                var t,
                  n = Vu(e);
                if (r) {
                  var i = Vu(this).constructor;
                  t = Reflect.construct(n, arguments, i);
                } else t = n.apply(this, arguments);
                return Bu(this, t);
              });
        function a() {
          var t;
          !(function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          })(this, a);
          var e = i("[data-faq]", Fu((t = o.call(this)))),
            r = i("[data-section-toggle]", Fu(t)),
            n = !0,
            s = "c-faq--toggle",
            l = "c-faq__wrapper--opened";
          return (
            e.listen("click", function (t) {
              var r = t.$node,
                n = r.classList.contains(l);
              e.modifyClass("remove", l), n || r.modifyClass("add", l);
            }),
            r.listen("click", function (e) {
              e.$node, r && n ? (t.classList.remove(s), (n = !1)) : (t.classList.add(s), (n = !0));
            }),
            t
          );
        }
        return (n = a), Object.defineProperty(n, "prototype", { writable: !1 }), n;
      })(Gu(HTMLElement));
      function $u(t) {
        return (
          ($u =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                return typeof t;
              }
              : function (t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
              }),
          $u(t)
        );
      }
      function Xu(t, e) {
        if (e && ("object" === $u(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return Wu(t);
      }
      function Wu(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }
      function Uu(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
          (Uu = function (t) {
            if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
            var r;
            if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== e) {
              if (e.has(t)) return e.get(t);
              e.set(t, n);
            }
            function n() {
              return Zu(t, arguments, Ju(this).constructor);
            }
            return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), Ku(n, t);
          }),
          Uu(t)
        );
      }
      function Zu(t, e, r) {
        return (
          (Zu = Qu()
            ? Reflect.construct.bind()
            : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && Ku(i, r.prototype), i;
            }),
          Zu.apply(null, arguments)
        );
      }
      function Qu() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { })), !0;
        } catch (t) {
          return !1;
        }
      }
      function Ku(t, e) {
        return (
          (Ku = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (t, e) {
              return (t.__proto__ = e), t;
            }),
          Ku(t, e)
        );
      }
      function Ju(t) {
        return (
          (Ju = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
          Ju(t)
        );
      }
      var tp = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Ku(t, e);
        })(a, t);
        var e,
          r,
          n,
          o =
            ((e = a),
              (r = Qu()),
              function () {
                var t,
                  n = Ju(e);
                if (r) {
                  var i = Ju(this).constructor;
                  t = Reflect.construct(n, arguments, i);
                } else t = n.apply(this, arguments);
                return Xu(this, t);
              });
        function a() {
          var t;
          !(function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          })(this, a),
            (t = o.call(this)),
            qo.registerPlugin(Wl);
          var e = i("[data-lifestyle]", Wu(t)),
            r = i("[data-tile]", Wu(t));
          return (
            qo.set(r, { yPercent: 8, opacity: 0 }),
            qo.timeline({ scrollTrigger: { trigger: e, start: "top-=1000px top", end: "bottom bottom" } }).to(r, { yPercent: 0, opacity: 1, duration: 0.5, ease: "power2.out", stagger: 0.5 }),
            t
          );
        }
        return (n = a), Object.defineProperty(n, "prototype", { writable: !1 }), n;
      })(Uu(HTMLElement));
      function ep(t) {
        return (
          (ep =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                return typeof t;
              }
              : function (t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
              }),
          ep(t)
        );
      }
      function rp() {
        rp = function () {
          return t;
        };
        var t = {},
          e = Object.prototype,
          r = e.hasOwnProperty,
          n =
            Object.defineProperty ||
            function (t, e, r) {
              t[e] = r.value;
            },
          i = "function" == typeof Symbol ? Symbol : {},
          o = i.iterator || "@@iterator",
          a = i.asyncIterator || "@@asyncIterator",
          s = i.toStringTag || "@@toStringTag";
        function l(t, e, r) {
          return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e];
        }
        try {
          l({}, "");
        } catch (t) {
          l = function (t, e, r) {
            return (t[e] = r);
          };
        }
        function c(t, e, r, i) {
          var o = e && e.prototype instanceof f ? e : f,
            a = Object.create(o.prototype),
            s = new S(i || []);
          return n(a, "_invoke", { value: _(t, r, s) }), a;
        }
        function u(t, e, r) {
          try {
            return { type: "normal", arg: t.call(e, r) };
          } catch (t) {
            return { type: "throw", arg: t };
          }
        }
        t.wrap = c;
        var p = {};
        function f() { }
        function d() { }
        function h() { }
        var v = {};
        l(v, o, function () {
          return this;
        });
        var m = Object.getPrototypeOf,
          y = m && m(m(O([])));
        y && y !== e && r.call(y, o) && (v = y);
        var g = (h.prototype = f.prototype = Object.create(v));
        function b(t) {
          ["next", "throw", "return"].forEach(function (e) {
            l(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }
        function w(t, e) {
          function i(n, o, a, s) {
            var l = u(t[n], t, o);
            if ("throw" !== l.type) {
              var c = l.arg,
                p = c.value;
              return p && "object" == ep(p) && r.call(p, "__await")
                ? e.resolve(p.__await).then(
                  function (t) {
                    i("next", t, a, s);
                  },
                  function (t) {
                    i("throw", t, a, s);
                  }
                )
                : e.resolve(p).then(
                  function (t) {
                    (c.value = t), a(c);
                  },
                  function (t) {
                    return i("throw", t, a, s);
                  }
                );
            }
            s(l.arg);
          }
          var o;
          n(this, "_invoke", {
            value: function (t, r) {
              function n() {
                return new e(function (e, n) {
                  i(t, r, e, n);
                });
              }
              return (o = o ? o.then(n, n) : n());
            },
          });
        }
        function _(t, e, r) {
          var n = "suspendedStart";
          return function (i, o) {
            if ("executing" === n) throw new Error("Generator is already running");
            if ("completed" === n) {
              if ("throw" === i) throw o;
              return { value: void 0, done: !0 };
            }
            for (r.method = i, r.arg = o; ;) {
              var a = r.delegate;
              if (a) {
                var s = x(a, r);
                if (s) {
                  if (s === p) continue;
                  return s;
                }
              }
              if ("next" === r.method) r.sent = r._sent = r.arg;
              else if ("throw" === r.method) {
                if ("suspendedStart" === n) throw ((n = "completed"), r.arg);
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              n = "executing";
              var l = u(t, e, r);
              if ("normal" === l.type) {
                if (((n = r.done ? "completed" : "suspendedYield"), l.arg === p)) continue;
                return { value: l.arg, done: r.done };
              }
              "throw" === l.type && ((n = "completed"), (r.method = "throw"), (r.arg = l.arg));
            }
          };
        }
        function x(t, e) {
          var r = e.method,
            n = t.iterator[r];
          if (void 0 === n)
            return (
              (e.delegate = null),
              ("throw" === r && t.iterator.return && ((e.method = "return"), (e.arg = void 0), x(t, e), "throw" === e.method)) ||
              ("return" !== r && ((e.method = "throw"), (e.arg = new TypeError("The iterator does not provide a '" + r + "' method")))),
              p
            );
          var i = u(n, t.iterator, e.arg);
          if ("throw" === i.type) return (e.method = "throw"), (e.arg = i.arg), (e.delegate = null), p;
          var o = i.arg;
          return o
            ? o.done
              ? ((e[t.resultName] = o.value), (e.next = t.nextLoc), "return" !== e.method && ((e.method = "next"), (e.arg = void 0)), (e.delegate = null), p)
              : o
            : ((e.method = "throw"), (e.arg = new TypeError("iterator result is not an object")), (e.delegate = null), p);
        }
        function T(t) {
          var e = { tryLoc: t[0] };
          1 in t && (e.catchLoc = t[1]), 2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])), this.tryEntries.push(e);
        }
        function E(t) {
          var e = t.completion || {};
          (e.type = "normal"), delete e.arg, (t.completion = e);
        }
        function S(t) {
          (this.tryEntries = [{ tryLoc: "root" }]), t.forEach(T, this), this.reset(!0);
        }
        function O(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) {
              var n = -1,
                i = function e() {
                  for (; ++n < t.length;) if (r.call(t, n)) return (e.value = t[n]), (e.done = !1), e;
                  return (e.value = void 0), (e.done = !0), e;
                };
              return (i.next = i);
            }
          }
          return { next: P };
        }
        function P() {
          return { value: void 0, done: !0 };
        }
        return (
          (d.prototype = h),
          n(g, "constructor", { value: h, configurable: !0 }),
          n(h, "constructor", { value: d, configurable: !0 }),
          (d.displayName = l(h, s, "GeneratorFunction")),
          (t.isGeneratorFunction = function (t) {
            var e = "function" == typeof t && t.constructor;
            return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
          }),
          (t.mark = function (t) {
            return Object.setPrototypeOf ? Object.setPrototypeOf(t, h) : ((t.__proto__ = h), l(t, s, "GeneratorFunction")), (t.prototype = Object.create(g)), t;
          }),
          (t.awrap = function (t) {
            return { __await: t };
          }),
          b(w.prototype),
          l(w.prototype, a, function () {
            return this;
          }),
          (t.AsyncIterator = w),
          (t.async = function (e, r, n, i, o) {
            void 0 === o && (o = Promise);
            var a = new w(c(e, r, n, i), o);
            return t.isGeneratorFunction(r)
              ? a
              : a.next().then(function (t) {
                return t.done ? t.value : a.next();
              });
          }),
          b(g),
          l(g, s, "Generator"),
          l(g, o, function () {
            return this;
          }),
          l(g, "toString", function () {
            return "[object Generator]";
          }),
          (t.keys = function (t) {
            var e = Object(t),
              r = [];
            for (var n in e) r.push(n);
            return (
              r.reverse(),
              function t() {
                for (; r.length;) {
                  var n = r.pop();
                  if (n in e) return (t.value = n), (t.done = !1), t;
                }
                return (t.done = !0), t;
              }
            );
          }),
          (t.values = O),
          (S.prototype = {
            constructor: S,
            reset: function (t) {
              if (((this.prev = 0), (this.next = 0), (this.sent = this._sent = void 0), (this.done = !1), (this.delegate = null), (this.method = "next"), (this.arg = void 0), this.tryEntries.forEach(E), !t))
                for (var e in this) "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            },
            stop: function () {
              this.done = !0;
              var t = this.tryEntries[0].completion;
              if ("throw" === t.type) throw t.arg;
              return this.rval;
            },
            dispatchException: function (t) {
              if (this.done) throw t;
              var e = this;
              function n(r, n) {
                return (a.type = "throw"), (a.arg = t), (e.next = r), n && ((e.method = "next"), (e.arg = void 0)), !!n;
              }
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var o = this.tryEntries[i],
                  a = o.completion;
                if ("root" === o.tryLoc) return n("end");
                if (o.tryLoc <= this.prev) {
                  var s = r.call(o, "catchLoc"),
                    l = r.call(o, "finallyLoc");
                  if (s && l) {
                    if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
                    if (this.prev < o.finallyLoc) return n(o.finallyLoc);
                  } else if (s) {
                    if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
                  } else {
                    if (!l) throw new Error("try statement without catch or finally");
                    if (this.prev < o.finallyLoc) return n(o.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (t, e) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var i = this.tryEntries[n];
                if (i.tryLoc <= this.prev && r.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                  var o = i;
                  break;
                }
              }
              o && ("break" === t || "continue" === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
              var a = o ? o.completion : {};
              return (a.type = t), (a.arg = e), o ? ((this.method = "next"), (this.next = o.finallyLoc), p) : this.complete(a);
            },
            complete: function (t, e) {
              if ("throw" === t.type) throw t.arg;
              return (
                "break" === t.type || "continue" === t.type
                  ? (this.next = t.arg)
                  : "return" === t.type
                    ? ((this.rval = this.arg = t.arg), (this.method = "return"), (this.next = "end"))
                    : "normal" === t.type && e && (this.next = e),
                p
              );
            },
            finish: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), E(r), p;
              }
            },
            catch: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                  var n = r.completion;
                  if ("throw" === n.type) {
                    var i = n.arg;
                    E(r);
                  }
                  return i;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (t, e, r) {
              return (this.delegate = { iterator: O(t), resultName: e, nextLoc: r }), "next" === this.method && (this.arg = void 0), p;
            },
          }),
          t
        );
      }
      function np(t, e, r, n, i, o, a) {
        try {
          var s = t[o](a),
            l = s.value;
        } catch (t) {
          return void r(t);
        }
        s.done ? e(l) : Promise.resolve(l).then(n, i);
      }
      function ip(t) {
        return function () {
          var e = this,
            r = arguments;
          return new Promise(function (n, i) {
            var o = t.apply(e, r);
            function a(t) {
              np(o, n, i, a, s, "next", t);
            }
            function s(t) {
              np(o, n, i, a, s, "throw", t);
            }
            a(void 0);
          });
        };
      }
      function op(t, e) {
        if (e && ("object" === ep(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return ap(t);
      }
      function ap(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }
      function sp(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
          (sp = function (t) {
            if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
            var r;
            if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== e) {
              if (e.has(t)) return e.get(t);
              e.set(t, n);
            }
            function n() {
              return lp(t, arguments, pp(this).constructor);
            }
            return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), up(n, t);
          }),
          sp(t)
        );
      }
      function lp(t, e, r) {
        return (
          (lp = cp()
            ? Reflect.construct.bind()
            : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && up(i, r.prototype), i;
            }),
          lp.apply(null, arguments)
        );
      }
      function cp() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { })), !0;
        } catch (t) {
          return !1;
        }
      }
      function up(t, e) {
        return (
          (up = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (t, e) {
              return (t.__proto__ = e), t;
            }),
          up(t, e)
        );
      }
      function pp(t) {
        return (
          (pp = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
          pp(t)
        );
      }
      var fp = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && up(t, e);
        })(a, t);
        var e,
          r,
          n,
          o =
            ((e = a),
              (r = cp()),
              function () {
                var t,
                  n = pp(e);
                if (r) {
                  var i = pp(this).constructor;
                  t = Reflect.construct(n, arguments, i);
                } else t = n.apply(this, arguments);
                return op(this, t);
              });
        function a() {
          var t;
          !(function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          })(this, a);
          var e = i("[data-load-more]", ap((t = o.call(this)))),
            r = i("[data-button-text]", e),
            n = i("[data-spinner]", e),
            s = i("[data-product-grid]"),
            l = "u-hide",
            c = s.dataset.nextUrl;
          function u() {
            return p.apply(this, arguments);
          }
          function p() {
            return (
              (p = ip(
                rp().mark(function t() {
                  var e;
                  return rp().wrap(
                    function (t) {
                      for (; ;)
                        switch ((t.prev = t.next)) {
                          case 0:
                            return (t.prev = 0), (t.next = 3), fetch(c);
                          case 3:
                            return (e = t.sent), (t.next = 6), e.text();
                          case 6:
                            return t.abrupt("return", t.sent);
                          case 9:
                            (t.prev = 9), (t.t0 = t.catch(0)), console.log(t.t0);
                          case 12:
                          case "end":
                            return t.stop();
                        }
                    },
                    t,
                    null,
                    [[0, 9]]
                  );
                })
              )),
              p.apply(this, arguments)
            );
          }
          function f() {
            return (f = ip(
              rp().mark(function t() {
                var i, o, a, p, f, d;
                return rp().wrap(function (t) {
                  for (; ;)
                    switch ((t.prev = t.next)) {
                      case 0:
                        return r.modifyClass("add", l), n.modifyClass("remove", l), (t.next = 4), u();
                      case 4:
                        (i = t.sent),
                          (o = new DOMParser()),
                          (a = o.parseFromString(i, "text/html")),
                          n.modifyClass("add", l),
                          (p = a.getElementById("product-grid")),
                          (f = p.getElementsByClassName("grid__item")),
                          (d = p.dataset.nextUrl) ? (r.modifyClass("remove", l), e.blur()) : e.modifyClass("add", l),
                          (c = d),
                          Array.from(f).forEach(function (t) {
                            s.appendChild(t);
                          });
                      case 14:
                      case "end":
                        return t.stop();
                    }
                }, t);
              })
            )).apply(this, arguments);
          }
          return (
            e.listen("click", function () {
              return (function () {
                return f.apply(this, arguments);
              })();
            }),
            t
          );
        }
        return (n = a), Object.defineProperty(n, "prototype", { writable: !1 }), n;
      })(sp(HTMLElement));
      function dp(t) {
        return (
          (dp =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                return typeof t;
              }
              : function (t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
              }),
          dp(t)
        );
      }
      function hp(t, e) {
        if (e && ("object" === dp(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return vp(t);
      }
      function vp(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }
      function mp(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
          (mp = function (t) {
            if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
            var r;
            if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== e) {
              if (e.has(t)) return e.get(t);
              e.set(t, n);
            }
            function n() {
              return yp(t, arguments, wp(this).constructor);
            }
            return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), bp(n, t);
          }),
          mp(t)
        );
      }
      function yp(t, e, r) {
        return (
          (yp = gp()
            ? Reflect.construct.bind()
            : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && bp(i, r.prototype), i;
            }),
          yp.apply(null, arguments)
        );
      }
      function gp() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { })), !0;
        } catch (t) {
          return !1;
        }
      }
      function bp(t, e) {
        return (
          (bp = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (t, e) {
              return (t.__proto__ = e), t;
            }),
          bp(t, e)
        );
      }
      function wp(t) {
        return (
          (wp = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
          wp(t)
        );
      }
      var _p = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && bp(t, e);
        })(a, t);
        var e,
          r,
          n,
          o =
            ((e = a),
              (r = gp()),
              function () {
                var t,
                  n = wp(e);
                if (r) {
                  var i = wp(this).constructor;
                  t = Reflect.construct(n, arguments, i);
                } else t = n.apply(this, arguments);
                return hp(this, t);
              });
        function a() {
          var t;
          !(function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          })(this, a);
          var e = i("[data-parent-link]", vp((t = o.call(this)))),
            r = i("body"),
            n = i("[data-nav-overlay]"),
            s = i("[data-announcement-bar]"),
            l = i("[data-dropdown-menu", vp(t)),
            c = i("[data-mobile-nav]"),
            u = i("[data-mobile-summary]"),
            p = i("[data-close-nav]", vp(t)),
            f = i("[data-mobile-close]", vp(t)),
            d = i("[data-continent-trigger]"),
            h = "c-countryPicker__continent--selected";
          function v() {
            r.modifyClass("remove", "nav-open"), r.modifyClass("remove", "nav-open--already"), l.modifyClass("remove", "open"), e.modifyClass("remove", "link-open"), n.modifyClass("remove", "c-navOverlay--visible");
          }
          return (
            e.listen("mouseenter", function (o) {
              var a = o.$node,
                s = a.dataset.parentLink;
              if ("blank" !== s) {
                var c = i('[data-dropdown-menu="'.concat(s, '"]'), vp(t));
                l.modifyClass("remove", "open"),
                  e.modifyClass("remove", "link-open"),
                  a.modifyClass("add", "link-open"),
                  r.modifyClass("add", "nav-open"),
                  c.modifyClass("add", "open"),
                  n.modifyClass("add", "c-navOverlay--visible"),
                  setTimeout(function () {
                    r.modifyClass("add", "nav-open--already");
                  }, 500);
              } else v();
            }),
            n.listen("mouseover", function () {
              v();
            }),
            s.listen("mouseover", function () {
              v();
            }),
            p.listen("click", function () {
              v();
            }),
            f.listen("click", function () {
              c.modifyClass("remove", "menu-opening"),
                u.setAttribute("aria-expanded", !1),
                document.body.modifyClass("remove", "overflow-hidden-tablet"),
                setTimeout(function () {
                  c.removeAttribute("open");
                }, 1e3);
            }),
            d.listen("click", function (t) {
              var e = t.$node,
                r = e.parentNode.classList.contains(h);
              d.forEach(function (t) {
                return t.parentNode.classList.remove(h);
              }),
                r || e.parentNode.classList.add(h);
            }),
            t
          );
        }
        return (n = a), Object.defineProperty(n, "prototype", { writable: !1 }), n;
      })(mp(HTMLElement));
      function xp(t) {
        return (
          (xp =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                return typeof t;
              }
              : function (t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
              }),
          xp(t)
        );
      }
      function Tp(t, e) {
        if (e && ("object" === xp(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return Ep(t);
      }
      function Ep(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }
      function Sp(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
          (Sp = function (t) {
            if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
            var r;
            if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== e) {
              if (e.has(t)) return e.get(t);
              e.set(t, n);
            }
            function n() {
              return Op(t, arguments, Cp(this).constructor);
            }
            return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), Ap(n, t);
          }),
          Sp(t)
        );
      }
      function Op(t, e, r) {
        return (
          (Op = Pp()
            ? Reflect.construct.bind()
            : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && Ap(i, r.prototype), i;
            }),
          Op.apply(null, arguments)
        );
      }
      function Pp() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { })), !0;
        } catch (t) {
          return !1;
        }
      }
      function Ap(t, e) {
        return (
          (Ap = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (t, e) {
              return (t.__proto__ = e), t;
            }),
          Ap(t, e)
        );
      }
      function Cp(t) {
        return (
          (Cp = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
          Cp(t)
        );
      }
      var Lp = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Ap(t, e);
        })(a, t);
        var e,
          r,
          n,
          o =
            ((e = a),
              (r = Pp()),
              function () {
                var t,
                  n = Cp(e);
                if (r) {
                  var i = Cp(this).constructor;
                  t = Reflect.construct(n, arguments, i);
                } else t = n.apply(this, arguments);
                return Tp(this, t);
              });
        function a() {
          var t;
          !(function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          })(this, a),
            (t = o.call(this));
          var e,
            r,
            n,
            s = i("body"),
            l = i("[data-modal]", Ep(t)),
            c = i("[data-modal-trigger]"),
            u = i("[data-video-carousel]", Ep(t)),
            p = i("[data-modal-video]", Ep(t)),
            f = i("[data-carousel-page]", Ep(t)),
            d = i("[data-carousel-total]", Ep(t)),
            h = "c-linkCard__videoWrapper--playing",
            v = i("[data-product-gallery]", Ep(t)),
            m = i("[data-gallery-thumbs]", Ep(t));
          m.childNodes && m.childNodes.length && (r = new _t(m, { slidesPerView: 10, direction: "vertical" }));
          var y = { modules: [Pt, xt, At], slidesPerView: 1, spaceBetween: 24, direction: "vertical", mousewheel: !0, scrollbar: { el: ".swiper-scrollbar", draggable: !0 }, thumbs: { swiper: r } };
          return (
            v.childNodes && v.childNodes.length && (n = new _t(v, y)),
            u.childNodes &&
            u.childNodes.length &&
            (e = new _t(u, {
              modules: [Et],
              slidesPerView: 1,
              spaceBetween: 24,
              loop: !0,
              navigation: { prevEl: "[data-prev-modal]", nextEl: "[data-next-modal]" },
              on: {
                init: function (t) {
                  var e = t.slides.length;
                  d.textContent = e;
                },
                slideChangeTransitionEnd: function (t) {
                  var e = t.realIndex + 1;
                  f.textContent = e;
                  var r = i('[data-modal-video="'.concat(e, '"]'));
                  (r.currentTime = 0), r.play(), r.parentElement.classList.add(h);
                },
              },
            })),
            c.listen("click", function (t) {
              var o = t.$node,
                a = o.dataset.modalTrigger,
                l = i('[data-modal="'.concat(a, '"]')),
                c = i("[data-modal-exit]");
              if (
                (s.modifyClass("add", "u-noScroll"),
                  l.modifyClass("add", "open"),
                  c.listen("click", function () {
                    s.modifyClass("remove", "u-noScroll"),
                      l.modifyClass("remove", "open"),
                      l.modifyClass("remove", "country-select--footer"),
                      p.forEach(function (t) {
                        t.pause(), t.parentElement.classList.remove(h);
                      });
                  }),
                  "video" === a)
              ) {
                var u = o.dataset.cardVideo;
                if (e) {
                  e.slideTo(u - 1, 0);
                  var f = i('[data-modal-video="'.concat(u, '"]'));
                  (f.currentTime = 0), f.play(), f.parentElement.classList.add(h);
                }
              }
              if ((o.hasAttribute("data-footer-trigger") && l.modifyClass("add", "country-select--footer"), "pdpLightbox" === a)) {
                var d = o.dataset.slideIndex;
                n && n.slideTo(d, 0, !1), r && r.slideTo(d, 0, !1);
              }
            }),
            p.listen("click", function (t) {
              var e = t.$node;
              e.paused ? (e.play(), e.parentElement.classList.add(h)) : (e.pause(), e.parentElement.classList.remove(h));
            }),
            (document.onkeydown = function (t) {
              ("key" in (t = t || window.event) ? "Escape" === t.key || "Esc" === t.key : 27 === t.keyCode) && (s.modifyClass("remove", "u-noScroll"), l.modifyClass("remove", "open"));
            }),
            t
          );
        }
        return (n = a), Object.defineProperty(n, "prototype", { writable: !1 }), n;
      })(Sp(HTMLElement));
      function kp(t) {
        return (
          (kp =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                return typeof t;
              }
              : function (t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
              }),
          kp(t)
        );
      }
      function Mp(t, e) {
        if (e && ("object" === kp(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return jp(t);
      }
      function jp(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }
      function Rp(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
          (Rp = function (t) {
            if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
            var r;
            if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== e) {
              if (e.has(t)) return e.get(t);
              e.set(t, n);
            }
            function n() {
              return Ip(t, arguments, Bp(this).constructor);
            }
            return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), Dp(n, t);
          }),
          Rp(t)
        );
      }
      function Ip(t, e, r) {
        return (
          (Ip = zp()
            ? Reflect.construct.bind()
            : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && Dp(i, r.prototype), i;
            }),
          Ip.apply(null, arguments)
        );
      }
      function zp() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { })), !0;
        } catch (t) {
          return !1;
        }
      }
      function Dp(t, e) {
        return (
          (Dp = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (t, e) {
              return (t.__proto__ = e), t;
            }),
          Dp(t, e)
        );
      }
      function Bp(t) {
        return (
          (Bp = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
          Bp(t)
        );
      }
      var Fp = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Dp(t, e);
        })(a, t);
        var e,
          r,
          n,
          o =
            ((e = a),
              (r = zp()),
              function () {
                var t,
                  n = Bp(e);
                if (r) {
                  var i = Bp(this).constructor;
                  t = Reflect.construct(n, arguments, i);
                } else t = n.apply(this, arguments);
                return Mp(this, t);
              });
        function a() {
          var t;
          !(function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          })(this, a);
          var e,
            r,
            n = i("[data-grid-item-swatch]", jp((t = o.call(this)))),
            s = i("[data-swatch-carousel]", jp(t)),
            l = "c-gridItem__wrapper--selected",
            c = s.dataset.cardsPerRow;
          return (
            c && 4 != c
              ? 3 == c &&
              ((e = 2),
                (r = {
                  450: { slidesPerView: 2 },
                  500: { slidesPerView: 5, slidesPerGroup: 3 },
                  550: { slidesPerView: 6 },
                  625: { slidesPerView: 7 },
                  675: { slidesPerView: 8, slidesPerGroup: 4 },
                  750: { slidesPerView: 9 },
                  767: { slidesPerView: 2, slidesPerGroup: 1 },
                  800: { slidesPerView: 3, slidesPerGroup: 2 },
                  925: { slidesPerView: 4 },
                  1150: { slidesPerView: 5 },
                  1300: { slidesPerView: 6, slidesPerGroup: 3 },
                  1400: { slidesPerView: 7 },
                }))
              : ((e = 2),
                (r = {
                  385: { slidesPerView: 3, slidesPerGroup: 1 },
                  500: { slidesPerView: 3 },
                  600: { slidesPerView: 4, slidesPerGroup: 2 },
                  675: { slidesPerView: 4 },
                  775: { slidesPerView: 3, slidesPerGroup: 1 },
                  860: { slidesPerView: 3 },
                  1175: { slidesPerView: 4 },
                  1350: { slidesPerView: 4, slidesPerGroup: 2 },
                  1500: { slidesPerView: 5 },
                })),
            new _t(s, {
              modules: [Et],
              slidesPerView: e,
              slidesPerGroup: 2,
              spaceBetween: 4,
              breakpoints: r,
              on: {
                init: function (t) {
                  var e = t.el.closest("[data-carousel-swatch-container]"),
                    r = i("[data-swatch-prev]", e),
                    n = i("[data-swatch-next]", e);
                  r.listen("click", function () {
                    t.el.swiper.slidePrev();
                  }),
                    n.listen("click", function () {
                      t.el.swiper.slideNext();
                    });
                },
                slideChange: function (t) {
                  var e = t.el.closest("[data-carousel-swatch-container]"),
                    r = i("[data-swatch-prev]", e),
                    n = i("[data-swatch-next]", e);
                  t.isBeginning ? r.modifyClass("add", "c-chevron--disabled") : r.modifyClass("remove", "c-chevron--disabled"),
                    t.isEnd ? n.modifyClass("add", "c-chevron--disabled") : n.modifyClass("remove", "c-chevron--disabled");
                },
              },
            }),
            n.listen("click", function (t) {
              !(function (t) {
                var e = t.dataset,
                  r = e.primaryImage,
                  n = e.productId,
                  o = e.variantId,
                  a = e.variantTitle,
                  s = e.badge,
                  c = e.badgeText,
                  u = e.productPrice,
                  p = e.productComparePrice,
                  f = e.valuePrice,
                  d = e.valueComparePrice,
                  h = e.isCustomizable,
                  v = e.variantUrl,
                  m = JSON.parse(t.dataset.available),
                  y = t.closest("[data-product-card]"),
                  g = t.closest("[data-carousel-container]"),
                  loggedEmployee = e.loggedEmployee,
                  foraDaLojinha = e.foraDaLojinha;
                g &&
                  i('[data-product-card][data-id="'.concat(n, '"]'), g).execute(function (t) {
                    i('[data-grid-item-swatch][data-variant-id="'.concat(o, '"]'), t).click();
                  });
                var b = y.querySelector("[data-atc-text]"),
                  w = y.querySelector("[data-atc-soldout]"),
                  _ = y.querySelector("[data-variant-input]"),
                  x = y.querySelector("[data-buy-button]"),
                  T = y.querySelector("[data-product-badge]"),
                  E = y.querySelectorAll("[data-badge-icon]"),
                  S = y.querySelector('[data-badge-icon="'.concat(s, '"]')),
                  O = i("[data-swatch-wrapper]", y),
                  P = i("[data-grid-item-url]", y),
                  A = i("[data-product-image]", y),
                  C = i("[data-product-color]", y),
                  L = i("[data-price]", y),
                  k = i("[data-compare-price]", y),
                  M = i("[data-selected-price-container]", y),
                  j = i("[data-starting-price-container]", y),
                  R = i("[data-customizable]", y), 
                  productForm = x.closest("product-form form"),
                  badge = y.querySelector('.c-gridItem__soldOutBadge'),
                  title = y.querySelector("[data-product-title]"),
                  discountPrice = Number(y.dataset.discountPrice),
                  haveDiscountPrice = discountPrice != 1 && discountPrice != '' && discountPrice != null;
                m
                  ? (f < d
                    ? (!T.textContent.includes("Black Friday - ") && 
                        (T.textContent = "Promoção",
                        T.dataset.productBadge = s,
                        T.classList.add("c-gridItem__sale"),
                        L.modifyClass("add", "u-colorRed")))
                    : (E.forEach(function (t) {
                      if(!T.textContent.includes("Black Friday - ")) t.classList.add("u-hide")
                    }),
                      T && T.classList.remove("c-gridItem__sale"),
                      s
                        ? ((T.textContent = c),
                          (T.dataset.productBadge = s),
                          s.includes("Ship") ? R.modifyClass("add", "c-gridItem__customize--shipping-badge") : R.modifyClass("remove", "c-gridItem__customize--shipping-badge"))
                        : (T && ((T.textContent = ""), (T.dataset.productBadge = "")), R.modifyClass("remove", "c-gridItem__customize--shipping-badge")),
                      L.modifyClass("remove", "u-colorRed")),
                    S && S.classList.remove("u-hide"),
                    (x.disabled = !1),
                    x.setAttribute("aria-disabled", !1),
                    badge && badge.classList.add("u-hide"),
                    b && b.classList.remove("u-hide"),
                    w && w.classList.add("u-hide"))
                  : (f < d
                    ? ((T.textContent = "Promoção"), (T.dataset.productBadge = s), T.classList.add("c-gridItem__sale"), L.modifyClass("add", "u-colorRed"))
                    : (E.forEach(function (t) {
                      t.classList.add("u-hide");
                    }),
                    T && T.classList.remove("c-gridItem__sale"),
                    s
                        ? ((T.textContent = c),
                          (T.dataset.productBadge = s),
                          s.includes("Ship") ? R.modifyClass("add", "c-gridItem__customize--shipping-badge") : R.modifyClass("remove", "c-gridItem__customize--shipping-badge"))
                        : (T && ((T.textContent = ""), (T.dataset.productBadge = "")), R.modifyClass("remove", "c-gridItem__customize--shipping-badge")),
                      
                      S && S.classList.remove("u-hide"),

                    badge && badge.classList.add("u-hide"),
                    x.disabled = !0), x.setAttribute("aria-disabled", !0), badge && badge.classList.remove("u-hide"), b && b.classList.add("u-hide"), w && w.classList.remove("u-hide")),
                  O.modifyClass("remove", l),
                  O.execute(function(element) {
                    var slide = element.closest('.swiper-slide');
                    if (slide) {
                      slide.setAttribute("aria-current", "false");
                    }
                  }),
                  t.parentNode.classList.add(l),
                  (function() {
                    var currentSlide = t.parentNode.closest('.swiper-slide');
                    if (currentSlide) {
                      currentSlide.setAttribute("aria-current", "true");
                    }
                  })(),
                  (A.src = r),
                  (title.textContent = a),
                  _ && (_.value = o),

                  (() => {
                    if (foraDaLojinha == 'true' || foraDaLojinha == true) {
                      productForm.querySelectorAll('.input-lojinha').forEach(item => item.remove());
                      productForm.querySelectorAll('.input-lojinha-representante').forEach(item => item.remove());
                    } else {
                      let inputClass
                      let inputValue
                      if (loggedEmployee == 'lojinha') {
                        inputClass = 'input-lojinha'
                        inputValue = 'lojinha'
                      } else {
                        inputClass = 'input-lojinha-representante'
                        inputValue = 'representante'
                      }

                      const input1 = document.createElement("input");
                      input1.type = "hidden";
                      input1.className = inputClass;
                      input1.name = "properties[_lojinha]";
                      input1.value = "true";
                      input1.setAttribute("data-lojinha-order", "");

                      const input2 = document.createElement("input");
                      input2.type = "hidden";
                      input2.className = inputClass;
                      input2.name = "properties[_custom_discount_price]";
                      input2.value = inputValue;
                      
                      productForm.appendChild(input1);
                      productForm.appendChild(input2);
                    }
                  })(),

                  haveDiscountPrice && (foraDaLojinha == 'false' || foraDaLojinha == false)
                  ? Number(d) !== 0 
                    ? (k.textContent = p)
                    : (k.textContent = u)
                  : Number(d) !== 0 
                    ? (k.textContent = p)
                    : (k.textContent = ''),

                  haveDiscountPrice && (foraDaLojinha == 'false' || foraDaLojinha == false)
                  ? Number(d) !== 0
                    ? (L.textContent = (d * discountPrice / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }))
                    : (L.textContent = (f * discountPrice / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })) 
                  : (L.textContent = u),

                  P.forEach(function (t) {
                    t.href = v;
                  }),
                  j.modifyClass("add", "u-hide"),
                  M.modifyClass("remove", "u-hide"),
                  x.classList.remove("u-hide"),
                  "true" === h ? R.modifyClass("remove", "c-gridItem__customize--disabled") : R.modifyClass("add", "c-gridItem__customize--disabled");
              })(t.$node);
            }),
            n.listen("mouseover", function (t) {
              var e = t.$node,
                r = e.dataset.variantColor;
              i("[data-product-color]", e.closest("[data-product-card]")).textContent = r;
            }),
            n.listen("mouseleave", function (t) {
              var e = i("[data-product-color]", t.$node.closest("[data-product-card]")),
                r = e.dataset.productColor;
              e.textContent = r;
            }),
            t
          );
        }
        return (n = a), Object.defineProperty(n, "prototype", { writable: !1 }), n;
      })(Rp(HTMLElement));
      function Gp(t) {
        return (
          (Gp =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                return typeof t;
              }
              : function (t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
              }),
          Gp(t)
        );
      }
      function Np(t, e) {
        if (e && ("object" === Gp(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return Yp(t);
      }
      function Yp(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }
      function Hp(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
          (Hp = function (t) {
            if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
            var r;
            if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== e) {
              if (e.has(t)) return e.get(t);
              e.set(t, n);
            }
            function n() {
              return Vp(t, arguments, Xp(this).constructor);
            }
            return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), $p(n, t);
          }),
          Hp(t)
        );
      }
      function Vp(t, e, r) {
        return (
          (Vp = qp()
            ? Reflect.construct.bind()
            : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && $p(i, r.prototype), i;
            }),
          Vp.apply(null, arguments)
        );
      }
      function qp() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { })), !0;
        } catch (t) {
          return !1;
        }
      }
      function $p(t, e) {
        return (
          ($p = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (t, e) {
              return (t.__proto__ = e), t;
            }),
          $p(t, e)
        );
      }
      function Xp(t) {
        return (
          (Xp = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
          Xp(t)
        );
      }
      var Wp = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && $p(t, e);
        })(a, t);
        var e,
          r,
          n,
          o =
            ((e = a),
              (r = qp()),
              function () {
                var t,
                  n = Xp(e);
                if (r) {
                  var i = Xp(this).constructor;
                  t = Reflect.construct(n, arguments, i);
                } else t = n.apply(this, arguments);
                return Np(this, t);
              });
        function a() {
          var t;
          !(function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          })(this, a);
          var e = i("[data-size]", Yp((t = o.call(this)))),
            r = i("[data-link]", Yp(t)),
            n = i("[data-price-display]", Yp(t)),
            s = i("[data-size-display]", Yp(t)),
            l = i("[data-product-image]", Yp(t)),
            c = i("[data-variant-input]", Yp(t)),
            u = i("[data-buy-button]", Yp(t)),
            p = i(".sold-out-message", u),
            f = "c-btn--selected",
            d = "c-btn--disabled";
          return (
            e.listen("click", function (t) {
              var i = t.$node,
                o = i.dataset,
                a = o.size,
                h = o.price,
                v = o.variant,
                m = o.url,
                y = o.image,
                g = o.inventory,
                b = o.inventoryPolicy,
                w = "".concat(m, "?variant=").concat(v);
              if ((e.modifyClass("remove", f), i.modifyClass("add", f), (n.textContent = h), (s.textContent = a), (c.value = v), (r.href = w), (l.src = y), g < 1 && "deny" === b)) {
                if (!p) return;
                u.setAttribute("aria-disabled", !0), u.modifyClass("add", d), u.querySelector("span").classList.add("hidden"), (u.disabled = !0), p.modifyClass("remove", "hidden");
              } else {
                if (!p) return;
                u.setAttribute("aria-disabled", !1), u.modifyClass("remove", d), u.querySelector("span").classList.remove("hidden"), (u.disabled = !1), p.modifyClass("add", "hidden");
              }
            }),
            t
          );
        }
        return (n = a), Object.defineProperty(n, "prototype", { writable: !1 }), n;
      })(Hp(HTMLElement));
      function Up(t) {
        return (
          (Up =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                return typeof t;
              }
              : function (t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
              }),
          Up(t)
        );
      }
      function Zp(t, e) {
        var r = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(t);
          e &&
            (n = n.filter(function (e) {
              return Object.getOwnPropertyDescriptor(t, e).enumerable;
            })),
            r.push.apply(r, n);
        }
        return r;
      }
      function Qp(t) {
        for (var e = 1; e < arguments.length; e++) {
          var r = null != arguments[e] ? arguments[e] : {};
          e % 2
            ? Zp(Object(r), !0).forEach(function (e) {
              uf(t, e, r[e]);
            })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r))
              : Zp(Object(r)).forEach(function (e) {
                Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
              });
        }
        return t;
      }
      function Kp() {
        Kp = function () {
          return t;
        };
        var t = {},
          e = Object.prototype,
          r = e.hasOwnProperty,
          n =
            Object.defineProperty ||
            function (t, e, r) {
              t[e] = r.value;
            },
          i = "function" == typeof Symbol ? Symbol : {},
          o = i.iterator || "@@iterator",
          a = i.asyncIterator || "@@asyncIterator",
          s = i.toStringTag || "@@toStringTag";
        function l(t, e, r) {
          return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e];
        }
        try {
          l({}, "");
        } catch (t) {
          l = function (t, e, r) {
            return (t[e] = r);
          };
        }
        function c(t, e, r, i) {
          var o = e && e.prototype instanceof f ? e : f,
            a = Object.create(o.prototype),
            s = new S(i || []);
          return n(a, "_invoke", { value: _(t, r, s) }), a;
        }
        function u(t, e, r) {
          try {
            return { type: "normal", arg: t.call(e, r) };
          } catch (t) {
            return { type: "throw", arg: t };
          }
        }
        t.wrap = c;
        var p = {};
        function f() { }
        function d() { }
        function h() { }
        var v = {};
        l(v, o, function () {
          return this;
        });
        var m = Object.getPrototypeOf,
          y = m && m(m(O([])));
        y && y !== e && r.call(y, o) && (v = y);
        var g = (h.prototype = f.prototype = Object.create(v));
        function b(t) {
          ["next", "throw", "return"].forEach(function (e) {
            l(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }
        function w(t, e) {
          function i(n, o, a, s) {
            var l = u(t[n], t, o);
            if ("throw" !== l.type) {
              var c = l.arg,
                p = c.value;
              return p && "object" == Up(p) && r.call(p, "__await")
                ? e.resolve(p.__await).then(
                  function (t) {
                    i("next", t, a, s);
                  },
                  function (t) {
                    i("throw", t, a, s);
                  }
                )
                : e.resolve(p).then(
                  function (t) {
                    (c.value = t), a(c);
                  },
                  function (t) {
                    return i("throw", t, a, s);
                  }
                );
            }
            s(l.arg);
          }
          var o;
          n(this, "_invoke", {
            value: function (t, r) {
              function n() {
                return new e(function (e, n) {
                  i(t, r, e, n);
                });
              }
              return (o = o ? o.then(n, n) : n());
            },
          });
        }
        function _(t, e, r) {
          var n = "suspendedStart";
          return function (i, o) {
            if ("executing" === n) throw new Error("Generator is already running");
            if ("completed" === n) {
              if ("throw" === i) throw o;
              return { value: void 0, done: !0 };
            }
            for (r.method = i, r.arg = o; ;) {
              var a = r.delegate;
              if (a) {
                var s = x(a, r);
                if (s) {
                  if (s === p) continue;
                  return s;
                }
              }
              if ("next" === r.method) r.sent = r._sent = r.arg;
              else if ("throw" === r.method) {
                if ("suspendedStart" === n) throw ((n = "completed"), r.arg);
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              n = "executing";
              var l = u(t, e, r);
              if ("normal" === l.type) {
                if (((n = r.done ? "completed" : "suspendedYield"), l.arg === p)) continue;
                return { value: l.arg, done: r.done };
              }
              "throw" === l.type && ((n = "completed"), (r.method = "throw"), (r.arg = l.arg));
            }
          };
        }
        function x(t, e) {
          var r = e.method,
            n = t.iterator[r];
          if (void 0 === n)
            return (
              (e.delegate = null),
              ("throw" === r && t.iterator.return && ((e.method = "return"), (e.arg = void 0), x(t, e), "throw" === e.method)) ||
              ("return" !== r && ((e.method = "throw"), (e.arg = new TypeError("The iterator does not provide a '" + r + "' method")))),
              p
            );
          var i = u(n, t.iterator, e.arg);
          if ("throw" === i.type) return (e.method = "throw"), (e.arg = i.arg), (e.delegate = null), p;
          var o = i.arg;
          return o
            ? o.done
              ? ((e[t.resultName] = o.value), (e.next = t.nextLoc), "return" !== e.method && ((e.method = "next"), (e.arg = void 0)), (e.delegate = null), p)
              : o
            : ((e.method = "throw"), (e.arg = new TypeError("iterator result is not an object")), (e.delegate = null), p);
        }
        function T(t) {
          var e = { tryLoc: t[0] };
          1 in t && (e.catchLoc = t[1]), 2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])), this.tryEntries.push(e);
        }
        function E(t) {
          var e = t.completion || {};
          (e.type = "normal"), delete e.arg, (t.completion = e);
        }
        function S(t) {
          (this.tryEntries = [{ tryLoc: "root" }]), t.forEach(T, this), this.reset(!0);
        }
        function O(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) {
              var n = -1,
                i = function e() {
                  for (; ++n < t.length;) if (r.call(t, n)) return (e.value = t[n]), (e.done = !1), e;
                  return (e.value = void 0), (e.done = !0), e;
                };
              return (i.next = i);
            }
          }
          return { next: P };
        }
        function P() {
          return { value: void 0, done: !0 };
        }
        return (
          (d.prototype = h),
          n(g, "constructor", { value: h, configurable: !0 }),
          n(h, "constructor", { value: d, configurable: !0 }),
          (d.displayName = l(h, s, "GeneratorFunction")),
          (t.isGeneratorFunction = function (t) {
            var e = "function" == typeof t && t.constructor;
            return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
          }),
          (t.mark = function (t) {
            return Object.setPrototypeOf ? Object.setPrototypeOf(t, h) : ((t.__proto__ = h), l(t, s, "GeneratorFunction")), (t.prototype = Object.create(g)), t;
          }),
          (t.awrap = function (t) {
            return { __await: t };
          }),
          b(w.prototype),
          l(w.prototype, a, function () {
            return this;
          }),
          (t.AsyncIterator = w),
          (t.async = function (e, r, n, i, o) {
            void 0 === o && (o = Promise);
            var a = new w(c(e, r, n, i), o);
            return t.isGeneratorFunction(r)
              ? a
              : a.next().then(function (t) {
                return t.done ? t.value : a.next();
              });
          }),
          b(g),
          l(g, s, "Generator"),
          l(g, o, function () {
            return this;
          }),
          l(g, "toString", function () {
            return "[object Generator]";
          }),
          (t.keys = function (t) {
            var e = Object(t),
              r = [];
            for (var n in e) r.push(n);
            return (
              r.reverse(),
              function t() {
                for (; r.length;) {
                  var n = r.pop();
                  if (n in e) return (t.value = n), (t.done = !1), t;
                }
                return (t.done = !0), t;
              }
            );
          }),
          (t.values = O),
          (S.prototype = {
            constructor: S,
            reset: function (t) {
              if (((this.prev = 0), (this.next = 0), (this.sent = this._sent = void 0), (this.done = !1), (this.delegate = null), (this.method = "next"), (this.arg = void 0), this.tryEntries.forEach(E), !t))
                for (var e in this) "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            },
            stop: function () {
              this.done = !0;
              var t = this.tryEntries[0].completion;
              if ("throw" === t.type) throw t.arg;
              return this.rval;
            },
            dispatchException: function (t) {
              if (this.done) throw t;
              var e = this;
              function n(r, n) {
                return (a.type = "throw"), (a.arg = t), (e.next = r), n && ((e.method = "next"), (e.arg = void 0)), !!n;
              }
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var o = this.tryEntries[i],
                  a = o.completion;
                if ("root" === o.tryLoc) return n("end");
                if (o.tryLoc <= this.prev) {
                  var s = r.call(o, "catchLoc"),
                    l = r.call(o, "finallyLoc");
                  if (s && l) {
                    if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
                    if (this.prev < o.finallyLoc) return n(o.finallyLoc);
                  } else if (s) {
                    if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
                  } else {
                    if (!l) throw new Error("try statement without catch or finally");
                    if (this.prev < o.finallyLoc) return n(o.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (t, e) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var i = this.tryEntries[n];
                if (i.tryLoc <= this.prev && r.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                  var o = i;
                  break;
                }
              }
              o && ("break" === t || "continue" === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
              var a = o ? o.completion : {};
              return (a.type = t), (a.arg = e), o ? ((this.method = "next"), (this.next = o.finallyLoc), p) : this.complete(a);
            },
            complete: function (t, e) {
              if ("throw" === t.type) throw t.arg;
              return (
                "break" === t.type || "continue" === t.type
                  ? (this.next = t.arg)
                  : "return" === t.type
                    ? ((this.rval = this.arg = t.arg), (this.method = "return"), (this.next = "end"))
                    : "normal" === t.type && e && (this.next = e),
                p
              );
            },
            finish: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), E(r), p;
              }
            },
            catch: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                  var n = r.completion;
                  if ("throw" === n.type) {
                    var i = n.arg;
                    E(r);
                  }
                  return i;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (t, e, r) {
              return (this.delegate = { iterator: O(t), resultName: e, nextLoc: r }), "next" === this.method && (this.arg = void 0), p;
            },
          }),
          t
        );
      }
      function Jp(t, e, r, n, i, o, a) {
        try {
          var s = t[o](a),
            l = s.value;
        } catch (t) {
          return void r(t);
        }
        s.done ? e(l) : Promise.resolve(l).then(n, i);
      }
      function tf(t) {
        return function () {
          var e = this,
            r = arguments;
          return new Promise(function (n, i) {
            var o = t.apply(e, r);
            function a(t) {
              Jp(o, n, i, a, s, "next", t);
            }
            function s(t) {
              Jp(o, n, i, a, s, "throw", t);
            }
            a(void 0);
          });
        };
      }
      function ef(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          (n.enumerable = n.enumerable || !1), (n.configurable = !0), "value" in n && (n.writable = !0), Object.defineProperty(t, pf(n.key), n);
        }
      }
      function rf(t, e) {
        if (e && ("object" === Up(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return nf(t);
      }
      function nf(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }
      function of(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
          (of = function (t) {
            if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
            var r;
            if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== e) {
              if (e.has(t)) return e.get(t);
              e.set(t, n);
            }
            function n() {
              return af(t, arguments, cf(this).constructor);
            }
            return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), lf(n, t);
          }),
          of(t)
        );
      }
      function af(t, e, r) {
        return (
          (af = sf()
            ? Reflect.construct.bind()
            : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && lf(i, r.prototype), i;
            }),
          af.apply(null, arguments)
        );
      }
      function sf() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { })), !0;
        } catch (t) {
          return !1;
        }
      }
      function lf(t, e) {
        return (
          (lf = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (t, e) {
              return (t.__proto__ = e), t;
            }),
          lf(t, e)
        );
      }
      function cf(t) {
        return (
          (cf = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
          cf(t)
        );
      }
      function uf(t, e, r) {
        return (e = pf(e)) in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : (t[e] = r), t;
      }
      function pf(t) {
        var e = (function (t, e) {
          if ("object" !== Up(t) || null === t) return t;
          var r = t[Symbol.toPrimitive];
          if (void 0 !== r) {
            var n = r.call(t, "string");
            if ("object" !== Up(n)) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return String(t);
        })(t);
        return "symbol" === Up(e) ? e : String(e);
      }
      function ff(t) {
        var e,
          r,
          n,
          i = 2;
        for ("undefined" != typeof Symbol && ((r = Symbol.asyncIterator), (n = Symbol.iterator)); i--;) {
          if (r && null != (e = t[r])) return e.call(t);
          if (n && null != (e = t[n])) return new df(e.call(t));
          (r = "@@asyncIterator"), (n = "@@iterator");
        }
        throw new TypeError("Object is not async iterable");
      }
      function df(t) {
        function e(t) {
          if (Object(t) !== t) return Promise.reject(new TypeError(t + " is not an object."));
          var e = t.done;
          return Promise.resolve(t.value).then(function (t) {
            return { value: t, done: e };
          });
        }
        return (
          (df = function (t) {
            (this.s = t), (this.n = t.next);
          }),
          (df.prototype = {
            s: null,
            n: null,
            next: function () {
              return e(this.n.apply(this.s, arguments));
            },
            return: function (t) {
              var r = this.s.return;
              return void 0 === r ? Promise.resolve({ value: t, done: !0 }) : e(r.apply(this.s, arguments));
            },
            throw: function (t) {
              var r = this.s.return;
              return void 0 === r ? Promise.reject(t) : e(r.apply(this.s, arguments));
            },
          }),
          new df(t)
        );
      }
      var hf = window.libraries,
        vf = hf.select,
        mf = hf.getSectionInnerHTML,
        yf = hf.getData,
        gf = hf.Swiper,
        bf = (function (t) {
          !(function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && lf(t, e);
          })(s, t);
          var e,
            r,
            n,
            i,
            o,
            a =
              ((e = s),
                (r = sf()),
                function () {
                  var t,
                    n = cf(e);
                  if (r) {
                    var i = cf(this).constructor;
                    t = Reflect.construct(n, arguments, i);
                  } else t = n.apply(this, arguments);
                  return rf(this, t);
                });
          function s() {
            var t;
            return (
              (function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
              })(this, s),
              uf(nf((t = a.call(this))), "toggleOn", function () {
                t.style.display = "block";
              }),
              uf(
                nf(t),
                "loadSavedItems",
                tf(
                  Kp().mark(function e() {
                    var r, n, i, o, a, s, l, c, u, p, f, d;
                    return Kp().wrap(
                      function (e) {
                        for (; ;)
                          switch ((e.prev = e.next)) {
                            case 0:
                              return (e.next = 2), t.getProductData();
                            case 2:
                              if (!(r = e.sent).length) {
                                e.next = 44;
                                break;
                              }
                              (n = ""), (i = !1), (o = !1), (e.prev = 7), (s = ff(r));
                            case 9:
                              return (e.next = 11), s.next();
                            case 11:
                              if (!(i = !(l = e.sent).done)) {
                                e.next = 23;
                                break;
                              }
                              return (c = l.value), (u = c.product), (e.next = 16), yf("/products/".concat(u.handle, "/?sections=product-grid-item"));
                            case 16:
                              (p = e.sent), (f = mf(p["product-grid-item"])), (d = '<div class="swiper-slide">'.concat(f, "</div>")), (n += d);
                            case 20:
                              (i = !1), (e.next = 9);
                              break;
                            case 23:
                              e.next = 29;
                              break;
                            case 25:
                              (e.prev = 25), (e.t0 = e.catch(7)), (o = !0), (a = e.t0);
                            case 29:
                              if (((e.prev = 29), (e.prev = 30), !i || null == s.return)) {
                                e.next = 34;
                                break;
                              }
                              return (e.next = 34), s.return();
                            case 34:
                              if (((e.prev = 34), !o)) {
                                e.next = 37;
                                break;
                              }
                              throw a;
                            case 37:
                              return e.finish(34);
                            case 38:
                              return e.finish(29);
                            case 39:
                              (t.sliderWrapper.innerHTML = ""),
                                (t.sliderWrapper.innerHTML += n),
                                r.forEach(function (t) {
                                  document.querySelector('[data-grid-item-swatch][data-variant-id="'.concat(t.saved_id, '"]')).click();
                                }),
                                new gf(t.slider, {
                                  slidesPerView: 1.3,
                                  spaceBetween: 24,
                                  loop: !0,
                                  navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
                                  breakpoints: { 768: { slidesPerView: 3, spaceBetween: 32 } },
                                  on: {
                                    init: function (t) {
                                      var e = t.slides.length,
                                        r = "".concat((2 / e) * 100, "%"),
                                        n = t.el.closest("[data-carousel-container]");
                                      vf("[data-progress]", n).style.width = r;
                                    },
                                    slideChange: function (t) {
                                      var e = t.slides.length / 2,
                                        r = t.realIndex + 1;
                                      r > e && (r -= e);
                                      var n = (r / e) * 100;
                                      t.el.closest("[data-carousel-container]").querySelector("[data-progress]").style.width = "".concat(n, "%");
                                    },
                                  },
                                }),
                                t.toggleOn();
                            case 44:
                            case "end":
                              return e.stop();
                          }
                      },
                      e,
                      null,
                      [
                        [7, 25, 29, 39],
                        [30, , 34, 38],
                      ]
                    );
                  })
                )
              ),
              uf(
                nf(t),
                "getProductData",
                tf(
                  Kp().mark(function t() {
                    var e, r, n, i, o, a, s, l, c, u, p, f;
                    return Kp().wrap(
                      function (t) {
                        for (; ;)
                          switch ((t.prev = t.next)) {
                            case 0:
                              return (t.next = 2), JSON.parse(window.localStorage.getItem("elva.savedItems"));
                            case 2:
                              if (((t.t0 = t.sent), t.t0)) {
                                t.next = 5;
                                break;
                              }
                              t.t0 = [];
                            case 5:
                              (e = t.t0), (r = []), (n = !1), (i = !1), (t.prev = 9), (a = ff(e));
                            case 11:
                              return (t.next = 13), a.next();
                            case 13:
                              if (!(n = !(s = t.sent).done)) {
                                t.next = 25;
                                break;
                              }
                              return (l = s.value), (c = l.split("::")), (u = c[0]), (p = c[1]), (t.next = 20), yf("/products/".concat(u, ".json"));
                            case 20:
                              (f = t.sent), r.push(Qp(Qp({}, f), {}, { saved_id: p }));
                            case 22:
                              (n = !1), (t.next = 11);
                              break;
                            case 25:
                              t.next = 31;
                              break;
                            case 27:
                              (t.prev = 27), (t.t1 = t.catch(9)), (i = !0), (o = t.t1);
                            case 31:
                              if (((t.prev = 31), (t.prev = 32), !n || null == a.return)) {
                                t.next = 36;
                                break;
                              }
                              return (t.next = 36), a.return();
                            case 36:
                              if (((t.prev = 36), !i)) {
                                t.next = 39;
                                break;
                              }
                              throw o;
                            case 39:
                              return t.finish(36);
                            case 40:
                              return t.finish(31);
                            case 41:
                              return t.abrupt("return", r);
                            case 42:
                            case "end":
                              return t.stop();
                          }
                      },
                      t,
                      null,
                      [
                        [9, 27, 31, 41],
                        [32, , 36, 40],
                      ]
                    );
                  })
                )
              ),
              (t.slider = vf("[data-card-carousel]", nf(t))),
              (t.sliderWrapper = vf("[data-swiper-wrapper]", nf(t))),
              t
            );
          }
          return (
            (n = s),
            (i = [
              {
                key: "connectedCallback",
                value:
                  ((o = tf(
                    Kp().mark(function t() {
                      return Kp().wrap(
                        function (t) {
                          for (; ;)
                            switch ((t.prev = t.next)) {
                              case 0:
                                return (t.next = 2), this.loadSavedItems();
                              case 2:
                              case "end":
                                return t.stop();
                            }
                        },
                        t,
                        this
                      );
                    })
                  )),
                    function () {
                      return o.apply(this, arguments);
                    }),
              },
            ]),
            i && ef(n.prototype, i),
            Object.defineProperty(n, "prototype", { writable: !1 }),
            s
          );
        })(of(HTMLElement));
      function wf(t) {
        return (
          (wf =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                return typeof t;
              }
              : function (t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
              }),
          wf(t)
        );
      }
      function _f(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
        return n;
      }
      function xf(t, e) {
        if (e && ("object" === wf(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return (function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        })(t);
      }
      function Tf(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
          (Tf = function (t) {
            if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
            var r;
            if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== e) {
              if (e.has(t)) return e.get(t);
              e.set(t, n);
            }
            function n() {
              return Ef(t, arguments, Pf(this).constructor);
            }
            return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), Of(n, t);
          }),
          Tf(t)
        );
      }
      function Ef(t, e, r) {
        return (
          (Ef = Sf()
            ? Reflect.construct.bind()
            : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && Of(i, r.prototype), i;
            }),
          Ef.apply(null, arguments)
        );
      }
      function Sf() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { })), !0;
        } catch (t) {
          return !1;
        }
      }
      function Of(t, e) {
        return (
          (Of = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (t, e) {
              return (t.__proto__ = e), t;
            }),
          Of(t, e)
        );
      }
      function Pf(t) {
        return (
          (Pf = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
          Pf(t)
        );
      }
      var Af = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Of(t, e);
        })(a, t);
        var e,
          r,
          n,
          o =
            ((e = a),
              (r = Sf()),
              function () {
                var t,
                  n = Pf(e);
                if (r) {
                  var i = Pf(this).constructor;
                  t = Reflect.construct(n, arguments, i);
                } else t = n.apply(this, arguments);
                return xf(this, t);
              });
        function a() {
          var t;
          !(function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          })(this, a),
            (t = o.call(this));
          var e = i("[data-tab]"),
            r = i("[data-tab-block]");
          return (
            e.listen("click", function (t) {
              var n,
                o = t.$node;
              if (
                !((n = o.classList),
                  (function (t) {
                    if (Array.isArray(t)) return _f(t);
                  })(n) ||
                  (function (t) {
                    if (("undefined" != typeof Symbol && null != t[Symbol.iterator]) || null != t["@@iterator"]) return Array.from(t);
                  })(n) ||
                  (function (t, e) {
                    if (t) {
                      if ("string" == typeof t) return _f(t, e);
                      var r = Object.prototype.toString.call(t).slice(8, -1);
                      return (
                        "Object" === r && t.constructor && (r = t.constructor.name),
                        "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? _f(t, e) : void 0
                      );
                    }
                  })(n) ||
                  (function () {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                  })()).includes("c-tab--active")
              ) {
                e.modifyClass("remove", "c-tab--active"), o.modifyClass("add", "c-tab--active");
                var a = o.dataset.tab,
                  s = i('[data-tab-block="'.concat(a, '"]'));
                r.modifyClass("remove", "c-tabBlock--active"), s.modifyClass("add", "c-tabBlock--active");
              }
            }),
            t
          );
        }
        return (n = a), Object.defineProperty(n, "prototype", { writable: !1 }), n;
      })(Tf(HTMLElement));
      function Cf(t) {
        return (
          (Cf =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                return typeof t;
              }
              : function (t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
              }),
          Cf(t)
        );
      }
      function Lf(t, e) {
        if (e && ("object" === Cf(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return kf(t);
      }
      function kf(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }
      function Mf(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
          (Mf = function (t) {
            if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
            var r;
            if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== e) {
              if (e.has(t)) return e.get(t);
              e.set(t, n);
            }
            function n() {
              return jf(t, arguments, zf(this).constructor);
            }
            return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), If(n, t);
          }),
          Mf(t)
        );
      }
      function jf(t, e, r) {
        return (
          (jf = Rf()
            ? Reflect.construct.bind()
            : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && If(i, r.prototype), i;
            }),
          jf.apply(null, arguments)
        );
      }
      function Rf() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { })), !0;
        } catch (t) {
          return !1;
        }
      }
      function If(t, e) {
        return (
          (If = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (t, e) {
              return (t.__proto__ = e), t;
            }),
          If(t, e)
        );
      }
      function zf(t) {
        return (
          (zf = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
          zf(t)
        );
      }
      var Df = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && If(t, e);
        })(a, t);
        var e,
          r,
          n,
          o =
            ((e = a),
              (r = Rf()),
              function () {
                var t,
                  n = zf(e);
                if (r) {
                  var i = zf(this).constructor;
                  t = Reflect.construct(n, arguments, i);
                } else t = n.apply(this, arguments);
                return Lf(this, t);
              });
        function a() {
          var t;
          !(function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          })(this, a);
          var e = i("[data-video]", kf((t = o.call(this)))),
            r = i("[data-play-pause]", kf(t)),
            n = "c-controls--playing";
          return (
            e.listen("mouseenter", function (t) {
              var e = t.$node;
              window.innerWidth >= 1200 && (e.play(), r.modifyClass("add", n));
            }),
            e.listen("mouseleave", function (t) {
              var e = t.$node;
              window.innerWidth >= 1200 && (e.pause(), r.modifyClass("remove", n));
            }),
            e.listen("click", function (t) {
              var e = t.$node;
              window.innerWidth < 1200 && !r.classList.contains("u-hide") && (e.setAttribute("controls", "controls"), (e.muted = !1), e.play(), r.modifyClass("add", "u-hide"));
            }),
            t
          );
        }
        return (n = a), Object.defineProperty(n, "prototype", { writable: !1 }), n;
      })(Mf(HTMLElement));
      function Bf(t) {
        return (
          (Bf =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                return typeof t;
              }
              : function (t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
              }),
          Bf(t)
        );
      }
      function Ff(t, e) {
        if (e && ("object" === Bf(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return Gf(t);
      }
      function Gf(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }
      function Nf(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
          (Nf = function (t) {
            if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
            var r;
            if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== e) {
              if (e.has(t)) return e.get(t);
              e.set(t, n);
            }
            function n() {
              return Yf(t, arguments, qf(this).constructor);
            }
            return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), Vf(n, t);
          }),
          Nf(t)
        );
      }
      function Yf(t, e, r) {
        return (
          (Yf = Hf()
            ? Reflect.construct.bind()
            : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && Vf(i, r.prototype), i;
            }),
          Yf.apply(null, arguments)
        );
      }
      function Hf() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { })), !0;
        } catch (t) {
          return !1;
        }
      }
      function Vf(t, e) {
        return (
          (Vf = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (t, e) {
              return (t.__proto__ = e), t;
            }),
          Vf(t, e)
        );
      }
      function qf(t) {
        return (
          (qf = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
          qf(t)
        );
      }
      var $f = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Vf(t, e);
        })(a, t);
        var e,
          r,
          n,
          o =
            ((e = a),
              (r = Hf()),
              function () {
                var t,
                  n = qf(e);
                if (r) {
                  var i = qf(this).constructor;
                  t = Reflect.construct(n, arguments, i);
                } else t = n.apply(this, arguments);
                return Ff(this, t);
              });
        function a() {
          var t;
          !(function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          })(this, a);
          var e = i("[data-video]", Gf((t = o.call(this)))),
            r = i("[data-play-pause]", Gf(t));
          r.listen("click", function () {
            r.modifyClass("toggle", "c-controls--playing"), r.classList.contains("c-controls--playing") ? e.play() : e.pause();
          });
          try {
            e.addEventListener("ended", function () {
              r.classList.remove("c-controls--playing");
            });
          } catch (t) {
            console.log(t);
          }
          return t;
        }
        return (n = a), Object.defineProperty(n, "prototype", { writable: !1 }), n;
      })(Nf(HTMLElement)),
        Xf = r(257),
        Wf = {};
      function Uf(t) {
        return (
          (Uf =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                return typeof t;
              }
              : function (t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
              }),
          Uf(t)
        );
      }
      function Zf(t, e) {
        if (e && ("object" === Uf(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return Qf(t);
      }
      function Qf(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }
      function Kf(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
          (Kf = function (t) {
            if (null === t || ((r = t), -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
            var r;
            if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== e) {
              if (e.has(t)) return e.get(t);
              e.set(t, n);
            }
            function n() {
              return Jf(t, arguments, rd(this).constructor);
            }
            return (n.prototype = Object.create(t.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } })), ed(n, t);
          }),
          Kf(t)
        );
      }
      function Jf(t, e, r) {
        return (
          (Jf = td()
            ? Reflect.construct.bind()
            : function (t, e, r) {
              var n = [null];
              n.push.apply(n, e);
              var i = new (Function.bind.apply(t, n))();
              return r && ed(i, r.prototype), i;
            }),
          Jf.apply(null, arguments)
        );
      }
      function td() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { })), !0;
        } catch (t) {
          return !1;
        }
      }
      function ed(t, e) {
        return (
          (ed = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (t, e) {
              return (t.__proto__ = e), t;
            }),
          ed(t, e)
        );
      }
      function rd(t) {
        return (
          (rd = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
          rd(t)
        );
      }
      (Wf.styleTagTransform = Gt()), (Wf.setAttributes = zt()), (Wf.insert = Rt().bind(null, "head")), (Wf.domAPI = Mt()), (Wf.insertStyleElement = Bt()), Lt()(Xf.Z, Wf), Xf.Z && Xf.Z.locals && Xf.Z.locals;
      var nd,
        id = (function (t) {
          !(function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && ed(t, e);
          })(a, t);
          var e,
            r,
            n,
            o =
              ((e = a),
                (r = td()),
                function () {
                  var t,
                    n = rd(e);
                  if (r) {
                    var i = rd(this).constructor;
                    t = Reflect.construct(n, arguments, i);
                  } else t = n.apply(this, arguments);
                  return Zf(this, t);
                });
          function a() {
            var t;
            !(function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            })(this, a);
            var e = i("[data-visual-slider]", Qf((t = o.call(this)))),
              r = i("[data-visual-cta]", Qf(t));
            return (
              new _t(e, {
                modules: [Et, Ot],
                slidesPerView: 1,
                loop: !0,
                navigation: { prevEl: "[data-prev-visual]", nextEl: "[data-next-visual]" },
                pagination: { el: "[data-pagination]" },
                on: {
                  slideChange: function (t) {
                    var e = t.realIndex,
                      n = i('[data-product="'.concat(e, '"]')).dataset.url;
                    r.href = n;
                  },
                },
              }),
              t
            );
          }
          return (n = a), Object.defineProperty(n, "prototype", { writable: !1 }), n;
        })(Kf(HTMLElement));
      function od(t) {
        return (
          (od =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                return typeof t;
              }
              : function (t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
              }),
          od(t)
        );
      }
      function ad() {
        ad = function () {
          return t;
        };
        var t = {},
          e = Object.prototype,
          r = e.hasOwnProperty,
          n =
            Object.defineProperty ||
            function (t, e, r) {
              t[e] = r.value;
            },
          i = "function" == typeof Symbol ? Symbol : {},
          o = i.iterator || "@@iterator",
          a = i.asyncIterator || "@@asyncIterator",
          s = i.toStringTag || "@@toStringTag";
        function l(t, e, r) {
          return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e];
        }
        try {
          l({}, "");
        } catch (t) {
          l = function (t, e, r) {
            return (t[e] = r);
          };
        }
        function c(t, e, r, i) {
          var o = e && e.prototype instanceof f ? e : f,
            a = Object.create(o.prototype),
            s = new S(i || []);
          return n(a, "_invoke", { value: _(t, r, s) }), a;
        }
        function u(t, e, r) {
          try {
            return { type: "normal", arg: t.call(e, r) };
          } catch (t) {
            return { type: "throw", arg: t };
          }
        }
        t.wrap = c;
        var p = {};
        function f() { }
        function d() { }
        function h() { }
        var v = {};
        l(v, o, function () {
          return this;
        });
        var m = Object.getPrototypeOf,
          y = m && m(m(O([])));
        y && y !== e && r.call(y, o) && (v = y);
        var g = (h.prototype = f.prototype = Object.create(v));
        function b(t) {
          ["next", "throw", "return"].forEach(function (e) {
            l(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }
        function w(t, e) {
          function i(n, o, a, s) {
            var l = u(t[n], t, o);
            if ("throw" !== l.type) {
              var c = l.arg,
                p = c.value;
              return p && "object" == od(p) && r.call(p, "__await")
                ? e.resolve(p.__await).then(
                  function (t) {
                    i("next", t, a, s);
                  },
                  function (t) {
                    i("throw", t, a, s);
                  }
                )
                : e.resolve(p).then(
                  function (t) {
                    (c.value = t), a(c);
                  },
                  function (t) {
                    return i("throw", t, a, s);
                  }
                );
            }
            s(l.arg);
          }
          var o;
          n(this, "_invoke", {
            value: function (t, r) {
              function n() {
                return new e(function (e, n) {
                  i(t, r, e, n);
                });
              }
              return (o = o ? o.then(n, n) : n());
            },
          });
        }
        function _(t, e, r) {
          var n = "suspendedStart";
          return function (i, o) {
            if ("executing" === n) throw new Error("Generator is already running");
            if ("completed" === n) {
              if ("throw" === i) throw o;
              return { value: void 0, done: !0 };
            }
            for (r.method = i, r.arg = o; ;) {
              var a = r.delegate;
              if (a) {
                var s = x(a, r);
                if (s) {
                  if (s === p) continue;
                  return s;
                }
              }
              if ("next" === r.method) r.sent = r._sent = r.arg;
              else if ("throw" === r.method) {
                if ("suspendedStart" === n) throw ((n = "completed"), r.arg);
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              n = "executing";
              var l = u(t, e, r);
              if ("normal" === l.type) {
                if (((n = r.done ? "completed" : "suspendedYield"), l.arg === p)) continue;
                return { value: l.arg, done: r.done };
              }
              "throw" === l.type && ((n = "completed"), (r.method = "throw"), (r.arg = l.arg));
            }
          };
        }
        function x(t, e) {
          var r = e.method,
            n = t.iterator[r];
          if (void 0 === n)
            return (
              (e.delegate = null),
              ("throw" === r && t.iterator.return && ((e.method = "return"), (e.arg = void 0), x(t, e), "throw" === e.method)) ||
              ("return" !== r && ((e.method = "throw"), (e.arg = new TypeError("The iterator does not provide a '" + r + "' method")))),
              p
            );
          var i = u(n, t.iterator, e.arg);
          if ("throw" === i.type) return (e.method = "throw"), (e.arg = i.arg), (e.delegate = null), p;
          var o = i.arg;
          return o
            ? o.done
              ? ((e[t.resultName] = o.value), (e.next = t.nextLoc), "return" !== e.method && ((e.method = "next"), (e.arg = void 0)), (e.delegate = null), p)
              : o
            : ((e.method = "throw"), (e.arg = new TypeError("iterator result is not an object")), (e.delegate = null), p);
        }
        function T(t) {
          var e = { tryLoc: t[0] };
          1 in t && (e.catchLoc = t[1]), 2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])), this.tryEntries.push(e);
        }
        function E(t) {
          var e = t.completion || {};
          (e.type = "normal"), delete e.arg, (t.completion = e);
        }
        function S(t) {
          (this.tryEntries = [{ tryLoc: "root" }]), t.forEach(T, this), this.reset(!0);
        }
        function O(t) {
          if (t) {
            var e = t[o];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) {
              var n = -1,
                i = function e() {
                  for (; ++n < t.length;) if (r.call(t, n)) return (e.value = t[n]), (e.done = !1), e;
                  return (e.value = void 0), (e.done = !0), e;
                };
              return (i.next = i);
            }
          }
          return { next: P };
        }
        function P() {
          return { value: void 0, done: !0 };
        }
        return (
          (d.prototype = h),
          n(g, "constructor", { value: h, configurable: !0 }),
          n(h, "constructor", { value: d, configurable: !0 }),
          (d.displayName = l(h, s, "GeneratorFunction")),
          (t.isGeneratorFunction = function (t) {
            var e = "function" == typeof t && t.constructor;
            return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
          }),
          (t.mark = function (t) {
            return Object.setPrototypeOf ? Object.setPrototypeOf(t, h) : ((t.__proto__ = h), l(t, s, "GeneratorFunction")), (t.prototype = Object.create(g)), t;
          }),
          (t.awrap = function (t) {
            return { __await: t };
          }),
          b(w.prototype),
          l(w.prototype, a, function () {
            return this;
          }),
          (t.AsyncIterator = w),
          (t.async = function (e, r, n, i, o) {
            void 0 === o && (o = Promise);
            var a = new w(c(e, r, n, i), o);
            return t.isGeneratorFunction(r)
              ? a
              : a.next().then(function (t) {
                return t.done ? t.value : a.next();
              });
          }),
          b(g),
          l(g, s, "Generator"),
          l(g, o, function () {
            return this;
          }),
          l(g, "toString", function () {
            return "[object Generator]";
          }),
          (t.keys = function (t) {
            var e = Object(t),
              r = [];
            for (var n in e) r.push(n);
            return (
              r.reverse(),
              function t() {
                for (; r.length;) {
                  var n = r.pop();
                  if (n in e) return (t.value = n), (t.done = !1), t;
                }
                return (t.done = !0), t;
              }
            );
          }),
          (t.values = O),
          (S.prototype = {
            constructor: S,
            reset: function (t) {
              if (((this.prev = 0), (this.next = 0), (this.sent = this._sent = void 0), (this.done = !1), (this.delegate = null), (this.method = "next"), (this.arg = void 0), this.tryEntries.forEach(E), !t))
                for (var e in this) "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
            },
            stop: function () {
              this.done = !0;
              var t = this.tryEntries[0].completion;
              if ("throw" === t.type) throw t.arg;
              return this.rval;
            },
            dispatchException: function (t) {
              if (this.done) throw t;
              var e = this;
              function n(r, n) {
                return (a.type = "throw"), (a.arg = t), (e.next = r), n && ((e.method = "next"), (e.arg = void 0)), !!n;
              }
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var o = this.tryEntries[i],
                  a = o.completion;
                if ("root" === o.tryLoc) return n("end");
                if (o.tryLoc <= this.prev) {
                  var s = r.call(o, "catchLoc"),
                    l = r.call(o, "finallyLoc");
                  if (s && l) {
                    if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
                    if (this.prev < o.finallyLoc) return n(o.finallyLoc);
                  } else if (s) {
                    if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
                  } else {
                    if (!l) throw new Error("try statement without catch or finally");
                    if (this.prev < o.finallyLoc) return n(o.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (t, e) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var i = this.tryEntries[n];
                if (i.tryLoc <= this.prev && r.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                  var o = i;
                  break;
                }
              }
              o && ("break" === t || "continue" === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
              var a = o ? o.completion : {};
              return (a.type = t), (a.arg = e), o ? ((this.method = "next"), (this.next = o.finallyLoc), p) : this.complete(a);
            },
            complete: function (t, e) {
              if ("throw" === t.type) throw t.arg;
              return (
                "break" === t.type || "continue" === t.type
                  ? (this.next = t.arg)
                  : "return" === t.type
                    ? ((this.rval = this.arg = t.arg), (this.method = "return"), (this.next = "end"))
                    : "normal" === t.type && e && (this.next = e),
                p
              );
            },
            finish: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), E(r), p;
              }
            },
            catch: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                  var n = r.completion;
                  if ("throw" === n.type) {
                    var i = n.arg;
                    E(r);
                  }
                  return i;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (t, e, r) {
              return (this.delegate = { iterator: O(t), resultName: e, nextLoc: r }), "next" === this.method && (this.arg = void 0), p;
            },
          }),
          t
        );
      }
      function sd(t, e, r, n, i, o, a) {
        try {
          var s = t[o](a),
            l = s.value;
        } catch (t) {
          return void r(t);
        }
        s.done ? e(l) : Promise.resolve(l).then(n, i);
      }
      ((nd = ad().mark(function t() {
        return ad().wrap(function (t) {
          for (; ;)
            switch ((t.prev = t.next)) {
              case 0:
                customElements.define("example-component", d),
                  customElements.define("example-extended", b),
                  customElements.define("accordion-item", A),
                  customElements.define("article-carousel", Jt),
                  customElements.define("banner-animate", pc),
                  customElements.define("card-carousel", xc),
                  customElements.define("cart-addons", ru),
                  customElements.define("cart-page", yu),
                  customElements.define("collection-sort", Ou),
                  customElements.define("countdown-timer", zu),
                  customElements.define("faq-module", qu),
                  customElements.define("lifestyle-tiles", tp),
                  customElements.define("load-more", fp),
                  customElements.define("main-header", _p),
                  customElements.define("modal-window", Lp),
                  customElements.define("product-card-swatches", Fp),
                  customElements.define("product-feature", Wp),
                  customElements.define("saved-items", bf),
                  customElements.define("tab-item", Af),
                  customElements.define("video-frame", $f),
                  customElements.define("video-controls", Df),
                  customElements.define("visual-carousel", id);
              case 22:
              case "end":
                return t.stop();
            }
        }, t);
      })),
        function () {
          var t = this,
            e = arguments;
          return new Promise(function (r, n) {
            var i = nd.apply(t, e);
            function o(t) {
              sd(i, r, n, o, a, "next", t);
            }
            function a(t) {
              sd(i, r, n, o, a, "throw", t);
            }
            o(void 0);
          });
        })();
    })();
})();
